export const EXTRA_COMMAND_GROUPS = [
    {
        "id": "deployment",
        "label": "Deploy, hosting y CI/CD",
        "description": "Automatizaci\u00f3n de despliegues, VPS, process managers, TLS y plataformas de hosting/deploy."
    },
    {
        "id": "virtualization",
        "label": "Virtualizaci\u00f3n y datacenter",
        "description": "Hipervisores, m\u00e1quinas virtuales, contenedores, storage, cluster y alta disponibilidad."
    }
];

export const COMMAND_CATEGORY_EXPANSIONS = {
    "linux": [
        {
            "command": "ls -lah",
            "level": "basic",
            "topic": "Navegaci\u00f3n y archivos",
            "description": "Lista archivos incluyendo ocultos con tama\u00f1os legibles.",
            "example": "ls -lah",
            "expected": "Listado detallado con permisos, propietario, tama\u00f1o y nombre.",
            "note": ""
        },
        {
            "command": "find . -maxdepth 2 -type f",
            "level": "basic",
            "topic": "Navegaci\u00f3n y archivos",
            "description": "Busca archivos hasta dos niveles de profundidad.",
            "example": "find . -maxdepth 2 -type f",
            "expected": "Rutas de archivos encontrados, una por l\u00ednea.",
            "note": ""
        },
        {
            "command": "find . -type f -mtime -1",
            "level": "intermediate",
            "topic": "Navegaci\u00f3n y archivos",
            "description": "Busca archivos modificados en las \u00faltimas 24 horas.",
            "example": "find . -type f -mtime -1",
            "expected": "Rutas que cumplen la condici\u00f3n de tiempo.",
            "note": ""
        },
        {
            "command": "find . -type f -size +100M",
            "level": "intermediate",
            "topic": "Navegaci\u00f3n y archivos",
            "description": "Busca archivos mayores a 100 MB.",
            "example": "find . -type f -size +100M",
            "expected": "Rutas de archivos grandes.",
            "note": ""
        },
        {
            "command": "find . -type f -print0 | xargs -0 grep -n \"TODO\"",
            "level": "advanced",
            "topic": "Navegaci\u00f3n y archivos",
            "description": "Busca TODO en archivos manejando de forma segura nombres con espacios.",
            "example": "find . -type f -print0 | xargs -0 grep -n \"TODO\"",
            "expected": "L\u00edneas coincidentes con archivo y n\u00famero de l\u00ednea.",
            "note": "Revis\u00e1 el comando antes de combinar xargs con acciones destructivas."
        },
        {
            "command": "chmod u+x script.sh",
            "level": "basic",
            "topic": "Permisos y usuarios",
            "description": "Agrega permiso de ejecuci\u00f3n al propietario.",
            "example": "chmod u+x script.sh",
            "expected": "Sin salida si fue correcto.",
            "note": ""
        },
        {
            "command": "getfacl <path>",
            "level": "intermediate",
            "topic": "Permisos y usuarios",
            "description": "Muestra ACL extendidas de un archivo o directorio.",
            "example": "getfacl <path>",
            "expected": "Permisos POSIX y entradas ACL.",
            "note": ""
        },
        {
            "command": "setfacl -m u:<user>:rwx <path>",
            "level": "intermediate",
            "topic": "Permisos y usuarios",
            "description": "Concede permisos ACL a un usuario puntual.",
            "example": "setfacl -m u:<user>:rwx <path>",
            "expected": "Sin salida si se aplica correctamente.",
            "note": ""
        },
        {
            "command": "sudo -l",
            "level": "advanced",
            "topic": "Permisos y usuarios",
            "description": "Lista qu\u00e9 comandos puede ejecutar el usuario con sudo.",
            "example": "sudo -l",
            "expected": "Reglas sudo aplicables al usuario actual.",
            "note": ""
        },
        {
            "command": "lsblk -f",
            "level": "basic",
            "topic": "Discos y filesystem",
            "description": "Muestra discos, particiones, filesystem y UUID.",
            "example": "lsblk -f",
            "expected": "Tabla de bloques con FSTYPE, LABEL, UUID y mountpoint.",
            "note": ""
        },
        {
            "command": "sudo mount -o ro <device> <mountpoint>",
            "level": "intermediate",
            "topic": "Discos y filesystem",
            "description": "Monta un filesystem en modo solo lectura.",
            "example": "sudo mount -o ro <device> <mountpoint>",
            "expected": "Sin salida si monta correctamente.",
            "note": "Verific\u00e1 device y mountpoint antes de ejecutar."
        },
        {
            "command": "sudo tune2fs -l <device>",
            "level": "advanced",
            "topic": "Discos y filesystem",
            "description": "Muestra metadata avanzada de un filesystem ext.",
            "example": "sudo tune2fs -l <device>",
            "expected": "Propiedades del superblock.",
            "note": "Solo aplica a filesystems compatibles como ext4."
        },
        {
            "command": "free -h",
            "level": "basic",
            "topic": "Procesos y recursos",
            "description": "Muestra memoria RAM y swap en formato legible.",
            "example": "free -h",
            "expected": "Totales, usados, libres, buffers/cache y swap.",
            "note": ""
        },
        {
            "command": "ps -eo pid,ppid,user,%cpu,%mem,etime,cmd --sort=-%cpu | head",
            "level": "intermediate",
            "topic": "Procesos y recursos",
            "description": "Lista los procesos con mayor consumo de CPU.",
            "example": "ps -eo pid,ppid,user,%cpu,%mem,etime,cmd --sort=-%cpu | head",
            "expected": "Top de procesos con PID, usuario, CPU, memoria y tiempo.",
            "note": ""
        },
        {
            "command": "lsof -i :3000",
            "level": "intermediate",
            "topic": "Procesos y recursos",
            "description": "Identifica procesos usando el puerto 3000.",
            "example": "lsof -i :3000",
            "expected": "Proceso, PID, usuario y socket asociado.",
            "note": ""
        },
        {
            "command": "strace -f -p <pid>",
            "level": "advanced",
            "topic": "Procesos y recursos",
            "description": "Traza syscalls de un proceso y sus hijos.",
            "example": "strace -f -p <pid>",
            "expected": "Flujo de llamadas al sistema en stderr.",
            "note": "Puede generar mucha salida y afectar rendimiento."
        },
        {
            "command": "journalctl -xe --no-pager",
            "level": "basic",
            "topic": "Servicios y logs",
            "description": "Muestra eventos recientes con contexto de errores.",
            "example": "journalctl -xe --no-pager",
            "expected": "Logs del journal con explicaciones cuando existen.",
            "note": ""
        },
        {
            "command": "journalctl --since today -p warning",
            "level": "intermediate",
            "topic": "Servicios y logs",
            "description": "Filtra warnings y errores desde hoy.",
            "example": "journalctl --since today -p warning",
            "expected": "Entradas del journal con prioridad warning o superior.",
            "note": ""
        },
        {
            "command": "ss -tulpn",
            "level": "basic",
            "topic": "Red y conectividad",
            "description": "Lista sockets TCP/UDP en escucha con procesos.",
            "example": "ss -tulpn",
            "expected": "Puertos, direcciones, PID y proceso cuando hay permisos.",
            "note": ""
        },
        {
            "command": "ip route get 1.1.1.1",
            "level": "intermediate",
            "topic": "Red y conectividad",
            "description": "Muestra la ruta que usar\u00eda el kernel hacia un destino.",
            "example": "ip route get 1.1.1.1",
            "expected": "Interfaz, gateway, IP origen y ruta elegida.",
            "note": ""
        },
        {
            "command": "sudo tcpdump -ni any port 443",
            "level": "advanced",
            "topic": "Red y conectividad",
            "description": "Captura tr\u00e1fico HTTPS en todas las interfaces.",
            "example": "sudo tcpdump -ni any port 443",
            "expected": "Paquetes coincidentes en tiempo real.",
            "note": "Puede exponer metadata sensible; usalo solo donde tengas autorizaci\u00f3n."
        },
        {
            "command": "sort <file> | uniq -c | sort -nr",
            "level": "basic",
            "topic": "Texto y pipelines",
            "description": "Cuenta l\u00edneas repetidas y las ordena por frecuencia.",
            "example": "sort access.log | uniq -c | sort -nr",
            "expected": "Conteo y valor por l\u00ednea, de mayor a menor.",
            "note": ""
        },
        {
            "command": "awk -F, '{print $1,$3}' <file.csv>",
            "level": "intermediate",
            "topic": "Texto y pipelines",
            "description": "Extrae columnas 1 y 3 de un CSV simple.",
            "example": "awk -F, '{print $1,$3}' <file.csv>",
            "expected": "Campos seleccionados por fila.",
            "note": "No reemplaza un parser CSV cuando hay comas escapadas o quoted fields."
        },
        {
            "command": "watch -n 2 '<command>'",
            "level": "intermediate",
            "topic": "Shell y automatizaci\u00f3n",
            "description": "Repite un comando cada 2 segundos.",
            "example": "watch -n 2 '<command>'",
            "expected": "Pantalla actualizada peri\u00f3dicamente.",
            "note": ""
        },
        {
            "command": "nohup <command> > app.log 2>&1 &",
            "level": "advanced",
            "topic": "Shell y automatizaci\u00f3n",
            "description": "Ejecuta un proceso en background sobreviviendo al cierre de sesi\u00f3n.",
            "example": "nohup <command> > app.log 2>&1 &",
            "expected": "PID del job y salida redirigida a app.log.",
            "note": ""
        }
    ],
    "cmd": [
        {
            "command": "dir /a",
            "level": "basic",
            "topic": "Archivos y directorios",
            "description": "Lista archivos incluidos ocultos y de sistema.",
            "example": "dir /a",
            "expected": "Listado del directorio con atributos especiales.",
            "note": ""
        },
        {
            "command": "where <executable>",
            "level": "basic",
            "topic": "Archivos y directorios",
            "description": "Busca un ejecutable usando PATH.",
            "example": "where <executable>",
            "expected": "Ruta o rutas del ejecutable encontrado.",
            "note": ""
        },
        {
            "command": "robocopy <src> <dst> /MIR /R:2 /W:2",
            "level": "intermediate",
            "topic": "Archivos y directorios",
            "description": "Replica un directorio en modo espejo.",
            "example": "robocopy <src> <dst> /MIR /R:2 /W:2",
            "expected": "Resumen de archivos copiados, omitidos y errores.",
            "note": "/MIR elimina en destino lo que no exista en origen."
        },
        {
            "command": "forfiles /p <path> /s /m *.log /d -30 /c \"cmd /c echo @path\"",
            "level": "intermediate",
            "topic": "Archivos y directorios",
            "description": "Enumera logs con m\u00e1s de 30 d\u00edas.",
            "example": "forfiles /p <path> /s /m *.log /d -30 /c \"cmd /c echo @path\"",
            "expected": "Rutas de archivos antiguos.",
            "note": ""
        },
        {
            "command": "tasklist /fi \"IMAGENAME eq node.exe\"",
            "level": "basic",
            "topic": "Procesos y servicios",
            "description": "Filtra procesos Node.js.",
            "example": "tasklist /fi \"IMAGENAME eq node.exe\"",
            "expected": "Filas de node.exe con PID y memoria.",
            "note": ""
        },
        {
            "command": "taskkill /PID <pid> /T",
            "level": "intermediate",
            "topic": "Procesos y servicios",
            "description": "Finaliza un proceso y su \u00e1rbol.",
            "example": "taskkill /PID <pid> /T",
            "expected": "Mensaje de proceso finalizado.",
            "note": "Agreg\u00e1 /F solo si realmente necesit\u00e1s forzar."
        },
        {
            "command": "sc query <service>",
            "level": "intermediate",
            "topic": "Procesos y servicios",
            "description": "Consulta el estado de un servicio.",
            "example": "sc query <service>",
            "expected": "STATE, WIN32_EXIT_CODE y metadata del servicio.",
            "note": ""
        },
        {
            "command": "sc qc <service>",
            "level": "advanced",
            "topic": "Procesos y servicios",
            "description": "Muestra la configuraci\u00f3n de un servicio.",
            "example": "sc qc <service>",
            "expected": "Ruta binaria, tipo de inicio, cuenta y dependencias.",
            "note": ""
        },
        {
            "command": "ipconfig /all",
            "level": "basic",
            "topic": "Red",
            "description": "Muestra configuraci\u00f3n completa de adaptadores.",
            "example": "ipconfig /all",
            "expected": "IPv4/IPv6, gateway, DNS, DHCP y MAC.",
            "note": ""
        },
        {
            "command": "nslookup <domain>",
            "level": "basic",
            "topic": "Red",
            "description": "Resuelve un nombre DNS.",
            "example": "nslookup <domain>",
            "expected": "Servidor DNS y direcciones resultantes.",
            "note": ""
        },
        {
            "command": "netstat -ano | findstr :3000",
            "level": "intermediate",
            "topic": "Red",
            "description": "Busca conexiones o listeners del puerto 3000.",
            "example": "netstat -ano | findstr :3000",
            "expected": "L\u00ednea con protocolo, direcciones, estado y PID.",
            "note": ""
        },
        {
            "command": "netsh interface portproxy show all",
            "level": "intermediate",
            "topic": "Red",
            "description": "Lista redirecciones de puertos configuradas.",
            "example": "netsh interface portproxy show all",
            "expected": "Tabla de listen/connect address y ports.",
            "note": ""
        },
        {
            "command": "systeminfo",
            "level": "basic",
            "topic": "Sistema y discos",
            "description": "Muestra informaci\u00f3n del sistema Windows.",
            "example": "systeminfo",
            "expected": "SO, hotfixes, memoria, dominio y hardware b\u00e1sico.",
            "note": ""
        },
        {
            "command": "sfc /scannow",
            "level": "intermediate",
            "topic": "Sistema y discos",
            "description": "Verifica y repara archivos protegidos de Windows.",
            "example": "sfc /scannow",
            "expected": "Porcentaje de progreso y resultado de integridad.",
            "note": "Requiere consola elevada."
        },
        {
            "command": "DISM /Online /Cleanup-Image /RestoreHealth",
            "level": "advanced",
            "topic": "Sistema y discos",
            "description": "Repara la imagen de Windows usando fuentes de mantenimiento.",
            "example": "DISM /Online /Cleanup-Image /RestoreHealth",
            "expected": "Progreso y mensaje de operaci\u00f3n completada.",
            "note": "Requiere permisos de administrador."
        },
        {
            "command": "set",
            "level": "basic",
            "topic": "Variables y scripting",
            "description": "Lista variables de entorno de CMD.",
            "example": "set",
            "expected": "Pares NOMBRE=valor.",
            "note": ""
        },
        {
            "command": "setx <NAME> \"<value>\"",
            "level": "intermediate",
            "topic": "Variables y scripting",
            "description": "Persiste una variable para futuras sesiones.",
            "example": "setx <NAME> \"<value>\"",
            "expected": "SUCCESS indicando que se guard\u00f3.",
            "note": "No modifica la consola actual."
        },
        {
            "command": "reg query <key> /s",
            "level": "intermediate",
            "topic": "Registro y seguridad",
            "description": "Consulta una clave del Registro recursivamente.",
            "example": "reg query <key> /s",
            "expected": "Subclaves, valores y tipos.",
            "note": ""
        },
        {
            "command": "icacls <path> /save acl.txt /t",
            "level": "advanced",
            "topic": "Registro y seguridad",
            "description": "Exporta ACL de un \u00e1rbol.",
            "example": "icacls <path> /save acl.txt /t",
            "expected": "Cantidad de archivos procesados y acl.txt.",
            "note": "Guard\u00e1 el backup antes de cambios masivos de permisos."
        }
    ],
    "powershell": [
        {
            "command": "Get-ChildItem -Force",
            "level": "basic",
            "topic": "Archivos y directorios",
            "description": "Lista contenido incluyendo elementos ocultos.",
            "example": "Get-ChildItem -Force",
            "expected": "Objetos FileInfo y DirectoryInfo.",
            "note": ""
        },
        {
            "command": "Get-ChildItem -Recurse -File | Sort-Object Length -Descending | Select-Object -First 20 FullName,Length",
            "level": "intermediate",
            "topic": "Archivos y directorios",
            "description": "Encuentra los 20 archivos m\u00e1s grandes bajo la ruta actual.",
            "example": "Get-ChildItem -Recurse -File | Sort-Object Length -Descending | Select-Object -First 20 FullName,Length",
            "expected": "Tabla con ruta y tama\u00f1o de los 20 archivos mayores.",
            "note": ""
        },
        {
            "command": "Get-Process | Sort-Object CPU -Descending | Select-Object -First 10",
            "level": "basic",
            "topic": "Objetos y pipeline",
            "description": "Muestra los procesos con mayor CPU acumulada.",
            "example": "Get-Process | Sort-Object CPU -Descending | Select-Object -First 10",
            "expected": "Objetos Process ordenados por CPU.",
            "note": ""
        },
        {
            "command": "Import-Csv <file.csv> | Group-Object <column>",
            "level": "intermediate",
            "topic": "Objetos y pipeline",
            "description": "Agrupa registros de un CSV por una columna.",
            "example": "Import-Csv users.csv | Group-Object role",
            "expected": "Grupos con Count, Name y Group.",
            "note": ""
        },
        {
            "command": "Get-Service | Where-Object Status -eq 'Running'",
            "level": "intermediate",
            "topic": "Objetos y pipeline",
            "description": "Filtra servicios que est\u00e1n en ejecuci\u00f3n.",
            "example": "Get-Service | Where-Object Status -eq 'Running'",
            "expected": "Objetos ServiceController cuyo Status es Running.",
            "note": ""
        },
        {
            "command": "Get-Service <name>",
            "level": "basic",
            "topic": "Procesos y servicios",
            "description": "Consulta un servicio.",
            "example": "Get-Service <name>",
            "expected": "Status, Name y DisplayName.",
            "note": ""
        },
        {
            "command": "Restart-Service <name> -Force",
            "level": "intermediate",
            "topic": "Procesos y servicios",
            "description": "Reinicia un servicio.",
            "example": "Restart-Service <name> -Force",
            "expected": "Sin salida por defecto si funciona.",
            "note": "Us\u00e1 -WhatIf cuando el cmdlet lo soporte antes de cambios sensibles."
        },
        {
            "command": "Test-NetConnection <host> -Port 443",
            "level": "basic",
            "topic": "Red",
            "description": "Prueba conectividad TCP a un puerto.",
            "example": "Test-NetConnection <host> -Port 443",
            "expected": "TcpTestSucceeded y datos de ruta/interfaz.",
            "note": ""
        },
        {
            "command": "Get-NetTCPConnection -State Listen | Sort-Object LocalPort",
            "level": "intermediate",
            "topic": "Red",
            "description": "Lista puertos TCP en escucha ordenados por puerto.",
            "example": "Get-NetTCPConnection -State Listen | Sort-Object LocalPort",
            "expected": "LocalAddress, LocalPort y OwningProcess ordenados.",
            "note": ""
        },
        {
            "command": "Resolve-DnsName <domain> -Type A",
            "level": "intermediate",
            "topic": "Red",
            "description": "Consulta registros A de DNS.",
            "example": "Resolve-DnsName <domain> -Type A",
            "expected": "Name, Type, TTL e IPAddress.",
            "note": ""
        },
        {
            "command": "Test-WSMan <computer>",
            "level": "basic",
            "topic": "Remoting",
            "description": "Comprueba WinRM remoto.",
            "example": "Test-WSMan <computer>",
            "expected": "Metadata WS-Management si responde.",
            "note": ""
        },
        {
            "command": "Enter-PSSession -ComputerName <computer>",
            "level": "intermediate",
            "topic": "Remoting",
            "description": "Abre una sesi\u00f3n PowerShell remota interactiva.",
            "example": "Enter-PSSession -ComputerName <computer>",
            "expected": "Prompt cambia al equipo remoto.",
            "note": "Requiere WinRM y autorizaci\u00f3n."
        },
        {
            "command": "Invoke-Command -ComputerName <computer> -ScriptBlock { Get-Service }",
            "level": "advanced",
            "topic": "Remoting",
            "description": "Ejecuta un bloque remoto.",
            "example": "Invoke-Command -ComputerName <computer> -ScriptBlock { Get-Service }",
            "expected": "Objetos serializados con PSComputerName.",
            "note": ""
        },
        {
            "command": "Get-Module -ListAvailable",
            "level": "basic",
            "topic": "M\u00f3dulos y paquetes",
            "description": "Lista m\u00f3dulos instalados disponibles.",
            "example": "Get-Module -ListAvailable",
            "expected": "Nombre, versi\u00f3n y ruta de m\u00f3dulos.",
            "note": ""
        },
        {
            "command": "Find-Module <name>",
            "level": "intermediate",
            "topic": "M\u00f3dulos y paquetes",
            "description": "Busca un m\u00f3dulo en repositorios configurados.",
            "example": "Find-Module <name>",
            "expected": "Metadata del m\u00f3dulo encontrado.",
            "note": ""
        },
        {
            "command": "Install-Module <name> -Scope CurrentUser",
            "level": "intermediate",
            "topic": "M\u00f3dulos y paquetes",
            "description": "Instala un m\u00f3dulo para el usuario actual.",
            "example": "Install-Module <name> -Scope CurrentUser",
            "expected": "Confirmaciones y luego m\u00f3dulo disponible.",
            "note": "Revis\u00e1 la confianza del repositorio y del paquete."
        },
        {
            "command": "Get-ComputerInfo",
            "level": "basic",
            "topic": "Sistema y registro",
            "description": "Muestra informaci\u00f3n extensa del equipo.",
            "example": "Get-ComputerInfo",
            "expected": "Objeto con SO, BIOS, hardware, hotfixes y m\u00e1s.",
            "note": ""
        },
        {
            "command": "Get-CimInstance Win32_OperatingSystem",
            "level": "intermediate",
            "topic": "Sistema y registro",
            "description": "Consulta el SO mediante CIM.",
            "example": "Get-CimInstance Win32_OperatingSystem",
            "expected": "Caption, Version, BuildNumber, memoria y uptime base.",
            "note": ""
        },
        {
            "command": "Get-ExecutionPolicy -List",
            "level": "basic",
            "topic": "Seguridad y credenciales",
            "description": "Muestra pol\u00edticas de ejecuci\u00f3n por scope.",
            "example": "Get-ExecutionPolicy -List",
            "expected": "Scope y ExecutionPolicy.",
            "note": ""
        },
        {
            "command": "Get-FileHash <file> -Algorithm SHA256",
            "level": "intermediate",
            "topic": "Seguridad y credenciales",
            "description": "Calcula SHA-256 de un archivo.",
            "example": "Get-FileHash <file> -Algorithm SHA256",
            "expected": "Algorithm, Hash y Path.",
            "note": ""
        },
        {
            "command": "Get-Command <name>",
            "level": "basic",
            "topic": "Scripting y jobs",
            "description": "Descubre un comando y su tipo.",
            "example": "Get-Command <name>",
            "expected": "CommandType, Name, Version y Source.",
            "note": ""
        },
        {
            "command": "Get-Help <cmdlet> -Examples",
            "level": "basic",
            "topic": "Scripting y jobs",
            "description": "Muestra ejemplos oficiales del cmdlet.",
            "example": "Get-Help <cmdlet> -Examples",
            "expected": "Ejemplos de uso en consola.",
            "note": ""
        },
        {
            "command": "Start-Job -ScriptBlock { <command> }",
            "level": "intermediate",
            "topic": "Scripting y jobs",
            "description": "Ejecuta un job en background.",
            "example": "Start-Job -ScriptBlock { <command> }",
            "expected": "Objeto Job con Id, State y HasMoreData.",
            "note": ""
        },
        {
            "command": "Receive-Job -Id <id> -Keep",
            "level": "intermediate",
            "topic": "Scripting y jobs",
            "description": "Lee la salida de un job sin descartarla.",
            "example": "Receive-Job -Id <id> -Keep",
            "expected": "Salida producida por el job.",
            "note": ""
        },
        {
            "command": "Register-ScheduledTask -TaskName <name> -Action <action> -Trigger <trigger>",
            "level": "advanced",
            "topic": "Scripting y jobs",
            "description": "Registra una tarea programada.",
            "example": "Register-ScheduledTask -TaskName <name> -Action <action> -Trigger <trigger>",
            "expected": "Objeto ScheduledTask.",
            "note": "Cre\u00e1 Action y Trigger previamente y revis\u00e1 privilegios."
        }
    ],
    "wsl": [
        {
            "command": "wsl --list --online",
            "level": "basic",
            "topic": "Instalaci\u00f3n y distribuciones",
            "description": "Lista distribuciones disponibles para instalar.",
            "example": "wsl --list --online",
            "expected": "Tabla NAME y FRIENDLY NAME.",
            "note": ""
        },
        {
            "command": "wsl --install -d Ubuntu",
            "level": "basic",
            "topic": "Instalaci\u00f3n y distribuciones",
            "description": "Instala Ubuntu en WSL.",
            "example": "wsl --install -d Ubuntu",
            "expected": "Progreso de descarga/instalaci\u00f3n y solicitud de reinicio si aplica.",
            "note": ""
        },
        {
            "command": "wsl --list --verbose",
            "level": "basic",
            "topic": "Instalaci\u00f3n y distribuciones",
            "description": "Lista distribuciones, estado y versi\u00f3n WSL.",
            "example": "wsl --list --verbose",
            "expected": "NAME, STATE y VERSION.",
            "note": ""
        },
        {
            "command": "wsl --set-default <distro>",
            "level": "intermediate",
            "topic": "Instalaci\u00f3n y distribuciones",
            "description": "Define la distribuci\u00f3n predeterminada.",
            "example": "wsl --set-default <distro>",
            "expected": "Sin salida si se aplica correctamente.",
            "note": ""
        },
        {
            "command": "wsl --set-version <distro> 2",
            "level": "intermediate",
            "topic": "Instalaci\u00f3n y distribuciones",
            "description": "Convierte una distro a WSL 2.",
            "example": "wsl --set-version <distro> 2",
            "expected": "Progreso de conversi\u00f3n y confirmaci\u00f3n.",
            "note": ""
        },
        {
            "command": "wsl --export <distro> <backup.tar>",
            "level": "intermediate",
            "topic": "Importar y exportar",
            "description": "Exporta una distro a TAR.",
            "example": "wsl --export <distro> <backup.tar>",
            "expected": "Progreso y archivo TAR resultante.",
            "note": ""
        },
        {
            "command": "wsl --import <distro> <install-dir> <backup.tar> --version 2",
            "level": "intermediate",
            "topic": "Importar y exportar",
            "description": "Importa una distro desde backup.",
            "example": "wsl --import <distro> <install-dir> <backup.tar> --version 2",
            "expected": "Nueva distro registrada.",
            "note": ""
        },
        {
            "command": "wsl --import-in-place <distro> <ext4.vhdx>",
            "level": "advanced",
            "topic": "Importar y exportar",
            "description": "Registra un VHDX existente como distro.",
            "example": "wsl --import-in-place <distro> <ext4.vhdx>",
            "expected": "Distro disponible en wsl -l -v.",
            "note": "Usalo con un VHDX compatible y backup previo."
        },
        {
            "command": "wsl -d <distro>",
            "level": "basic",
            "topic": "Ejecuci\u00f3n e integraci\u00f3n",
            "description": "Abre la distribuci\u00f3n indicada.",
            "example": "wsl -d <distro>",
            "expected": "Shell interactiva de esa distro.",
            "note": ""
        },
        {
            "command": "wsl -d <distro> -- <command>",
            "level": "basic",
            "topic": "Ejecuci\u00f3n e integraci\u00f3n",
            "description": "Ejecuta un comando Linux desde Windows.",
            "example": "wsl -d <distro> -- <command>",
            "expected": "Salida del comando Linux en la terminal actual.",
            "note": ""
        },
        {
            "command": "wsl --user <user>",
            "level": "intermediate",
            "topic": "Ejecuci\u00f3n e integraci\u00f3n",
            "description": "Inicia WSL con un usuario concreto.",
            "example": "wsl --user <user>",
            "expected": "Shell usando el usuario indicado.",
            "note": ""
        },
        {
            "command": "wslpath -w /home/<user>/<file>",
            "level": "intermediate",
            "topic": "Ejecuci\u00f3n e integraci\u00f3n",
            "description": "Convierte una ruta Linux a formato Windows.",
            "example": "wslpath -w /home/<user>/<file>",
            "expected": "Ruta Windows equivalente.",
            "note": ""
        },
        {
            "command": "wsl --status",
            "level": "basic",
            "topic": "Sistema y diagn\u00f3stico",
            "description": "Muestra configuraci\u00f3n global de WSL.",
            "example": "wsl --status",
            "expected": "Default distro, kernel y versi\u00f3n predeterminada.",
            "note": ""
        },
        {
            "command": "wsl --version",
            "level": "basic",
            "topic": "Sistema y diagn\u00f3stico",
            "description": "Muestra versiones de WSL y componentes.",
            "example": "wsl --version",
            "expected": "WSL, kernel, WSLg y componentes.",
            "note": ""
        },
        {
            "command": "wsl --update",
            "level": "intermediate",
            "topic": "Sistema y diagn\u00f3stico",
            "description": "Actualiza WSL.",
            "example": "wsl --update",
            "expected": "Progreso y versi\u00f3n instalada.",
            "note": ""
        },
        {
            "command": "wsl --shutdown",
            "level": "intermediate",
            "topic": "Sistema y diagn\u00f3stico",
            "description": "Apaga todas las VMs ligeras de WSL.",
            "example": "wsl --shutdown",
            "expected": "Sin salida; distros quedan detenidas.",
            "note": ""
        },
        {
            "command": "wsl --terminate <distro>",
            "level": "intermediate",
            "topic": "Sistema y diagn\u00f3stico",
            "description": "Detiene una distro puntual.",
            "example": "wsl --terminate <distro>",
            "expected": "Sin salida si se detiene.",
            "note": ""
        },
        {
            "command": "wsl --debug-shell",
            "level": "advanced",
            "topic": "Sistema y diagn\u00f3stico",
            "description": "Abre una shell de diagn\u00f3stico del sistema WSL.",
            "example": "wsl --debug-shell",
            "expected": "Shell del entorno de diagn\u00f3stico.",
            "note": "Usalo solo para troubleshooting avanzado."
        },
        {
            "command": "wsl -l -q",
            "level": "basic",
            "topic": "Distribuciones",
            "description": "Lista s\u00f3lo los nombres de distribuciones instaladas.",
            "example": "wsl -l -q",
            "expected": "Un nombre de distribuci\u00f3n por l\u00ednea.",
            "note": ""
        },
        {
            "command": "wsl --set-default-version 2",
            "level": "intermediate",
            "topic": "Distribuciones",
            "description": "Define WSL 2 como versi\u00f3n por defecto para nuevas distros.",
            "example": "wsl --set-default-version 2",
            "expected": "Confirmaci\u00f3n del cambio de configuraci\u00f3n.",
            "note": ""
        },
        {
            "command": "wsl --unregister <distro>",
            "level": "intermediate",
            "topic": "Distribuciones",
            "description": "Elimina una distribuci\u00f3n y todos sus datos.",
            "example": "wsl --unregister <distro>",
            "expected": "Confirmaci\u00f3n o retorno silencioso.",
            "note": "Es destructivo; export\u00e1 un backup antes si necesit\u00e1s conservar datos."
        },
        {
            "command": "wsl --cd ~",
            "level": "basic",
            "topic": "Ejecuci\u00f3n",
            "description": "Abre WSL directamente en el home Linux.",
            "example": "wsl --cd ~",
            "expected": "Shell interactiva posicionada en ~.",
            "note": ""
        },
        {
            "command": "wsl --cd <path>",
            "level": "intermediate",
            "topic": "Ejecuci\u00f3n",
            "description": "Abre WSL usando un directorio de trabajo espec\u00edfico.",
            "example": "wsl --cd <path>",
            "expected": "Shell en la ruta solicitada.",
            "note": ""
        },
        {
            "command": "wsl --system",
            "level": "intermediate",
            "topic": "Sistema",
            "description": "Abre una shell de la distribuci\u00f3n de sistema de WSL.",
            "example": "wsl --system",
            "expected": "Shell del entorno de sistema de WSL; requiere soporte de la versi\u00f3n instalada.",
            "note": ""
        },
        {
            "command": "wsl --mount <disk>",
            "level": "advanced",
            "topic": "Discos",
            "description": "Adjunta un disco f\u00edsico a WSL.",
            "example": "wsl --mount <disk>",
            "expected": "El disco queda disponible para montar dentro de WSL.",
            "note": "Requiere privilegios de administrador y una ruta de disco v\u00e1lida."
        },
        {
            "command": "wsl --unmount <disk>",
            "level": "advanced",
            "topic": "Discos",
            "description": "Desmonta un disco previamente adjuntado a WSL.",
            "example": "wsl --unmount <disk>",
            "expected": "El disco se desacopla de WSL.",
            "note": ""
        }
    ],
    "npm": [
        {
            "command": "npm run",
            "level": "basic",
            "topic": "Proyecto y scripts",
            "description": "Lista scripts definidos en package.json.",
            "example": "npm run",
            "expected": "Listado de lifecycle y scripts disponibles.",
            "note": ""
        },
        {
            "command": "npm run <script> -- --flag",
            "level": "basic",
            "topic": "Proyecto y scripts",
            "description": "Ejecuta un script pasando argumentos al comando interno.",
            "example": "npm run <script> -- --flag",
            "expected": "Salida del script con el flag recibido.",
            "note": ""
        },
        {
            "command": "npm pkg get scripts",
            "level": "intermediate",
            "topic": "Proyecto y scripts",
            "description": "Lee el objeto scripts desde package.json.",
            "example": "npm pkg get scripts",
            "expected": "JSON con scripts configurados.",
            "note": ""
        },
        {
            "command": "npm pkg set scripts.dev=\"vite\"",
            "level": "intermediate",
            "topic": "Proyecto y scripts",
            "description": "Agrega o modifica un script en package.json.",
            "example": "npm pkg set scripts.dev=\"vite\"",
            "expected": "Sin salida; package.json queda actualizado.",
            "note": ""
        },
        {
            "command": "npm ls --depth=0",
            "level": "basic",
            "topic": "Dependencias",
            "description": "Lista dependencias directas instaladas.",
            "example": "npm ls --depth=0",
            "expected": "Arbol de dependencias de primer nivel.",
            "note": ""
        },
        {
            "command": "npm explain <package>",
            "level": "intermediate",
            "topic": "Dependencias",
            "description": "Explica por qu\u00e9 est\u00e1 instalado un paquete.",
            "example": "npm explain <package>",
            "expected": "Cadena de dependencias que lo requiere.",
            "note": ""
        },
        {
            "command": "npm dedupe",
            "level": "intermediate",
            "topic": "Dependencias",
            "description": "Reduce duplicados en node_modules cuando es posible.",
            "example": "npm dedupe",
            "expected": "Resumen de cambios/auditor\u00eda.",
            "note": ""
        },
        {
            "command": "npm prune --omit=dev",
            "level": "intermediate",
            "topic": "Dependencias",
            "description": "Elimina paquetes no necesarios y omite devDependencies.",
            "example": "npm prune --omit=dev",
            "expected": "Resumen de paquetes removidos y auditados.",
            "note": "Pensado para instalaciones de producci\u00f3n."
        },
        {
            "command": "npm audit",
            "level": "basic",
            "topic": "Auditor\u00eda y calidad",
            "description": "Analiza vulnerabilidades conocidas.",
            "example": "npm audit",
            "expected": "Resumen por severidad y dependencias afectadas.",
            "note": ""
        },
        {
            "command": "npm audit fix",
            "level": "intermediate",
            "topic": "Auditor\u00eda y calidad",
            "description": "Aplica upgrades compatibles para resolver vulnerabilidades.",
            "example": "npm audit fix",
            "expected": "Paquetes cambiados y reporte restante.",
            "note": "Revis\u00e1 tests y lockfile despu\u00e9s."
        },
        {
            "command": "npm audit fix --force",
            "level": "advanced",
            "topic": "Auditor\u00eda y calidad",
            "description": "Permite upgrades mayores para intentar corregir vulnerabilidades.",
            "example": "npm audit fix --force",
            "expected": "Cambios potencialmente breaking y reporte.",
            "note": "Puede romper compatibilidad; usalo solo con revisi\u00f3n y tests."
        },
        {
            "command": "npm config get registry",
            "level": "basic",
            "topic": "Configuraci\u00f3n y cache",
            "description": "Muestra el registry activo.",
            "example": "npm config get registry",
            "expected": "URL del registry.",
            "note": ""
        },
        {
            "command": "npm config list -l",
            "level": "intermediate",
            "topic": "Configuraci\u00f3n y cache",
            "description": "Lista configuraci\u00f3n efectiva extendida.",
            "example": "npm config list -l",
            "expected": "Claves npm con origen/valor.",
            "note": ""
        },
        {
            "command": "npm cache verify",
            "level": "intermediate",
            "topic": "Configuraci\u00f3n y cache",
            "description": "Verifica integridad y compacta cache.",
            "example": "npm cache verify",
            "expected": "Resumen de contenido verificado.",
            "note": ""
        },
        {
            "command": "npm view <package> version",
            "level": "basic",
            "topic": "Registry y publicaci\u00f3n",
            "description": "Consulta la versi\u00f3n publicada m\u00e1s reciente.",
            "example": "npm view <package> version",
            "expected": "N\u00famero de versi\u00f3n.",
            "note": ""
        },
        {
            "command": "npm pack",
            "level": "intermediate",
            "topic": "Registry y publicaci\u00f3n",
            "description": "Genera el tarball que se publicar\u00eda.",
            "example": "npm pack",
            "expected": "Nombre del .tgz y resumen de contenido.",
            "note": ""
        },
        {
            "command": "npm publish --dry-run",
            "level": "intermediate",
            "topic": "Registry y publicaci\u00f3n",
            "description": "Simula una publicaci\u00f3n sin subirla.",
            "example": "npm publish --dry-run",
            "expected": "Contenido, tama\u00f1o y metadata del paquete.",
            "note": ""
        },
        {
            "command": "npm dist-tag add <package>@<version> <tag>",
            "level": "advanced",
            "topic": "Registry y publicaci\u00f3n",
            "description": "Asocia un dist-tag a una versi\u00f3n publicada.",
            "example": "npm dist-tag add <package>@<version> <tag>",
            "expected": "Sin salida o confirmaci\u00f3n.",
            "note": "Modifica metadata p\u00fablica del paquete."
        },
        {
            "command": "npm version patch",
            "level": "intermediate",
            "topic": "Versiones y workspaces",
            "description": "Incrementa patch, crea commit y tag por defecto.",
            "example": "npm version patch",
            "expected": "Nueva versi\u00f3n como vX.Y.Z.",
            "note": "Requiere working tree limpio salvo configuraci\u00f3n contraria."
        },
        {
            "command": "npm workspaces list",
            "level": "intermediate",
            "topic": "Versiones y workspaces",
            "description": "Lista workspaces del proyecto.",
            "example": "npm workspaces list",
            "expected": "Nombres/rutas de workspaces.",
            "note": ""
        },
        {
            "command": "npm query ':attr(workspace)'",
            "level": "advanced",
            "topic": "Versiones y workspaces",
            "description": "Consulta dependencias usando selectores npm.",
            "example": "npm query ':attr(workspace)'",
            "expected": "JSON con nodos que coinciden.",
            "note": ""
        }
    ],
    "yarn": [
        {
            "command": "yarn --version",
            "level": "basic",
            "topic": "Proyecto y scripts",
            "description": "Muestra la versi\u00f3n de Yarn.",
            "example": "yarn --version",
            "expected": "N\u00famero de versi\u00f3n.",
            "note": ""
        },
        {
            "command": "yarn run",
            "level": "basic",
            "topic": "Proyecto y scripts",
            "description": "Lista scripts disponibles.",
            "example": "yarn run",
            "expected": "Scripts definidos en package.json.",
            "note": ""
        },
        {
            "command": "yarn dlx <package> <args>",
            "level": "intermediate",
            "topic": "Proyecto y scripts",
            "description": "Ejecuta temporalmente un paquete sin agregarlo al proyecto.",
            "example": "yarn dlx <package> <args>",
            "expected": "Salida del ejecutable descargado.",
            "note": ""
        },
        {
            "command": "yarn add <package>",
            "level": "basic",
            "topic": "Dependencias",
            "description": "Agrega una dependencia.",
            "example": "yarn add <package>",
            "expected": "Lockfile y manifiesto actualizados.",
            "note": ""
        },
        {
            "command": "yarn remove <package>",
            "level": "basic",
            "topic": "Dependencias",
            "description": "Elimina una dependencia.",
            "example": "yarn remove <package>",
            "expected": "package.json y lockfile actualizados.",
            "note": ""
        },
        {
            "command": "yarn up <package>",
            "level": "intermediate",
            "topic": "Dependencias",
            "description": "Actualiza un paquete seg\u00fan rangos/resoluci\u00f3n de Yarn.",
            "example": "yarn up <package>",
            "expected": "Resoluci\u00f3n y lockfile actualizados.",
            "note": ""
        },
        {
            "command": "yarn why <package>",
            "level": "intermediate",
            "topic": "Dependencias",
            "description": "Explica qu\u00e9 workspace/dependencia requiere un paquete.",
            "example": "yarn why <package>",
            "expected": "Cadenas de dependencia y tama\u00f1os cuando aplica.",
            "note": ""
        },
        {
            "command": "yarn dedupe --check",
            "level": "advanced",
            "topic": "Dependencias",
            "description": "Comprueba si el lockfile puede deduplicarse.",
            "example": "yarn dedupe --check",
            "expected": "Exit code distinto de 0 si encuentra duplicados.",
            "note": ""
        },
        {
            "command": "yarn workspaces list",
            "level": "basic",
            "topic": "Workspaces",
            "description": "Lista workspaces.",
            "example": "yarn workspaces list",
            "expected": "Nombre y ubicaci\u00f3n de cada workspace.",
            "note": ""
        },
        {
            "command": "yarn workspace <name> <command>",
            "level": "intermediate",
            "topic": "Workspaces",
            "description": "Ejecuta un comando dentro de un workspace.",
            "example": "yarn workspace <name> <command>",
            "expected": "Salida del comando en ese workspace.",
            "note": ""
        },
        {
            "command": "yarn workspaces foreach -A run build",
            "level": "advanced",
            "topic": "Workspaces",
            "description": "Ejecuta build en todos los workspaces.",
            "example": "yarn workspaces foreach -A run build",
            "expected": "Salida por workspace.",
            "note": "Revis\u00e1 dependencias entre workspaces y paralelismo."
        },
        {
            "command": "yarn config get nodeLinker",
            "level": "basic",
            "topic": "Configuraci\u00f3n y cache",
            "description": "Muestra el node linker configurado.",
            "example": "yarn config get nodeLinker",
            "expected": "pnp, node-modules u otro valor.",
            "note": ""
        },
        {
            "command": "yarn config set nodeLinker node-modules",
            "level": "intermediate",
            "topic": "Configuraci\u00f3n y cache",
            "description": "Configura node_modules en vez de PnP.",
            "example": "yarn config set nodeLinker node-modules",
            "expected": "Configuraci\u00f3n persistida en .yarnrc.yml.",
            "note": ""
        },
        {
            "command": "yarn cache clean",
            "level": "intermediate",
            "topic": "Configuraci\u00f3n y cache",
            "description": "Limpia cache local de Yarn.",
            "example": "yarn cache clean",
            "expected": "Confirmaci\u00f3n/progreso de limpieza.",
            "note": ""
        },
        {
            "command": "yarn npm info <package>",
            "level": "intermediate",
            "topic": "Publicaci\u00f3n y versi\u00f3n",
            "description": "Consulta metadata del paquete en npm.",
            "example": "yarn npm info <package>",
            "expected": "Metadata publicada del paquete.",
            "note": ""
        },
        {
            "command": "yarn npm publish --dry-run",
            "level": "intermediate",
            "topic": "Publicaci\u00f3n y versi\u00f3n",
            "description": "Simula la publicaci\u00f3n.",
            "example": "yarn npm publish --dry-run",
            "expected": "Contenido que se incluir\u00eda y metadata.",
            "note": ""
        },
        {
            "command": "yarn version check",
            "level": "advanced",
            "topic": "Publicaci\u00f3n y versi\u00f3n",
            "description": "Comprueba archivos de versionado en monorepos Yarn.",
            "example": "yarn version check",
            "expected": "Estado de releases pendientes.",
            "note": ""
        },
        {
            "command": "yarn version apply --all",
            "level": "advanced",
            "topic": "Publicaci\u00f3n y versi\u00f3n",
            "description": "Aplica versiones pendientes en todos los workspaces.",
            "example": "yarn version apply --all",
            "expected": "Manifiestos y archivos de versi\u00f3n actualizados.",
            "note": "Revis\u00e1 cambios antes de publicar."
        }
    ],
    "pnpm": [
        {
            "command": "pnpm --version",
            "level": "basic",
            "topic": "Proyecto y scripts",
            "description": "Muestra la versi\u00f3n de pnpm.",
            "example": "pnpm --version",
            "expected": "N\u00famero de versi\u00f3n.",
            "note": ""
        },
        {
            "command": "pnpm run",
            "level": "basic",
            "topic": "Proyecto y scripts",
            "description": "Lista scripts del proyecto.",
            "example": "pnpm run",
            "expected": "Scripts disponibles.",
            "note": ""
        },
        {
            "command": "pnpm dlx <package> <args>",
            "level": "intermediate",
            "topic": "Proyecto y scripts",
            "description": "Ejecuta un paquete temporalmente.",
            "example": "pnpm dlx <package> <args>",
            "expected": "Salida del binario ejecutado.",
            "note": ""
        },
        {
            "command": "pnpm add <package>",
            "level": "basic",
            "topic": "Dependencias",
            "description": "Agrega dependencia usando el store de pnpm.",
            "example": "pnpm add <package>",
            "expected": "Manifiesto y lockfile actualizados.",
            "note": ""
        },
        {
            "command": "pnpm remove <package>",
            "level": "basic",
            "topic": "Dependencias",
            "description": "Elimina una dependencia.",
            "example": "pnpm remove <package>",
            "expected": "package.json y pnpm-lock.yaml actualizados.",
            "note": ""
        },
        {
            "command": "pnpm why <package>",
            "level": "intermediate",
            "topic": "Dependencias",
            "description": "Explica por qu\u00e9 est\u00e1 presente un paquete.",
            "example": "pnpm why <package>",
            "expected": "Rutas de dependencia.",
            "note": ""
        },
        {
            "command": "pnpm list --depth 0",
            "level": "intermediate",
            "topic": "Dependencias",
            "description": "Lista dependencias directas.",
            "example": "pnpm list --depth 0",
            "expected": "Arbol de primer nivel.",
            "note": ""
        },
        {
            "command": "pnpm outdated -r",
            "level": "intermediate",
            "topic": "Dependencias",
            "description": "Busca paquetes desactualizados recursivamente.",
            "example": "pnpm outdated -r",
            "expected": "Tabla Current, Wanted y Latest por workspace.",
            "note": ""
        },
        {
            "command": "pnpm -r run build",
            "level": "basic",
            "topic": "Workspaces",
            "description": "Ejecuta build en todos los workspaces.",
            "example": "pnpm -r run build",
            "expected": "Salida prefijada por paquete.",
            "note": ""
        },
        {
            "command": "pnpm --filter <selector> run test",
            "level": "intermediate",
            "topic": "Workspaces",
            "description": "Ejecuta test en workspaces filtrados.",
            "example": "pnpm --filter <selector> run test",
            "expected": "Salida solo de paquetes coincidentes.",
            "note": ""
        },
        {
            "command": "pnpm --filter '...[origin/main]' run test",
            "level": "advanced",
            "topic": "Workspaces",
            "description": "Ejecuta test en paquetes afectados desde una referencia Git.",
            "example": "pnpm --filter '...[origin/main]' run test",
            "expected": "Salida de workspaces impactados.",
            "note": "Requiere selector compatible con tu versi\u00f3n de pnpm."
        },
        {
            "command": "pnpm store path",
            "level": "basic",
            "topic": "Store y cache",
            "description": "Muestra la ruta del content-addressable store.",
            "example": "pnpm store path",
            "expected": "Ruta absoluta del store.",
            "note": ""
        },
        {
            "command": "pnpm store status",
            "level": "intermediate",
            "topic": "Store y cache",
            "description": "Comprueba paquetes modificados en el store.",
            "example": "pnpm store status",
            "expected": "Estado o lista de paquetes alterados.",
            "note": ""
        },
        {
            "command": "pnpm store prune",
            "level": "intermediate",
            "topic": "Store y cache",
            "description": "Elimina paquetes no referenciados del store.",
            "example": "pnpm store prune",
            "expected": "Resumen de contenido eliminado.",
            "note": ""
        },
        {
            "command": "pnpm config get registry",
            "level": "basic",
            "topic": "Publicaci\u00f3n y config",
            "description": "Muestra registry configurado.",
            "example": "pnpm config get registry",
            "expected": "URL del registry.",
            "note": ""
        },
        {
            "command": "pnpm pack",
            "level": "intermediate",
            "topic": "Publicaci\u00f3n y config",
            "description": "Crea tarball del paquete.",
            "example": "pnpm pack",
            "expected": "Nombre del archivo .tgz.",
            "note": ""
        },
        {
            "command": "pnpm publish --dry-run",
            "level": "intermediate",
            "topic": "Publicaci\u00f3n y config",
            "description": "Simula publicaci\u00f3n.",
            "example": "pnpm publish --dry-run",
            "expected": "Archivos y metadata que se publicar\u00edan.",
            "note": ""
        },
        {
            "command": "pnpm deploy --filter <app> <target-dir>",
            "level": "advanced",
            "topic": "Publicaci\u00f3n y config",
            "description": "Crea una versi\u00f3n deployable de un workspace.",
            "example": "pnpm deploy --filter <app> <target-dir>",
            "expected": "Directorio objetivo con dependencias necesarias.",
            "note": "Especialmente \u00fatil en monorepos; revis\u00e1 versi\u00f3n de pnpm."
        }
    ],
    "node": [
        {
            "command": "node --version",
            "level": "basic",
            "topic": "Runtime y ejecuci\u00f3n",
            "description": "Muestra la versi\u00f3n de Node.js.",
            "example": "node --version",
            "expected": "vX.Y.Z.",
            "note": ""
        },
        {
            "command": "node -e \"console.log(process.version)\"",
            "level": "basic",
            "topic": "Runtime y ejecuci\u00f3n",
            "description": "Ejecuta JavaScript inline.",
            "example": "node -e \"console.log(process.version)\"",
            "expected": "Versi\u00f3n de Node impresa.",
            "note": ""
        },
        {
            "command": "node --check <file.js>",
            "level": "basic",
            "topic": "Runtime y ejecuci\u00f3n",
            "description": "Valida sintaxis sin ejecutar el archivo.",
            "example": "node --check <file.js>",
            "expected": "Sin salida si es v\u00e1lido; error con l\u00ednea si falla.",
            "note": ""
        },
        {
            "command": "node --watch <file.js>",
            "level": "intermediate",
            "topic": "Runtime y ejecuci\u00f3n",
            "description": "Reinicia la ejecuci\u00f3n al cambiar archivos.",
            "example": "node --watch <file.js>",
            "expected": "Proceso activo y reinicios al detectar cambios.",
            "note": ""
        },
        {
            "command": "node --env-file=.env <file.js>",
            "level": "intermediate",
            "topic": "Runtime y ejecuci\u00f3n",
            "description": "Carga variables desde .env antes de ejecutar.",
            "example": "node --env-file=.env <file.js>",
            "expected": "Salida normal del script con variables disponibles.",
            "note": "Disponible en versiones modernas de Node."
        },
        {
            "command": "node --test",
            "level": "intermediate",
            "topic": "Runtime y ejecuci\u00f3n",
            "description": "Ejecuta tests del runner nativo.",
            "example": "node --test",
            "expected": "Resumen TAP/tests pasados y fallidos.",
            "note": ""
        },
        {
            "command": "node --inspect <file.js>",
            "level": "basic",
            "topic": "Depuraci\u00f3n y profiling",
            "description": "Activa inspector en el puerto por defecto.",
            "example": "node --inspect <file.js>",
            "expected": "URL ws:// para conectar DevTools.",
            "note": ""
        },
        {
            "command": "node --inspect-brk <file.js>",
            "level": "intermediate",
            "topic": "Depuraci\u00f3n y profiling",
            "description": "Pausa en la primera l\u00ednea esperando debugger.",
            "example": "node --inspect-brk <file.js>",
            "expected": "Inspector listening y proceso detenido.",
            "note": ""
        },
        {
            "command": "node --cpu-prof <file.js>",
            "level": "advanced",
            "topic": "Depuraci\u00f3n y profiling",
            "description": "Genera un perfil de CPU V8.",
            "example": "node --cpu-prof <file.js>",
            "expected": "Archivo .cpuprofile al terminar.",
            "note": ""
        },
        {
            "command": "node --heap-prof <file.js>",
            "level": "advanced",
            "topic": "Depuraci\u00f3n y profiling",
            "description": "Genera un perfil de heap.",
            "example": "node --heap-prof <file.js>",
            "expected": "Archivo .heapprofile al terminar.",
            "note": ""
        },
        {
            "command": "node --require <module> <file.js>",
            "level": "intermediate",
            "topic": "M\u00f3dulos y resoluci\u00f3n",
            "description": "Precarga un m\u00f3dulo CommonJS.",
            "example": "node --require <module> <file.js>",
            "expected": "Salida del script con el m\u00f3dulo cargado.",
            "note": ""
        },
        {
            "command": "node --import <module> <file.mjs>",
            "level": "intermediate",
            "topic": "M\u00f3dulos y resoluci\u00f3n",
            "description": "Precarga un m\u00f3dulo ESM.",
            "example": "node --import <module> <file.mjs>",
            "expected": "Salida normal con import previo.",
            "note": ""
        },
        {
            "command": "node --v8-options",
            "level": "intermediate",
            "topic": "Sistema y memoria",
            "description": "Lista opciones disponibles de V8.",
            "example": "node --v8-options",
            "expected": "Listado extenso de flags V8.",
            "note": ""
        },
        {
            "command": "node --max-old-space-size=4096 <file.js>",
            "level": "advanced",
            "topic": "Sistema y memoria",
            "description": "Fija aproximadamente 4 GB para old space de V8.",
            "example": "node --max-old-space-size=4096 <file.js>",
            "expected": "Proceso ejecutado con nuevo l\u00edmite de memoria.",
            "note": "No sustituye investigar fugas de memoria."
        },
        {
            "command": "node --report-on-fatalerror <file.js>",
            "level": "advanced",
            "topic": "Sistema y memoria",
            "description": "Genera diagnostic report ante error fatal.",
            "example": "node --report-on-fatalerror <file.js>",
            "expected": "Archivo JSON de diagn\u00f3stico si ocurre el fallo.",
            "note": ""
        },
        {
            "command": "corepack enable",
            "level": "basic",
            "topic": "Corepack y runners",
            "description": "Habilita shims de gestores compatibles.",
            "example": "corepack enable",
            "expected": "Sin salida o confirmaci\u00f3n.",
            "note": ""
        },
        {
            "command": "corepack prepare pnpm@latest --activate",
            "level": "intermediate",
            "topic": "Corepack y runners",
            "description": "Prepara y activa una versi\u00f3n de pnpm.",
            "example": "corepack prepare pnpm@latest --activate",
            "expected": "Descarga/preparaci\u00f3n del package manager.",
            "note": "La disponibilidad exacta depende de la versi\u00f3n de Node/Corepack."
        }
    ],
    "typescript": [
        {
            "command": "npx tsc --init",
            "level": "basic",
            "topic": "Proyecto y configuraci\u00f3n",
            "description": "Crea tsconfig.json inicial.",
            "example": "npx tsc --init",
            "expected": "Mensaje de archivo creado y opciones base.",
            "note": ""
        },
        {
            "command": "npx tsc --showConfig",
            "level": "basic",
            "topic": "Proyecto y configuraci\u00f3n",
            "description": "Muestra la configuraci\u00f3n efectiva.",
            "example": "npx tsc --showConfig",
            "expected": "JSON con compilerOptions y archivos.",
            "note": ""
        },
        {
            "command": "npx tsc -p <tsconfig.json>",
            "level": "intermediate",
            "topic": "Proyecto y configuraci\u00f3n",
            "description": "Compila usando un tsconfig puntual.",
            "example": "npx tsc -p <tsconfig.json>",
            "expected": "Sin salida si compila; diagn\u00f3sticos si falla.",
            "note": ""
        },
        {
            "command": "npx tsc --noEmit",
            "level": "basic",
            "topic": "Compilaci\u00f3n",
            "description": "Type-check sin generar JavaScript.",
            "example": "npx tsc --noEmit",
            "expected": "Sin salida si no hay errores.",
            "note": ""
        },
        {
            "command": "npx tsc --outDir dist",
            "level": "intermediate",
            "topic": "Compilaci\u00f3n",
            "description": "Compila enviando emit a dist.",
            "example": "npx tsc --outDir dist",
            "expected": "Archivos generados en dist.",
            "note": ""
        },
        {
            "command": "npx tsc --declaration --emitDeclarationOnly",
            "level": "intermediate",
            "topic": "Compilaci\u00f3n",
            "description": "Genera solo declaraciones .d.ts.",
            "example": "npx tsc --declaration --emitDeclarationOnly",
            "expected": "Archivos .d.ts.",
            "note": ""
        },
        {
            "command": "npx tsc --watch",
            "level": "basic",
            "topic": "Watch e incremental",
            "description": "Mantiene TypeScript observando cambios.",
            "example": "npx tsc --watch",
            "expected": "Compilaciones incrementales y diagn\u00f3sticos en vivo.",
            "note": ""
        },
        {
            "command": "npx tsc --incremental",
            "level": "intermediate",
            "topic": "Watch e incremental",
            "description": "Activa informaci\u00f3n incremental.",
            "example": "npx tsc --incremental",
            "expected": "Archivo tsbuildinfo y compilaci\u00f3n.",
            "note": ""
        },
        {
            "command": "npx tsc --build",
            "level": "intermediate",
            "topic": "Project references",
            "description": "Compila proyectos con references.",
            "example": "npx tsc --build",
            "expected": "Proyectos compilados en orden de dependencias.",
            "note": ""
        },
        {
            "command": "npx tsc --build --clean",
            "level": "intermediate",
            "topic": "Project references",
            "description": "Elimina outputs de proyectos compuestos.",
            "example": "npx tsc --build --clean",
            "expected": "Outputs generados previamente removidos.",
            "note": ""
        },
        {
            "command": "npx tsc --build --force",
            "level": "advanced",
            "topic": "Project references",
            "description": "Fuerza rebuild aunque parezca actualizado.",
            "example": "npx tsc --build --force",
            "expected": "Todos los proyectos vuelven a compilar.",
            "note": ""
        },
        {
            "command": "npx tsc --traceResolution",
            "level": "intermediate",
            "topic": "Diagn\u00f3stico",
            "description": "Explica resoluci\u00f3n de imports y tipos.",
            "example": "npx tsc --traceResolution",
            "expected": "Traza detallada de cada resoluci\u00f3n.",
            "note": ""
        },
        {
            "command": "npx tsc --extendedDiagnostics",
            "level": "intermediate",
            "topic": "Diagn\u00f3stico",
            "description": "Muestra tiempos y memoria del compilador.",
            "example": "npx tsc --extendedDiagnostics",
            "expected": "M\u00e9tricas de parse, check, emit y memoria.",
            "note": ""
        },
        {
            "command": "npx tsc --explainFiles",
            "level": "advanced",
            "topic": "Diagn\u00f3stico",
            "description": "Explica por qu\u00e9 cada archivo forma parte del programa.",
            "example": "npx tsc --explainFiles",
            "expected": "Motivos de inclusi\u00f3n por archivo.",
            "note": ""
        },
        {
            "command": "npx tsc --sourceMap",
            "level": "basic",
            "topic": "Compilaci\u00f3n",
            "description": "Compila generando source maps.",
            "example": "npx tsc --sourceMap",
            "expected": "Archivos JavaScript y sus .map seg\u00fan tsconfig.",
            "note": ""
        },
        {
            "command": "npx tsc --noEmitOnError",
            "level": "intermediate",
            "topic": "Compilaci\u00f3n",
            "description": "Evita emitir JS cuando existen errores de tipos.",
            "example": "npx tsc --noEmitOnError",
            "expected": "Errores de TypeScript y ning\u00fan archivo emitido si falla.",
            "note": ""
        },
        {
            "command": "npx tsc --removeComments",
            "level": "intermediate",
            "topic": "Compilaci\u00f3n",
            "description": "Compila eliminando comentarios del JavaScript emitido.",
            "example": "npx tsc --removeComments",
            "expected": "JS generado sin comentarios removibles.",
            "note": ""
        },
        {
            "command": "npx tsc --types node",
            "level": "intermediate",
            "topic": "Configuraci\u00f3n",
            "description": "Incluye expl\u00edcitamente tipos de Node en la compilaci\u00f3n.",
            "example": "npx tsc --types node",
            "expected": "Compilaci\u00f3n usando el paquete de tipos indicado.",
            "note": ""
        },
        {
            "command": "npx tsc --moduleResolution bundler",
            "level": "advanced",
            "topic": "Configuraci\u00f3n",
            "description": "Fuerza estrategia de resoluci\u00f3n orientada a bundlers.",
            "example": "npx tsc --moduleResolution bundler",
            "expected": "Diagn\u00f3sticos seg\u00fan esa estrategia y archivos emitidos si corresponde.",
            "note": ""
        },
        {
            "command": "npx tsc --listEmittedFiles",
            "level": "advanced",
            "topic": "Diagn\u00f3stico",
            "description": "Lista los archivos emitidos por el compilador.",
            "example": "npx tsc --listEmittedFiles",
            "expected": "L\u00edneas TSFILE con rutas de salida.",
            "note": ""
        },
        {
            "command": "npx tsc --listFilesOnly",
            "level": "advanced",
            "topic": "Diagn\u00f3stico",
            "description": "Lista archivos incluidos sin compilar.",
            "example": "npx tsc --listFilesOnly",
            "expected": "Rutas de todos los archivos que forman el programa.",
            "note": ""
        },
        {
            "command": "npx tsc -b --verbose",
            "level": "advanced",
            "topic": "Project references",
            "description": "Compila project references mostrando decisiones del build.",
            "example": "npx tsc -b --verbose",
            "expected": "Detalle de proyectos actualizados, omitidos o reconstruidos.",
            "note": ""
        },
        {
            "command": "npx tsc -b --dry",
            "level": "advanced",
            "topic": "Project references",
            "description": "Simula un build de project references.",
            "example": "npx tsc -b --dry",
            "expected": "Indica qu\u00e9 proyectos se compilar\u00edan sin emitir artefactos.",
            "note": ""
        }
    ],
    "react": [
        {
            "command": "npm create vite@latest <app> -- --template react",
            "level": "basic",
            "topic": "Scaffolding",
            "description": "Crea un proyecto React con Vite.",
            "example": "npm create vite@latest <app> -- --template react",
            "expected": "Asistente o carpeta del proyecto generada.",
            "note": ""
        },
        {
            "command": "npm create vite@latest <app> -- --template react-ts",
            "level": "basic",
            "topic": "Scaffolding",
            "description": "Crea React + TypeScript con Vite.",
            "example": "npm create vite@latest <app> -- --template react-ts",
            "expected": "Proyecto inicial con TS configurado.",
            "note": ""
        },
        {
            "command": "npm run dev",
            "level": "basic",
            "topic": "Desarrollo",
            "description": "Inicia el servidor de desarrollo definido por el proyecto.",
            "example": "npm run dev",
            "expected": "URL local y estado del dev server.",
            "note": ""
        },
        {
            "command": "npx vite --host 0.0.0.0",
            "level": "intermediate",
            "topic": "Desarrollo",
            "description": "Expone Vite en todas las interfaces.",
            "example": "npx vite --host 0.0.0.0",
            "expected": "URLs Local y Network.",
            "note": "No expongas un dev server a redes no confiables."
        },
        {
            "command": "npm run build",
            "level": "basic",
            "topic": "Build y preview",
            "description": "Ejecuta el build de produccion.",
            "example": "npm run build",
            "expected": "Bundle en el directorio configurado, habitualmente dist.",
            "note": ""
        },
        {
            "command": "npx vite preview",
            "level": "basic",
            "topic": "Build y preview",
            "description": "Sirve localmente el build para inspeccionarlo.",
            "example": "npx vite preview",
            "expected": "URL del servidor de preview.",
            "note": "No es un servidor de produccion."
        },
        {
            "command": "npx vite build --mode staging",
            "level": "intermediate",
            "topic": "Build y preview",
            "description": "Construye usando el modo staging.",
            "example": "npx vite build --mode staging",
            "expected": "Bundle con variables del modo seleccionado.",
            "note": ""
        },
        {
            "command": "npx vitest run",
            "level": "basic",
            "topic": "Testing y calidad",
            "description": "Ejecuta tests una vez.",
            "example": "npx vitest run",
            "expected": "Resumen de tests pasados/fallidos.",
            "note": ""
        },
        {
            "command": "npx vitest --coverage",
            "level": "intermediate",
            "topic": "Testing y calidad",
            "description": "Ejecuta tests con cobertura.",
            "example": "npx vitest --coverage",
            "expected": "Resumen y reporte de cobertura si el provider esta instalado.",
            "note": ""
        },
        {
            "command": "npx eslint src",
            "level": "basic",
            "topic": "Testing y calidad",
            "description": "Ejecuta ESLint sobre src.",
            "example": "npx eslint src",
            "expected": "Errores y warnings con archivo y linea.",
            "note": ""
        },
        {
            "command": "npx prettier --check \"src/**/*.{js,jsx,ts,tsx,css}\"",
            "level": "basic",
            "topic": "Testing y calidad",
            "description": "Comprueba formato sin modificar.",
            "example": "npx prettier --check \"src/**/*.{js,jsx,ts,tsx,css}\"",
            "expected": "Lista de archivos fuera de formato o confirmacion.",
            "note": ""
        },
        {
            "command": "npx prettier --write \"src/**/*.{js,jsx,ts,tsx,css}\"",
            "level": "intermediate",
            "topic": "Testing y calidad",
            "description": "Formatea archivos del frontend.",
            "example": "npx prettier --write \"src/**/*.{js,jsx,ts,tsx,css}\"",
            "expected": "Archivos procesados/modificados.",
            "note": ""
        },
        {
            "command": "npm install react-router-dom",
            "level": "basic",
            "topic": "Dependencias y tooling",
            "description": "Instala React Router.",
            "example": "npm install react-router-dom",
            "expected": "package.json y lockfile actualizados.",
            "note": ""
        },
        {
            "command": "npm install @tanstack/react-query",
            "level": "basic",
            "topic": "Dependencias y tooling",
            "description": "Instala TanStack Query.",
            "example": "npm install @tanstack/react-query",
            "expected": "Dependencia agregada.",
            "note": ""
        },
        {
            "command": "npx storybook@latest init",
            "level": "intermediate",
            "topic": "Dependencias y tooling",
            "description": "Inicializa Storybook.",
            "example": "npx storybook@latest init",
            "expected": "Archivos .storybook, scripts y dependencias.",
            "note": ""
        },
        {
            "command": "npm run build-storybook",
            "level": "intermediate",
            "topic": "Dependencias y tooling",
            "description": "Genera Storybook estatico.",
            "example": "npm run build-storybook",
            "expected": "Directorio de salida para deploy.",
            "note": ""
        },
        {
            "command": "npm install react react-dom",
            "level": "intermediate",
            "topic": "Dependencias y tooling",
            "description": "Instala las dependencias runtime principales de React.",
            "example": "npm install react react-dom",
            "expected": "package.json/package-lock actualizados y node_modules instalado.",
            "note": ""
        },
        {
            "command": "npx vitest --ui",
            "level": "intermediate",
            "topic": "Testing y calidad",
            "description": "Abre la interfaz de Vitest si @vitest/ui est\u00e1 instalada.",
            "example": "npx vitest --ui",
            "expected": "Servidor/UI de tests en el navegador.",
            "note": "Requiere @vitest/ui."
        }
    ],
    "react-native": [
        {
            "command": "npx @react-native-community/cli@latest init <app>",
            "level": "basic",
            "topic": "Proyecto y setup",
            "description": "Crea un proyecto React Native bare.",
            "example": "npx @react-native-community/cli@latest init <app>",
            "expected": "Carpeta del proyecto y dependencias base.",
            "note": ""
        },
        {
            "command": "npx create-expo-app@latest <app>",
            "level": "basic",
            "topic": "Proyecto y setup",
            "description": "Crea un proyecto Expo.",
            "example": "npx create-expo-app@latest <app>",
            "expected": "Proyecto inicial y dependencias.",
            "note": ""
        },
        {
            "command": "npx expo install <package>",
            "level": "basic",
            "topic": "Proyecto y setup",
            "description": "Instala una version compatible con el SDK Expo.",
            "example": "npx expo install <package>",
            "expected": "Dependencia compatible agregada.",
            "note": ""
        },
        {
            "command": "npx react-native start",
            "level": "basic",
            "topic": "Metro y desarrollo",
            "description": "Inicia Metro bundler.",
            "example": "npx react-native start",
            "expected": "Metro escuchando y menu de comandos.",
            "note": ""
        },
        {
            "command": "npx react-native start --reset-cache",
            "level": "intermediate",
            "topic": "Metro y desarrollo",
            "description": "Reinicia Metro limpiando cache.",
            "example": "npx react-native start --reset-cache",
            "expected": "Cache reconstruida y Metro activo.",
            "note": ""
        },
        {
            "command": "npx expo start",
            "level": "basic",
            "topic": "Metro y desarrollo",
            "description": "Inicia Expo dev server.",
            "example": "npx expo start",
            "expected": "QR, URL y opciones de plataforma.",
            "note": ""
        },
        {
            "command": "npx expo start --tunnel",
            "level": "intermediate",
            "topic": "Metro y desarrollo",
            "description": "Expone el dev server mediante tunel.",
            "example": "npx expo start --tunnel",
            "expected": "URL/QR accesible externamente.",
            "note": "Puede ser mas lento que LAN/local."
        },
        {
            "command": "npx react-native run-android",
            "level": "basic",
            "topic": "Android",
            "description": "Compila, instala y abre la app en Android.",
            "example": "npx react-native run-android",
            "expected": "Logs de Gradle, instalacion y Metro.",
            "note": ""
        },
        {
            "command": "npx expo run:android",
            "level": "basic",
            "topic": "Android",
            "description": "Genera/compila proyecto nativo Android con Expo.",
            "example": "npx expo run:android",
            "expected": "Build Gradle e instalacion.",
            "note": ""
        },
        {
            "command": "cd android && ./gradlew assembleDebug",
            "level": "intermediate",
            "topic": "Android",
            "description": "Genera APK debug.",
            "example": "cd android && ./gradlew assembleDebug",
            "expected": "APK bajo android/app/build/outputs/apk/debug.",
            "note": ""
        },
        {
            "command": "cd android && ./gradlew bundleRelease",
            "level": "intermediate",
            "topic": "Android",
            "description": "Genera Android App Bundle release.",
            "example": "cd android && ./gradlew bundleRelease",
            "expected": "AAB en outputs/bundle/release.",
            "note": "Requiere signing/config de release correcto."
        },
        {
            "command": "npx react-native run-ios",
            "level": "basic",
            "topic": "iOS",
            "description": "Compila y ejecuta en simulador iOS.",
            "example": "npx react-native run-ios",
            "expected": "Logs de xcodebuild y app lanzada.",
            "note": ""
        },
        {
            "command": "npx expo run:ios",
            "level": "basic",
            "topic": "iOS",
            "description": "Genera/compila el proyecto nativo iOS.",
            "example": "npx expo run:ios",
            "expected": "Build Xcode y simulador/dispositivo.",
            "note": ""
        },
        {
            "command": "cd ios && pod install",
            "level": "intermediate",
            "topic": "iOS",
            "description": "Instala pods CocoaPods.",
            "example": "cd ios && pod install",
            "expected": "Pods instalados y workspace actualizado.",
            "note": ""
        },
        {
            "command": "eas login",
            "level": "basic",
            "topic": "EAS build y submit",
            "description": "Autentica EAS CLI.",
            "example": "eas login",
            "expected": "Cuenta autenticada.",
            "note": ""
        },
        {
            "command": "eas build:configure",
            "level": "basic",
            "topic": "EAS build y submit",
            "description": "Genera configuracion inicial de EAS Build.",
            "example": "eas build:configure",
            "expected": "eas.json creado/actualizado.",
            "note": ""
        },
        {
            "command": "eas build --platform android --profile production",
            "level": "intermediate",
            "topic": "EAS build y submit",
            "description": "Lanza build Android remoto.",
            "example": "eas build --platform android --profile production",
            "expected": "URL/ID del build y estado en EAS.",
            "note": ""
        },
        {
            "command": "eas build --platform ios --profile production",
            "level": "intermediate",
            "topic": "EAS build y submit",
            "description": "Lanza build iOS remoto.",
            "example": "eas build --platform ios --profile production",
            "expected": "URL/ID del build.",
            "note": ""
        },
        {
            "command": "eas submit --platform android",
            "level": "intermediate",
            "topic": "EAS build y submit",
            "description": "Envia un build Android a la store configurada.",
            "example": "eas submit --platform android",
            "expected": "Submission ID y estado.",
            "note": "Requiere credenciales de store."
        },
        {
            "command": "eas update --branch production --message \"hotfix\"",
            "level": "advanced",
            "topic": "EAS build y submit",
            "description": "Publica una actualizacion OTA.",
            "example": "eas update --branch production --message \"hotfix\"",
            "expected": "Update group/ID y branch.",
            "note": "Solo aplica a cambios compatibles con el runtime instalado."
        },
        {
            "command": "npx react-native doctor",
            "level": "basic",
            "topic": "Diagnostico",
            "description": "Verifica toolchain React Native.",
            "example": "npx react-native doctor",
            "expected": "Checks de Node, Android, Xcode y dependencias.",
            "note": ""
        },
        {
            "command": "npx expo-doctor",
            "level": "basic",
            "topic": "Diagnostico",
            "description": "Analiza compatibilidad y configuracion Expo.",
            "example": "npx expo-doctor",
            "expected": "Checks y recomendaciones.",
            "note": ""
        }
    ],
    "nest": [
        {
            "command": "nest new <app>",
            "level": "basic",
            "topic": "Proyecto y generacion",
            "description": "Crea un proyecto NestJS.",
            "example": "nest new <app>",
            "expected": "Proyecto generado y dependencias instaladas segun opcion.",
            "note": ""
        },
        {
            "command": "nest g module <name>",
            "level": "basic",
            "topic": "Proyecto y generacion",
            "description": "Genera un modulo.",
            "example": "nest g module <name>",
            "expected": "Archivo .module.ts y actualizacion de imports cuando aplica.",
            "note": ""
        },
        {
            "command": "nest g controller <name>",
            "level": "basic",
            "topic": "Proyecto y generacion",
            "description": "Genera un controller.",
            "example": "nest g controller <name>",
            "expected": "Controller y spec segun configuracion.",
            "note": ""
        },
        {
            "command": "nest g service <name>",
            "level": "basic",
            "topic": "Proyecto y generacion",
            "description": "Genera un service.",
            "example": "nest g service <name>",
            "expected": "Service y spec.",
            "note": ""
        },
        {
            "command": "nest g resource <name>",
            "level": "intermediate",
            "topic": "Proyecto y generacion",
            "description": "Genera recurso CRUD guiado.",
            "example": "nest g resource <name>",
            "expected": "Modulo, controller, service, DTOs/entities segun respuestas.",
            "note": ""
        },
        {
            "command": "nest g guard <name>",
            "level": "intermediate",
            "topic": "Proyecto y generacion",
            "description": "Genera un guard.",
            "example": "nest g guard <name>",
            "expected": "Archivo .guard.ts y spec.",
            "note": ""
        },
        {
            "command": "nest g interceptor <name>",
            "level": "intermediate",
            "topic": "Proyecto y generacion",
            "description": "Genera interceptor.",
            "example": "nest g interceptor <name>",
            "expected": "Archivo .interceptor.ts.",
            "note": ""
        },
        {
            "command": "nest g pipe <name>",
            "level": "intermediate",
            "topic": "Proyecto y generacion",
            "description": "Genera pipe.",
            "example": "nest g pipe <name>",
            "expected": "Archivo .pipe.ts.",
            "note": ""
        },
        {
            "command": "nest g decorator <name>",
            "level": "intermediate",
            "topic": "Proyecto y generacion",
            "description": "Genera decorator custom.",
            "example": "nest g decorator <name>",
            "expected": "Archivo .decorator.ts.",
            "note": ""
        },
        {
            "command": "nest start --watch",
            "level": "basic",
            "topic": "Desarrollo y build",
            "description": "Inicia Nest recompilando al cambiar archivos.",
            "example": "nest start --watch",
            "expected": "Servidor activo y reinicios automaticos.",
            "note": ""
        },
        {
            "command": "nest start --debug --watch",
            "level": "intermediate",
            "topic": "Desarrollo y build",
            "description": "Inicia con inspector/debug.",
            "example": "nest start --debug --watch",
            "expected": "Puerto de inspector y servidor activo.",
            "note": ""
        },
        {
            "command": "nest build",
            "level": "basic",
            "topic": "Desarrollo y build",
            "description": "Compila TypeScript segun nest-cli.",
            "example": "nest build",
            "expected": "Salida en dist o configuracion equivalente.",
            "note": ""
        },
        {
            "command": "nest g app <name>",
            "level": "intermediate",
            "topic": "Monorepo y librerias",
            "description": "Agrega una aplicacion a un workspace monorepo.",
            "example": "nest g app <name>",
            "expected": "Nuevo proyecto en apps/ o configuracion equivalente.",
            "note": ""
        },
        {
            "command": "nest g library <name>",
            "level": "intermediate",
            "topic": "Monorepo y librerias",
            "description": "Crea una libreria de Nest.",
            "example": "nest g library <name>",
            "expected": "Proyecto de libreria y paths configurados.",
            "note": ""
        },
        {
            "command": "nest info",
            "level": "basic",
            "topic": "Info y mantenimiento",
            "description": "Muestra versiones de Nest, Node y plataforma.",
            "example": "nest info",
            "expected": "Tabla de versiones del entorno.",
            "note": ""
        },
        {
            "command": "nest add <library>",
            "level": "intermediate",
            "topic": "Info y mantenimiento",
            "description": "Instala/configura una libreria compatible con schematics.",
            "example": "nest add <library>",
            "expected": "Cambios del schematic y dependencias.",
            "note": ""
        },
        {
            "command": "npm test",
            "level": "basic",
            "topic": "Testing y scripts",
            "description": "Ejecuta tests unitarios definidos por el proyecto.",
            "example": "npm test",
            "expected": "Resumen Jest u otro runner.",
            "note": ""
        },
        {
            "command": "npm run test:e2e",
            "level": "intermediate",
            "topic": "Testing y scripts",
            "description": "Ejecuta tests end-to-end.",
            "example": "npm run test:e2e",
            "expected": "Resumen de suites E2E.",
            "note": ""
        },
        {
            "command": "npm run test:cov",
            "level": "intermediate",
            "topic": "Testing y scripts",
            "description": "Ejecuta tests con cobertura.",
            "example": "npm run test:cov",
            "expected": "Reporte de coverage.",
            "note": ""
        },
        {
            "command": "npm run lint",
            "level": "intermediate",
            "topic": "Testing y scripts",
            "description": "Ejecuta el linter del proyecto.",
            "example": "npm run lint",
            "expected": "Errores/warnings o confirmacion limpia.",
            "note": ""
        }
    ],
    "docker": [
        {
            "command": "docker ps -a",
            "level": "basic",
            "topic": "Contenedores",
            "description": "Lista contenedores activos y detenidos.",
            "example": "docker ps -a",
            "expected": "ID, imagen, comando, estado, puertos y nombre.",
            "note": ""
        },
        {
            "command": "docker run --rm -it <image> sh",
            "level": "basic",
            "topic": "Contenedores",
            "description": "Ejecuta un contenedor interactivo temporal.",
            "example": "docker run --rm -it <image> sh",
            "expected": "Shell dentro del contenedor; se elimina al salir.",
            "note": ""
        },
        {
            "command": "docker run -d --name <name> --restart unless-stopped -p 8080:80 <image>",
            "level": "intermediate",
            "topic": "Contenedores",
            "description": "Crea un servicio background con restart policy.",
            "example": "docker run -d --name <name> --restart unless-stopped -p 8080:80 <image>",
            "expected": "ID del contenedor.",
            "note": "Revis\u00c3\u00a1 puertos y volumenes antes de usar en produccion."
        },
        {
            "command": "docker logs -f --tail 100 <container>",
            "level": "basic",
            "topic": "Logs, exec y debug",
            "description": "Sigue los ultimos logs.",
            "example": "docker logs -f --tail 100 <container>",
            "expected": "Stream de stdout/stderr del contenedor.",
            "note": ""
        },
        {
            "command": "docker exec -it <container> sh",
            "level": "basic",
            "topic": "Logs, exec y debug",
            "description": "Abre shell dentro de un contenedor en ejecucion.",
            "example": "docker exec -it <container> sh",
            "expected": "Prompt dentro del contenedor.",
            "note": ""
        },
        {
            "command": "docker stats --no-stream",
            "level": "intermediate",
            "topic": "Logs, exec y debug",
            "description": "Muestra una muestra de recursos.",
            "example": "docker stats --no-stream",
            "expected": "CPU, memoria, red, block I/O y PIDs.",
            "note": ""
        },
        {
            "command": "docker inspect <image-or-container>",
            "level": "basic",
            "topic": "Imagenes",
            "description": "Muestra metadata JSON de Docker.",
            "example": "docker inspect <image-or-container>",
            "expected": "JSON con config, mounts, network y state.",
            "note": ""
        },
        {
            "command": "docker history --no-trunc <image>",
            "level": "intermediate",
            "topic": "Imagenes",
            "description": "Muestra capas de una imagen sin truncar comandos.",
            "example": "docker history --no-trunc <image>",
            "expected": "Layers, tamanos y comandos.",
            "note": ""
        },
        {
            "command": "docker build -t <name>:<tag> .",
            "level": "basic",
            "topic": "Build y Buildx",
            "description": "Construye una imagen.",
            "example": "docker build -t <name>:<tag> .",
            "expected": "Logs de build e ID/tag final.",
            "note": ""
        },
        {
            "command": "docker build --no-cache -t <name>:<tag> .",
            "level": "intermediate",
            "topic": "Build y Buildx",
            "description": "Reconstruye sin reutilizar cache.",
            "example": "docker build --no-cache -t <name>:<tag> .",
            "expected": "Todas las capas se ejecutan otra vez.",
            "note": ""
        },
        {
            "command": "docker buildx build --platform linux/amd64,linux/arm64 -t <registry>/<image>:<tag> --push .",
            "level": "advanced",
            "topic": "Build y Buildx",
            "description": "Construye y publica imagen multi-arquitectura.",
            "example": "docker buildx build --platform linux/amd64,linux/arm64 -t <registry>/<image>:<tag> --push .",
            "expected": "Progreso BuildKit y manifest en registry.",
            "note": "Requiere builder/registry configurados."
        },
        {
            "command": "docker network ls",
            "level": "basic",
            "topic": "Redes",
            "description": "Lista redes.",
            "example": "docker network ls",
            "expected": "ID, NAME, DRIVER y SCOPE.",
            "note": ""
        },
        {
            "command": "docker network inspect <network>",
            "level": "intermediate",
            "topic": "Redes",
            "description": "Inspecciona una red.",
            "example": "docker network inspect <network>",
            "expected": "JSON con subred, gateway y containers conectados.",
            "note": ""
        },
        {
            "command": "docker network connect <network> <container>",
            "level": "intermediate",
            "topic": "Redes",
            "description": "Conecta un contenedor existente a una red.",
            "example": "docker network connect <network> <container>",
            "expected": "Sin salida si funciona.",
            "note": ""
        },
        {
            "command": "docker volume ls",
            "level": "basic",
            "topic": "Volumenes",
            "description": "Lista volumenes.",
            "example": "docker volume ls",
            "expected": "DRIVER y VOLUME NAME.",
            "note": ""
        },
        {
            "command": "docker volume inspect <volume>",
            "level": "intermediate",
            "topic": "Volumenes",
            "description": "Muestra metadata y mountpoint.",
            "example": "docker volume inspect <volume>",
            "expected": "JSON con ruta y labels.",
            "note": ""
        },
        {
            "command": "docker run --rm -v <volume>:/data -v \"$PWD\":/backup alpine tar czf /backup/volume.tgz -C /data .",
            "level": "advanced",
            "topic": "Volumenes",
            "description": "Crea backup TAR de un volumen.",
            "example": "docker run --rm -v <volume>:/data -v \"$PWD\":/backup alpine tar czf /backup/volume.tgz -C /data .",
            "expected": "Archivo volume.tgz en el directorio actual.",
            "note": "Verific\u00c3\u00a1 consistencia de datos si la app escribe mientras respald\u00c3\u00a1s."
        },
        {
            "command": "docker login <registry>",
            "level": "basic",
            "topic": "Registry y auth",
            "description": "Autentica contra un registry.",
            "example": "docker login <registry>",
            "expected": "Login Succeeded o error.",
            "note": ""
        },
        {
            "command": "docker tag <image> <registry>/<image>:<tag>",
            "level": "basic",
            "topic": "Registry y auth",
            "description": "Agrega un tag para registry.",
            "example": "docker tag <image> <registry>/<image>:<tag>",
            "expected": "Sin salida; aparece un nuevo tag local.",
            "note": ""
        },
        {
            "command": "docker push <registry>/<image>:<tag>",
            "level": "basic",
            "topic": "Registry y auth",
            "description": "Publica una imagen.",
            "example": "docker push <registry>/<image>:<tag>",
            "expected": "Progreso por layer y digest final.",
            "note": ""
        },
        {
            "command": "docker system df",
            "level": "basic",
            "topic": "Sistema y limpieza",
            "description": "Muestra uso de disco de Docker.",
            "example": "docker system df",
            "expected": "Tamanos de images, containers, volumes y build cache.",
            "note": ""
        },
        {
            "command": "docker system prune -a",
            "level": "intermediate",
            "topic": "Sistema y limpieza",
            "description": "Elimina recursos no usados incluyendo imagenes.",
            "example": "docker system prune -a",
            "expected": "Resumen y espacio recuperado.",
            "note": "Puede borrar imagenes necesarias para rollback local."
        },
        {
            "command": "docker context ls",
            "level": "intermediate",
            "topic": "Contextos y remotos",
            "description": "Lista contextos Docker.",
            "example": "docker context ls",
            "expected": "NAME, DESCRIPTION, endpoint y actual.",
            "note": ""
        },
        {
            "command": "docker context create <name> --docker \"host=ssh://<user>@<host>\"",
            "level": "intermediate",
            "topic": "Contextos y remotos",
            "description": "Crea un contexto Docker remoto via SSH.",
            "example": "docker context create <name> --docker \"host=ssh://<user>@<host>\"",
            "expected": "Contexto creado.",
            "note": ""
        },
        {
            "command": "docker --context <name> ps",
            "level": "intermediate",
            "topic": "Contextos y remotos",
            "description": "Ejecuta Docker contra el daemon del contexto remoto.",
            "example": "docker --context <name> ps",
            "expected": "Lista de contenedores del host remoto.",
            "note": ""
        }
    ],
    "compose": [
        {
            "command": "docker compose up -d",
            "level": "basic",
            "topic": "Lifecycle",
            "description": "Crea/inicia servicios en background.",
            "example": "docker compose up -d",
            "expected": "Contenedores/redes creados o iniciados.",
            "note": ""
        },
        {
            "command": "docker compose down",
            "level": "basic",
            "topic": "Lifecycle",
            "description": "Detiene y elimina contenedores/redes del proyecto.",
            "example": "docker compose down",
            "expected": "Recursos eliminados.",
            "note": "No borra volumenes nombrados salvo flags adicionales."
        },
        {
            "command": "docker compose down -v",
            "level": "intermediate",
            "topic": "Lifecycle",
            "description": "Baja el stack y elimina volumenes declarados.",
            "example": "docker compose down -v",
            "expected": "Contenedores, redes y volumenes eliminados.",
            "note": "Destructivo para datos persistidos en esos volumenes."
        },
        {
            "command": "docker compose ps",
            "level": "basic",
            "topic": "Servicios y debugging",
            "description": "Lista servicios/containers del proyecto.",
            "example": "docker compose ps",
            "expected": "NAME, IMAGE, COMMAND, SERVICE, STATUS, PORTS.",
            "note": ""
        },
        {
            "command": "docker compose logs -f --tail 100 <service>",
            "level": "basic",
            "topic": "Servicios y debugging",
            "description": "Sigue logs de un servicio.",
            "example": "docker compose logs -f --tail 100 <service>",
            "expected": "Stream de logs.",
            "note": ""
        },
        {
            "command": "docker compose exec <service> sh",
            "level": "basic",
            "topic": "Servicios y debugging",
            "description": "Abre shell en un servicio.",
            "example": "docker compose exec <service> sh",
            "expected": "Prompt dentro del contenedor.",
            "note": ""
        },
        {
            "command": "docker compose run --rm <service> <command>",
            "level": "intermediate",
            "topic": "Servicios y debugging",
            "description": "Ejecuta un comando en un contenedor one-off.",
            "example": "docker compose run --rm <service> <command>",
            "expected": "Salida del comando; contenedor eliminado.",
            "note": ""
        },
        {
            "command": "docker compose cp <service>:/path ./local",
            "level": "intermediate",
            "topic": "Servicios y debugging",
            "description": "Copia un archivo desde un servicio.",
            "example": "docker compose cp <service>:/path ./local",
            "expected": "Archivo copiado localmente.",
            "note": ""
        },
        {
            "command": "docker compose build",
            "level": "basic",
            "topic": "Build e imagenes",
            "description": "Construye imagenes del stack.",
            "example": "docker compose build",
            "expected": "Logs de BuildKit por servicio.",
            "note": ""
        },
        {
            "command": "docker compose build --no-cache",
            "level": "intermediate",
            "topic": "Build e imagenes",
            "description": "Reconstruye sin cache.",
            "example": "docker compose build --no-cache",
            "expected": "Build completo.",
            "note": ""
        },
        {
            "command": "docker compose pull",
            "level": "basic",
            "topic": "Build e imagenes",
            "description": "Descarga imagenes remotas.",
            "example": "docker compose pull",
            "expected": "Progreso y digests.",
            "note": ""
        },
        {
            "command": "docker compose config",
            "level": "basic",
            "topic": "Configuracion",
            "description": "Renderiza la configuracion final combinada.",
            "example": "docker compose config",
            "expected": "YAML efectivo con variables/interpolacion.",
            "note": ""
        },
        {
            "command": "docker compose config --services",
            "level": "intermediate",
            "topic": "Configuracion",
            "description": "Lista nombres de servicios.",
            "example": "docker compose config --services",
            "expected": "Un servicio por linea.",
            "note": ""
        },
        {
            "command": "docker compose --profile <profile> up -d",
            "level": "intermediate",
            "topic": "Configuracion",
            "description": "Levanta servicios de un profile.",
            "example": "docker compose --profile <profile> up -d",
            "expected": "Servicios del perfil iniciados.",
            "note": ""
        },
        {
            "command": "docker compose up -d --scale <service>=3",
            "level": "intermediate",
            "topic": "Escalado y recursos",
            "description": "Escala un servicio a 3 replicas locales.",
            "example": "docker compose up -d --scale <service>=3",
            "expected": "Tres containers del servicio.",
            "note": "No aplica bien a servicios con puertos host fijos sin estrategia adecuada."
        },
        {
            "command": "docker compose restart <service>",
            "level": "intermediate",
            "topic": "Escalado y recursos",
            "description": "Reinicia un servicio.",
            "example": "docker compose restart <service>",
            "expected": "Servicio recreado/reiniciado.",
            "note": ""
        },
        {
            "command": "docker compose wait <service>",
            "level": "advanced",
            "topic": "Escalado y recursos",
            "description": "Espera a que un servicio termine y retorna su exit code.",
            "example": "docker compose wait <service>",
            "expected": "Exit code del servicio.",
            "note": ""
        },
        {
            "command": "docker compose up -d --remove-orphans",
            "level": "intermediate",
            "topic": "Lifecycle",
            "description": "Levanta servicios y elimina contenedores hu\u00e9rfanos del proyecto.",
            "example": "docker compose up -d --remove-orphans",
            "expected": "Servicios en ejecuci\u00f3n y hu\u00e9rfanos removidos.",
            "note": ""
        },
        {
            "command": "docker compose down --remove-orphans",
            "level": "intermediate",
            "topic": "Lifecycle",
            "description": "Detiene el stack y elimina hu\u00e9rfanos.",
            "example": "docker compose down --remove-orphans",
            "expected": "Contenedores/redes del proyecto detenidos y eliminados.",
            "note": ""
        },
        {
            "command": "docker compose ls",
            "level": "basic",
            "topic": "Servicios",
            "description": "Lista proyectos Compose detectados.",
            "example": "docker compose ls",
            "expected": "Tabla con NAME, STATUS y CONFIG FILES.",
            "note": ""
        },
        {
            "command": "docker compose ps --all",
            "level": "intermediate",
            "topic": "Servicios",
            "description": "Lista tambi\u00e9n contenedores detenidos del proyecto.",
            "example": "docker compose ps --all",
            "expected": "Tabla de todos los servicios y estados.",
            "note": ""
        },
        {
            "command": "docker compose exec -u root <service> sh",
            "level": "intermediate",
            "topic": "Servicios",
            "description": "Abre shell como root dentro de un servicio.",
            "example": "docker compose exec -u root <service> sh",
            "expected": "Shell interactiva en el contenedor.",
            "note": ""
        },
        {
            "command": "docker compose images",
            "level": "intermediate",
            "topic": "Im\u00e1genes",
            "description": "Lista im\u00e1genes usadas por el stack.",
            "example": "docker compose images",
            "expected": "Tabla de contenedor, repositorio, tag e image ID.",
            "note": ""
        },
        {
            "command": "docker compose config --profiles",
            "level": "intermediate",
            "topic": "Configuraci\u00f3n",
            "description": "Lista perfiles definidos en la configuraci\u00f3n.",
            "example": "docker compose config --profiles",
            "expected": "Nombres de perfiles, uno por l\u00ednea.",
            "note": ""
        },
        {
            "command": "docker compose config --environment",
            "level": "advanced",
            "topic": "Configuraci\u00f3n",
            "description": "Muestra variables usadas para interpolar el modelo Compose.",
            "example": "docker compose config --environment",
            "expected": "Variables/valores usados por Compose.",
            "note": "Puede mostrar valores sensibles; evit\u00e1 compartir la salida."
        }
    ],
    "kubernetes": [
        {
            "command": "kubectl config get-contexts",
            "level": "basic",
            "topic": "Contextos y configuracion",
            "description": "Lista contextos configurados.",
            "example": "kubectl config get-contexts",
            "expected": "Tabla CURRENT, NAME, CLUSTER, AUTHINFO y NAMESPACE.",
            "note": ""
        },
        {
            "command": "kubectl config current-context",
            "level": "basic",
            "topic": "Contextos y configuracion",
            "description": "Muestra el contexto actual.",
            "example": "kubectl config current-context",
            "expected": "Nombre del contexto.",
            "note": ""
        },
        {
            "command": "kubectl config use-context <context>",
            "level": "intermediate",
            "topic": "Contextos y configuracion",
            "description": "Cambia el contexto activo.",
            "example": "kubectl config use-context <context>",
            "expected": "Switched to context ...",
            "note": ""
        },
        {
            "command": "kubectl config set-context --current --namespace=<ns>",
            "level": "intermediate",
            "topic": "Contextos y configuracion",
            "description": "Define namespace por defecto del contexto.",
            "example": "kubectl config set-context --current --namespace=<ns>",
            "expected": "Context modified.",
            "note": ""
        },
        {
            "command": "kubectl api-resources",
            "level": "intermediate",
            "topic": "Contextos y configuracion",
            "description": "Lista tipos de recursos disponibles.",
            "example": "kubectl api-resources",
            "expected": "NAME, SHORTNAMES, APIVERSION, NAMESPACED, KIND.",
            "note": ""
        },
        {
            "command": "kubectl get pods -A -o wide",
            "level": "basic",
            "topic": "Pods y debugging",
            "description": "Lista pods de todos los namespaces con detalles.",
            "example": "kubectl get pods -A -o wide",
            "expected": "Pod, namespace, IP, node, readiness y estado.",
            "note": ""
        },
        {
            "command": "kubectl describe pod <pod> -n <ns>",
            "level": "basic",
            "topic": "Pods y debugging",
            "description": "Muestra detalle y eventos de un pod.",
            "example": "kubectl describe pod <pod> -n <ns>",
            "expected": "Spec resumida, status, conditions y events.",
            "note": ""
        },
        {
            "command": "kubectl logs -f <pod> -n <ns>",
            "level": "basic",
            "topic": "Pods y debugging",
            "description": "Sigue logs de un pod.",
            "example": "kubectl logs -f <pod> -n <ns>",
            "expected": "Stream de stdout/stderr.",
            "note": ""
        },
        {
            "command": "kubectl logs <pod> -c <container> --previous -n <ns>",
            "level": "intermediate",
            "topic": "Pods y debugging",
            "description": "Muestra logs de la instancia anterior del container.",
            "example": "kubectl logs <pod> -c <container> --previous -n <ns>",
            "expected": "Logs previos, util para CrashLoopBackOff.",
            "note": ""
        },
        {
            "command": "kubectl exec -it <pod> -n <ns> -- sh",
            "level": "intermediate",
            "topic": "Pods y debugging",
            "description": "Abre shell dentro de un container.",
            "example": "kubectl exec -it <pod> -n <ns> -- sh",
            "expected": "Prompt en el container.",
            "note": ""
        },
        {
            "command": "kubectl port-forward pod/<pod> 8080:80 -n <ns>",
            "level": "intermediate",
            "topic": "Pods y debugging",
            "description": "Redirige un puerto local al pod.",
            "example": "kubectl port-forward pod/<pod> 8080:80 -n <ns>",
            "expected": "Forwarding from 127.0.0.1:8080 ...",
            "note": ""
        },
        {
            "command": "kubectl debug <pod> -it --image=busybox --target=<container>",
            "level": "advanced",
            "topic": "Pods y debugging",
            "description": "Agrega un ephemeral container de diagnostico.",
            "example": "kubectl debug <pod> -it --image=busybox --target=<container>",
            "expected": "Sesion interactiva de debug.",
            "note": "Requiere soporte del cluster y permisos adecuados."
        },
        {
            "command": "kubectl get deploy -A",
            "level": "basic",
            "topic": "Deployments y rollouts",
            "description": "Lista deployments.",
            "example": "kubectl get deploy -A",
            "expected": "READY, UP-TO-DATE y AVAILABLE.",
            "note": ""
        },
        {
            "command": "kubectl rollout status deployment/<name> -n <ns>",
            "level": "intermediate",
            "topic": "Deployments y rollouts",
            "description": "Espera el resultado del rollout.",
            "example": "kubectl rollout status deployment/<name> -n <ns>",
            "expected": "Confirmacion successful rolled out o error/time-out.",
            "note": ""
        },
        {
            "command": "kubectl rollout history deployment/<name> -n <ns>",
            "level": "intermediate",
            "topic": "Deployments y rollouts",
            "description": "Muestra revisiones del deployment.",
            "example": "kubectl rollout history deployment/<name> -n <ns>",
            "expected": "REVISION y CHANGE-CAUSE cuando existe.",
            "note": ""
        },
        {
            "command": "kubectl rollout undo deployment/<name> -n <ns>",
            "level": "intermediate",
            "topic": "Deployments y rollouts",
            "description": "Revierte a la revision anterior.",
            "example": "kubectl rollout undo deployment/<name> -n <ns>",
            "expected": "deployment rolled back.",
            "note": "Impacta produccion; valida revision y estado."
        },
        {
            "command": "kubectl set image deployment/<name> <container>=<image>:<tag> -n <ns>",
            "level": "advanced",
            "topic": "Deployments y rollouts",
            "description": "Actualiza la imagen y dispara rollout.",
            "example": "kubectl set image deployment/<name> <container>=<image>:<tag> -n <ns>",
            "expected": "deployment.apps/... image updated.",
            "note": ""
        },
        {
            "command": "kubectl get svc -A",
            "level": "basic",
            "topic": "Services e ingress",
            "description": "Lista services.",
            "example": "kubectl get svc -A",
            "expected": "TYPE, CLUSTER-IP, EXTERNAL-IP y PORTS.",
            "note": ""
        },
        {
            "command": "kubectl expose deployment <name> --port=80 --target-port=3000 --type=ClusterIP",
            "level": "intermediate",
            "topic": "Services e ingress",
            "description": "Crea un Service para un deployment.",
            "example": "kubectl expose deployment <name> --port=80 --target-port=3000 --type=ClusterIP",
            "expected": "service/... exposed.",
            "note": ""
        },
        {
            "command": "kubectl get ingress -A",
            "level": "intermediate",
            "topic": "Services e ingress",
            "description": "Lista ingress.",
            "example": "kubectl get ingress -A",
            "expected": "HOSTS, ADDRESS y PORTS.",
            "note": ""
        },
        {
            "command": "kubectl get configmap -n <ns>",
            "level": "basic",
            "topic": "ConfigMaps y Secrets",
            "description": "Lista ConfigMaps.",
            "example": "kubectl get configmap -n <ns>",
            "expected": "NAME, DATA y AGE.",
            "note": ""
        },
        {
            "command": "kubectl create configmap <name> --from-env-file=.env -n <ns>",
            "level": "intermediate",
            "topic": "ConfigMaps y Secrets",
            "description": "Crea ConfigMap desde archivo env.",
            "example": "kubectl create configmap <name> --from-env-file=.env -n <ns>",
            "expected": "configmap/... created.",
            "note": "No uses ConfigMap para secretos."
        },
        {
            "command": "kubectl create secret generic <name> --from-literal=KEY=value -n <ns>",
            "level": "intermediate",
            "topic": "ConfigMaps y Secrets",
            "description": "Crea Secret generico.",
            "example": "kubectl create secret generic <name> --from-literal=KEY=value -n <ns>",
            "expected": "secret/... created.",
            "note": "Evita dejar secretos en historial de shell; preferi archivos/secret managers."
        },
        {
            "command": "kubectl get pvc -A",
            "level": "basic",
            "topic": "Storage",
            "description": "Lista PersistentVolumeClaims.",
            "example": "kubectl get pvc -A",
            "expected": "STATUS, VOLUME, CAPACITY, ACCESS MODES y STORAGECLASS.",
            "note": ""
        },
        {
            "command": "kubectl get nodes -o wide",
            "level": "basic",
            "topic": "Nodos y mantenimiento",
            "description": "Lista nodos con detalles.",
            "example": "kubectl get nodes -o wide",
            "expected": "STATUS, ROLES, VERSION, IPs y OS image.",
            "note": ""
        },
        {
            "command": "kubectl cordon <node>",
            "level": "intermediate",
            "topic": "Nodos y mantenimiento",
            "description": "Marca un nodo como no schedulable.",
            "example": "kubectl cordon <node>",
            "expected": "node/... cordoned.",
            "note": ""
        },
        {
            "command": "kubectl drain <node> --ignore-daemonsets --delete-emptydir-data",
            "level": "advanced",
            "topic": "Nodos y mantenimiento",
            "description": "Evacua workloads de un nodo.",
            "example": "kubectl drain <node> --ignore-daemonsets --delete-emptydir-data",
            "expected": "Pods evicted y node drained.",
            "note": "Puede interrumpir servicios; revisa PDBs y replicas antes."
        },
        {
            "command": "kubectl auth can-i get pods -n <ns>",
            "level": "basic",
            "topic": "RBAC y seguridad",
            "description": "Comprueba si la identidad actual puede hacer una accion.",
            "example": "kubectl auth can-i get pods -n <ns>",
            "expected": "yes o no.",
            "note": ""
        },
        {
            "command": "kubectl auth can-i --list -n <ns>",
            "level": "intermediate",
            "topic": "RBAC y seguridad",
            "description": "Lista permisos efectivos en un namespace.",
            "example": "kubectl auth can-i --list -n <ns>",
            "expected": "Tabla de resources, non-resource URLs y verbs.",
            "note": ""
        },
        {
            "command": "kubectl apply -f <file.yaml>",
            "level": "basic",
            "topic": "Manifiestos y recursos",
            "description": "Crea o actualiza recursos declarativos.",
            "example": "kubectl apply -f <file.yaml>",
            "expected": "resource configured/created.",
            "note": ""
        },
        {
            "command": "kubectl diff -f <file.yaml>",
            "level": "intermediate",
            "topic": "Manifiestos y recursos",
            "description": "Muestra cambios que aplicaria.",
            "example": "kubectl diff -f <file.yaml>",
            "expected": "Diff y exit code indicando diferencias.",
            "note": ""
        },
        {
            "command": "kubectl wait --for=condition=available deployment/<name> --timeout=120s -n <ns>",
            "level": "intermediate",
            "topic": "Manifiestos y recursos",
            "description": "Espera una condicion.",
            "example": "kubectl wait --for=condition=available deployment/<name> --timeout=120s -n <ns>",
            "expected": "resource condition met o timeout.",
            "note": ""
        }
    ],
    "terraform": [
        {
            "command": "terraform init",
            "level": "basic",
            "topic": "Init y providers",
            "description": "Inicializa backend, providers y modulos.",
            "example": "terraform init",
            "expected": "Providers instalados y mensaje de inicializacion exitosa.",
            "note": ""
        },
        {
            "command": "terraform init -upgrade",
            "level": "intermediate",
            "topic": "Init y providers",
            "description": "Actualiza providers/modulos dentro de restricciones.",
            "example": "terraform init -upgrade",
            "expected": "Descargas y lockfile actualizado.",
            "note": ""
        },
        {
            "command": "terraform providers",
            "level": "intermediate",
            "topic": "Init y providers",
            "description": "Muestra dependencias de providers.",
            "example": "terraform providers",
            "expected": "Arbol de providers requeridos por configuracion/state.",
            "note": ""
        },
        {
            "command": "terraform plan",
            "level": "basic",
            "topic": "Plan, apply y destroy",
            "description": "Calcula cambios sin aplicarlos.",
            "example": "terraform plan",
            "expected": "Plan con add/change/destroy.",
            "note": ""
        },
        {
            "command": "terraform plan -out=tfplan",
            "level": "intermediate",
            "topic": "Plan, apply y destroy",
            "description": "Guarda un plan binario.",
            "example": "terraform plan -out=tfplan",
            "expected": "tfplan y resumen de cambios.",
            "note": ""
        },
        {
            "command": "terraform apply tfplan",
            "level": "intermediate",
            "topic": "Plan, apply y destroy",
            "description": "Aplica exactamente un plan guardado.",
            "example": "terraform apply tfplan",
            "expected": "Progreso y Apply complete.",
            "note": "Revisa el plan antes de aplicarlo."
        },
        {
            "command": "terraform apply -replace=<address>",
            "level": "advanced",
            "topic": "Plan, apply y destroy",
            "description": "Fuerza reemplazo de un recurso durante apply.",
            "example": "terraform apply -replace=<address>",
            "expected": "Plan y recreacion del recurso.",
            "note": "Puede causar downtime o perdida de datos."
        },
        {
            "command": "terraform destroy -target=<address>",
            "level": "advanced",
            "topic": "Plan, apply y destroy",
            "description": "Destruye un recurso seleccionado y dependencias necesarias.",
            "example": "terraform destroy -target=<address>",
            "expected": "Plan y recursos destruidos.",
            "note": "Uso excepcional; target puede dejar estado/config parcial."
        },
        {
            "command": "terraform fmt -recursive",
            "level": "basic",
            "topic": "Formato y validacion",
            "description": "Formatea archivos Terraform recursivamente.",
            "example": "terraform fmt -recursive",
            "expected": "Rutas de archivos modificados.",
            "note": ""
        },
        {
            "command": "terraform validate",
            "level": "basic",
            "topic": "Formato y validacion",
            "description": "Valida sintaxis y coherencia interna.",
            "example": "terraform validate",
            "expected": "Success o diagnosticos.",
            "note": ""
        },
        {
            "command": "terraform state list",
            "level": "basic",
            "topic": "State",
            "description": "Lista addresses del state.",
            "example": "terraform state list",
            "expected": "Un resource address por linea.",
            "note": ""
        },
        {
            "command": "terraform state show <address>",
            "level": "intermediate",
            "topic": "State",
            "description": "Muestra atributos de un recurso del state.",
            "example": "terraform state show <address>",
            "expected": "Representacion HCL-like del recurso.",
            "note": ""
        },
        {
            "command": "terraform state mv <src> <dst>",
            "level": "advanced",
            "topic": "State",
            "description": "Mueve/renombra un address dentro del state.",
            "example": "terraform state mv <src> <dst>",
            "expected": "Confirmacion de movimiento.",
            "note": "Haz backup del state y valida addresses."
        },
        {
            "command": "terraform state rm <address>",
            "level": "advanced",
            "topic": "State",
            "description": "Deja de administrar un recurso sin destruirlo.",
            "example": "terraform state rm <address>",
            "expected": "Mensaje Removed ...",
            "note": "El recurso real permanece, pero Terraform deja de gestionarlo."
        },
        {
            "command": "terraform import <address> <id>",
            "level": "intermediate",
            "topic": "State",
            "description": "Importa un recurso existente al state.",
            "example": "terraform import <address> <id>",
            "expected": "Import successful o diagnosticos.",
            "note": ""
        },
        {
            "command": "terraform workspace list",
            "level": "basic",
            "topic": "Workspaces",
            "description": "Lista workspaces.",
            "example": "terraform workspace list",
            "expected": "Lista con * en el actual.",
            "note": ""
        },
        {
            "command": "terraform workspace new <name>",
            "level": "intermediate",
            "topic": "Workspaces",
            "description": "Crea y selecciona un workspace.",
            "example": "terraform workspace new <name>",
            "expected": "Created and switched to workspace ...",
            "note": ""
        },
        {
            "command": "terraform output",
            "level": "basic",
            "topic": "Outputs e inspeccion",
            "description": "Muestra outputs.",
            "example": "terraform output",
            "expected": "Valores declarados como output.",
            "note": ""
        },
        {
            "command": "terraform output -json",
            "level": "intermediate",
            "topic": "Outputs e inspeccion",
            "description": "Exporta outputs como JSON.",
            "example": "terraform output -json",
            "expected": "Objeto JSON.",
            "note": ""
        },
        {
            "command": "terraform show -json tfplan",
            "level": "intermediate",
            "topic": "Outputs e inspeccion",
            "description": "Convierte plan/state a JSON.",
            "example": "terraform show -json tfplan",
            "expected": "JSON estructurado para automatizacion.",
            "note": ""
        },
        {
            "command": "terraform graph | dot -Tsvg > graph.svg",
            "level": "advanced",
            "topic": "Outputs e inspeccion",
            "description": "Genera un gr\u00e1fico SVG del grafo de dependencias de Terraform.",
            "example": "terraform graph | dot -Tsvg > graph.svg",
            "expected": "Archivo graph.svg.",
            "note": "Requiere Graphviz (dot) instalado."
        },
        {
            "command": "terraform login",
            "level": "basic",
            "topic": "Cloud y login",
            "description": "Autentica con HCP Terraform/Terraform Enterprise.",
            "example": "terraform login",
            "expected": "Token almacenado segun CLI config.",
            "note": "Protege el archivo de credenciales."
        }
    ],
    "aws": [
        {
            "command": "aws configure",
            "level": "basic",
            "topic": "Auth y configuracion",
            "description": "Configura credenciales, region y formato.",
            "example": "aws configure",
            "expected": "Prompts y archivos ~/.aws/config y credentials.",
            "note": ""
        },
        {
            "command": "aws sts get-caller-identity",
            "level": "basic",
            "topic": "Auth y configuracion",
            "description": "Muestra la identidad efectiva.",
            "example": "aws sts get-caller-identity",
            "expected": "Account, Arn y UserId.",
            "note": ""
        },
        {
            "command": "aws configure list-profiles",
            "level": "intermediate",
            "topic": "Auth y configuracion",
            "description": "Lista perfiles configurados.",
            "example": "aws configure list-profiles",
            "expected": "Un profile por linea.",
            "note": ""
        },
        {
            "command": "aws sso login --profile <profile>",
            "level": "intermediate",
            "topic": "Auth y configuracion",
            "description": "Inicia sesion SSO para un profile.",
            "example": "aws sso login --profile <profile>",
            "expected": "Browser/device flow y confirmacion.",
            "note": ""
        },
        {
            "command": "aws s3 ls",
            "level": "basic",
            "topic": "S3",
            "description": "Lista buckets.",
            "example": "aws s3 ls",
            "expected": "Fecha y nombre de buckets.",
            "note": ""
        },
        {
            "command": "aws s3 ls s3://<bucket>/",
            "level": "basic",
            "topic": "S3",
            "description": "Lista objetos/prefixes.",
            "example": "aws s3 ls s3://<bucket>/",
            "expected": "Fechas, tamanos y keys.",
            "note": ""
        },
        {
            "command": "aws s3 sync ./dist s3://<bucket>/ --delete",
            "level": "intermediate",
            "topic": "S3",
            "description": "Sincroniza un directorio con un bucket.",
            "example": "aws s3 sync ./dist s3://<bucket>/ --delete",
            "expected": "Archivos upload/delete por linea.",
            "note": "--delete elimina objetos remotos que no existan localmente."
        },
        {
            "command": "aws s3 cp s3://<bucket>/<key> .",
            "level": "intermediate",
            "topic": "S3",
            "description": "Descarga un objeto.",
            "example": "aws s3 cp s3://<bucket>/<key> .",
            "expected": "Progreso y archivo local.",
            "note": ""
        },
        {
            "command": "aws ec2 describe-instances --query 'Reservations[].Instances[].{Id:InstanceId,State:State.Name,IP:PublicIpAddress}' --output table",
            "level": "basic",
            "topic": "EC2",
            "description": "Lista instancias resumidas.",
            "example": "aws ec2 describe-instances --query 'Reservations[].Instances[].{Id:InstanceId,State:State.Name,IP:PublicIpAddress}' --output table",
            "expected": "Tabla con ID, estado e IP.",
            "note": ""
        },
        {
            "command": "aws ec2 start-instances --instance-ids <id>",
            "level": "intermediate",
            "topic": "EC2",
            "description": "Inicia una instancia.",
            "example": "aws ec2 start-instances --instance-ids <id>",
            "expected": "JSON con estado anterior/actual.",
            "note": ""
        },
        {
            "command": "aws ec2 stop-instances --instance-ids <id>",
            "level": "intermediate",
            "topic": "EC2",
            "description": "Detiene una instancia.",
            "example": "aws ec2 stop-instances --instance-ids <id>",
            "expected": "JSON de transicion de estado.",
            "note": "Puede interrumpir servicios."
        },
        {
            "command": "aws ecr get-login-password --region <region> | docker login --username AWS --password-stdin <account>.dkr.ecr.<region>.amazonaws.com",
            "level": "basic",
            "topic": "ECR y ECS",
            "description": "Autentica Docker contra un registry privado de Amazon ECR.",
            "example": "aws ecr get-login-password --region us-east-1 | docker login --username AWS --password-stdin 123456789012.dkr.ecr.us-east-1.amazonaws.com",
            "expected": "Login Succeeded.",
            "note": "Evita imprimir la contrase\u00f1a en consola; el token se env\u00eda por stdin."
        },
        {
            "command": "aws ecr describe-repositories",
            "level": "intermediate",
            "topic": "ECR y ECS",
            "description": "Lista repositories ECR.",
            "example": "aws ecr describe-repositories",
            "expected": "JSON con URI y metadata.",
            "note": ""
        },
        {
            "command": "aws ecs list-clusters",
            "level": "intermediate",
            "topic": "ECR y ECS",
            "description": "Lista clusters ECS.",
            "example": "aws ecs list-clusters",
            "expected": "ARNs de clusters.",
            "note": ""
        },
        {
            "command": "aws ecs list-services --cluster <cluster>",
            "level": "intermediate",
            "topic": "ECR y ECS",
            "description": "Lista services de un cluster.",
            "example": "aws ecs list-services --cluster <cluster>",
            "expected": "ARNs de services.",
            "note": ""
        },
        {
            "command": "aws lambda list-functions",
            "level": "basic",
            "topic": "Lambda",
            "description": "Lista funciones Lambda.",
            "example": "aws lambda list-functions",
            "expected": "JSON con nombres, runtimes y metadata.",
            "note": ""
        },
        {
            "command": "aws lambda invoke --function-name <name> response.json",
            "level": "intermediate",
            "topic": "Lambda",
            "description": "Invoca una funcion.",
            "example": "aws lambda invoke --function-name <name> response.json",
            "expected": "StatusCode y archivo response.json.",
            "note": ""
        },
        {
            "command": "aws cloudformation list-stacks --stack-status-filter CREATE_COMPLETE UPDATE_COMPLETE",
            "level": "basic",
            "topic": "CloudFormation",
            "description": "Lista stacks activos.",
            "example": "aws cloudformation list-stacks --stack-status-filter CREATE_COMPLETE UPDATE_COMPLETE",
            "expected": "Summaries de stacks.",
            "note": ""
        },
        {
            "command": "aws cloudformation deploy --template-file template.yaml --stack-name <name> --capabilities CAPABILITY_NAMED_IAM",
            "level": "intermediate",
            "topic": "CloudFormation",
            "description": "Crea/actualiza un stack.",
            "example": "aws cloudformation deploy --template-file template.yaml --stack-name <name> --capabilities CAPABILITY_NAMED_IAM",
            "expected": "Waiting for changeset y stack success/failure.",
            "note": "CAPABILITY_NAMED_IAM permite cambios de IAM: revisa el template."
        },
        {
            "command": "aws logs tail <log-group> --follow",
            "level": "basic",
            "topic": "Logs y monitoreo",
            "description": "Sigue CloudWatch Logs.",
            "example": "aws logs tail <log-group> --follow",
            "expected": "Stream de eventos.",
            "note": ""
        },
        {
            "command": "aws logs filter-log-events --log-group-name <group> --filter-pattern ERROR",
            "level": "intermediate",
            "topic": "Logs y monitoreo",
            "description": "Filtra eventos por patron.",
            "example": "aws logs filter-log-events --log-group-name <group> --filter-pattern ERROR",
            "expected": "JSON con eventos coincidentes.",
            "note": ""
        },
        {
            "command": "aws iam list-users",
            "level": "basic",
            "topic": "IAM y seguridad",
            "description": "Lista usuarios IAM.",
            "example": "aws iam list-users",
            "expected": "JSON con usuarios.",
            "note": ""
        },
        {
            "command": "aws secretsmanager get-secret-value --secret-id <id>",
            "level": "intermediate",
            "topic": "IAM y seguridad",
            "description": "Lee un secret autorizado.",
            "example": "aws secretsmanager get-secret-value --secret-id <id>",
            "expected": "SecretString/SecretBinary y metadata.",
            "note": "No pegues la salida en tickets o logs."
        },
        {
            "command": "aws rds describe-db-instances",
            "level": "basic",
            "topic": "RDS y datos",
            "description": "Lista instancias RDS.",
            "example": "aws rds describe-db-instances",
            "expected": "JSON con engine, endpoint, status y clase.",
            "note": ""
        },
        {
            "command": "aws dynamodb scan --table-name <table> --limit 10",
            "level": "intermediate",
            "topic": "RDS y datos",
            "description": "Lee hasta 10 items via Scan.",
            "example": "aws dynamodb scan --table-name <table> --limit 10",
            "expected": "Items y Count/ScannedCount.",
            "note": "Scan puede ser costoso en tablas grandes."
        }
    ],
    "github": [
        {
            "command": "gh auth status",
            "level": "basic",
            "topic": "Autenticacion y config",
            "description": "Muestra cuentas y hosts autenticados.",
            "example": "gh auth status",
            "expected": "Estado, usuario, scopes y metodo Git.",
            "note": ""
        },
        {
            "command": "gh auth login",
            "level": "basic",
            "topic": "Autenticacion y config",
            "description": "Inicia el flujo de autenticacion.",
            "example": "gh auth login",
            "expected": "Prompts y confirmacion.",
            "note": ""
        },
        {
            "command": "gh repo view --web",
            "level": "basic",
            "topic": "Repositorios",
            "description": "Abre el repo actual en el navegador.",
            "example": "gh repo view --web",
            "expected": "Navegador abierto en la URL del repo.",
            "note": ""
        },
        {
            "command": "gh repo clone <owner>/<repo>",
            "level": "intermediate",
            "topic": "Repositorios",
            "description": "Clona un repositorio.",
            "example": "gh repo clone <owner>/<repo>",
            "expected": "Progreso de git clone y carpeta local.",
            "note": ""
        },
        {
            "command": "gh repo fork <owner>/<repo> --clone",
            "level": "intermediate",
            "topic": "Repositorios",
            "description": "Crea fork y lo clona.",
            "example": "gh repo fork <owner>/<repo> --clone",
            "expected": "Fork creado y clone local.",
            "note": ""
        },
        {
            "command": "gh pr status",
            "level": "basic",
            "topic": "Pull requests",
            "description": "Muestra PRs relevantes para el repo.",
            "example": "gh pr status",
            "expected": "PRs actuales, creadas y solicitadas para review.",
            "note": ""
        },
        {
            "command": "gh pr create --fill",
            "level": "basic",
            "topic": "Pull requests",
            "description": "Crea PR usando commit/title/body inferidos.",
            "example": "gh pr create --fill",
            "expected": "URL del PR creado.",
            "note": ""
        },
        {
            "command": "gh pr checkout <number>",
            "level": "intermediate",
            "topic": "Pull requests",
            "description": "Cambia a la rama de un PR.",
            "example": "gh pr checkout <number>",
            "expected": "Branch local y tracking configurado.",
            "note": ""
        },
        {
            "command": "gh pr merge <number> --squash --delete-branch",
            "level": "intermediate",
            "topic": "Pull requests",
            "description": "Mergea por squash y elimina branch remoto/local cuando aplica.",
            "example": "gh pr merge <number> --squash --delete-branch",
            "expected": "Confirmacion de merge y limpieza.",
            "note": "Revisa checks y aprobaciones antes."
        },
        {
            "command": "gh issue list",
            "level": "basic",
            "topic": "Issues",
            "description": "Lista issues.",
            "example": "gh issue list",
            "expected": "Numero, titulo, labels y estado.",
            "note": ""
        },
        {
            "command": "gh issue create --title \"<title>\" --body \"<body>\"",
            "level": "intermediate",
            "topic": "Issues",
            "description": "Crea un issue.",
            "example": "gh issue create --title \"<title>\" --body \"<body>\"",
            "expected": "URL del issue.",
            "note": ""
        },
        {
            "command": "gh release list",
            "level": "basic",
            "topic": "Releases",
            "description": "Lista releases.",
            "example": "gh release list",
            "expected": "TITLE, TYPE, TAG, PUBLISHED.",
            "note": ""
        },
        {
            "command": "gh release create <tag> --generate-notes",
            "level": "intermediate",
            "topic": "Releases",
            "description": "Crea una release con notas generadas.",
            "example": "gh release create <tag> --generate-notes",
            "expected": "URL de la release.",
            "note": ""
        },
        {
            "command": "gh workflow list",
            "level": "basic",
            "topic": "Actions y workflows",
            "description": "Lista workflows.",
            "example": "gh workflow list",
            "expected": "Nombre, estado e ID.",
            "note": ""
        },
        {
            "command": "gh workflow run <workflow.yml> --ref main",
            "level": "intermediate",
            "topic": "Actions y workflows",
            "description": "Dispara un workflow manual.",
            "example": "gh workflow run <workflow.yml> --ref main",
            "expected": "Confirmacion del dispatch.",
            "note": ""
        },
        {
            "command": "gh run list --limit 20",
            "level": "basic",
            "topic": "Actions y workflows",
            "description": "Lista ejecuciones recientes.",
            "example": "gh run list --limit 20",
            "expected": "STATUS, CONCLUSION, WORKFLOW, BRANCH, EVENT, ID.",
            "note": ""
        },
        {
            "command": "gh run watch <run-id>",
            "level": "intermediate",
            "topic": "Actions y workflows",
            "description": "Sigue una ejecucion.",
            "example": "gh run watch <run-id>",
            "expected": "Estado de jobs/steps hasta terminar.",
            "note": ""
        },
        {
            "command": "gh run view <run-id> --log-failed",
            "level": "intermediate",
            "topic": "Actions y workflows",
            "description": "Muestra logs de steps fallidos.",
            "example": "gh run view <run-id> --log-failed",
            "expected": "Logs de errores de la ejecucion.",
            "note": ""
        },
        {
            "command": "gh secret list",
            "level": "intermediate",
            "topic": "Actions y workflows",
            "description": "Lista nombres de Actions secrets.",
            "example": "gh secret list",
            "expected": "Nombres y fecha de actualizacion, nunca valores.",
            "note": ""
        },
        {
            "command": "gh secret set <NAME> --body \"<value>\"",
            "level": "intermediate",
            "topic": "Actions y workflows",
            "description": "Crea/actualiza un Actions secret.",
            "example": "gh secret set <NAME> --body \"<value>\"",
            "expected": "Confirmacion.",
            "note": "Evita pasar secretos por CLI si el historial o procesos pudieran exponerlos; stdin es preferible."
        },
        {
            "command": "gh api repos/{owner}/{repo}",
            "level": "intermediate",
            "topic": "API y extensiones",
            "description": "Consulta la API REST autenticada.",
            "example": "gh api repos/{owner}/{repo}",
            "expected": "JSON del repositorio.",
            "note": ""
        },
        {
            "command": "gh api graphql -f query='<query>'",
            "level": "advanced",
            "topic": "API y extensiones",
            "description": "Ejecuta GraphQL contra GitHub.",
            "example": "gh api graphql -f query='<query>'",
            "expected": "JSON data/errors.",
            "note": "Valida scopes y costo de la query."
        },
        {
            "command": "gh codespace list",
            "level": "basic",
            "topic": "Codespaces",
            "description": "Lista Codespaces.",
            "example": "gh codespace list",
            "expected": "Nombre, repositorio, estado y branch.",
            "note": ""
        },
        {
            "command": "gh codespace ssh -c <name>",
            "level": "intermediate",
            "topic": "Codespaces",
            "description": "Abre SSH a un Codespace.",
            "example": "gh codespace ssh -c <name>",
            "expected": "Shell remota.",
            "note": ""
        }
    ],
    "ssh": [
        {
            "command": "ssh <user>@<host>",
            "level": "basic",
            "topic": "Conexion",
            "description": "Abre una sesion SSH.",
            "example": "ssh <user>@<host>",
            "expected": "Prompt remoto o solicitud de autenticacion.",
            "note": ""
        },
        {
            "command": "ssh -p <port> <user>@<host>",
            "level": "intermediate",
            "topic": "Conexion",
            "description": "Conecta usando un puerto distinto de 22.",
            "example": "ssh -p <port> <user>@<host>",
            "expected": "Sesion remota.",
            "note": ""
        },
        {
            "command": "ssh -i ~/.ssh/<key> <user>@<host>",
            "level": "intermediate",
            "topic": "Conexion",
            "description": "Usa una clave privada especifica.",
            "example": "ssh -i ~/.ssh/<key> <user>@<host>",
            "expected": "Sesion remota si la clave es aceptada.",
            "note": "Protege la clave con permisos adecuados y passphrase."
        },
        {
            "command": "ssh-keygen -t ed25519 -C \"<email>\"",
            "level": "basic",
            "topic": "Claves y agente",
            "description": "Genera un par de claves Ed25519.",
            "example": "ssh-keygen -t ed25519 -C \"<email>\"",
            "expected": "Ruta de private/public key y fingerprint.",
            "note": ""
        },
        {
            "command": "ssh-add ~/.ssh/<key>",
            "level": "basic",
            "topic": "Claves y agente",
            "description": "Carga una clave en ssh-agent.",
            "example": "ssh-add ~/.ssh/<key>",
            "expected": "Identity added ...",
            "note": ""
        },
        {
            "command": "ssh-add -l",
            "level": "intermediate",
            "topic": "Claves y agente",
            "description": "Lista fingerprints de claves cargadas.",
            "example": "ssh-add -l",
            "expected": "Bit size/fingerprint/comment.",
            "note": ""
        },
        {
            "command": "ssh-copy-id <user>@<host>",
            "level": "intermediate",
            "topic": "Claves y agente",
            "description": "Copia la clave publica al servidor.",
            "example": "ssh-copy-id <user>@<host>",
            "expected": "Claves agregadas y mensaje de prueba.",
            "note": ""
        },
        {
            "command": "ssh-keyscan -H <host> >> ~/.ssh/known_hosts",
            "level": "basic",
            "topic": "Known hosts",
            "description": "Obtiene host keys y las agrega hasheadas.",
            "example": "ssh-keyscan -H <host> >> ~/.ssh/known_hosts",
            "expected": "Lineas de host key agregadas.",
            "note": "Verifica fingerprint por un canal confiable antes de confiar."
        },
        {
            "command": "ssh-keygen -R <host>",
            "level": "intermediate",
            "topic": "Known hosts",
            "description": "Elimina host key guardada para un host.",
            "example": "ssh-keygen -R <host>",
            "expected": "Archivo known_hosts actualizado.",
            "note": "No ignores un cambio de host key sin investigar."
        },
        {
            "command": "scp <file> <user>@<host>:<path>",
            "level": "basic",
            "topic": "Transferencia",
            "description": "Copia un archivo al servidor.",
            "example": "scp <file> <user>@<host>:<path>",
            "expected": "Progreso de transferencia.",
            "note": ""
        },
        {
            "command": "scp -r <dir> <user>@<host>:<path>",
            "level": "basic",
            "topic": "Transferencia",
            "description": "Copia un directorio recursivamente.",
            "example": "scp -r <dir> <user>@<host>:<path>",
            "expected": "Progreso por archivos.",
            "note": ""
        },
        {
            "command": "rsync -avh --progress <src>/ <user>@<host>:<dst>/",
            "level": "intermediate",
            "topic": "Transferencia",
            "description": "Sincroniza archivos eficientemente.",
            "example": "rsync -avh --progress <src>/ <user>@<host>:<dst>/",
            "expected": "Listado de archivos y estadisticas.",
            "note": ""
        },
        {
            "command": "rsync -avh --delete --dry-run <src>/ <user>@<host>:<dst>/",
            "level": "advanced",
            "topic": "Transferencia",
            "description": "Simula espejo con eliminaciones.",
            "example": "rsync -avh --delete --dry-run <src>/ <user>@<host>:<dst>/",
            "expected": "Lista de cambios sin aplicarlos.",
            "note": "Quita --dry-run solo despues de revisar."
        },
        {
            "command": "ssh -L 5433:127.0.0.1:5432 <user>@<host>",
            "level": "intermediate",
            "topic": "Tuneles y port forwarding",
            "description": "Crea tunel local hacia PostgreSQL remoto.",
            "example": "ssh -L 5433:127.0.0.1:5432 <user>@<host>",
            "expected": "Sesion SSH; localhost:5433 reenvia al remoto.",
            "note": ""
        },
        {
            "command": "ssh -R 8080:127.0.0.1:3000 <user>@<host>",
            "level": "advanced",
            "topic": "Tuneles y port forwarding",
            "description": "Expone un puerto local a traves del servidor remoto.",
            "example": "ssh -R 8080:127.0.0.1:3000 <user>@<host>",
            "expected": "Forwarding remoto activo.",
            "note": "Depende de GatewayPorts/config del servidor."
        },
        {
            "command": "ssh -D 1080 <user>@<host>",
            "level": "advanced",
            "topic": "Tuneles y port forwarding",
            "description": "Crea proxy SOCKS dinamico.",
            "example": "ssh -D 1080 <user>@<host>",
            "expected": "Proxy SOCKS en localhost:1080.",
            "note": ""
        },
        {
            "command": "ssh -J <jump-user>@<jump-host> <user>@<target>",
            "level": "advanced",
            "topic": "Tuneles y port forwarding",
            "description": "Conecta a un destino atravesando un jump host.",
            "example": "ssh -J <jump-user>@<jump-host> <user>@<target>",
            "expected": "Sesion al target via bastion.",
            "note": ""
        },
        {
            "command": "ssh -v <user>@<host>",
            "level": "basic",
            "topic": "Config y diagnostico",
            "description": "Conecta mostrando diagnostico.",
            "example": "ssh -v <user>@<host>",
            "expected": "Traza de negociacion, keys y auth.",
            "note": ""
        },
        {
            "command": "ssh -vvv <user>@<host>",
            "level": "advanced",
            "topic": "Config y diagnostico",
            "description": "Maximo detalle de debug habitual.",
            "example": "ssh -vvv <user>@<host>",
            "expected": "Traza muy detallada en stderr.",
            "note": "Puede mostrar metadata sensible de rutas/usuarios."
        },
        {
            "command": "ssh -G <host>",
            "level": "intermediate",
            "topic": "Config y diagnostico",
            "description": "Muestra la configuracion SSH efectiva.",
            "example": "ssh -G <host>",
            "expected": "Opciones finales despues de procesar ~/.ssh/config.",
            "note": ""
        }
    ],
    "curl": [
        {
            "command": "curl https://example.com",
            "level": "basic",
            "topic": "Requests basicos",
            "description": "Hace un GET y escribe body en stdout.",
            "example": "curl https://example.com",
            "expected": "HTML/JSON de respuesta.",
            "note": ""
        },
        {
            "command": "curl -I https://example.com",
            "level": "basic",
            "topic": "Requests basicos",
            "description": "Hace HEAD y muestra headers.",
            "example": "curl -I https://example.com",
            "expected": "Status line y headers HTTP.",
            "note": ""
        },
        {
            "command": "curl -X DELETE https://api.example.com/items/123",
            "level": "intermediate",
            "topic": "Requests basicos",
            "description": "Hace una solicitud DELETE.",
            "example": "curl -X DELETE https://api.example.com/items/123",
            "expected": "Body/status definido por la API.",
            "note": "Confirma el endpoint antes: puede eliminar datos."
        },
        {
            "command": "curl -H \"Accept: application/json\" https://api.example.com/items",
            "level": "basic",
            "topic": "Headers y auth",
            "description": "Agrega un header.",
            "example": "curl -H \"Accept: application/json\" https://api.example.com/items",
            "expected": "Respuesta del endpoint.",
            "note": ""
        },
        {
            "command": "curl -H \"Authorization: Bearer <token>\" https://api.example.com/me",
            "level": "intermediate",
            "topic": "Headers y auth",
            "description": "Usa Bearer token.",
            "example": "curl -H \"Authorization: Bearer <token>\" https://api.example.com/me",
            "expected": "Respuesta autenticada o 401/403.",
            "note": "No dejes tokens reales en historial; preferi variables seguras."
        },
        {
            "command": "curl -u <user>:<password> https://api.example.com",
            "level": "intermediate",
            "topic": "Headers y auth",
            "description": "Usa Basic Auth.",
            "example": "curl -u <user>:<password> https://api.example.com",
            "expected": "Respuesta autenticada.",
            "note": "La password puede quedar visible en historial/procesos; mejor usar mecanismos seguros."
        },
        {
            "command": "curl -X POST -H \"Content-Type: application/json\" -d '{\"name\":\"demo\"}' https://api.example.com/items",
            "level": "basic",
            "topic": "Body y uploads",
            "description": "Envia JSON.",
            "example": "curl -X POST -H \"Content-Type: application/json\" -d '{\"name\":\"demo\"}' https://api.example.com/items",
            "expected": "Respuesta de creacion y status.",
            "note": ""
        },
        {
            "command": "curl -F \"file=@./report.pdf\" https://api.example.com/upload",
            "level": "intermediate",
            "topic": "Body y uploads",
            "description": "Sube un archivo multipart.",
            "example": "curl -F \"file=@./report.pdf\" https://api.example.com/upload",
            "expected": "Respuesta del endpoint de upload.",
            "note": ""
        },
        {
            "command": "curl --data-urlencode \"q=texto con espacios\" https://api.example.com/search",
            "level": "intermediate",
            "topic": "Body y uploads",
            "description": "Codifica un parametro form/query.",
            "example": "curl --data-urlencode \"q=texto con espacios\" https://api.example.com/search",
            "expected": "Respuesta de busqueda.",
            "note": ""
        },
        {
            "command": "curl -o file.zip https://example.com/file.zip",
            "level": "basic",
            "topic": "Downloads y salida",
            "description": "Descarga a un nombre local.",
            "example": "curl -o file.zip https://example.com/file.zip",
            "expected": "Progreso y file.zip.",
            "note": ""
        },
        {
            "command": "curl -O https://example.com/file.zip",
            "level": "basic",
            "topic": "Downloads y salida",
            "description": "Conserva el nombre remoto.",
            "example": "curl -O https://example.com/file.zip",
            "expected": "Archivo file.zip.",
            "note": ""
        },
        {
            "command": "curl -L https://example.com",
            "level": "basic",
            "topic": "Redirects, retry y timeouts",
            "description": "Sigue redirects.",
            "example": "curl -L https://example.com",
            "expected": "Body del destino final.",
            "note": ""
        },
        {
            "command": "curl --retry 5 --retry-all-errors --connect-timeout 5 --max-time 30 https://api.example.com/health",
            "level": "intermediate",
            "topic": "Redirects, retry y timeouts",
            "description": "Reintenta fallos transitorios con limites.",
            "example": "curl --retry 5 --retry-all-errors --connect-timeout 5 --max-time 30 https://api.example.com/health",
            "expected": "Respuesta o error despues de reintentos.",
            "note": ""
        },
        {
            "command": "curl --cacert <ca.pem> https://internal.example.com",
            "level": "intermediate",
            "topic": "TLS y certificados",
            "description": "Confia en una CA especifica.",
            "example": "curl --cacert <ca.pem> https://internal.example.com",
            "expected": "Respuesta HTTPS si la cadena valida.",
            "note": ""
        },
        {
            "command": "curl --cert <client.pem> --key <client.key> https://mtls.example.com",
            "level": "advanced",
            "topic": "TLS y certificados",
            "description": "Usa mTLS con certificado cliente.",
            "example": "curl --cert <client.pem> --key <client.key> https://mtls.example.com",
            "expected": "Respuesta si autenticacion TLS funciona.",
            "note": "Protege la clave privada."
        },
        {
            "command": "curl --resolve example.com:443:203.0.113.10 https://example.com",
            "level": "intermediate",
            "topic": "Proxy y red",
            "description": "Fuerza resolucion DNS para una solicitud.",
            "example": "curl --resolve example.com:443:203.0.113.10 https://example.com",
            "expected": "Respuesta usando la IP indicada manteniendo Host/SNI.",
            "note": ""
        },
        {
            "command": "curl -x http://127.0.0.1:8080 https://example.com",
            "level": "intermediate",
            "topic": "Proxy y red",
            "description": "Usa un proxy HTTP.",
            "example": "curl -x http://127.0.0.1:8080 https://example.com",
            "expected": "Respuesta a traves del proxy.",
            "note": ""
        },
        {
            "command": "curl -v https://example.com",
            "level": "basic",
            "topic": "Diagnostico",
            "description": "Muestra handshake/headers de request y response.",
            "example": "curl -v https://example.com",
            "expected": "Traza en stderr y body en stdout.",
            "note": ""
        },
        {
            "command": "curl -sS -o /dev/null -w '%{http_code} %{time_total}\n' https://example.com",
            "level": "intermediate",
            "topic": "Diagnostico",
            "description": "Mide status y tiempo total sin body.",
            "example": "curl -sS -o /dev/null -w '%{http_code} %{time_total}\n' https://example.com",
            "expected": "Ejemplo: 200 0.153.",
            "note": ""
        },
        {
            "command": "curl --trace-time --trace-ascii trace.txt https://example.com",
            "level": "advanced",
            "topic": "Diagnostico",
            "description": "Guarda una traza detallada.",
            "example": "curl --trace-time --trace-ascii trace.txt https://example.com",
            "expected": "Archivo trace.txt.",
            "note": "Puede contener headers, tokens o payloads; sanitizalo antes de compartir."
        }
    ],
    "postgres": [
        {
            "command": "psql -h <host> -p 5432 -U <user> -d <db>",
            "level": "basic",
            "topic": "Conexi\u00f3n y sesi\u00f3n",
            "description": "Abre una sesi\u00f3n psql.",
            "example": "psql -h <host> -p 5432 -U <user> -d <db>",
            "expected": "Prompt de PostgreSQL o error de autenticaci\u00f3n.",
            "note": ""
        },
        {
            "command": "psql \"postgresql://<user>@<host>:5432/<db>\"",
            "level": "basic",
            "topic": "Conexi\u00f3n y sesi\u00f3n",
            "description": "Conecta usando connection URI.",
            "example": "psql \"postgresql://<user>@<host>:5432/<db>\"",
            "expected": "Prompt psql.",
            "note": "Evita incluir password en la URI visible."
        },
        {
            "command": "psql -v ON_ERROR_STOP=1 -f <script.sql> <db>",
            "level": "intermediate",
            "topic": "Conexi\u00f3n y sesi\u00f3n",
            "description": "Ejecuta un script y corta ante el primer error SQL.",
            "example": "psql -v ON_ERROR_STOP=1 -f <script.sql> <db>",
            "expected": "Salida del script o error con exit code distinto de 0.",
            "note": ""
        },
        {
            "command": "psql -Atc \"SELECT current_database(), current_user;\" <db>",
            "level": "intermediate",
            "topic": "Conexi\u00f3n y sesi\u00f3n",
            "description": "Ejecuta consulta en formato apto para scripting.",
            "example": "psql -Atc \"SELECT current_database(), current_user;\" <db>",
            "expected": "Una l\u00ednea sin headers/alineaci\u00f3n.",
            "note": ""
        },
        {
            "command": "\\l",
            "level": "basic",
            "topic": "Schema e inspecci\u00f3n",
            "description": "Lista bases dentro de psql.",
            "example": "\\l",
            "expected": "Nombre, owner, encoding y privilegios.",
            "note": ""
        },
        {
            "command": "\\dt",
            "level": "basic",
            "topic": "Schema e inspecci\u00f3n",
            "description": "Lista tablas del search_path.",
            "example": "\\dt",
            "expected": "Schema, Name, Type y Owner.",
            "note": ""
        },
        {
            "command": "\\d+ <table>",
            "level": "basic",
            "topic": "Schema e inspecci\u00f3n",
            "description": "Describe tabla con detalles.",
            "example": "\\d+ <table>",
            "expected": "Columnas, tipos, indexes, constraints y storage.",
            "note": ""
        },
        {
            "command": "\\du+",
            "level": "intermediate",
            "topic": "Schema e inspecci\u00f3n",
            "description": "Lista roles con atributos.",
            "example": "\\du+",
            "expected": "Roles, flags y membres\u00edas.",
            "note": ""
        },
        {
            "command": "pg_dump -Fc -f backup.dump <db>",
            "level": "basic",
            "topic": "Backup y restore",
            "description": "Crea backup custom format.",
            "example": "pg_dump -Fc -f backup.dump <db>",
            "expected": "Archivo backup.dump.",
            "note": "Verifica espacio y compatibilidad de versiones."
        },
        {
            "command": "pg_restore -l backup.dump",
            "level": "intermediate",
            "topic": "Backup y restore",
            "description": "Lista contenido de un dump custom.",
            "example": "pg_restore -l backup.dump",
            "expected": "Tabla de contenidos del archive.",
            "note": ""
        },
        {
            "command": "pg_restore -d <db> --clean --if-exists backup.dump",
            "level": "intermediate",
            "topic": "Backup y restore",
            "description": "Restaura limpiando objetos existentes.",
            "example": "pg_restore -d <db> --clean --if-exists backup.dump",
            "expected": "Progreso/errores de restore.",
            "note": "Puede reemplazar objetos y datos existentes."
        },
        {
            "command": "pg_dumpall --globals-only > globals.sql",
            "level": "advanced",
            "topic": "Backup y restore",
            "description": "Respalda roles y objetos globales.",
            "example": "pg_dumpall --globals-only > globals.sql",
            "expected": "Archivo SQL con roles/tablespaces.",
            "note": ""
        },
        {
            "command": "createdb -U <user> <db>",
            "level": "basic",
            "topic": "Administraci\u00f3n",
            "description": "Crea una base.",
            "example": "createdb -U <user> <db>",
            "expected": "Sin salida si funciona.",
            "note": ""
        },
        {
            "command": "dropdb --interactive <db>",
            "level": "basic",
            "topic": "Administraci\u00f3n",
            "description": "Elimina una base con confirmaci\u00f3n.",
            "example": "dropdb --interactive <db>",
            "expected": "Prompt y base eliminada si confirmas.",
            "note": "Destructivo."
        },
        {
            "command": "vacuumdb --analyze-in-stages <db>",
            "level": "intermediate",
            "topic": "Administraci\u00f3n",
            "description": "Actualiza estad\u00edsticas en etapas.",
            "example": "vacuumdb --analyze-in-stages <db>",
            "expected": "Progreso por tablas/fases.",
            "note": ""
        },
        {
            "command": "reindexdb --concurrently <db>",
            "level": "advanced",
            "topic": "Administraci\u00f3n",
            "description": "Reconstruye indexes intentando minimizar bloqueo.",
            "example": "reindexdb --concurrently <db>",
            "expected": "Progreso/resultado por objetos.",
            "note": "Requiere versi\u00f3n compatible y recursos suficientes."
        },
        {
            "command": "\\copy <table> TO 'data.csv' CSV HEADER",
            "level": "basic",
            "topic": "Importar y exportar",
            "description": "Exporta tabla desde psql al filesystem del cliente.",
            "example": "\\copy <table> TO 'data.csv' CSV HEADER",
            "expected": "Archivo data.csv.",
            "note": ""
        },
        {
            "command": "\\copy <table> FROM 'data.csv' CSV HEADER",
            "level": "basic",
            "topic": "Importar y exportar",
            "description": "Importa CSV desde el cliente.",
            "example": "\\copy <table> FROM 'data.csv' CSV HEADER",
            "expected": "COPY N con filas importadas.",
            "note": "Valida tipos y destino antes de cargar."
        },
        {
            "command": "EXPLAIN SELECT * FROM <table> WHERE <condition>;",
            "level": "basic",
            "topic": "Diagn\u00f3stico y performance",
            "description": "Muestra el plan estimado.",
            "example": "EXPLAIN SELECT * FROM <table> WHERE <condition>;",
            "expected": "Nodos del plan y costos estimados.",
            "note": ""
        },
        {
            "command": "EXPLAIN (ANALYZE, BUFFERS) SELECT ...;",
            "level": "intermediate",
            "topic": "Diagn\u00f3stico y performance",
            "description": "Ejecuta la consulta y mide plan real/buffers.",
            "example": "EXPLAIN (ANALYZE, BUFFERS) SELECT ...;",
            "expected": "Tiempos reales, filas y buffers.",
            "note": "ANALYZE ejecuta realmente la consulta; cuidado con UPDATE/DELETE."
        },
        {
            "command": "pg_isready -h <host> -p 5432",
            "level": "intermediate",
            "topic": "Diagn\u00f3stico y performance",
            "description": "Comprueba si PostgreSQL acepta conexiones.",
            "example": "pg_isready -h <host> -p 5432",
            "expected": "accepting connections o estado de rechazo.",
            "note": ""
        },
        {
            "command": "pgbench -c 10 -j 2 -T 60 <db>",
            "level": "advanced",
            "topic": "Diagn\u00f3stico y performance",
            "description": "Ejecuta benchmark durante 60 segundos.",
            "example": "pgbench -c 10 -j 2 -T 60 <db>",
            "expected": "TPS, latency y estad\u00edsticas.",
            "note": "No ejecutes benchmarks pesados en producci\u00f3n sin planificar."
        },
        {
            "command": "pg_basebackup -h <primary> -D <dir> -U <repl-user> -Fp -Xs -P",
            "level": "advanced",
            "topic": "Replicaci\u00f3n",
            "description": "Crea un base backup para replicaci\u00f3n.",
            "example": "pg_basebackup -h <primary> -D <dir> -U <repl-user> -Fp -Xs -P",
            "expected": "Progreso y data directory.",
            "note": "Requiere permisos de replicaci\u00f3n y espacio suficiente."
        }
    ],
    "mysql": [
        {
            "command": "mysql -h <host> -P 3306 -u <user> -p <db>",
            "level": "basic",
            "topic": "Conexi\u00f3n",
            "description": "Conecta al servidor MySQL.",
            "example": "mysql -h <host> -P 3306 -u <user> -p <db>",
            "expected": "Prompt mysql tras pedir password.",
            "note": ""
        },
        {
            "command": "mysql --protocol=TCP -h 127.0.0.1 -u <user> -p",
            "level": "intermediate",
            "topic": "Conexi\u00f3n",
            "description": "Fuerza conexi\u00f3n TCP local.",
            "example": "mysql --protocol=TCP -h 127.0.0.1 -u <user> -p",
            "expected": "Prompt mysql.",
            "note": ""
        },
        {
            "command": "mysql -N -B -e \"SELECT VERSION();\"",
            "level": "intermediate",
            "topic": "Conexi\u00f3n",
            "description": "Ejecuta una consulta en modo batch sin headers.",
            "example": "mysql -N -B -e \"SELECT VERSION();\"",
            "expected": "Una l\u00ednea con la versi\u00f3n.",
            "note": ""
        },
        {
            "command": "SHOW DATABASES;",
            "level": "basic",
            "topic": "Schema e inspecci\u00f3n",
            "description": "Lista bases visibles.",
            "example": "SHOW DATABASES;",
            "expected": "Filas con Database.",
            "note": ""
        },
        {
            "command": "SHOW TABLES;",
            "level": "basic",
            "topic": "Schema e inspecci\u00f3n",
            "description": "Lista tablas de la base actual.",
            "example": "SHOW TABLES;",
            "expected": "Nombres de tablas.",
            "note": ""
        },
        {
            "command": "SHOW CREATE TABLE <table>\\G",
            "level": "basic",
            "topic": "Schema e inspecci\u00f3n",
            "description": "Muestra el DDL de una tabla.",
            "example": "SHOW CREATE TABLE <table>\\G",
            "expected": "CREATE TABLE completo.",
            "note": ""
        },
        {
            "command": "SHOW INDEX FROM <table>;",
            "level": "intermediate",
            "topic": "Schema e inspecci\u00f3n",
            "description": "Lista indexes de una tabla.",
            "example": "SHOW INDEX FROM <table>;",
            "expected": "Key_name, Column_name, Cardinality y m\u00e1s.",
            "note": ""
        },
        {
            "command": "mysqldump -u <user> -p <db> > backup.sql",
            "level": "basic",
            "topic": "Backup y restore",
            "description": "Exporta una base a SQL.",
            "example": "mysqldump -u <user> -p <db> > backup.sql",
            "expected": "Archivo backup.sql.",
            "note": "Protege el dump: puede contener datos sensibles."
        },
        {
            "command": "mysqldump -u <user> -p --single-transaction --routines --triggers <db> > backup.sql",
            "level": "intermediate",
            "topic": "Backup y restore",
            "description": "Crea dump consistente para InnoDB con rutinas/triggers.",
            "example": "mysqldump -u <user> -p --single-transaction --routines --triggers <db> > backup.sql",
            "expected": "Archivo SQL.",
            "note": "Comprueba engine y requisitos de consistencia."
        },
        {
            "command": "mysql -u <user> -p <db> < backup.sql",
            "level": "basic",
            "topic": "Backup y restore",
            "description": "Restaura SQL.",
            "example": "mysql -u <user> -p <db> < backup.sql",
            "expected": "Salida solo ante mensajes/errores.",
            "note": "Puede sobrescribir datos seg\u00fan el dump."
        },
        {
            "command": "CREATE USER '<user>'@'%' IDENTIFIED BY '<password>';",
            "level": "basic",
            "topic": "Usuarios y seguridad",
            "description": "Crea un usuario.",
            "example": "CREATE USER '<user>'@'%' IDENTIFIED BY '<password>';",
            "expected": "Query OK.",
            "note": "Usa una password fuerte y host lo m\u00e1s restrictivo posible."
        },
        {
            "command": "GRANT SELECT,INSERT,UPDATE ON <db>.* TO '<user>'@'%';",
            "level": "intermediate",
            "topic": "Usuarios y seguridad",
            "description": "Concede privilegios concretos.",
            "example": "GRANT SELECT,INSERT,UPDATE ON <db>.* TO '<user>'@'%';",
            "expected": "Query OK.",
            "note": "Aplica principio de m\u00ednimo privilegio."
        },
        {
            "command": "SHOW GRANTS FOR '<user>'@'%';",
            "level": "intermediate",
            "topic": "Usuarios y seguridad",
            "description": "Muestra permisos de un usuario.",
            "example": "SHOW GRANTS FOR '<user>'@'%';",
            "expected": "Sentencias GRANT efectivas.",
            "note": ""
        },
        {
            "command": "mysqladmin -u <user> -p status",
            "level": "basic",
            "topic": "Administraci\u00f3n",
            "description": "Muestra estado resumido del servidor.",
            "example": "mysqladmin -u <user> -p status",
            "expected": "Uptime, threads, questions, slow queries y m\u00e1s.",
            "note": ""
        },
        {
            "command": "mysqlcheck -u <user> -p --all-databases",
            "level": "intermediate",
            "topic": "Administraci\u00f3n",
            "description": "Comprueba tablas.",
            "example": "mysqlcheck -u <user> -p --all-databases",
            "expected": "Estado por tabla.",
            "note": ""
        },
        {
            "command": "SHOW FULL PROCESSLIST;",
            "level": "basic",
            "topic": "Diagn\u00f3stico",
            "description": "Muestra conexiones/queries activas.",
            "example": "SHOW FULL PROCESSLIST;",
            "expected": "Id, User, Host, DB, Command, Time, State, Info.",
            "note": ""
        },
        {
            "command": "EXPLAIN FORMAT=JSON SELECT ...;",
            "level": "intermediate",
            "topic": "Diagn\u00f3stico",
            "description": "Muestra plan de ejecuci\u00f3n en JSON.",
            "example": "EXPLAIN FORMAT=JSON SELECT ...;",
            "expected": "Plan detallado JSON.",
            "note": ""
        },
        {
            "command": "SHOW ENGINE INNODB STATUS\\G",
            "level": "advanced",
            "topic": "Diagn\u00f3stico",
            "description": "Muestra estado interno de InnoDB.",
            "example": "SHOW ENGINE INNODB STATUS\\G",
            "expected": "Texto con transactions, locks, buffer pool y deadlocks.",
            "note": ""
        }
    ],
    "redis": [
        {
            "command": "redis-cli -h <host> -p 6379 PING",
            "level": "basic",
            "topic": "Conexi\u00f3n y servidor",
            "description": "Prueba conexi\u00f3n.",
            "example": "redis-cli -h <host> -p 6379 PING",
            "expected": "PONG.",
            "note": ""
        },
        {
            "command": "redis-cli --tls -h <host> -p <port> --cacert <ca.pem> PING",
            "level": "intermediate",
            "topic": "Conexi\u00f3n y servidor",
            "description": "Conecta usando TLS.",
            "example": "redis-cli --tls -h <host> -p <port> --cacert <ca.pem> PING",
            "expected": "PONG o error TLS/auth.",
            "note": ""
        },
        {
            "command": "redis-cli INFO server",
            "level": "basic",
            "topic": "Conexi\u00f3n y servidor",
            "description": "Muestra secci\u00f3n server.",
            "example": "redis-cli INFO server",
            "expected": "Version, mode, os, uptime y process id.",
            "note": ""
        },
        {
            "command": "redis-cli INFO memory",
            "level": "intermediate",
            "topic": "Conexi\u00f3n y servidor",
            "description": "Muestra m\u00e9tricas de memoria.",
            "example": "redis-cli INFO memory",
            "expected": "used_memory, fragmentation, allocator y m\u00e1s.",
            "note": ""
        },
        {
            "command": "redis-cli SET <key> <value>",
            "level": "basic",
            "topic": "Keys",
            "description": "Guarda un string.",
            "example": "redis-cli SET <key> <value>",
            "expected": "OK.",
            "note": ""
        },
        {
            "command": "redis-cli GET <key>",
            "level": "basic",
            "topic": "Keys",
            "description": "Lee un string.",
            "example": "redis-cli GET <key>",
            "expected": "Valor o nil.",
            "note": ""
        },
        {
            "command": "redis-cli EXPIRE <key> 3600",
            "level": "basic",
            "topic": "Keys",
            "description": "Define TTL de una hora.",
            "example": "redis-cli EXPIRE <key> 3600",
            "expected": "1 si se aplic\u00f3.",
            "note": ""
        },
        {
            "command": "redis-cli SCAN 0 MATCH 'prefix:*' COUNT 100",
            "level": "intermediate",
            "topic": "Keys",
            "description": "Itera keys sin bloquear como KEYS.",
            "example": "redis-cli SCAN 0 MATCH 'prefix:*' COUNT 100",
            "expected": "Cursor siguiente y lote de keys.",
            "note": ""
        },
        {
            "command": "redis-cli UNLINK <key>",
            "level": "intermediate",
            "topic": "Keys",
            "description": "Desasocia una key y libera memoria asincr\u00f3nicamente.",
            "example": "redis-cli UNLINK <key>",
            "expected": "Cantidad eliminada.",
            "note": ""
        },
        {
            "command": "redis-cli HSET user:1 name Ana role admin",
            "level": "basic",
            "topic": "Hashes y colecciones",
            "description": "Guarda campos en un hash.",
            "example": "redis-cli HSET user:1 name Ana role admin",
            "expected": "N\u00famero de campos nuevos.",
            "note": ""
        },
        {
            "command": "redis-cli HGETALL user:1",
            "level": "basic",
            "topic": "Hashes y colecciones",
            "description": "Lee todos los campos del hash.",
            "example": "redis-cli HGETALL user:1",
            "expected": "Lista campo/valor.",
            "note": ""
        },
        {
            "command": "redis-cli LPUSH queue item1 item2",
            "level": "basic",
            "topic": "Hashes y colecciones",
            "description": "Inserta elementos en una lista.",
            "example": "redis-cli LPUSH queue item1 item2",
            "expected": "Nueva longitud.",
            "note": ""
        },
        {
            "command": "redis-cli SADD tags api backend",
            "level": "basic",
            "topic": "Hashes y colecciones",
            "description": "Agrega miembros a un set.",
            "example": "redis-cli SADD tags api backend",
            "expected": "Cantidad de miembros nuevos.",
            "note": ""
        },
        {
            "command": "redis-cli ZADD leaderboard 100 user1 120 user2",
            "level": "intermediate",
            "topic": "Hashes y colecciones",
            "description": "Agrega miembros con score a sorted set.",
            "example": "redis-cli ZADD leaderboard 100 user1 120 user2",
            "expected": "Cantidad de miembros nuevos.",
            "note": ""
        },
        {
            "command": "redis-cli PUBLISH events '{\"type\":\"demo\"}'",
            "level": "basic",
            "topic": "Pub/Sub y streams",
            "description": "Publica un mensaje.",
            "example": "redis-cli PUBLISH events '{\"type\":\"demo\"}'",
            "expected": "N\u00famero de suscriptores que lo recibieron.",
            "note": ""
        },
        {
            "command": "redis-cli XADD events '*' type login user 42",
            "level": "intermediate",
            "topic": "Pub/Sub y streams",
            "description": "Agrega entrada a stream.",
            "example": "redis-cli XADD events '*' type login user 42",
            "expected": "ID generado.",
            "note": ""
        },
        {
            "command": "redis-cli XREAD BLOCK 5000 STREAMS events '$'",
            "level": "advanced",
            "topic": "Pub/Sub y streams",
            "description": "Espera nuevas entradas hasta 5s.",
            "example": "redis-cli XREAD BLOCK 5000 STREAMS events '$'",
            "expected": "Nuevos entries o nil.",
            "note": ""
        },
        {
            "command": "redis-cli BGSAVE",
            "level": "basic",
            "topic": "Persistencia y backup",
            "description": "Dispara RDB en background.",
            "example": "redis-cli BGSAVE",
            "expected": "Background saving started.",
            "note": ""
        },
        {
            "command": "redis-cli LASTSAVE",
            "level": "intermediate",
            "topic": "Persistencia y backup",
            "description": "Muestra epoch del ultimo save.",
            "example": "redis-cli LASTSAVE",
            "expected": "Timestamp Unix.",
            "note": ""
        },
        {
            "command": "redis-check-rdb <dump.rdb>",
            "level": "advanced",
            "topic": "Persistencia y backup",
            "description": "Valida un archivo RDB.",
            "example": "redis-check-rdb <dump.rdb>",
            "expected": "Diagn\u00f3stico y OK/error.",
            "note": ""
        },
        {
            "command": "redis-cli INFO replication",
            "level": "intermediate",
            "topic": "Cluster y replicaci\u00f3n",
            "description": "Muestra rol y estado de replicas.",
            "example": "redis-cli INFO replication",
            "expected": "role, connected_slaves/master status.",
            "note": ""
        },
        {
            "command": "redis-cli --cluster check <host>:<port>",
            "level": "advanced",
            "topic": "Cluster y replicaci\u00f3n",
            "description": "Valida topolog\u00eda Redis Cluster.",
            "example": "redis-cli --cluster check <host>:<port>",
            "expected": "Slots, nodos y consistencia.",
            "note": ""
        },
        {
            "command": "redis-cli CLUSTER NODES",
            "level": "advanced",
            "topic": "Cluster y replicaci\u00f3n",
            "description": "Lista nodos vistos por el nodo actual.",
            "example": "redis-cli CLUSTER NODES",
            "expected": "Node IDs, flags, address y slots.",
            "note": ""
        }
    ],
    "python": [
        {
            "command": "python --version",
            "level": "basic",
            "topic": "Runtime y scripts",
            "description": "Muestra la versi\u00f3n de Python.",
            "example": "python --version",
            "expected": "Python X.Y.Z.",
            "note": ""
        },
        {
            "command": "python -c \"import sys; print(sys.executable)\"",
            "level": "basic",
            "topic": "Runtime y scripts",
            "description": "Muestra el interprete actual.",
            "example": "python -c \"import sys; print(sys.executable)\"",
            "expected": "Ruta absoluta del ejecutable.",
            "note": ""
        },
        {
            "command": "python -m http.server 8000",
            "level": "intermediate",
            "topic": "Runtime y scripts",
            "description": "Sirve el directorio actual por HTTP.",
            "example": "python -m http.server 8000",
            "expected": "Serving HTTP on ...:8000.",
            "note": "Solo para desarrollo local."
        },
        {
            "command": "python -m json.tool < input.json",
            "level": "intermediate",
            "topic": "Runtime y scripts",
            "description": "Valida y formatea JSON.",
            "example": "python -m json.tool < input.json",
            "expected": "JSON indentado o error de parseo.",
            "note": ""
        },
        {
            "command": "python -m venv .venv",
            "level": "basic",
            "topic": "Entornos virtuales",
            "description": "Crea un entorno virtual.",
            "example": "python -m venv .venv",
            "expected": "Directorio .venv.",
            "note": ""
        },
        {
            "command": ".\\.venv\\Scripts\\Activate.ps1",
            "level": "basic",
            "topic": "Entornos virtuales",
            "description": "Activa venv en PowerShell Windows.",
            "example": ".\\.venv\\Scripts\\Activate.ps1",
            "expected": "Prompt suele mostrar (.venv).",
            "note": ""
        },
        {
            "command": "source .venv/bin/activate",
            "level": "basic",
            "topic": "Entornos virtuales",
            "description": "Activa venv en Linux/macOS.",
            "example": "source .venv/bin/activate",
            "expected": "Prompt suele mostrar (.venv).",
            "note": ""
        },
        {
            "command": "python -m pip install -r requirements.txt",
            "level": "basic",
            "topic": "pip y paquetes",
            "description": "Instala dependencias de un archivo.",
            "example": "python -m pip install -r requirements.txt",
            "expected": "Descargas/instalaciones y resumen.",
            "note": ""
        },
        {
            "command": "python -m pip freeze > requirements.txt",
            "level": "basic",
            "topic": "pip y paquetes",
            "description": "Exporta versiones instaladas.",
            "example": "python -m pip freeze > requirements.txt",
            "expected": "Archivo requirements.txt.",
            "note": ""
        },
        {
            "command": "python -m pip check",
            "level": "intermediate",
            "topic": "pip y paquetes",
            "description": "Comprueba compatibilidad de dependencias instaladas.",
            "example": "python -m pip check",
            "expected": "No broken requirements found o conflictos.",
            "note": ""
        },
        {
            "command": "python -m pip list --outdated",
            "level": "intermediate",
            "topic": "pip y paquetes",
            "description": "Lista paquetes desactualizados.",
            "example": "python -m pip list --outdated",
            "expected": "Package, Version y Latest.",
            "note": ""
        },
        {
            "command": "pytest -q",
            "level": "basic",
            "topic": "Testing",
            "description": "Ejecuta pytest con salida compacta.",
            "example": "pytest -q",
            "expected": "Resumen de tests.",
            "note": ""
        },
        {
            "command": "pytest -x -vv",
            "level": "intermediate",
            "topic": "Testing",
            "description": "Detiene al primer fallo con detalle.",
            "example": "pytest -x -vv",
            "expected": "Detalle por test y primer fallo.",
            "note": ""
        },
        {
            "command": "pytest --lf",
            "level": "intermediate",
            "topic": "Testing",
            "description": "Ejecuta los tests que fallaron en la corrida anterior.",
            "example": "pytest --lf",
            "expected": "Resultados de last-failed.",
            "note": ""
        },
        {
            "command": "coverage run -m pytest && coverage report -m",
            "level": "intermediate",
            "topic": "Testing",
            "description": "Mide cobertura y la muestra.",
            "example": "coverage run -m pytest && coverage report -m",
            "expected": "Tabla de archivos, statements y missing lines.",
            "note": ""
        },
        {
            "command": "ruff check .",
            "level": "basic",
            "topic": "Lint y formato",
            "description": "Ejecuta lint con Ruff.",
            "example": "ruff check .",
            "expected": "Issues o All checks passed.",
            "note": ""
        },
        {
            "command": "ruff format --check .",
            "level": "basic",
            "topic": "Lint y formato",
            "description": "Comprueba formato Ruff.",
            "example": "ruff format --check .",
            "expected": "Archivos que cambiar\u00edan o confirmaci\u00f3n.",
            "note": ""
        },
        {
            "command": "black --check .",
            "level": "basic",
            "topic": "Lint y formato",
            "description": "Comprueba formato Black.",
            "example": "black --check .",
            "expected": "Archivos que se reformatear\u00edan.",
            "note": ""
        },
        {
            "command": "mypy .",
            "level": "intermediate",
            "topic": "Lint y formato",
            "description": "Ejecuta type checking est\u00e1tico.",
            "example": "mypy .",
            "expected": "Errores de tipos o Success.",
            "note": ""
        },
        {
            "command": "python -m build",
            "level": "intermediate",
            "topic": "Packaging",
            "description": "Construye sdist y wheel.",
            "example": "python -m build",
            "expected": "Archivos en dist/.",
            "note": ""
        },
        {
            "command": "twine check dist/*",
            "level": "intermediate",
            "topic": "Packaging",
            "description": "Valida metadata de artifacts.",
            "example": "twine check dist/*",
            "expected": "PASSED o errores.",
            "note": ""
        },
        {
            "command": "twine upload dist/*",
            "level": "advanced",
            "topic": "Packaging",
            "description": "Publica artifacts en un package index.",
            "example": "twine upload dist/*",
            "expected": "Progreso y URLs.",
            "note": "Requiere credenciales y puede publicar de forma irreversible."
        },
        {
            "command": "python -m pdb <script.py>",
            "level": "basic",
            "topic": "Profiling y debug",
            "description": "Ejecuta bajo debugger pdb.",
            "example": "python -m pdb <script.py>",
            "expected": "Prompt (Pdb).",
            "note": ""
        },
        {
            "command": "python -m cProfile -s cumulative <script.py>",
            "level": "intermediate",
            "topic": "Profiling y debug",
            "description": "Perfila CPU y ordena por tiempo acumulado.",
            "example": "python -m cProfile -s cumulative <script.py>",
            "expected": "Tabla de funciones y tiempos.",
            "note": ""
        },
        {
            "command": "python -X tracemalloc=25 <script.py>",
            "level": "advanced",
            "topic": "Profiling y debug",
            "description": "Activa tracemalloc con 25 frames.",
            "example": "python -X tracemalloc=25 <script.py>",
            "expected": "Salida del script y trazas disponibles para diagnostico.",
            "note": ""
        }
    ],
    "network": [
        {
            "command": "ping <host>",
            "level": "basic",
            "topic": "Conectividad",
            "description": "Prueba alcance ICMP.",
            "example": "ping <host>",
            "expected": "Latencia por paquete y resumen de perdida.",
            "note": ""
        },
        {
            "command": "traceroute <host>",
            "level": "intermediate",
            "topic": "Conectividad",
            "description": "Muestra saltos hasta el destino en Linux/macOS.",
            "example": "traceroute <host>",
            "expected": "Lista de hops y latencias.",
            "note": ""
        },
        {
            "command": "tracert <host>",
            "level": "intermediate",
            "topic": "Conectividad",
            "description": "Muestra saltos en Windows.",
            "example": "tracert <host>",
            "expected": "Hops y tiempos.",
            "note": ""
        },
        {
            "command": "mtr -rwzc 50 <host>",
            "level": "advanced",
            "topic": "Conectividad",
            "description": "Combina ping/traceroute con estadisticas.",
            "example": "mtr -rwzc 50 <host>",
            "expected": "Reporte por hop con perdida y latencias.",
            "note": ""
        },
        {
            "command": "dig <domain> A +short",
            "level": "basic",
            "topic": "DNS",
            "description": "Resuelve registros A de forma compacta.",
            "example": "dig <domain> A +short",
            "expected": "IPs, una por linea.",
            "note": ""
        },
        {
            "command": "dig <domain> ANY +noall +answer",
            "level": "intermediate",
            "topic": "DNS",
            "description": "Solicita respuestas disponibles y muestra answer.",
            "example": "dig <domain> ANY +noall +answer",
            "expected": "Registros devueltos por el servidor.",
            "note": "ANY puede estar limitado por servidores modernos."
        },
        {
            "command": "dig +trace <domain>",
            "level": "intermediate",
            "topic": "DNS",
            "description": "Sigue la delegacion DNS desde root.",
            "example": "dig +trace <domain>",
            "expected": "Cadena root/TLD/autoritativos.",
            "note": ""
        },
        {
            "command": "nslookup <domain>",
            "level": "basic",
            "topic": "DNS",
            "description": "Consulta DNS.",
            "example": "nslookup <domain>",
            "expected": "Servidor consultado y direcciones.",
            "note": ""
        },
        {
            "command": "nc -vz <host> <port>",
            "level": "basic",
            "topic": "Puertos y sockets",
            "description": "Prueba conexion TCP con netcat.",
            "example": "nc -vz <host> <port>",
            "expected": "succeeded/open o error.",
            "note": ""
        },
        {
            "command": "ss -lntp",
            "level": "intermediate",
            "topic": "Puertos y sockets",
            "description": "Lista listeners TCP y procesos.",
            "example": "ss -lntp",
            "expected": "Puertos, addresses y process metadata.",
            "note": ""
        },
        {
            "command": "lsof -nP -iTCP:<port> -sTCP:LISTEN",
            "level": "intermediate",
            "topic": "Puertos y sockets",
            "description": "Identifica quien escucha un puerto.",
            "example": "lsof -nP -iTCP:<port> -sTCP:LISTEN",
            "expected": "COMMAND, PID, USER y socket.",
            "note": ""
        },
        {
            "command": "ip addr",
            "level": "basic",
            "topic": "Interfaces y rutas",
            "description": "Muestra interfaces e IPs en Linux.",
            "example": "ip addr",
            "expected": "Estado, MAC, IPv4/IPv6.",
            "note": ""
        },
        {
            "command": "ip route",
            "level": "basic",
            "topic": "Interfaces y rutas",
            "description": "Muestra tabla de rutas.",
            "example": "ip route",
            "expected": "Default gateway y prefijos.",
            "note": ""
        },
        {
            "command": "ip route get <ip>",
            "level": "intermediate",
            "topic": "Interfaces y rutas",
            "description": "Calcula la ruta efectiva.",
            "example": "ip route get <ip>",
            "expected": "Gateway, interfaz, source address.",
            "note": ""
        },
        {
            "command": "Get-NetIPConfiguration",
            "level": "basic",
            "topic": "Interfaces y rutas",
            "description": "Muestra configuracion IP en PowerShell.",
            "example": "Get-NetIPConfiguration",
            "expected": "Interfaces, IPv4/IPv6, gateway y DNS.",
            "note": ""
        },
        {
            "command": "curl -I https://<domain>",
            "level": "basic",
            "topic": "HTTP y TLS",
            "description": "Muestra status y headers HTTP.",
            "example": "curl -I https://<domain>",
            "expected": "Headers de respuesta.",
            "note": ""
        },
        {
            "command": "openssl s_client -connect <domain>:443 -servername <domain> </dev/null",
            "level": "intermediate",
            "topic": "HTTP y TLS",
            "description": "Inspecciona handshake TLS.",
            "example": "openssl s_client -connect <domain>:443 -servername <domain> </dev/null",
            "expected": "Cadena de certificados, protocolo y cipher.",
            "note": ""
        },
        {
            "command": "sudo tcpdump -ni any host <ip>",
            "level": "intermediate",
            "topic": "Captura y diagnostico",
            "description": "Captura trafico de un host.",
            "example": "sudo tcpdump -ni any host <ip>",
            "expected": "Paquetes en tiempo real.",
            "note": "Puede contener informacion sensible."
        },
        {
            "command": "sudo tcpdump -ni any port <port> -w capture.pcap",
            "level": "advanced",
            "topic": "Captura y diagnostico",
            "description": "Guarda captura pcap.",
            "example": "sudo tcpdump -ni any port <port> -w capture.pcap",
            "expected": "Archivo capture.pcap.",
            "note": "Captura solo donde tengas autorizacion."
        },
        {
            "command": "tshark -r capture.pcap -Y 'http.response.code >= 400'",
            "level": "advanced",
            "topic": "Captura y diagnostico",
            "description": "Filtra un pcap con display filter.",
            "example": "tshark -r capture.pcap -Y 'http.response.code >= 400'",
            "expected": "Paquetes HTTP con status >=400.",
            "note": ""
        }
    ],
    "processes": [
        {
            "command": "tasklist",
            "level": "basic",
            "topic": "Windows",
            "description": "Lista procesos Windows.",
            "example": "tasklist",
            "expected": "Imagen, PID, sesion y memoria.",
            "note": ""
        },
        {
            "command": "taskkill /PID <pid> /F",
            "level": "intermediate",
            "topic": "Windows",
            "description": "Fuerza cierre por PID.",
            "example": "taskkill /PID <pid> /F",
            "expected": "Mensaje de proceso finalizado.",
            "note": "Puede causar perdida de trabajo/datos."
        },
        {
            "command": "Get-Process",
            "level": "basic",
            "topic": "Windows",
            "description": "Lista procesos desde PowerShell.",
            "example": "Get-Process",
            "expected": "Objetos Process.",
            "note": ""
        },
        {
            "command": "Get-Process -Id <pid> | Format-List *",
            "level": "intermediate",
            "topic": "Windows",
            "description": "Muestra todas las propiedades disponibles de un proceso.",
            "example": "Get-Process -Id 1234 | Format-List *",
            "expected": "Detalle completo del objeto Process.",
            "note": ""
        },
        {
            "command": "Get-NetTCPConnection -OwningProcess <pid>",
            "level": "intermediate",
            "topic": "Windows",
            "description": "Lista sockets TCP de un PID.",
            "example": "Get-NetTCPConnection -OwningProcess <pid>",
            "expected": "Conexiones y listeners.",
            "note": ""
        },
        {
            "command": "ps aux --sort=-%mem | head",
            "level": "basic",
            "topic": "Linux",
            "description": "Lista procesos con mayor consumo de memoria.",
            "example": "ps aux --sort=-%mem | head",
            "expected": "Top de procesos con consumo y comando.",
            "note": ""
        },
        {
            "command": "pgrep -af <pattern>",
            "level": "basic",
            "topic": "Linux",
            "description": "Busca procesos y muestra command line.",
            "example": "pgrep -af <pattern>",
            "expected": "PID y comando.",
            "note": ""
        },
        {
            "command": "pkill -TERM -f <pattern>",
            "level": "intermediate",
            "topic": "Linux",
            "description": "Envia SIGTERM a procesos coincidentes.",
            "example": "pkill -TERM -f <pattern>",
            "expected": "Sin salida si funciona.",
            "note": "Verifica con pgrep antes para evitar cerrar procesos incorrectos."
        },
        {
            "command": "kill -TERM <pid>",
            "level": "intermediate",
            "topic": "Linux",
            "description": "Solicita finalizacion limpia.",
            "example": "kill -TERM <pid>",
            "expected": "Sin salida si acepta la senal.",
            "note": ""
        },
        {
            "command": "kill -KILL <pid>",
            "level": "advanced",
            "topic": "Linux",
            "description": "Fuerza finalizacion inmediata.",
            "example": "kill -KILL <pid>",
            "expected": "Proceso termina sin cleanup.",
            "note": "Usalo solo si TERM no funciona."
        },
        {
            "command": "ss -lntp",
            "level": "basic",
            "topic": "Puertos",
            "description": "Lista listeners TCP Linux.",
            "example": "ss -lntp",
            "expected": "Address, port y process.",
            "note": ""
        },
        {
            "command": "netstat -ano | findstr LISTENING",
            "level": "basic",
            "topic": "Puertos",
            "description": "Lista listeners de Windows junto con su PID.",
            "example": "netstat -ano | findstr LISTENING",
            "expected": "Direcci\u00f3n local, puerto, estado LISTENING y PID.",
            "note": ""
        },
        {
            "command": "fuser -v <port>/tcp",
            "level": "intermediate",
            "topic": "Puertos",
            "description": "Muestra procesos asociados a un puerto.",
            "example": "fuser -v <port>/tcp",
            "expected": "USER, PID, ACCESS, COMMAND.",
            "note": ""
        },
        {
            "command": "top",
            "level": "basic",
            "topic": "Recursos",
            "description": "Monitor interactivo Linux.",
            "example": "top",
            "expected": "CPU, load, memoria y procesos.",
            "note": ""
        },
        {
            "command": "htop",
            "level": "basic",
            "topic": "Recursos",
            "description": "Monitor interactivo mejorado.",
            "example": "htop",
            "expected": "Vista navegable de recursos/procesos.",
            "note": ""
        },
        {
            "command": "pidstat -p <pid> 1",
            "level": "intermediate",
            "topic": "Recursos",
            "description": "Muestrea CPU de un PID cada segundo.",
            "example": "pidstat -p <pid> 1",
            "expected": "Metricas periodicas del proceso.",
            "note": ""
        },
        {
            "command": "pmap -x <pid>",
            "level": "intermediate",
            "topic": "Recursos",
            "description": "Muestra mapa de memoria de un proceso.",
            "example": "pmap -x <pid>",
            "expected": "Regiones, RSS y dirty memory.",
            "note": ""
        },
        {
            "command": "perf top -p <pid>",
            "level": "advanced",
            "topic": "Recursos",
            "description": "Perfila hotspots en tiempo real.",
            "example": "perf top -p <pid>",
            "expected": "Funciones/simbolos con porcentaje de CPU.",
            "note": "Requiere perf y permisos apropiados."
        }
    ],
    "packages": [
        {
            "command": "winget search <package>",
            "level": "basic",
            "topic": "Windows winget",
            "description": "Busca paquetes.",
            "example": "winget search <package>",
            "expected": "Nombre, Id, Version, Source.",
            "note": ""
        },
        {
            "command": "winget install --id <id> -e",
            "level": "basic",
            "topic": "Windows winget",
            "description": "Instala por ID exacto.",
            "example": "winget install --id <id> -e",
            "expected": "Progreso y estado de instalacion.",
            "note": ""
        },
        {
            "command": "winget upgrade",
            "level": "basic",
            "topic": "Windows winget",
            "description": "Lista upgrades disponibles.",
            "example": "winget upgrade",
            "expected": "Tabla de paquetes actualizables.",
            "note": ""
        },
        {
            "command": "winget upgrade --all",
            "level": "intermediate",
            "topic": "Windows winget",
            "description": "Actualiza todos los paquetes compatibles.",
            "example": "winget upgrade --all",
            "expected": "Progreso por paquete.",
            "note": "Revisa cambios mayores antes en equipos criticos."
        },
        {
            "command": "winget export -o packages.json",
            "level": "intermediate",
            "topic": "Windows winget",
            "description": "Exporta lista de paquetes.",
            "example": "winget export -o packages.json",
            "expected": "Archivo packages.json.",
            "note": ""
        },
        {
            "command": "choco search <package>",
            "level": "basic",
            "topic": "Chocolatey",
            "description": "Busca paquetes Chocolatey.",
            "example": "choco search <package>",
            "expected": "Resultados con version.",
            "note": ""
        },
        {
            "command": "choco install <package> -y",
            "level": "basic",
            "topic": "Chocolatey",
            "description": "Instala sin prompt.",
            "example": "choco install <package> -y",
            "expected": "Progreso y resumen.",
            "note": ""
        },
        {
            "command": "choco upgrade all -y",
            "level": "intermediate",
            "topic": "Chocolatey",
            "description": "Actualiza todos los paquetes.",
            "example": "choco upgrade all -y",
            "expected": "Resumen de upgrades.",
            "note": "Puede actualizar muchas herramientas de una vez; valida en equipos de trabajo."
        },
        {
            "command": "scoop search <package>",
            "level": "basic",
            "topic": "Scoop",
            "description": "Busca manifests.",
            "example": "scoop search <package>",
            "expected": "Resultados de buckets.",
            "note": ""
        },
        {
            "command": "scoop install <package>",
            "level": "basic",
            "topic": "Scoop",
            "description": "Instala paquete para el usuario.",
            "example": "scoop install <package>",
            "expected": "Descarga y shim creado.",
            "note": ""
        },
        {
            "command": "sudo apt update",
            "level": "basic",
            "topic": "Debian / Ubuntu",
            "description": "Actualiza indices.",
            "example": "sudo apt update",
            "expected": "Repos consultados y paquetes disponibles.",
            "note": ""
        },
        {
            "command": "sudo apt install <package>",
            "level": "basic",
            "topic": "Debian / Ubuntu",
            "description": "Instala paquete.",
            "example": "sudo apt install <package>",
            "expected": "Dependencias, descarga e instalacion.",
            "note": ""
        },
        {
            "command": "apt-cache policy <package>",
            "level": "intermediate",
            "topic": "Debian / Ubuntu",
            "description": "Muestra version instalada/candidata y origen.",
            "example": "apt-cache policy <package>",
            "expected": "Installed, Candidate y repos.",
            "note": ""
        },
        {
            "command": "sudo apt-mark hold <package>",
            "level": "advanced",
            "topic": "Debian / Ubuntu",
            "description": "Bloquea upgrades de un paquete.",
            "example": "sudo apt-mark hold <package>",
            "expected": "Mensaje package set on hold.",
            "note": "Recorda quitar hold cuando corresponda."
        },
        {
            "command": "sudo dnf search <package>",
            "level": "basic",
            "topic": "Fedora / RHEL",
            "description": "Busca paquetes.",
            "example": "sudo dnf search <package>",
            "expected": "Paquetes coincidentes.",
            "note": ""
        },
        {
            "command": "sudo dnf install <package>",
            "level": "basic",
            "topic": "Fedora / RHEL",
            "description": "Instala paquete.",
            "example": "sudo dnf install <package>",
            "expected": "Transaction summary y resultado.",
            "note": ""
        },
        {
            "command": "sudo pacman -Syu",
            "level": "basic",
            "topic": "Arch Linux",
            "description": "Sincroniza repos y actualiza sistema.",
            "example": "sudo pacman -Syu",
            "expected": "Lista de upgrades y progreso.",
            "note": "En Arch se recomienda full upgrade, no partial upgrades."
        },
        {
            "command": "pacman -Ss <package>",
            "level": "basic",
            "topic": "Arch Linux",
            "description": "Busca en repos.",
            "example": "pacman -Ss <package>",
            "expected": "Paquetes y descripciones.",
            "note": ""
        },
        {
            "command": "brew search <package>",
            "level": "basic",
            "topic": "macOS Homebrew",
            "description": "Busca formulas/casks.",
            "example": "brew search <package>",
            "expected": "Coincidencias.",
            "note": ""
        },
        {
            "command": "brew install <formula>",
            "level": "basic",
            "topic": "macOS Homebrew",
            "description": "Instala formula.",
            "example": "brew install <formula>",
            "expected": "Pour/build y caveats.",
            "note": ""
        },
        {
            "command": "brew bundle dump --force",
            "level": "intermediate",
            "topic": "macOS Homebrew",
            "description": "Exporta paquetes a Brewfile.",
            "example": "brew bundle dump --force",
            "expected": "Brewfile en directorio actual.",
            "note": ""
        },
        {
            "command": "snap list",
            "level": "basic",
            "topic": "Snap / Flatpak",
            "description": "Lista snaps instalados.",
            "example": "snap list",
            "expected": "Name, Version, Rev, Tracking.",
            "note": ""
        },
        {
            "command": "flatpak list",
            "level": "basic",
            "topic": "Snap / Flatpak",
            "description": "Lista apps/runtimes Flatpak.",
            "example": "flatpak list",
            "expected": "Application, ID, Version, Branch.",
            "note": ""
        }
    ],
    "go": [
        {
            "command": "go mod init <module>",
            "level": "basic",
            "topic": "Proyecto y modulos",
            "description": "Inicializa go.mod.",
            "example": "go mod init <module>",
            "expected": "go.mod creado.",
            "note": ""
        },
        {
            "command": "go mod tidy",
            "level": "basic",
            "topic": "Proyecto y modulos",
            "description": "Agrega dependencias necesarias y elimina no usadas.",
            "example": "go mod tidy",
            "expected": "go.mod/go.sum actualizados.",
            "note": ""
        },
        {
            "command": "go work init ./app ./lib",
            "level": "intermediate",
            "topic": "Proyecto y modulos",
            "description": "Crea un workspace multi-modulo.",
            "example": "go work init ./app ./lib",
            "expected": "go.work creado.",
            "note": ""
        },
        {
            "command": "go run .",
            "level": "basic",
            "topic": "Build y ejecucion",
            "description": "Compila y ejecuta el paquete actual.",
            "example": "go run .",
            "expected": "Salida de la aplicacion.",
            "note": ""
        },
        {
            "command": "go build ./...",
            "level": "basic",
            "topic": "Build y ejecucion",
            "description": "Compila todos los paquetes.",
            "example": "go build ./...",
            "expected": "Sin salida si compila correctamente.",
            "note": ""
        },
        {
            "command": "go build -race ./...",
            "level": "intermediate",
            "topic": "Build y ejecucion",
            "description": "Compila con race detector.",
            "example": "go build -race ./...",
            "expected": "Binarios/tests instrumentados o errores.",
            "note": "Aumenta costo de ejecucion; pensado para diagnostico."
        },
        {
            "command": "GOOS=linux GOARCH=amd64 go build -o app-linux .",
            "level": "intermediate",
            "topic": "Build y ejecucion",
            "description": "Cross-compila para Linux amd64.",
            "example": "GOOS=linux GOARCH=amd64 go build -o app-linux .",
            "expected": "Binario app-linux.",
            "note": ""
        },
        {
            "command": "go test ./...",
            "level": "basic",
            "topic": "Testing y cobertura",
            "description": "Ejecuta tests.",
            "example": "go test ./...",
            "expected": "ok/fail por paquete.",
            "note": ""
        },
        {
            "command": "go test -race ./...",
            "level": "intermediate",
            "topic": "Testing y cobertura",
            "description": "Ejecuta tests con race detector.",
            "example": "go test -race ./...",
            "expected": "Resultados y posibles data races.",
            "note": ""
        },
        {
            "command": "go test -coverprofile=coverage.out ./...",
            "level": "intermediate",
            "topic": "Testing y cobertura",
            "description": "Genera perfil de cobertura.",
            "example": "go test -coverprofile=coverage.out ./...",
            "expected": "coverage.out y porcentaje por paquete.",
            "note": ""
        },
        {
            "command": "go tool cover -html=coverage.out",
            "level": "intermediate",
            "topic": "Testing y cobertura",
            "description": "Abre reporte HTML.",
            "example": "go tool cover -html=coverage.out",
            "expected": "Navegador con cobertura por linea.",
            "note": ""
        },
        {
            "command": "go get <module>@latest",
            "level": "basic",
            "topic": "Dependencias",
            "description": "Actualiza/agrega dependencia.",
            "example": "go get <module>@latest",
            "expected": "go.mod/go.sum actualizados.",
            "note": ""
        },
        {
            "command": "go mod graph",
            "level": "intermediate",
            "topic": "Dependencias",
            "description": "Muestra grafo de modulos.",
            "example": "go mod graph",
            "expected": "Pares modulo dependencia.",
            "note": ""
        },
        {
            "command": "go mod why -m <module>",
            "level": "intermediate",
            "topic": "Dependencias",
            "description": "Explica por que se requiere un modulo.",
            "example": "go mod why -m <module>",
            "expected": "Cadena de paquetes.",
            "note": ""
        },
        {
            "command": "go env",
            "level": "basic",
            "topic": "Diagnostico",
            "description": "Muestra entorno Go.",
            "example": "go env",
            "expected": "Variables GOOS, GOPATH, GOMOD y mas.",
            "note": ""
        },
        {
            "command": "go vet ./...",
            "level": "basic",
            "topic": "Diagnostico",
            "description": "Ejecuta analisis estatico.",
            "example": "go vet ./...",
            "expected": "Diagnosticos o silencio.",
            "note": ""
        },
        {
            "command": "go list -deps ./...",
            "level": "intermediate",
            "topic": "Diagnostico",
            "description": "Lista dependencias de paquetes.",
            "example": "go list -deps ./...",
            "expected": "Import paths.",
            "note": ""
        },
        {
            "command": "go test -run '^$' -bench . -benchmem ./...",
            "level": "advanced",
            "topic": "Diagnostico",
            "description": "Ejecuta benchmarks sin tests normales.",
            "example": "go test -run '^$' -bench . -benchmem ./...",
            "expected": "ns/op, B/op, allocs/op.",
            "note": "Los resultados dependen del entorno."
        },
        {
            "command": "go mod download",
            "level": "intermediate",
            "topic": "M\u00f3dulos",
            "description": "Descarga m\u00f3dulos necesarios al cache local.",
            "example": "go mod download",
            "expected": "Puede no imprimir nada; llena el module cache.",
            "note": ""
        },
        {
            "command": "go mod vendor",
            "level": "intermediate",
            "topic": "M\u00f3dulos",
            "description": "Copia dependencias a vendor/.",
            "example": "go mod vendor",
            "expected": "Directorio vendor actualizado.",
            "note": ""
        },
        {
            "command": "go mod verify",
            "level": "advanced",
            "topic": "M\u00f3dulos",
            "description": "Verifica que m\u00f3dulos descargados no hayan cambiado.",
            "example": "go mod verify",
            "expected": "all modules verified o detalle del m\u00f3dulo inv\u00e1lido.",
            "note": ""
        },
        {
            "command": "go test -count=1 ./...",
            "level": "intermediate",
            "topic": "Testing",
            "description": "Ejecuta tests desactivando cache de resultados.",
            "example": "go test -count=1 ./...",
            "expected": "Resultados frescos de cada paquete.",
            "note": ""
        },
        {
            "command": "go test -shuffle=on ./...",
            "level": "advanced",
            "topic": "Testing",
            "description": "Ejecuta tests en orden aleatorio.",
            "example": "go test -shuffle=on ./...",
            "expected": "Resultados e identificador seed del shuffle.",
            "note": ""
        },
        {
            "command": "go env -json",
            "level": "advanced",
            "topic": "Diagn\u00f3stico",
            "description": "Muestra configuraci\u00f3n Go como JSON.",
            "example": "go env -json",
            "expected": "Objeto JSON con variables de entorno de Go.",
            "note": ""
        }
    ],
    "rust": [
        {
            "command": "cargo new <project>",
            "level": "basic",
            "topic": "Proyecto y build",
            "description": "Crea un proyecto Rust.",
            "example": "cargo new <project>",
            "expected": "Directorio con Cargo.toml y src/main.rs.",
            "note": ""
        },
        {
            "command": "cargo check",
            "level": "basic",
            "topic": "Proyecto y build",
            "description": "Type-check rapido sin generar binario final.",
            "example": "cargo check",
            "expected": "Finished o errores del compilador.",
            "note": ""
        },
        {
            "command": "cargo build --release",
            "level": "basic",
            "topic": "Proyecto y build",
            "description": "Compila optimizado.",
            "example": "cargo build --release",
            "expected": "Binario en target/release.",
            "note": ""
        },
        {
            "command": "cargo add <crate>",
            "level": "basic",
            "topic": "Dependencias",
            "description": "Agrega dependencia.",
            "example": "cargo add <crate>",
            "expected": "Cargo.toml y Cargo.lock actualizados.",
            "note": ""
        },
        {
            "command": "cargo tree",
            "level": "basic",
            "topic": "Dependencias",
            "description": "Muestra arbol de crates.",
            "example": "cargo tree",
            "expected": "Dependencias jerarquicas.",
            "note": ""
        },
        {
            "command": "cargo update -p <crate>",
            "level": "intermediate",
            "topic": "Dependencias",
            "description": "Actualiza una dependencia en lockfile.",
            "example": "cargo update -p <crate>",
            "expected": "Resolucion y Cargo.lock actualizado.",
            "note": ""
        },
        {
            "command": "cargo test",
            "level": "basic",
            "topic": "Testing y calidad",
            "description": "Ejecuta tests.",
            "example": "cargo test",
            "expected": "Resumen por target.",
            "note": ""
        },
        {
            "command": "cargo fmt -- --check",
            "level": "basic",
            "topic": "Testing y calidad",
            "description": "Comprueba formato.",
            "example": "cargo fmt -- --check",
            "expected": "Diff/error si requiere formato.",
            "note": ""
        },
        {
            "command": "cargo clippy -- -D warnings",
            "level": "basic",
            "topic": "Testing y calidad",
            "description": "Ejecuta Clippy tratando warnings como error.",
            "example": "cargo clippy -- -D warnings",
            "expected": "Diagnosticos o success.",
            "note": ""
        },
        {
            "command": "cargo test -- --nocapture",
            "level": "intermediate",
            "topic": "Testing y calidad",
            "description": "Muestra stdout de tests.",
            "example": "cargo test -- --nocapture",
            "expected": "Salida de tests sin captura.",
            "note": ""
        },
        {
            "command": "cargo package --list",
            "level": "intermediate",
            "topic": "Publicacion",
            "description": "Lista archivos que incluiria el paquete.",
            "example": "cargo package --list",
            "expected": "Paths incluidos.",
            "note": ""
        },
        {
            "command": "cargo publish --dry-run",
            "level": "intermediate",
            "topic": "Publicacion",
            "description": "Simula publicacion.",
            "example": "cargo publish --dry-run",
            "expected": "Checks y package sin upload.",
            "note": ""
        },
        {
            "command": "cargo publish",
            "level": "advanced",
            "topic": "Publicacion",
            "description": "Publica crate.",
            "example": "cargo publish",
            "expected": "Confirmacion y crate publicado.",
            "note": "Operacion publica: verifica metadata/version antes."
        },
        {
            "command": "rustup show",
            "level": "basic",
            "topic": "Toolchain",
            "description": "Muestra toolchains instalados/activo.",
            "example": "rustup show",
            "expected": "Default host, active toolchain y targets.",
            "note": ""
        },
        {
            "command": "rustup update",
            "level": "basic",
            "topic": "Toolchain",
            "description": "Actualiza toolchains.",
            "example": "rustup update",
            "expected": "Descargas y versiones.",
            "note": ""
        },
        {
            "command": "rustup target add wasm32-unknown-unknown",
            "level": "intermediate",
            "topic": "Toolchain",
            "description": "Agrega target WASM.",
            "example": "rustup target add wasm32-unknown-unknown",
            "expected": "Component installed.",
            "note": ""
        },
        {
            "command": "cargo install <crate>",
            "level": "intermediate",
            "topic": "Toolchain",
            "description": "Instala un binario Rust.",
            "example": "cargo install <crate>",
            "expected": "Binario bajo cargo bin.",
            "note": ""
        },
        {
            "command": "cargo metadata --format-version 1",
            "level": "advanced",
            "topic": "Toolchain",
            "description": "Emite metadata del workspace.",
            "example": "cargo metadata --format-version 1",
            "expected": "JSON de packages, targets y resolve graph.",
            "note": ""
        },
        {
            "command": "cargo build --workspace",
            "level": "intermediate",
            "topic": "Build",
            "description": "Construye todos los miembros del workspace.",
            "example": "cargo build --workspace",
            "expected": "Compilaci\u00f3n de crates del workspace.",
            "note": ""
        },
        {
            "command": "cargo check --all-targets",
            "level": "intermediate",
            "topic": "Build",
            "description": "Comprueba todos los targets sin generar binarios completos.",
            "example": "cargo check --all-targets",
            "expected": "Diagn\u00f3sticos r\u00e1pidos de todos los targets.",
            "note": ""
        },
        {
            "command": "cargo test --workspace",
            "level": "intermediate",
            "topic": "Testing",
            "description": "Ejecuta tests de todos los crates del workspace.",
            "example": "cargo test --workspace",
            "expected": "Resultado por crate/test.",
            "note": ""
        },
        {
            "command": "cargo test --release",
            "level": "advanced",
            "topic": "Testing",
            "description": "Ejecuta tests con perfil release.",
            "example": "cargo test --release",
            "expected": "Tests compilados optimizados y resultados.",
            "note": ""
        },
        {
            "command": "cargo tree -i <crate>",
            "level": "advanced",
            "topic": "Dependencias",
            "description": "Muestra dependencias inversas de un crate.",
            "example": "cargo tree -i <crate>",
            "expected": "\u00c1rbol de qui\u00e9n depende del crate indicado.",
            "note": ""
        },
        {
            "command": "rustup toolchain list",
            "level": "intermediate",
            "topic": "Toolchain",
            "description": "Lista toolchains instaladas.",
            "example": "rustup toolchain list",
            "expected": "Toolchains y cu\u00e1l es default/override.",
            "note": ""
        }
    ],
    "dotnet": [
        {
            "command": "dotnet new list",
            "level": "basic",
            "topic": "Proyecto y solution",
            "description": "Lista templates instalados.",
            "example": "dotnet new list",
            "expected": "Tabla de templates.",
            "note": ""
        },
        {
            "command": "dotnet new webapi -n <name>",
            "level": "basic",
            "topic": "Proyecto y solution",
            "description": "Crea una Web API.",
            "example": "dotnet new webapi -n <name>",
            "expected": "Proyecto generado.",
            "note": ""
        },
        {
            "command": "dotnet new sln -n <name>",
            "level": "basic",
            "topic": "Proyecto y solution",
            "description": "Crea solution.",
            "example": "dotnet new sln -n <name>",
            "expected": "Archivo .sln.",
            "note": ""
        },
        {
            "command": "dotnet sln <file.sln> add <project.csproj>",
            "level": "basic",
            "topic": "Proyecto y solution",
            "description": "Agrega proyecto a solution.",
            "example": "dotnet sln <file.sln> add <project.csproj>",
            "expected": "Confirmacion de proyecto agregado.",
            "note": ""
        },
        {
            "command": "dotnet restore",
            "level": "basic",
            "topic": "Build y ejecucion",
            "description": "Restaura NuGet packages.",
            "example": "dotnet restore",
            "expected": "Resumen de restore.",
            "note": ""
        },
        {
            "command": "dotnet build",
            "level": "basic",
            "topic": "Build y ejecucion",
            "description": "Compila la solucion/proyecto.",
            "example": "dotnet build",
            "expected": "Build succeeded/failed y warnings.",
            "note": ""
        },
        {
            "command": "dotnet run",
            "level": "basic",
            "topic": "Build y ejecucion",
            "description": "Compila y ejecuta.",
            "example": "dotnet run",
            "expected": "Salida de la app.",
            "note": ""
        },
        {
            "command": "dotnet watch run",
            "level": "intermediate",
            "topic": "Build y ejecucion",
            "description": "Ejecuta con hot reload.",
            "example": "dotnet watch run",
            "expected": "Servidor/proceso y recompilaciones.",
            "note": ""
        },
        {
            "command": "dotnet publish -c Release -o ./publish",
            "level": "intermediate",
            "topic": "Build y ejecucion",
            "description": "Publica artifacts.",
            "example": "dotnet publish -c Release -o ./publish",
            "expected": "Archivos en ./publish.",
            "note": ""
        },
        {
            "command": "dotnet add package <package>",
            "level": "basic",
            "topic": "Paquetes",
            "description": "Agrega NuGet package.",
            "example": "dotnet add package <package>",
            "expected": "csproj y restore actualizados.",
            "note": ""
        },
        {
            "command": "dotnet list package",
            "level": "basic",
            "topic": "Paquetes",
            "description": "Lista paquetes.",
            "example": "dotnet list package",
            "expected": "Top-level y transitive segun flags.",
            "note": ""
        },
        {
            "command": "dotnet list package --outdated",
            "level": "intermediate",
            "topic": "Paquetes",
            "description": "Busca paquetes desactualizados.",
            "example": "dotnet list package --outdated",
            "expected": "Requested, Resolved y Latest.",
            "note": ""
        },
        {
            "command": "dotnet test",
            "level": "basic",
            "topic": "Testing",
            "description": "Ejecuta tests.",
            "example": "dotnet test",
            "expected": "Passed/Failed/Skipped.",
            "note": ""
        },
        {
            "command": "dotnet test --collect:\"XPlat Code Coverage\"",
            "level": "intermediate",
            "topic": "Testing",
            "description": "Ejecuta tests con coverage collector.",
            "example": "dotnet test --collect:\"XPlat Code Coverage\"",
            "expected": "Archivo coverage en TestResults.",
            "note": ""
        },
        {
            "command": "dotnet ef migrations add <Name>",
            "level": "basic",
            "topic": "EF Core",
            "description": "Crea migracion EF Core.",
            "example": "dotnet ef migrations add <Name>",
            "expected": "Archivos de migracion.",
            "note": ""
        },
        {
            "command": "dotnet ef database update",
            "level": "intermediate",
            "topic": "EF Core",
            "description": "Aplica migraciones pendientes.",
            "example": "dotnet ef database update",
            "expected": "Build y migraciones aplicadas.",
            "note": "Respaldar datos en produccion antes de cambios de esquema."
        },
        {
            "command": "dotnet ef migrations script --idempotent -o migration.sql",
            "level": "intermediate",
            "topic": "EF Core",
            "description": "Genera SQL idempotente.",
            "example": "dotnet ef migrations script --idempotent -o migration.sql",
            "expected": "Archivo migration.sql.",
            "note": ""
        },
        {
            "command": "dotnet tool list -g",
            "level": "basic",
            "topic": "Tooling",
            "description": "Lista tools globales.",
            "example": "dotnet tool list -g",
            "expected": "Package Id, Version, Commands.",
            "note": ""
        },
        {
            "command": "dotnet format",
            "level": "intermediate",
            "topic": "Tooling",
            "description": "Formatea y corrige analyzers.",
            "example": "dotnet format",
            "expected": "Archivos modificados o diagnosticos.",
            "note": ""
        },
        {
            "command": "dotnet workload list",
            "level": "intermediate",
            "topic": "Tooling",
            "description": "Lista workloads instalados.",
            "example": "dotnet workload list",
            "expected": "Workload ID y version.",
            "note": ""
        },
        {
            "command": "dotnet new console -n <name>",
            "level": "basic",
            "topic": "Proyecto",
            "description": "Crea una aplicaci\u00f3n de consola.",
            "example": "dotnet new console -n <name>",
            "expected": "Directorio/proyecto con plantilla console.",
            "note": ""
        },
        {
            "command": "dotnet restore --locked-mode",
            "level": "intermediate",
            "topic": "Paquetes",
            "description": "Restaura paquetes exigiendo que el lock file no cambie.",
            "example": "dotnet restore --locked-mode",
            "expected": "Restore exitoso o error si el lock no coincide.",
            "note": ""
        },
        {
            "command": "dotnet test --filter <expression>",
            "level": "intermediate",
            "topic": "Testing",
            "description": "Ejecuta s\u00f3lo tests que coinciden con el filtro.",
            "example": "dotnet test --filter <expression>",
            "expected": "Resultados del subconjunto seleccionado.",
            "note": ""
        }
    ],
    "java": [
        {
            "command": "java -version",
            "level": "basic",
            "topic": "Java runtime",
            "description": "Muestra version del runtime.",
            "example": "java -version",
            "expected": "Version, vendor y VM.",
            "note": ""
        },
        {
            "command": "javac <File.java>",
            "level": "basic",
            "topic": "Java runtime",
            "description": "Compila una clase Java.",
            "example": "javac <File.java>",
            "expected": "Archivo .class o errores.",
            "note": ""
        },
        {
            "command": "java <MainClass>",
            "level": "basic",
            "topic": "Java runtime",
            "description": "Ejecuta una clase.",
            "example": "java <MainClass>",
            "expected": "Salida del programa.",
            "note": ""
        },
        {
            "command": "jar tf <app.jar>",
            "level": "intermediate",
            "topic": "Java runtime",
            "description": "Lista contenido de un JAR.",
            "example": "jar tf <app.jar>",
            "expected": "Entradas del archive.",
            "note": ""
        },
        {
            "command": "jps -lv",
            "level": "intermediate",
            "topic": "Java runtime",
            "description": "Lista JVMs locales.",
            "example": "jps -lv",
            "expected": "PID, main class/jar y args.",
            "note": ""
        },
        {
            "command": "jstack <pid>",
            "level": "advanced",
            "topic": "Java runtime",
            "description": "Obtiene thread dump.",
            "example": "jstack <pid>",
            "expected": "Stacks de threads.",
            "note": "Puede ser grande; util para deadlocks."
        },
        {
            "command": "jcmd <pid> VM.flags",
            "level": "advanced",
            "topic": "Java runtime",
            "description": "Consulta flags de una JVM.",
            "example": "jcmd <pid> VM.flags",
            "expected": "Flags efectivos.",
            "note": ""
        },
        {
            "command": "mvn clean test",
            "level": "basic",
            "topic": "Maven",
            "description": "Limpia y ejecuta tests.",
            "example": "mvn clean test",
            "expected": "BUILD SUCCESS/FAILURE y resultados.",
            "note": ""
        },
        {
            "command": "mvn clean package",
            "level": "basic",
            "topic": "Maven",
            "description": "Compila, testea y empaqueta.",
            "example": "mvn clean package",
            "expected": "Artifact en target/.",
            "note": ""
        },
        {
            "command": "mvn dependency:tree",
            "level": "intermediate",
            "topic": "Maven",
            "description": "Muestra arbol de dependencias.",
            "example": "mvn dependency:tree",
            "expected": "Dependencias y scopes.",
            "note": ""
        },
        {
            "command": "mvn versions:display-dependency-updates",
            "level": "intermediate",
            "topic": "Maven",
            "description": "Busca dependencias con nuevas versiones.",
            "example": "mvn versions:display-dependency-updates",
            "expected": "Lista de updates disponibles.",
            "note": ""
        },
        {
            "command": "./gradlew tasks",
            "level": "basic",
            "topic": "Gradle",
            "description": "Lista tareas Gradle.",
            "example": "./gradlew tasks",
            "expected": "Tareas agrupadas.",
            "note": ""
        },
        {
            "command": "./gradlew build",
            "level": "basic",
            "topic": "Gradle",
            "description": "Ejecuta build.",
            "example": "./gradlew build",
            "expected": "BUILD SUCCESSFUL/FAILED.",
            "note": ""
        },
        {
            "command": "./gradlew dependencies",
            "level": "intermediate",
            "topic": "Gradle",
            "description": "Muestra grafo de dependencias.",
            "example": "./gradlew dependencies",
            "expected": "Arbol por configuration.",
            "note": ""
        },
        {
            "command": "./gradlew build --scan",
            "level": "intermediate",
            "topic": "Gradle",
            "description": "Ejecuta build y genera Build Scan si esta habilitado.",
            "example": "./gradlew build --scan",
            "expected": "URL/metadata del scan.",
            "note": "Puede subir metadata a un servicio externo segun configuracion."
        },
        {
            "command": "./gradlew test",
            "level": "basic",
            "topic": "Testing y quality",
            "description": "Ejecuta tests.",
            "example": "./gradlew test",
            "expected": "Resultados y reportes HTML/XML.",
            "note": ""
        },
        {
            "command": "mvn test -Dtest=<TestClass>",
            "level": "intermediate",
            "topic": "Testing y quality",
            "description": "Ejecuta una clase de test puntual.",
            "example": "mvn test -Dtest=<TestClass>",
            "expected": "Resultados del test seleccionado.",
            "note": ""
        },
        {
            "command": "jdeps -summary <app.jar>",
            "level": "intermediate",
            "topic": "Java runtime",
            "description": "Resume dependencias de m\u00f3dulos/paquetes de un JAR.",
            "example": "jdeps -summary <app.jar>",
            "expected": "Listado de dependencias principales.",
            "note": ""
        },
        {
            "command": "jcmd <pid> GC.heap_info",
            "level": "advanced",
            "topic": "Java runtime",
            "description": "Consulta informaci\u00f3n del heap de una JVM en ejecuci\u00f3n.",
            "example": "jcmd <pid> GC.heap_info",
            "expected": "Resumen del heap y collector.",
            "note": ""
        },
        {
            "command": "mvn help:effective-pom",
            "level": "intermediate",
            "topic": "Maven",
            "description": "Muestra el POM efectivo despu\u00e9s de herencias/profiles.",
            "example": "mvn help:effective-pom",
            "expected": "XML POM completo resuelto.",
            "note": ""
        },
        {
            "command": "mvn help:effective-settings",
            "level": "advanced",
            "topic": "Maven",
            "description": "Muestra settings.xml efectivo.",
            "example": "mvn help:effective-settings",
            "expected": "Configuraci\u00f3n Maven resultante.",
            "note": "Puede revelar URLs/usuarios de repositorios; revis\u00e1 antes de compartir."
        },
        {
            "command": "./gradlew properties",
            "level": "intermediate",
            "topic": "Gradle",
            "description": "Lista propiedades del proyecto Gradle.",
            "example": "./gradlew properties",
            "expected": "Propiedades y valores del proyecto.",
            "note": ""
        },
        {
            "command": "./gradlew build --profile",
            "level": "advanced",
            "topic": "Gradle",
            "description": "Ejecuta build y genera reporte de profiling.",
            "example": "./gradlew build --profile",
            "expected": "Build normal m\u00e1s reporte HTML de tiempos.",
            "note": ""
        }
    ],
    "php": [
        {
            "command": "php -v",
            "level": "basic",
            "topic": "Runtime",
            "description": "Muestra version de PHP.",
            "example": "php -v",
            "expected": "Version, SAPI y Zend Engine.",
            "note": ""
        },
        {
            "command": "php -m",
            "level": "basic",
            "topic": "Runtime",
            "description": "Lista extensiones cargadas.",
            "example": "php -m",
            "expected": "Un modulo por linea.",
            "note": ""
        },
        {
            "command": "php -l <file.php>",
            "level": "basic",
            "topic": "Runtime",
            "description": "Valida sintaxis.",
            "example": "php -l <file.php>",
            "expected": "No syntax errors detected o error con linea.",
            "note": ""
        },
        {
            "command": "php -S 127.0.0.1:8000 -t public",
            "level": "intermediate",
            "topic": "Runtime",
            "description": "Inicia servidor embebido.",
            "example": "php -S 127.0.0.1:8000 -t public",
            "expected": "Servidor escuchando en 8000.",
            "note": "Solo desarrollo."
        },
        {
            "command": "composer install",
            "level": "basic",
            "topic": "Composer",
            "description": "Instala versiones del lockfile.",
            "example": "composer install",
            "expected": "Paquetes instalados y autoload generado.",
            "note": ""
        },
        {
            "command": "composer update",
            "level": "basic",
            "topic": "Composer",
            "description": "Resuelve y actualiza dependencias.",
            "example": "composer update",
            "expected": "composer.lock actualizado.",
            "note": "Puede introducir upgrades amplios; revisar diff/tests."
        },
        {
            "command": "composer require <package>",
            "level": "basic",
            "topic": "Composer",
            "description": "Agrega paquete.",
            "example": "composer require <package>",
            "expected": "composer.json/lock actualizados.",
            "note": ""
        },
        {
            "command": "composer outdated -D",
            "level": "intermediate",
            "topic": "Composer",
            "description": "Lista dependencias directas desactualizadas.",
            "example": "composer outdated -D",
            "expected": "Paquetes y versiones.",
            "note": ""
        },
        {
            "command": "composer audit",
            "level": "intermediate",
            "topic": "Composer",
            "description": "Busca advisories de seguridad.",
            "example": "composer audit",
            "expected": "Vulnerabilidades o confirmacion limpia.",
            "note": ""
        },
        {
            "command": "composer dump-autoload -o",
            "level": "intermediate",
            "topic": "Composer",
            "description": "Regenera autoload optimizado.",
            "example": "composer dump-autoload -o",
            "expected": "Optimized autoload files generated.",
            "note": ""
        },
        {
            "command": "php artisan list",
            "level": "basic",
            "topic": "Laravel Artisan",
            "description": "Lista comandos Artisan.",
            "example": "php artisan list",
            "expected": "Comandos por namespace.",
            "note": ""
        },
        {
            "command": "php artisan migrate",
            "level": "basic",
            "topic": "Laravel Artisan",
            "description": "Aplica migraciones.",
            "example": "php artisan migrate",
            "expected": "Migraciones ejecutadas.",
            "note": "Haz backup/plan de rollback en produccion."
        },
        {
            "command": "php artisan migrate:status",
            "level": "intermediate",
            "topic": "Laravel Artisan",
            "description": "Muestra estado de migraciones.",
            "example": "php artisan migrate:status",
            "expected": "Ran/Pending por migracion.",
            "note": ""
        },
        {
            "command": "php artisan optimize",
            "level": "intermediate",
            "topic": "Laravel Artisan",
            "description": "Genera caches de framework.",
            "example": "php artisan optimize",
            "expected": "Caches creadas.",
            "note": ""
        },
        {
            "command": "php artisan queue:work --tries=3",
            "level": "intermediate",
            "topic": "Laravel Artisan",
            "description": "Ejecuta worker de colas.",
            "example": "php artisan queue:work --tries=3",
            "expected": "Jobs procesados.",
            "note": "En produccion gestionarlo con supervisor/systemd."
        },
        {
            "command": "php bin/console list",
            "level": "basic",
            "topic": "Symfony Console",
            "description": "Lista comandos Symfony.",
            "example": "php bin/console list",
            "expected": "Comandos por namespace.",
            "note": ""
        },
        {
            "command": "php bin/console cache:clear --env=prod",
            "level": "intermediate",
            "topic": "Symfony Console",
            "description": "Limpia/recalienta cache de produccion.",
            "example": "php bin/console cache:clear --env=prod",
            "expected": "Cache cleared.",
            "note": ""
        },
        {
            "command": "vendor/bin/phpunit",
            "level": "basic",
            "topic": "Testing y calidad",
            "description": "Ejecuta PHPUnit.",
            "example": "vendor/bin/phpunit",
            "expected": "Tests, assertions y failures.",
            "note": ""
        },
        {
            "command": "vendor/bin/phpstan analyse src",
            "level": "intermediate",
            "topic": "Testing y calidad",
            "description": "Ejecuta analisis estatico.",
            "example": "vendor/bin/phpstan analyse src",
            "expected": "Errores por archivo o No errors.",
            "note": ""
        },
        {
            "command": "composer show",
            "level": "intermediate",
            "topic": "Composer",
            "description": "Lista paquetes instalados.",
            "example": "composer show",
            "expected": "Nombre, versi\u00f3n y descripci\u00f3n por paquete.",
            "note": ""
        },
        {
            "command": "composer show <package> --all",
            "level": "intermediate",
            "topic": "Composer",
            "description": "Muestra informaci\u00f3n disponible de un paquete.",
            "example": "composer show <package> --all",
            "expected": "Versiones, dependencias y metadata.",
            "note": ""
        },
        {
            "command": "composer why <package>",
            "level": "advanced",
            "topic": "Composer",
            "description": "Explica qu\u00e9 paquete requiere una dependencia.",
            "example": "composer why <package>",
            "expected": "Cadena de dependencias que la introduce.",
            "note": ""
        },
        {
            "command": "composer why-not <package> <version>",
            "level": "advanced",
            "topic": "Composer",
            "description": "Explica por qu\u00e9 una versi\u00f3n no puede instalarse.",
            "example": "composer why-not <package> <version>",
            "expected": "Restricciones incompatibles que bloquean la versi\u00f3n.",
            "note": ""
        },
        {
            "command": "php artisan route:list",
            "level": "intermediate",
            "topic": "Laravel Artisan",
            "description": "Lista rutas registradas de Laravel.",
            "example": "php artisan route:list",
            "expected": "Tabla con m\u00e9todo, URI, nombre, action y middleware.",
            "note": ""
        },
        {
            "command": "php artisan config:cache",
            "level": "intermediate",
            "topic": "Laravel Artisan",
            "description": "Genera cache de configuraci\u00f3n.",
            "example": "php artisan config:cache",
            "expected": "Mensaje Configuration cached successfully.",
            "note": "Despu\u00e9s de cambiar .env/config ejecut\u00e1 config:clear o regener\u00e1 el cache."
        }
    ],
    "android": [
        {
            "command": "adb devices -l",
            "level": "basic",
            "topic": "ADB dispositivos",
            "description": "Lista dispositivos con detalles.",
            "example": "adb devices -l",
            "expected": "Serial, state, product, model y transport id.",
            "note": ""
        },
        {
            "command": "adb get-state",
            "level": "basic",
            "topic": "ADB dispositivos",
            "description": "Muestra estado del dispositivo.",
            "example": "adb get-state",
            "expected": "device, offline o unknown.",
            "note": ""
        },
        {
            "command": "adb connect <ip>:5555",
            "level": "intermediate",
            "topic": "ADB dispositivos",
            "description": "Conecta ADB por TCP.",
            "example": "adb connect <ip>:5555",
            "expected": "connected to ...",
            "note": ""
        },
        {
            "command": "adb pair <ip>:<port>",
            "level": "intermediate",
            "topic": "ADB dispositivos",
            "description": "Empareja wireless debugging.",
            "example": "adb pair <ip>:<port>",
            "expected": "Prompt de pairing code y success.",
            "note": ""
        },
        {
            "command": "adb install -r <app.apk>",
            "level": "basic",
            "topic": "Apps y paquetes",
            "description": "Instala/reemplaza APK.",
            "example": "adb install -r <app.apk>",
            "expected": "Performing Streamed Install / Success.",
            "note": ""
        },
        {
            "command": "adb uninstall <package>",
            "level": "basic",
            "topic": "Apps y paquetes",
            "description": "Desinstala app.",
            "example": "adb uninstall <package>",
            "expected": "Success.",
            "note": ""
        },
        {
            "command": "adb shell pm list packages -3",
            "level": "intermediate",
            "topic": "Apps y paquetes",
            "description": "Lista paquetes third-party.",
            "example": "adb shell pm list packages -3",
            "expected": "package:<name>.",
            "note": ""
        },
        {
            "command": "adb shell am force-stop <package>",
            "level": "intermediate",
            "topic": "Apps y paquetes",
            "description": "Fuerza cierre de una app.",
            "example": "adb shell am force-stop <package>",
            "expected": "Sin salida si funciona.",
            "note": ""
        },
        {
            "command": "adb logcat",
            "level": "basic",
            "topic": "Logs y debug",
            "description": "Muestra logs Android.",
            "example": "adb logcat",
            "expected": "Stream de logs.",
            "note": ""
        },
        {
            "command": "adb logcat --pid=$(adb shell pidof -s <package>)",
            "level": "intermediate",
            "topic": "Logs y debug",
            "description": "Filtra logcat por PID de app.",
            "example": "adb logcat --pid=$(adb shell pidof -s <package>)",
            "expected": "Logs del proceso.",
            "note": "La sustitucion es mas directa en shells compatibles."
        },
        {
            "command": "adb shell dumpsys meminfo <package>",
            "level": "intermediate",
            "topic": "Logs y debug",
            "description": "Muestra memoria de una app.",
            "example": "adb shell dumpsys meminfo <package>",
            "expected": "PSS/RSS/heaps y categorias.",
            "note": ""
        },
        {
            "command": "adb bugreport <file.zip>",
            "level": "advanced",
            "topic": "Logs y debug",
            "description": "Genera reporte completo.",
            "example": "adb bugreport <file.zip>",
            "expected": "ZIP con diagnostico.",
            "note": "Puede contener informacion sensible."
        },
        {
            "command": "adb push <local> /sdcard/<name>",
            "level": "basic",
            "topic": "Archivos",
            "description": "Copia al dispositivo.",
            "example": "adb push <local> /sdcard/<name>",
            "expected": "Bytes transferidos y velocidad.",
            "note": ""
        },
        {
            "command": "adb pull /sdcard/<file> .",
            "level": "basic",
            "topic": "Archivos",
            "description": "Copia desde dispositivo.",
            "example": "adb pull /sdcard/<file> .",
            "expected": "Bytes transferidos.",
            "note": ""
        },
        {
            "command": "sdkmanager --list",
            "level": "basic",
            "topic": "Emulador y SDK",
            "description": "Lista SDK packages.",
            "example": "sdkmanager --list",
            "expected": "Installed/Available packages.",
            "note": ""
        },
        {
            "command": "sdkmanager \"platform-tools\" \"platforms;android-35\"",
            "level": "intermediate",
            "topic": "Emulador y SDK",
            "description": "Instala components SDK.",
            "example": "sdkmanager \"platform-tools\" \"platforms;android-35\"",
            "expected": "Progreso/licencias.",
            "note": ""
        },
        {
            "command": "avdmanager list avd",
            "level": "intermediate",
            "topic": "Emulador y SDK",
            "description": "Lista AVDs.",
            "example": "avdmanager list avd",
            "expected": "Name, Path, Target y Device.",
            "note": ""
        },
        {
            "command": "emulator -avd <name>",
            "level": "intermediate",
            "topic": "Emulador y SDK",
            "description": "Inicia emulador.",
            "example": "emulator -avd <name>",
            "expected": "Ventana/emulador y logs.",
            "note": ""
        },
        {
            "command": "./gradlew assembleDebug",
            "level": "basic",
            "topic": "Gradle Android",
            "description": "Genera APK debug.",
            "example": "./gradlew assembleDebug",
            "expected": "APK en app/build/outputs/apk/debug.",
            "note": ""
        },
        {
            "command": "./gradlew bundleRelease",
            "level": "intermediate",
            "topic": "Gradle Android",
            "description": "Genera AAB release.",
            "example": "./gradlew bundleRelease",
            "expected": "AAB en outputs/bundle/release.",
            "note": "Configura signing de release."
        }
    ],
    "nginx": [
        {
            "command": "nginx -t",
            "level": "basic",
            "topic": "Configuracion",
            "description": "Valida sintaxis y archivos incluidos.",
            "example": "nginx -t",
            "expected": "syntax is ok / test is successful o error con archivo y linea.",
            "note": ""
        },
        {
            "command": "nginx -T",
            "level": "intermediate",
            "topic": "Configuracion",
            "description": "Valida y vuelca toda la configuracion efectiva.",
            "example": "nginx -T",
            "expected": "Configuracion combinada en stdout/stderr.",
            "note": "Puede incluir rutas o valores sensibles."
        },
        {
            "command": "nginx -V",
            "level": "basic",
            "topic": "Configuracion",
            "description": "Muestra version, compiler y modulos.",
            "example": "nginx -V",
            "expected": "Version y configure arguments.",
            "note": ""
        },
        {
            "command": "sudo systemctl status nginx",
            "level": "basic",
            "topic": "Servicio",
            "description": "Muestra estado del servicio.",
            "example": "sudo systemctl status nginx",
            "expected": "Active state, PID y logs recientes.",
            "note": ""
        },
        {
            "command": "sudo systemctl reload nginx",
            "level": "basic",
            "topic": "Servicio",
            "description": "Recarga config sin cortar conexiones existentes.",
            "example": "sudo systemctl reload nginx",
            "expected": "Sin salida si funciona.",
            "note": "Ejecuta nginx -t antes."
        },
        {
            "command": "sudo systemctl restart nginx",
            "level": "intermediate",
            "topic": "Servicio",
            "description": "Reinicia Nginx.",
            "example": "sudo systemctl restart nginx",
            "expected": "Sin salida si funciona.",
            "note": "Puede cortar conexiones brevemente."
        },
        {
            "command": "sudo ln -s /etc/nginx/sites-available/<site> /etc/nginx/sites-enabled/<site>",
            "level": "basic",
            "topic": "Sites y proxy",
            "description": "Habilita un site en layouts Debian/Ubuntu.",
            "example": "sudo ln -s /etc/nginx/sites-available/<site> /etc/nginx/sites-enabled/<site>",
            "expected": "Symlink creado.",
            "note": ""
        },
        {
            "command": "grep -R \"server_name\" /etc/nginx/sites-enabled /etc/nginx/conf.d",
            "level": "intermediate",
            "topic": "Sites y proxy",
            "description": "Busca dominios configurados.",
            "example": "grep -R \"server_name\" /etc/nginx/sites-enabled /etc/nginx/conf.d",
            "expected": "Archivo y lineas coincidentes.",
            "note": ""
        },
        {
            "command": "curl -H 'Host: <domain>' http://127.0.0.1/",
            "level": "intermediate",
            "topic": "Sites y proxy",
            "description": "Prueba un virtual host localmente.",
            "example": "curl -H 'Host: <domain>' http://127.0.0.1/",
            "expected": "Respuesta del server block seleccionado.",
            "note": ""
        },
        {
            "command": "sudo tail -f /var/log/nginx/access.log",
            "level": "basic",
            "topic": "Logs",
            "description": "Sigue access log.",
            "example": "sudo tail -f /var/log/nginx/access.log",
            "expected": "Requests en tiempo real.",
            "note": ""
        },
        {
            "command": "sudo tail -f /var/log/nginx/error.log",
            "level": "basic",
            "topic": "Logs",
            "description": "Sigue error log.",
            "example": "sudo tail -f /var/log/nginx/error.log",
            "expected": "Errores/warnings en tiempo real.",
            "note": ""
        },
        {
            "command": "sudo awk '$9 >= 500 {print}' /var/log/nginx/access.log | tail -100",
            "level": "intermediate",
            "topic": "Logs",
            "description": "Muestra las respuestas 5xx m\u00e1s recientes del access log com\u00fan.",
            "example": "sudo awk '$9 >= 500 {print}' /var/log/nginx/access.log | tail -100",
            "expected": "Hasta 100 l\u00edneas recientes cuyo status HTTP es 5xx.",
            "note": "Ajust\u00e1 el n\u00famero de campo si us\u00e1s un log_format personalizado."
        },
        {
            "command": "sudo certbot --nginx -d <domain> -d www.<domain>",
            "level": "basic",
            "topic": "TLS",
            "description": "Solicita certificado y configura Nginx.",
            "example": "sudo certbot --nginx -d <domain> -d www.<domain>",
            "expected": "Certificado emitido y config actualizada.",
            "note": "DNS debe apuntar al servidor y puerto 80 accesible."
        },
        {
            "command": "sudo certbot renew --dry-run",
            "level": "intermediate",
            "topic": "TLS",
            "description": "Simula renovacion de certificados.",
            "example": "sudo certbot renew --dry-run",
            "expected": "Resultado de prueba de renewal.",
            "note": ""
        },
        {
            "command": "openssl s_client -connect <domain>:443 -servername <domain> </dev/null 2>/dev/null | openssl x509 -noout -dates -issuer -subject",
            "level": "intermediate",
            "topic": "TLS",
            "description": "Inspecciona fechas, emisor y subject del certificado servido por Nginx.",
            "example": "openssl s_client -connect example.com:443 -servername example.com </dev/null 2>/dev/null | openssl x509 -noout -dates -issuer -subject",
            "expected": "notBefore/notAfter, issuer y subject.",
            "note": ""
        },
        {
            "command": "sudo systemctl start nginx",
            "level": "basic",
            "topic": "Servicio",
            "description": "Inicia el servicio Nginx.",
            "example": "sudo systemctl start nginx",
            "expected": "systemctl retorna silenciosamente si inicia correctamente.",
            "note": ""
        },
        {
            "command": "sudo systemctl stop nginx",
            "level": "basic",
            "topic": "Servicio",
            "description": "Detiene Nginx.",
            "example": "sudo systemctl stop nginx",
            "expected": "El servicio queda detenido.",
            "note": ""
        },
        {
            "command": "sudo systemctl enable --now nginx",
            "level": "intermediate",
            "topic": "Servicio",
            "description": "Habilita Nginx al arranque y lo inicia ahora.",
            "example": "sudo systemctl enable --now nginx",
            "expected": "Se crean/enlazan units y el servicio queda activo.",
            "note": ""
        },
        {
            "command": "sudo systemctl is-active nginx",
            "level": "intermediate",
            "topic": "Servicio",
            "description": "Comprueba si Nginx est\u00e1 activo.",
            "example": "sudo systemctl is-active nginx",
            "expected": "Imprime active, inactive, failed, etc.",
            "note": ""
        },
        {
            "command": "sudo journalctl -u nginx -n 100 --no-pager",
            "level": "intermediate",
            "topic": "Logs",
            "description": "Muestra las \u00faltimas 100 entradas del servicio.",
            "example": "sudo journalctl -u nginx -n 100 --no-pager",
            "expected": "Logs recientes de systemd para Nginx.",
            "note": ""
        },
        {
            "command": "sudo journalctl -u nginx -f",
            "level": "intermediate",
            "topic": "Logs",
            "description": "Sigue logs de Nginx desde systemd en tiempo real.",
            "example": "sudo journalctl -u nginx -f",
            "expected": "Stream continuo hasta Ctrl+C.",
            "note": ""
        },
        {
            "command": "sudo nginx -t -c <nginx.conf>",
            "level": "advanced",
            "topic": "Configuraci\u00f3n",
            "description": "Valida un archivo de configuraci\u00f3n espec\u00edfico.",
            "example": "sudo nginx -t -c <nginx.conf>",
            "expected": "syntax is ok / test is successful o detalle del error.",
            "note": ""
        },
        {
            "command": "sudo rm /etc/nginx/sites-enabled/<site>",
            "level": "intermediate",
            "topic": "Sites y proxy",
            "description": "Deshabilita un site eliminando su enlace en sites-enabled.",
            "example": "sudo rm /etc/nginx/sites-enabled/<site>",
            "expected": "El enlace desaparece; recarg\u00e1 Nginx para aplicar.",
            "note": "No elimina el archivo original de sites-available si era un symlink."
        }
    ],
    "openssl": [
        {
            "command": "openssl x509 -in cert.pem -noout -text",
            "level": "basic",
            "topic": "Certificados X.509",
            "description": "Muestra un certificado PEM.",
            "example": "openssl x509 -in cert.pem -noout -text",
            "expected": "Subject, issuer, validity, SAN, key y extensions.",
            "note": ""
        },
        {
            "command": "openssl x509 -in cert.pem -noout -dates",
            "level": "basic",
            "topic": "Certificados X.509",
            "description": "Muestra fechas de validez.",
            "example": "openssl x509 -in cert.pem -noout -dates",
            "expected": "notBefore y notAfter.",
            "note": ""
        },
        {
            "command": "openssl x509 -in cert.pem -noout -fingerprint -sha256",
            "level": "intermediate",
            "topic": "Certificados X.509",
            "description": "Calcula fingerprint SHA-256.",
            "example": "openssl x509 -in cert.pem -noout -fingerprint -sha256",
            "expected": "Fingerprint hexadecimal.",
            "note": ""
        },
        {
            "command": "openssl genpkey -algorithm ED25519 -out private.key",
            "level": "basic",
            "topic": "Claves",
            "description": "Genera clave Ed25519.",
            "example": "openssl genpkey -algorithm ED25519 -out private.key",
            "expected": "Archivo private.key.",
            "note": "Protege permisos del archivo."
        },
        {
            "command": "openssl genpkey -algorithm RSA -pkeyopt rsa_keygen_bits:4096 -out private.key",
            "level": "basic",
            "topic": "Claves",
            "description": "Genera RSA 4096.",
            "example": "openssl genpkey -algorithm RSA -pkeyopt rsa_keygen_bits:4096 -out private.key",
            "expected": "Archivo private.key.",
            "note": "Puede tardar unos segundos."
        },
        {
            "command": "openssl pkey -in private.key -pubout -out public.pem",
            "level": "intermediate",
            "topic": "Claves",
            "description": "Extrae clave publica.",
            "example": "openssl pkey -in private.key -pubout -out public.pem",
            "expected": "Archivo public.pem.",
            "note": ""
        },
        {
            "command": "openssl pkey -in private.key -check -noout",
            "level": "intermediate",
            "topic": "Claves",
            "description": "Valida una clave privada.",
            "example": "openssl pkey -in private.key -check -noout",
            "expected": "Key is valid o error.",
            "note": ""
        },
        {
            "command": "openssl req -new -key private.key -out request.csr",
            "level": "basic",
            "topic": "CSR y CA",
            "description": "Genera CSR interactivo.",
            "example": "openssl req -new -key private.key -out request.csr",
            "expected": "Archivo request.csr.",
            "note": ""
        },
        {
            "command": "openssl req -in request.csr -noout -text",
            "level": "intermediate",
            "topic": "CSR y CA",
            "description": "Inspecciona CSR.",
            "example": "openssl req -in request.csr -noout -text",
            "expected": "Subject, public key y requested extensions.",
            "note": ""
        },
        {
            "command": "openssl s_client -connect <domain>:443 -servername <domain> </dev/null",
            "level": "basic",
            "topic": "TLS remoto",
            "description": "Abre handshake TLS y muestra cadena.",
            "example": "openssl s_client -connect <domain>:443 -servername <domain> </dev/null",
            "expected": "Certificados, cipher, protocol y verify return code.",
            "note": ""
        },
        {
            "command": "openssl s_client -connect <domain>:443 -servername <domain> -showcerts </dev/null",
            "level": "intermediate",
            "topic": "TLS remoto",
            "description": "Muestra toda la cadena enviada.",
            "example": "openssl s_client -connect <domain>:443 -servername <domain> -showcerts </dev/null",
            "expected": "Uno o mas certificados PEM.",
            "note": ""
        },
        {
            "command": "openssl s_client -connect <domain>:443 -servername <domain> -tls1_2 </dev/null",
            "level": "advanced",
            "topic": "TLS remoto",
            "description": "Fuerza TLS 1.2 para probar compatibilidad.",
            "example": "openssl s_client -connect <domain>:443 -servername <domain> -tls1_2 </dev/null",
            "expected": "Handshake o error si no es aceptado.",
            "note": ""
        },
        {
            "command": "openssl dgst -sha256 <file>",
            "level": "basic",
            "topic": "Hashes y encoding",
            "description": "Calcula SHA-256.",
            "example": "openssl dgst -sha256 <file>",
            "expected": "Hash hexadecimal.",
            "note": ""
        },
        {
            "command": "openssl rand -hex 32",
            "level": "basic",
            "topic": "Hashes y encoding",
            "description": "Genera 32 bytes aleatorios en hexadecimal.",
            "example": "openssl rand -hex 32",
            "expected": "64 caracteres hex.",
            "note": ""
        },
        {
            "command": "printf 'hello' | openssl base64",
            "level": "basic",
            "topic": "Hashes y encoding",
            "description": "Codifica texto en Base64 usando OpenSSL.",
            "example": "printf 'hello' | openssl base64",
            "expected": "Cadena Base64.",
            "note": ""
        },
        {
            "command": "openssl pkcs12 -in bundle.p12 -info -noout",
            "level": "intermediate",
            "topic": "PKCS",
            "description": "Inspecciona un PKCS#12.",
            "example": "openssl pkcs12 -in bundle.p12 -info -noout",
            "expected": "Metadata y solicitud de password.",
            "note": "No compartas la salida si contiene identificadores sensibles."
        },
        {
            "command": "openssl pkcs12 -export -out bundle.p12 -inkey private.key -in cert.pem -certfile chain.pem",
            "level": "advanced",
            "topic": "PKCS",
            "description": "Empaqueta key+cert+chain.",
            "example": "openssl pkcs12 -export -out bundle.p12 -inkey private.key -in cert.pem -certfile chain.pem",
            "expected": "Archivo bundle.p12 y prompt de password.",
            "note": "El archivo contiene clave privada: custodialo como secreto."
        },
        {
            "command": "openssl x509 -in cert.pem -noout -subject -issuer -serial",
            "level": "intermediate",
            "topic": "Certificados X.509",
            "description": "Muestra subject, issuer y serial de un certificado.",
            "example": "openssl x509 -in cert.pem -noout -subject -issuer -serial",
            "expected": "Tres l\u00edneas con los datos solicitados.",
            "note": ""
        },
        {
            "command": "openssl x509 -in cert.pem -noout -ocsp_uri",
            "level": "advanced",
            "topic": "Certificados X.509",
            "description": "Muestra la URI OCSP declarada por el certificado.",
            "example": "openssl x509 -in cert.pem -noout -ocsp_uri",
            "expected": "URL OCSP o salida vac\u00eda si no existe.",
            "note": ""
        },
        {
            "command": "openssl req -new -newkey rsa:4096 -nodes -keyout domain.key -out domain.csr",
            "level": "advanced",
            "topic": "CSR y CA",
            "description": "Genera clave RSA y CSR en una sola operaci\u00f3n.",
            "example": "openssl req -new -newkey rsa:4096 -nodes -keyout domain.key -out domain.csr",
            "expected": "domain.key y domain.csr.",
            "note": "La clave queda sin passphrase por -nodes; protegela con permisos estrictos."
        },
        {
            "command": "openssl s_client -connect <domain>:443 -servername <domain> -verify_return_error </dev/null",
            "level": "advanced",
            "topic": "TLS remoto",
            "description": "Prueba handshake TLS fallando si la validaci\u00f3n de certificado falla.",
            "example": "openssl s_client -connect <domain>:443 -servername <domain> -verify_return_error </dev/null",
            "expected": "Cadena, handshake y Verify return code.",
            "note": ""
        },
        {
            "command": "printf '%s' '<text>' | openssl dgst -sha256",
            "level": "intermediate",
            "topic": "Hashes y encoding",
            "description": "Calcula SHA-256 de texto sin newline.",
            "example": "printf '%s' '<text>' | openssl dgst -sha256",
            "expected": "Digest SHA2-256 en hexadecimal.",
            "note": ""
        }
    ],
    "jq": [
        {
            "command": "jq '.' file.json",
            "level": "basic",
            "topic": "Seleccion",
            "description": "Formatea JSON.",
            "example": "jq '.' file.json",
            "expected": "JSON pretty-printed.",
            "note": ""
        },
        {
            "command": "jq '.items[] | .name' file.json",
            "level": "basic",
            "topic": "Seleccion",
            "description": "Extrae el campo name de cada elemento de items.",
            "example": "jq -r '.items[] | .name' file.json",
            "expected": "Un nombre por elemento (con -r, texto sin comillas).",
            "note": ""
        },
        {
            "command": "jq '.items[] | select(.active == true)' file.json",
            "level": "intermediate",
            "topic": "Seleccion",
            "description": "Filtra items dejando s\u00f3lo objetos cuyo campo active es true.",
            "example": "jq '.items[] | select(.active == true)' file.json",
            "expected": "Objetos activos, uno por salida JSON.",
            "note": ""
        },
        {
            "command": "jq 'paths(scalars) as $p | {path:$p,value:getpath($p)}' file.json",
            "level": "intermediate",
            "topic": "Seleccion",
            "description": "Enumera paths de valores escalares y sus valores.",
            "example": "jq 'paths(scalars) as $p | {path:$p,value:getpath($p)}' file.json",
            "expected": "Objetos JSON con path y value.",
            "note": ""
        },
        {
            "command": "jq '.items | length' file.json",
            "level": "basic",
            "topic": "Arrays",
            "description": "Cuenta los elementos del array items.",
            "example": "jq '.items | length' file.json",
            "expected": "N\u00famero entero.",
            "note": ""
        },
        {
            "command": "jq '.items | sort_by(.name)' file.json",
            "level": "intermediate",
            "topic": "Arrays",
            "description": "Ordena el array items por la propiedad name.",
            "example": "jq '.items | sort_by(.name)' file.json",
            "expected": "Array JSON ordenado por name.",
            "note": ""
        },
        {
            "command": "jq '.items | group_by(.status) | map({status:.[0].status,count:length})' file.json",
            "level": "intermediate",
            "topic": "Arrays",
            "description": "Agrupa items por status y devuelve el conteo de cada grupo.",
            "example": "jq '.items | group_by(.status) | map({status:.[0].status,count:length})' file.json",
            "expected": "Array de objetos {status,count}.",
            "note": "group_by requiere que la entrada est\u00e9 ordenada por la expresi\u00f3n en versiones/escenarios donde el orden importe; pod\u00e9s aplicar sort_by(.status) antes."
        },
        {
            "command": "jq 'keys' file.json",
            "level": "basic",
            "topic": "Objetos",
            "description": "Lista claves de un objeto.",
            "example": "jq 'keys' file.json",
            "expected": "Array de strings.",
            "note": ""
        },
        {
            "command": "jq 'del(.password,.token)' file.json",
            "level": "intermediate",
            "topic": "Objetos",
            "description": "Elimina campos de la salida.",
            "example": "jq 'del(.password,.token)' file.json",
            "expected": "JSON sin esos campos.",
            "note": ""
        },
        {
            "command": "jq 'with_entries(.key |= ascii_downcase)' file.json",
            "level": "intermediate",
            "topic": "Objetos",
            "description": "Convierte las claves de primer nivel a min\u00fasculas.",
            "example": "jq 'with_entries(.key |= ascii_downcase)' file.json",
            "expected": "Objeto con claves transformadas a min\u00fasculas.",
            "note": ""
        },
        {
            "command": "jq --arg env prod '.environment=$env' file.json",
            "level": "intermediate",
            "topic": "Transformacion",
            "description": "Inyecta argumento string.",
            "example": "jq --arg env prod '.environment=$env' file.json",
            "expected": "JSON con environment=prod.",
            "note": ""
        },
        {
            "command": "jq 'reduce .items[] as $i ({}; .[$i.type] = ((.[$i.type] // 0) + 1))' file.json",
            "level": "advanced",
            "topic": "Transformacion",
            "description": "Acumula conteos por tipo.",
            "example": "jq 'reduce .items[] as $i ({}; .[$i.type] = ((.[$i.type] // 0) + 1))' file.json",
            "expected": "Objeto tipo->conteo.",
            "note": ""
        },
        {
            "command": "jq -r '.url' file.json",
            "level": "basic",
            "topic": "Entrada y salida",
            "description": "Emite string raw sin comillas.",
            "example": "jq -r '.url' file.json",
            "expected": "Texto de url.",
            "note": ""
        },
        {
            "command": "jq -c '.items[]' file.json",
            "level": "intermediate",
            "topic": "Entrada y salida",
            "description": "Emite JSON Lines compacto.",
            "example": "jq -c '.items[]' file.json",
            "expected": "Un JSON por linea.",
            "note": ""
        },
        {
            "command": "jq --stream '.' huge.json",
            "level": "advanced",
            "topic": "Entrada y salida",
            "description": "Parsea JSON en modo streaming.",
            "example": "jq --stream '.' huge.json",
            "expected": "Eventos path/value.",
            "note": "Util para archivos enormes; salida es de bajo nivel."
        },
        {
            "command": "jq '.name // \"sin-nombre\"' package.json",
            "level": "basic",
            "topic": "Selecci\u00f3n",
            "description": "Usa un valor alternativo cuando el campo es null o no existe.",
            "example": "jq '.name // \"sin-nombre\"' package.json",
            "expected": "Imprime el nombre o \"sin-nombre\".",
            "note": ""
        },
        {
            "command": "jq '.items | length' file.json",
            "level": "intermediate",
            "topic": "Selecci\u00f3n",
            "description": "Cuenta elementos de un array.",
            "example": "jq '.items | length' file.json",
            "expected": "Un n\u00famero entero.",
            "note": ""
        },
        {
            "command": "jq '[.items[] | select(.enabled)]' file.json",
            "level": "intermediate",
            "topic": "Arrays",
            "description": "Filtra un array conservando s\u00f3lo objetos habilitados.",
            "example": "jq '[.items[] | select(.enabled)]' file.json",
            "expected": "Nuevo array JSON con los elementos coincidentes.",
            "note": ""
        },
        {
            "command": "jq '.items | max_by(.score)' file.json",
            "level": "intermediate",
            "topic": "Arrays",
            "description": "Obtiene el objeto con mayor valor de una propiedad.",
            "example": "jq '.items | max_by(.score)' file.json",
            "expected": "Objeto con el score m\u00e1ximo.",
            "note": ""
        },
        {
            "command": "jq '.items | min_by(.createdAt)' file.json",
            "level": "intermediate",
            "topic": "Arrays",
            "description": "Obtiene el objeto m\u00ednimo seg\u00fan una propiedad.",
            "example": "jq '.items | min_by(.createdAt)' file.json",
            "expected": "Objeto que tenga el menor valor seg\u00fan la expresi\u00f3n.",
            "note": ""
        },
        {
            "command": "jq '. + {environment: \"prod\"}' file.json",
            "level": "intermediate",
            "topic": "Objetos",
            "description": "Agrega o sobrescribe una propiedad en un objeto.",
            "example": "jq '. + {environment: \"prod\"}' file.json",
            "expected": "Objeto JSON con environment=\"prod\".",
            "note": ""
        },
        {
            "command": "jq 'to_entries | map(select(.value != null)) | from_entries' file.json",
            "level": "advanced",
            "topic": "Objetos",
            "description": "Elimina propiedades de primer nivel cuyo valor es null.",
            "example": "jq 'to_entries | map(select(.value != null)) | from_entries' file.json",
            "expected": "Objeto reconstruido sin las claves null.",
            "note": ""
        },
        {
            "command": "jq -e '.ok == true' response.json",
            "level": "basic",
            "topic": "Entrada/salida",
            "description": "Eval\u00faa una condici\u00f3n usando el c\u00f3digo de salida de jq.",
            "example": "jq -e '.ok == true' response.json",
            "expected": "C\u00f3digo 0 si es true, 1 si es false/null y errores con otros c\u00f3digos.",
            "note": ""
        },
        {
            "command": "jq -S '.' file.json",
            "level": "intermediate",
            "topic": "Entrada/salida",
            "description": "Ordena claves de objetos al imprimir.",
            "example": "jq -S '.' file.json",
            "expected": "JSON formateado con claves ordenadas.",
            "note": ""
        }
    ],
    "text-utils": [
        {
            "command": "grep -RIn \"<pattern>\" <path>",
            "level": "basic",
            "topic": "grep",
            "description": "Busca recursivamente con archivo y linea.",
            "example": "grep -RIn \"<pattern>\" <path>",
            "expected": "Coincidencias file:line:text.",
            "note": ""
        },
        {
            "command": "grep -RIl \"<pattern>\" <path>",
            "level": "intermediate",
            "topic": "grep",
            "description": "Devuelve solo archivos que contienen patron.",
            "example": "grep -RIl \"<pattern>\" <path>",
            "expected": "Una ruta por linea.",
            "note": ""
        },
        {
            "command": "rg '<pattern>' <path>",
            "level": "intermediate",
            "topic": "grep",
            "description": "Busca con ripgrep.",
            "example": "rg '<pattern>' <path>",
            "expected": "Coincidencias rapidas con archivo/linea.",
            "note": ""
        },
        {
            "command": "rg -U '<multiline-regex>' <path>",
            "level": "advanced",
            "topic": "grep",
            "description": "Busca patrones multilinea.",
            "example": "rg -U '<multiline-regex>' <path>",
            "expected": "Coincidencias que cruzan saltos de linea.",
            "note": ""
        },
        {
            "command": "sed -n '1,20p' <file>",
            "level": "basic",
            "topic": "sed",
            "description": "Imprime lineas 1 a 20.",
            "example": "sed -n '1,20p' <file>",
            "expected": "Primeras 20 lineas.",
            "note": ""
        },
        {
            "command": "sed 's/old/new/g' <file>",
            "level": "intermediate",
            "topic": "sed",
            "description": "Reemplaza en salida sin modificar archivo.",
            "example": "sed 's/old/new/g' <file>",
            "expected": "Texto transformado.",
            "note": ""
        },
        {
            "command": "sed -i.bak 's/old/new/g' <file>",
            "level": "advanced",
            "topic": "sed",
            "description": "Edita in-place dejando backup.",
            "example": "sed -i.bak 's/old/new/g' <file>",
            "expected": "Archivo modificado y .bak.",
            "note": "Revisa diff antes de borrar el backup."
        },
        {
            "command": "awk '{print $1}' <file>",
            "level": "basic",
            "topic": "awk",
            "description": "Imprime primer campo por whitespace.",
            "example": "awk '{print $1}' <file>",
            "expected": "Primer campo por linea.",
            "note": ""
        },
        {
            "command": "awk -F, 'NR>1 {sum += $3} END {print sum}' <file.csv>",
            "level": "intermediate",
            "topic": "awk",
            "description": "Suma columna 3 omitiendo header.",
            "example": "awk -F, 'NR>1 {sum += $3} END {print sum}' <file.csv>",
            "expected": "Total numerico.",
            "note": "Solo para CSV simple sin quoted commas."
        },
        {
            "command": "awk '{count[$1]++} END {for (k in count) print k,count[k]}' <file>",
            "level": "advanced",
            "topic": "awk",
            "description": "Cuenta ocurrencias por primer campo.",
            "example": "awk '{count[$1]++} END {for (k in count) print k,count[k]}' <file>",
            "expected": "Clave y conteo.",
            "note": ""
        },
        {
            "command": "cut -d, -f1,3 <file.csv>",
            "level": "basic",
            "topic": "cut / sort / uniq",
            "description": "Extrae columnas delimitadas.",
            "example": "cut -d, -f1,3 <file.csv>",
            "expected": "Campos 1 y 3.",
            "note": "No es parser CSV completo."
        },
        {
            "command": "sort <file> | uniq -c",
            "level": "basic",
            "topic": "cut / sort / uniq",
            "description": "Cuenta l\u00edneas consecutivas despu\u00e9s de ordenarlas.",
            "example": "sort values.txt | uniq -c",
            "expected": "Conteo seguido de cada l\u00ednea \u00fanica.",
            "note": ""
        },
        {
            "command": "sort -t, -k3,3nr <file.csv>",
            "level": "intermediate",
            "topic": "cut / sort / uniq",
            "description": "Ordena numericamente por columna 3 descendente.",
            "example": "sort -t, -k3,3nr <file.csv>",
            "expected": "Filas ordenadas.",
            "note": ""
        },
        {
            "command": "find . -name '*.log' -print0 | xargs -0 wc -l",
            "level": "basic",
            "topic": "xargs y pipelines",
            "description": "Cuenta l\u00edneas de todos los logs manejando nombres con espacios.",
            "example": "find . -name '*.log' -print0 | xargs -0 wc -l",
            "expected": "Cantidad de l\u00edneas por archivo y total.",
            "note": ""
        },
        {
            "command": "printf '%s\\n' a b c | xargs -n1 -P4 <command>",
            "level": "intermediate",
            "topic": "xargs y pipelines",
            "description": "Ejecuta un comando por elemento con hasta cuatro procesos en paralelo.",
            "example": "printf '%s\\n' a b c | xargs -n1 -P4 echo",
            "expected": "Salida potencialmente intercalada de las ejecuciones.",
            "note": "Asegur\u00e1 que el comando sea seguro para paralelismo."
        },
        {
            "command": "tee output.log",
            "level": "intermediate",
            "topic": "xargs y pipelines",
            "description": "Duplica stdin a pantalla y archivo.",
            "example": "tee output.log",
            "expected": "Misma salida en stdout y output.log.",
            "note": ""
        },
        {
            "command": "column -t -s, <file.csv>",
            "level": "intermediate",
            "topic": "xargs y pipelines",
            "description": "Alinea campos separados por coma.",
            "example": "column -t -s, <file.csv>",
            "expected": "Tabla alineada.",
            "note": "Solo visualizacion simple."
        },
        {
            "command": "grep -E 'ERROR|WARN' app.log",
            "level": "intermediate",
            "topic": "grep",
            "description": "Busca m\u00faltiples alternativas con expresiones regulares extendidas.",
            "example": "grep -E 'ERROR|WARN' app.log",
            "expected": "L\u00edneas que contienen ERROR o WARN.",
            "note": ""
        },
        {
            "command": "grep -P '(?<=user=)[^ ]+' app.log",
            "level": "advanced",
            "topic": "grep",
            "description": "Usa regex PCRE cuando grep fue compilado con soporte -P.",
            "example": "grep -P '(?<=user=)[^ ]+' app.log",
            "expected": "Coincidencias que satisfacen la expresi\u00f3n.",
            "note": "-P no est\u00e1 disponible en todas las implementaciones de grep."
        },
        {
            "command": "sed -E 's/[[:space:]]+/ /g' <file>",
            "level": "intermediate",
            "topic": "sed",
            "description": "Normaliza grupos de espacios usando regex extendida.",
            "example": "sed -E 's/[[:space:]]+/ /g' <file>",
            "expected": "Texto transformado en stdout.",
            "note": ""
        },
        {
            "command": "awk 'NR==FNR{a[$1]=$2; next} {$2=a[$1]; print}' map.txt data.txt",
            "level": "intermediate",
            "topic": "awk",
            "description": "Combina datos de dos archivos usando una clave.",
            "example": "awk 'NR==FNR{a[$1]=$2; next} {$2=a[$1]; print}' map.txt data.txt",
            "expected": "Filas de data.txt con valor reemplazado desde map.txt.",
            "note": ""
        },
        {
            "command": "sort -u <file>",
            "level": "intermediate",
            "topic": "cut/sort/uniq",
            "description": "Ordena y elimina duplicados en una sola operaci\u00f3n.",
            "example": "sort -u <file>",
            "expected": "L\u00edneas \u00fanicas ordenadas.",
            "note": ""
        },
        {
            "command": "xargs -0 -n1 < files.null",
            "level": "intermediate",
            "topic": "xargs y pipelines",
            "description": "Procesa entrada separada por NUL de forma segura para nombres con espacios.",
            "example": "xargs -0 -n1 < files.null",
            "expected": "Una invocaci\u00f3n por elemento seg\u00fan -n1.",
            "note": ""
        },
        {
            "command": "find . -type f -print0 | xargs -0 sha256sum",
            "level": "advanced",
            "topic": "xargs y pipelines",
            "description": "Calcula hashes para muchos archivos de forma segura.",
            "example": "find . -type f -print0 | xargs -0 sha256sum",
            "expected": "Hash SHA-256 y ruta por archivo.",
            "note": ""
        }
    ],
    "helm": [
        {
            "command": "helm repo add <name> <url>",
            "level": "basic",
            "topic": "Repositorios",
            "description": "Agrega repo Helm.",
            "example": "helm repo add <name> <url>",
            "expected": "repo added.",
            "note": ""
        },
        {
            "command": "helm repo update",
            "level": "basic",
            "topic": "Repositorios",
            "description": "Actualiza indices.",
            "example": "helm repo update",
            "expected": "Update complete.",
            "note": ""
        },
        {
            "command": "helm search repo <query>",
            "level": "basic",
            "topic": "Repositorios",
            "description": "Busca charts.",
            "example": "helm search repo <query>",
            "expected": "NAME, CHART VERSION, APP VERSION, DESCRIPTION.",
            "note": ""
        },
        {
            "command": "helm create <chart>",
            "level": "basic",
            "topic": "Charts",
            "description": "Genera skeleton de chart.",
            "example": "helm create <chart>",
            "expected": "Directorio con Chart.yaml, values.yaml y templates.",
            "note": ""
        },
        {
            "command": "helm lint <chart>",
            "level": "basic",
            "topic": "Charts",
            "description": "Valida buenas practicas/sintaxis.",
            "example": "helm lint <chart>",
            "expected": "Lint summary.",
            "note": ""
        },
        {
            "command": "helm template <release> <chart> -f values.yaml",
            "level": "intermediate",
            "topic": "Charts",
            "description": "Renderiza manifests sin instalar.",
            "example": "helm template <release> <chart> -f values.yaml",
            "expected": "YAML renderizado.",
            "note": ""
        },
        {
            "command": "helm dependency update <chart>",
            "level": "intermediate",
            "topic": "Charts",
            "description": "Descarga dependencias.",
            "example": "helm dependency update <chart>",
            "expected": "Charts en charts/ y lock actualizado.",
            "note": ""
        },
        {
            "command": "helm list -A",
            "level": "basic",
            "topic": "Releases",
            "description": "Lista releases en todos namespaces.",
            "example": "helm list -A",
            "expected": "NAME, NAMESPACE, REVISION, STATUS, CHART, APP VERSION.",
            "note": ""
        },
        {
            "command": "helm status <release> -n <ns>",
            "level": "basic",
            "topic": "Releases",
            "description": "Muestra estado de release.",
            "example": "helm status <release> -n <ns>",
            "expected": "Status, revision, resources/notes.",
            "note": ""
        },
        {
            "command": "helm upgrade --install <release> <chart> -n <ns> --create-namespace",
            "level": "intermediate",
            "topic": "Releases",
            "description": "Instala o actualiza idempotentemente.",
            "example": "helm upgrade --install <release> <chart> -n <ns> --create-namespace",
            "expected": "Release deployed/upgraded.",
            "note": ""
        },
        {
            "command": "helm history <release> -n <ns>",
            "level": "intermediate",
            "topic": "Releases",
            "description": "Lista revisiones.",
            "example": "helm history <release> -n <ns>",
            "expected": "REVISION, UPDATED, STATUS, CHART, DESCRIPTION.",
            "note": ""
        },
        {
            "command": "helm rollback <release> <revision> -n <ns>",
            "level": "advanced",
            "topic": "Releases",
            "description": "Revierte a revision previa.",
            "example": "helm rollback <release> <revision> -n <ns>",
            "expected": "Rollback confirmation.",
            "note": "Impacta workloads; revisa valores y migraciones."
        },
        {
            "command": "helm get values <release> -n <ns> -a",
            "level": "basic",
            "topic": "Values y diff",
            "description": "Muestra valores efectivos.",
            "example": "helm get values <release> -n <ns> -a",
            "expected": "YAML de values.",
            "note": ""
        },
        {
            "command": "helm upgrade --install <release> <chart> --set image.tag=<tag>",
            "level": "intermediate",
            "topic": "Values y diff",
            "description": "Override puntual de value.",
            "example": "helm upgrade --install <release> <chart> --set image.tag=<tag>",
            "expected": "Release actualizada.",
            "note": ""
        },
        {
            "command": "helm registry login <registry>",
            "level": "basic",
            "topic": "Registry OCI",
            "description": "Autentica contra OCI registry.",
            "example": "helm registry login <registry>",
            "expected": "Login succeeded.",
            "note": ""
        },
        {
            "command": "helm push <chart.tgz> oci://<registry>/<repo>",
            "level": "intermediate",
            "topic": "Registry OCI",
            "description": "Publica chart OCI.",
            "example": "helm push <chart.tgz> oci://<registry>/<repo>",
            "expected": "Digest y URL.",
            "note": ""
        },
        {
            "command": "helm package <chart>",
            "level": "intermediate",
            "topic": "Charts",
            "description": "Empaqueta un chart en .tgz.",
            "example": "helm package <chart>",
            "expected": "Archivo <chart>-<version>.tgz.",
            "note": ""
        },
        {
            "command": "helm template <release> <chart> --debug",
            "level": "advanced",
            "topic": "Charts",
            "description": "Renderiza manifests localmente con informaci\u00f3n de debug.",
            "example": "helm template <release> <chart> --debug",
            "expected": "YAML renderizado y mensajes de diagn\u00f3stico.",
            "note": ""
        },
        {
            "command": "helm upgrade --install <release> <chart> --atomic --wait",
            "level": "advanced",
            "topic": "Releases",
            "description": "Instala/actualiza esperando readiness y revierte ante fallo.",
            "example": "helm upgrade --install <release> <chart> --atomic --wait",
            "expected": "Release deployed o rollback autom\u00e1tico si falla.",
            "note": "Puede tardar hasta el timeout configurado."
        }
    ],
    "ansible": [
        {
            "command": "ansible-inventory -i inventory.ini --graph",
            "level": "basic",
            "topic": "Inventario",
            "description": "Muestra inventario como arbol.",
            "example": "ansible-inventory -i inventory.ini --graph",
            "expected": "Hosts agrupados.",
            "note": ""
        },
        {
            "command": "ansible-inventory -i inventory.ini --host <host>",
            "level": "intermediate",
            "topic": "Inventario",
            "description": "Muestra variables de un host.",
            "example": "ansible-inventory -i inventory.ini --host <host>",
            "expected": "JSON de variables.",
            "note": ""
        },
        {
            "command": "ansible all -i inventory.ini -m ping",
            "level": "basic",
            "topic": "Ad-hoc",
            "description": "Prueba conectividad/ejecucion Python.",
            "example": "ansible all -i inventory.ini -m ping",
            "expected": "SUCCESS y pong por host.",
            "note": ""
        },
        {
            "command": "ansible web -i inventory.ini -m command -a 'uptime'",
            "level": "basic",
            "topic": "Ad-hoc",
            "description": "Ejecuta uptime en grupo web.",
            "example": "ansible web -i inventory.ini -m command -a 'uptime'",
            "expected": "stdout por host.",
            "note": ""
        },
        {
            "command": "ansible all -b -m package -a 'name=curl state=present'",
            "level": "intermediate",
            "topic": "Ad-hoc",
            "description": "Instala curl usando abstraccion package.",
            "example": "ansible all -b -m package -a 'name=curl state=present'",
            "expected": "changed/ok por host.",
            "note": "Requiere privilegios y package manager compatible."
        },
        {
            "command": "ansible-playbook -i inventory.ini site.yml",
            "level": "basic",
            "topic": "Playbooks",
            "description": "Ejecuta playbook.",
            "example": "ansible-playbook -i inventory.ini site.yml",
            "expected": "TASK output y PLAY RECAP.",
            "note": ""
        },
        {
            "command": "ansible-playbook -i inventory.ini site.yml --check --diff",
            "level": "intermediate",
            "topic": "Playbooks",
            "description": "Simula cambios y muestra diff.",
            "example": "ansible-playbook -i inventory.ini site.yml --check --diff",
            "expected": "Prediccion changed y diffs.",
            "note": "No todos los modulos soportan check mode perfectamente."
        },
        {
            "command": "ansible-playbook site.yml --limit <host>",
            "level": "intermediate",
            "topic": "Playbooks",
            "description": "Limita ejecucion.",
            "example": "ansible-playbook site.yml --limit <host>",
            "expected": "Solo hosts coincidentes.",
            "note": ""
        },
        {
            "command": "ansible-playbook site.yml --tags deploy",
            "level": "intermediate",
            "topic": "Playbooks",
            "description": "Ejecuta tags seleccionados.",
            "example": "ansible-playbook site.yml --tags deploy",
            "expected": "Tasks con tag deploy.",
            "note": ""
        },
        {
            "command": "ansible-playbook site.yml --start-at-task '<task>'",
            "level": "advanced",
            "topic": "Playbooks",
            "description": "Retoma desde una task.",
            "example": "ansible-playbook site.yml --start-at-task '<task>'",
            "expected": "Ejecucion desde el punto indicado.",
            "note": "Puede saltar precondiciones anteriores."
        },
        {
            "command": "ansible-vault create secrets.yml",
            "level": "basic",
            "topic": "Vault",
            "description": "Crea archivo cifrado.",
            "example": "ansible-vault create secrets.yml",
            "expected": "Editor y archivo cifrado.",
            "note": ""
        },
        {
            "command": "ansible-vault view secrets.yml",
            "level": "basic",
            "topic": "Vault",
            "description": "Descifra temporalmente para mostrar.",
            "example": "ansible-vault view secrets.yml",
            "expected": "Contenido plaintext en terminal.",
            "note": "Evita capturas/logs."
        },
        {
            "command": "ansible-vault encrypt_string 'value' --name 'secret_key'",
            "level": "intermediate",
            "topic": "Vault",
            "description": "Cifra un valor para YAML.",
            "example": "ansible-vault encrypt_string 'value' --name 'secret_key'",
            "expected": "Bloque !vault.",
            "note": ""
        },
        {
            "command": "ansible-galaxy collection install <namespace.collection>",
            "level": "basic",
            "topic": "Galaxy y collections",
            "description": "Instala collection.",
            "example": "ansible-galaxy collection install <namespace.collection>",
            "expected": "Progreso y ruta instalada.",
            "note": ""
        },
        {
            "command": "ansible-galaxy role init <role>",
            "level": "intermediate",
            "topic": "Galaxy y collections",
            "description": "Crea skeleton de role.",
            "example": "ansible-galaxy role init <role>",
            "expected": "Directorios defaults/tasks/handlers/etc.",
            "note": ""
        },
        {
            "command": "ansible-config dump --only-changed",
            "level": "basic",
            "topic": "Config y diagnostico",
            "description": "Muestra config que difiere del default.",
            "example": "ansible-config dump --only-changed",
            "expected": "Claves cambiadas y origen.",
            "note": ""
        },
        {
            "command": "ansible-doc <module>",
            "level": "basic",
            "topic": "Config y diagnostico",
            "description": "Muestra documentacion local de un modulo.",
            "example": "ansible-doc <module>",
            "expected": "Options, examples y return values.",
            "note": ""
        },
        {
            "command": "ansible-playbook site.yml --syntax-check",
            "level": "advanced",
            "topic": "Playbooks",
            "description": "Valida sintaxis del playbook sin ejecutarlo.",
            "example": "ansible-playbook site.yml --syntax-check",
            "expected": "playbook: site.yml si la sintaxis es v\u00e1lida o errores detallados.",
            "note": ""
        }
    ],
    "make": [
        {
            "command": "make",
            "level": "basic",
            "topic": "Targets",
            "description": "Ejecuta el primer target por defecto.",
            "example": "make",
            "expected": "Salida de recetas ejecutadas.",
            "note": ""
        },
        {
            "command": "make <target>",
            "level": "basic",
            "topic": "Targets",
            "description": "Ejecuta un target.",
            "example": "make <target>",
            "expected": "Comandos y salida del target.",
            "note": ""
        },
        {
            "command": "make -f <Makefile> <target>",
            "level": "intermediate",
            "topic": "Targets",
            "description": "Usa un Makefile alternativo.",
            "example": "make -f <Makefile> <target>",
            "expected": "Salida del target.",
            "note": ""
        },
        {
            "command": "make -C <dir> <target>",
            "level": "intermediate",
            "topic": "Targets",
            "description": "Cambia de directorio antes de ejecutar.",
            "example": "make -C <dir> <target>",
            "expected": "Entering/Leaving directory y salida.",
            "note": ""
        },
        {
            "command": "make -j4",
            "level": "intermediate",
            "topic": "Paralelismo",
            "description": "Ejecuta hasta 4 jobs.",
            "example": "make -j4",
            "expected": "Salida concurrente.",
            "note": ""
        },
        {
            "command": "make -j$(nproc)",
            "level": "advanced",
            "topic": "Paralelismo",
            "description": "Usa tantos jobs como CPUs logicas Linux.",
            "example": "make -j$(nproc)",
            "expected": "Build paralelo.",
            "note": "Puede saturar memoria/I/O."
        },
        {
            "command": "make -n <target>",
            "level": "basic",
            "topic": "Dry-run y debug",
            "description": "Muestra recetas sin ejecutarlas.",
            "example": "make -n <target>",
            "expected": "Comandos que correria.",
            "note": ""
        },
        {
            "command": "make --debug=v <target>",
            "level": "intermediate",
            "topic": "Dry-run y debug",
            "description": "Muestra debug verbose.",
            "example": "make --debug=v <target>",
            "expected": "Decisiones de targets/prerequisitos.",
            "note": ""
        },
        {
            "command": "make -pRrq -f <Makefile> :",
            "level": "advanced",
            "topic": "Dry-run y debug",
            "description": "Vuelca base interna sin reglas built-in.",
            "example": "make -pRrq -f <Makefile> :",
            "expected": "Variables y reglas evaluadas.",
            "note": "Salida muy extensa."
        },
        {
            "command": "make <target> VAR=value",
            "level": "basic",
            "topic": "Variables",
            "description": "Override de variable desde CLI.",
            "example": "make <target> VAR=value",
            "expected": "Target ejecutado con VAR=value.",
            "note": ""
        },
        {
            "command": "make -e <target>",
            "level": "intermediate",
            "topic": "Variables",
            "description": "Da prioridad a variables de entorno.",
            "example": "make -e <target>",
            "expected": "Build usando overrides del environment.",
            "note": "Puede cambiar comportamiento de manera poco visible."
        },
        {
            "command": "make -B <target>",
            "level": "intermediate",
            "topic": "Targets",
            "description": "Fuerza rebuild ignorando timestamps.",
            "example": "make -B <target>",
            "expected": "Recetas reejecutadas.",
            "note": ""
        },
        {
            "command": "make -k <target>",
            "level": "intermediate",
            "topic": "Targets",
            "description": "Continua despues de errores independientes.",
            "example": "make -k <target>",
            "expected": "Mas targets intentados y exit code de error.",
            "note": ""
        },
        {
            "command": "make --warn-undefined-variables <target>",
            "level": "advanced",
            "topic": "Targets",
            "description": "Advierte variables no definidas.",
            "example": "make --warn-undefined-variables <target>",
            "expected": "Warnings y salida normal.",
            "note": ""
        },
        {
            "command": "make help",
            "level": "basic",
            "topic": "Targets",
            "description": "Ejecuta el target help si el Makefile lo define.",
            "example": "make help",
            "expected": "Salida de ayuda definida por el propio proyecto.",
            "note": "No todos los Makefile incluyen un target help."
        },
        {
            "command": "make clean",
            "level": "basic",
            "topic": "Targets",
            "description": "Ejecuta el target clean.",
            "example": "make clean",
            "expected": "Normalmente muestra comandos que eliminan artefactos de build.",
            "note": "El efecto exacto depende del Makefile."
        },
        {
            "command": "make all",
            "level": "basic",
            "topic": "Targets",
            "description": "Ejecuta el target all.",
            "example": "make all",
            "expected": "Construye los objetivos asociados a all.",
            "note": ""
        },
        {
            "command": "make -t <target>",
            "level": "intermediate",
            "topic": "Control de ejecuci\u00f3n",
            "description": "Marca objetivos como actualizados sin ejecutar sus recetas.",
            "example": "make -t <target>",
            "expected": "Actualiza timestamps/estado seg\u00fan make.",
            "note": "Puede dejar un estado enga\u00f1oso; usalo s\u00f3lo si entend\u00e9s el grafo."
        },
        {
            "command": "make -q <target>",
            "level": "intermediate",
            "topic": "Control de ejecuci\u00f3n",
            "description": "Comprueba si un target est\u00e1 actualizado sin construirlo.",
            "example": "make -q <target>",
            "expected": "C\u00f3digo 0 si est\u00e1 actualizado, 1 si necesita rebuild y 2 ante error.",
            "note": ""
        },
        {
            "command": "make -s <target>",
            "level": "intermediate",
            "topic": "Control de ejecuci\u00f3n",
            "description": "Ejecuta un target en modo silencioso.",
            "example": "make -s <target>",
            "expected": "Oculta los comandos ejecutados y deja s\u00f3lo su salida.",
            "note": ""
        },
        {
            "command": "make -j <target>",
            "level": "advanced",
            "topic": "Paralelismo",
            "description": "Ejecuta tantos jobs en paralelo como sea posible.",
            "example": "make -j <target>",
            "expected": "Build paralelo; la salida puede aparecer intercalada.",
            "note": "Puede consumir muchos recursos."
        },
        {
            "command": "make -j4 --output-sync=target <target>",
            "level": "advanced",
            "topic": "Paralelismo",
            "description": "Ejecuta cuatro jobs sincronizando la salida por target.",
            "example": "make -j4 --output-sync=target <target>",
            "expected": "Salida agrupada por target, m\u00e1s legible en builds paralelos.",
            "note": ""
        },
        {
            "command": "make --trace <target>",
            "level": "intermediate",
            "topic": "Debug",
            "description": "Explica por qu\u00e9 se reconstruye cada target.",
            "example": "make --trace <target>",
            "expected": "L\u00edneas con archivo/receta y motivo de ejecuci\u00f3n.",
            "note": ""
        },
        {
            "command": "make --debug=a <target>",
            "level": "advanced",
            "topic": "Debug",
            "description": "Activa el nivel de debug m\u00e1s detallado.",
            "example": "make --debug=a <target>",
            "expected": "Gran cantidad de informaci\u00f3n sobre reglas, dependencias y decisiones.",
            "note": ""
        },
        {
            "command": "make -pn | less",
            "level": "advanced",
            "topic": "Base de datos",
            "description": "Imprime la base de datos interna de reglas y variables sin ejecutar.",
            "example": "make -pn | less",
            "expected": "Listado extenso de reglas, variables y targets.",
            "note": ""
        },
        {
            "command": "make -rR <target>",
            "level": "intermediate",
            "topic": "Variables",
            "description": "Desactiva reglas y variables impl\u00edcitas incorporadas.",
            "example": "make -rR <target>",
            "expected": "Ejecuta s\u00f3lo lo definido expl\u00edcitamente por el Makefile.",
            "note": ""
        },
        {
            "command": "make --no-print-directory -C <dir> <target>",
            "level": "intermediate",
            "topic": "Directorios",
            "description": "Ejecuta make en otro directorio sin banners Entering/Leaving.",
            "example": "make --no-print-directory -C <dir> <target>",
            "expected": "Salida m\u00e1s limpia del target ejecutado.",
            "note": ""
        }
    ],
    "azure-cli": [
        {
            "command": "az login",
            "level": "basic",
            "topic": "Auth y cuenta",
            "description": "Autentica Azure CLI.",
            "example": "az login",
            "expected": "Lista de subscriptions disponibles tras login.",
            "note": ""
        },
        {
            "command": "az account show -o table",
            "level": "basic",
            "topic": "Auth y cuenta",
            "description": "Muestra subscription activa.",
            "example": "az account show -o table",
            "expected": "Name, CloudName, SubscriptionId y TenantId.",
            "note": ""
        },
        {
            "command": "az account list -o table",
            "level": "basic",
            "topic": "Auth y cuenta",
            "description": "Lista subscriptions.",
            "example": "az account list -o table",
            "expected": "Tabla de cuentas/subscriptions.",
            "note": ""
        },
        {
            "command": "az account set --subscription <id-or-name>",
            "level": "intermediate",
            "topic": "Auth y cuenta",
            "description": "Cambia subscription activa.",
            "example": "az account set --subscription <id-or-name>",
            "expected": "Sin salida si funciona.",
            "note": ""
        },
        {
            "command": "az group list -o table",
            "level": "basic",
            "topic": "Resource Groups",
            "description": "Lista resource groups.",
            "example": "az group list -o table",
            "expected": "Name, Location y Status.",
            "note": ""
        },
        {
            "command": "az group create -n <name> -l <region>",
            "level": "basic",
            "topic": "Resource Groups",
            "description": "Crea resource group.",
            "example": "az group create -n <name> -l <region>",
            "expected": "JSON del recurso creado.",
            "note": ""
        },
        {
            "command": "az vm list -d -o table",
            "level": "basic",
            "topic": "Compute",
            "description": "Lista VMs con estado e IPs.",
            "example": "az vm list -d -o table",
            "expected": "Tabla de VMs.",
            "note": ""
        },
        {
            "command": "az vm start -g <rg> -n <vm>",
            "level": "intermediate",
            "topic": "Compute",
            "description": "Inicia una VM.",
            "example": "az vm start -g <rg> -n <vm>",
            "expected": "Sin salida o JSON segun flags.",
            "note": ""
        },
        {
            "command": "az vm deallocate -g <rg> -n <vm>",
            "level": "intermediate",
            "topic": "Compute",
            "description": "Libera compute de una VM.",
            "example": "az vm deallocate -g <rg> -n <vm>",
            "expected": "Operacion async completada.",
            "note": "La VM deja de ejecutar workloads."
        },
        {
            "command": "az storage account list -o table",
            "level": "basic",
            "topic": "Storage",
            "description": "Lista storage accounts.",
            "example": "az storage account list -o table",
            "expected": "Nombre, resource group, location y kind.",
            "note": ""
        },
        {
            "command": "az storage blob upload-batch -d '<container>' -s ./dist --account-name <account>",
            "level": "intermediate",
            "topic": "Storage",
            "description": "Sube un directorio a Blob Storage.",
            "example": "az storage blob upload-batch -d '<container>' -s ./dist --account-name <account>",
            "expected": "Archivos subidos y resultados.",
            "note": "Requiere auth/config adecuada."
        },
        {
            "command": "az acr list -o table",
            "level": "basic",
            "topic": "Containers",
            "description": "Lista registries ACR.",
            "example": "az acr list -o table",
            "expected": "Nombre, login server y resource group.",
            "note": ""
        },
        {
            "command": "az aks get-credentials -g <rg> -n <cluster>",
            "level": "intermediate",
            "topic": "Containers",
            "description": "Descarga credenciales AKS a kubeconfig.",
            "example": "az aks get-credentials -g <rg> -n <cluster>",
            "expected": "Merged context ...",
            "note": "Modifica kubeconfig local."
        },
        {
            "command": "az webapp list -o table",
            "level": "basic",
            "topic": "Web y Functions",
            "description": "Lista Web Apps.",
            "example": "az webapp list -o table",
            "expected": "Name, ResourceGroup, DefaultHostName y State.",
            "note": ""
        },
        {
            "command": "az webapp log tail -g <rg> -n <app>",
            "level": "intermediate",
            "topic": "Web y Functions",
            "description": "Sigue logs de App Service.",
            "example": "az webapp log tail -g <rg> -n <app>",
            "expected": "Stream de logs.",
            "note": ""
        },
        {
            "command": "az keyvault list -o table",
            "level": "basic",
            "topic": "Key Vault y seguridad",
            "description": "Lista Key Vaults.",
            "example": "az keyvault list -o table",
            "expected": "Name, Location, ResourceGroup.",
            "note": ""
        },
        {
            "command": "az keyvault secret show --vault-name <vault> --name <secret> --query value -o tsv",
            "level": "intermediate",
            "topic": "Key Vault y seguridad",
            "description": "Lee un secret autorizado.",
            "example": "az keyvault secret show --vault-name <vault> --name <secret> --query value -o tsv",
            "expected": "Valor del secret.",
            "note": "No copies la salida a logs/tickets."
        },
        {
            "command": "az monitor activity-log list --max-events 20 -o table",
            "level": "intermediate",
            "topic": "Monitor",
            "description": "Muestra eventos recientes.",
            "example": "az monitor activity-log list --max-events 20 -o table",
            "expected": "OperationName, Status, EventTimestamp y Caller.",
            "note": ""
        },
        {
            "command": "az login --use-device-code",
            "level": "intermediate",
            "topic": "Auth y cuenta",
            "description": "Inicia sesi\u00f3n con device code, \u00fatil en terminales sin navegador.",
            "example": "az login --use-device-code",
            "expected": "URL/c\u00f3digo y luego cuentas disponibles.",
            "note": ""
        },
        {
            "command": "az vm show -g <rg> -n <vm> -d -o table",
            "level": "intermediate",
            "topic": "Compute",
            "description": "Muestra una VM con IPs/datos de instancia.",
            "example": "az vm show -g <rg> -n <vm> -d -o table",
            "expected": "Tabla con estado, IPs y propiedades b\u00e1sicas.",
            "note": ""
        },
        {
            "command": "az webapp deploy -g <rg> -n <app> --src-path <artifact>",
            "level": "intermediate",
            "topic": "Web y Functions",
            "description": "Despliega un artefacto a una Web App.",
            "example": "az webapp deploy -g <rg> -n <app> --src-path <artifact>",
            "expected": "Estado del deployment y metadatos.",
            "note": ""
        }
    ],
    "gcloud": [
        {
            "command": "gcloud auth login",
            "level": "basic",
            "topic": "Auth y config",
            "description": "Autentica usuario.",
            "example": "gcloud auth login",
            "expected": "Browser flow y cuenta activa.",
            "note": ""
        },
        {
            "command": "gcloud auth list",
            "level": "basic",
            "topic": "Auth y config",
            "description": "Lista credenciales.",
            "example": "gcloud auth list",
            "expected": "Accounts y active marker.",
            "note": ""
        },
        {
            "command": "gcloud config list",
            "level": "basic",
            "topic": "Auth y config",
            "description": "Muestra configuracion activa.",
            "example": "gcloud config list",
            "expected": "Project, account, region/zone cuando existen.",
            "note": ""
        },
        {
            "command": "gcloud config set project <project-id>",
            "level": "intermediate",
            "topic": "Auth y config",
            "description": "Cambia proyecto activo.",
            "example": "gcloud config set project <project-id>",
            "expected": "Updated property [core/project].",
            "note": ""
        },
        {
            "command": "gcloud compute instances list",
            "level": "basic",
            "topic": "Compute",
            "description": "Lista VMs.",
            "example": "gcloud compute instances list",
            "expected": "NAME, ZONE, MACHINE_TYPE, IPs y STATUS.",
            "note": ""
        },
        {
            "command": "gcloud compute ssh <instance> --zone <zone>",
            "level": "intermediate",
            "topic": "Compute",
            "description": "Abre SSH a VM.",
            "example": "gcloud compute ssh <instance> --zone <zone>",
            "expected": "Sesion remota; puede crear claves/config.",
            "note": ""
        },
        {
            "command": "gcloud compute instances start <instance> --zone <zone>",
            "level": "intermediate",
            "topic": "Compute",
            "description": "Inicia VM.",
            "example": "gcloud compute instances start <instance> --zone <zone>",
            "expected": "Updated resource y estado.",
            "note": ""
        },
        {
            "command": "gcloud compute instances stop <instance> --zone <zone>",
            "level": "intermediate",
            "topic": "Compute",
            "description": "Detiene VM.",
            "example": "gcloud compute instances stop <instance> --zone <zone>",
            "expected": "Updated resource.",
            "note": "Interrumpe workloads."
        },
        {
            "command": "gcloud run services list",
            "level": "basic",
            "topic": "Cloud Run",
            "description": "Lista servicios Cloud Run.",
            "example": "gcloud run services list",
            "expected": "SERVICE, REGION, URL, LAST DEPLOYED BY/AT.",
            "note": ""
        },
        {
            "command": "gcloud run deploy <service> --source . --region <region>",
            "level": "intermediate",
            "topic": "Cloud Run",
            "description": "Build y deploy desde source.",
            "example": "gcloud run deploy <service> --source . --region <region>",
            "expected": "Build/deploy progress y URL.",
            "note": ""
        },
        {
            "command": "gcloud run services logs tail <service> --region <region>",
            "level": "intermediate",
            "topic": "Cloud Run",
            "description": "Sigue logs.",
            "example": "gcloud run services logs tail <service> --region <region>",
            "expected": "Stream de logs.",
            "note": ""
        },
        {
            "command": "gcloud container clusters list",
            "level": "basic",
            "topic": "GKE",
            "description": "Lista clusters GKE.",
            "example": "gcloud container clusters list",
            "expected": "NAME, LOCATION, MASTER_VERSION, STATUS.",
            "note": ""
        },
        {
            "command": "gcloud container clusters get-credentials <cluster> --location <loc>",
            "level": "intermediate",
            "topic": "GKE",
            "description": "Agrega contexto kubeconfig.",
            "example": "gcloud container clusters get-credentials <cluster> --location <loc>",
            "expected": "Fetching cluster endpoint/auth data.",
            "note": ""
        },
        {
            "command": "gcloud storage ls",
            "level": "basic",
            "topic": "Storage",
            "description": "Lista buckets.",
            "example": "gcloud storage ls",
            "expected": "URIs gs://.",
            "note": ""
        },
        {
            "command": "gcloud storage rsync ./dist gs://<bucket> --recursive",
            "level": "intermediate",
            "topic": "Storage",
            "description": "Sincroniza directorio a bucket.",
            "example": "gcloud storage rsync ./dist gs://<bucket> --recursive",
            "expected": "Operaciones copy/delete segun flags.",
            "note": ""
        },
        {
            "command": "gcloud functions list",
            "level": "basic",
            "topic": "Functions",
            "description": "Lista Cloud Functions.",
            "example": "gcloud functions list",
            "expected": "NAME, STATE, TRIGGER, REGION/ENV.",
            "note": ""
        },
        {
            "command": "gcloud functions deploy <name> --gen2 --runtime nodejs22 --trigger-http --region <region>",
            "level": "intermediate",
            "topic": "Functions",
            "description": "Despliega funcion HTTP Gen2.",
            "example": "gcloud functions deploy <name> --gen2 --runtime nodejs22 --trigger-http --region <region>",
            "expected": "Build/deploy y URI final.",
            "note": "Revisa IAM/invoker antes de exponer publicamente."
        },
        {
            "command": "gcloud secrets list",
            "level": "basic",
            "topic": "IAM y secrets",
            "description": "Lista secretos.",
            "example": "gcloud secrets list",
            "expected": "NAME, CREATED, REPLICATION_POLICY.",
            "note": ""
        },
        {
            "command": "gcloud secrets versions access latest --secret <name>",
            "level": "intermediate",
            "topic": "IAM y secrets",
            "description": "Lee version latest.",
            "example": "gcloud secrets versions access latest --secret <name>",
            "expected": "Valor del secret.",
            "note": "No dejes el valor en logs/historial."
        },
        {
            "command": "gcloud logging read 'severity>=ERROR' --limit 50 --format json",
            "level": "intermediate",
            "topic": "Logs",
            "description": "Consulta logs de error.",
            "example": "gcloud logging read 'severity>=ERROR' --limit 50 --format json",
            "expected": "Array/objetos JSON con entries.",
            "note": ""
        },
        {
            "command": "gcloud auth application-default login",
            "level": "intermediate",
            "topic": "Auth y config",
            "description": "Configura Application Default Credentials localmente.",
            "example": "gcloud auth application-default login",
            "expected": "Flujo de login y archivo ADC creado.",
            "note": ""
        },
        {
            "command": "gcloud compute instances describe <instance> --zone <zone>",
            "level": "intermediate",
            "topic": "Compute",
            "description": "Muestra detalle de una instancia.",
            "example": "gcloud compute instances describe <instance> --zone <zone>",
            "expected": "YAML/JSON-like con configuraci\u00f3n y estado.",
            "note": ""
        },
        {
            "command": "gcloud run services describe <service> --region <region>",
            "level": "intermediate",
            "topic": "Cloud Run",
            "description": "Muestra configuraci\u00f3n y estado de un servicio Cloud Run.",
            "example": "gcloud run services describe <service> --region <region>",
            "expected": "Detalle de revisions, URLs y settings.",
            "note": ""
        }
    ],
    "systemd": [
        {
            "command": "systemctl status <service>",
            "level": "basic",
            "topic": "Servicios",
            "description": "Muestra estado del servicio.",
            "example": "systemctl status <service>",
            "expected": "Loaded, Active, PID y logs recientes.",
            "note": ""
        },
        {
            "command": "sudo systemctl restart <service>",
            "level": "basic",
            "topic": "Servicios",
            "description": "Reinicia servicio.",
            "example": "sudo systemctl restart <service>",
            "expected": "Sin salida si funciona.",
            "note": "Puede causar interrupcion breve."
        },
        {
            "command": "sudo systemctl enable --now <service>",
            "level": "basic",
            "topic": "Servicios",
            "description": "Habilita autostart e inicia ahora.",
            "example": "sudo systemctl enable --now <service>",
            "expected": "Symlink creado y servicio activo.",
            "note": ""
        },
        {
            "command": "sudo systemctl mask <service>",
            "level": "intermediate",
            "topic": "Servicios",
            "description": "Impide que el servicio pueda iniciarse.",
            "example": "sudo systemctl mask <service>",
            "expected": "Symlink a /dev/null creado.",
            "note": "Puede romper dependencias; documenta el motivo."
        },
        {
            "command": "sudo systemctl unmask <service>",
            "level": "intermediate",
            "topic": "Servicios",
            "description": "Quita mask.",
            "example": "sudo systemctl unmask <service>",
            "expected": "Symlink removido.",
            "note": ""
        },
        {
            "command": "systemctl list-unit-files --type=service",
            "level": "basic",
            "topic": "Units",
            "description": "Lista unit files y estado de enablement.",
            "example": "systemctl list-unit-files --type=service",
            "expected": "UNIT FILE y STATE.",
            "note": ""
        },
        {
            "command": "systemctl cat <service>",
            "level": "intermediate",
            "topic": "Units",
            "description": "Muestra unit y drop-ins.",
            "example": "systemctl cat <service>",
            "expected": "Contenido de archivos efectivos.",
            "note": ""
        },
        {
            "command": "sudo systemctl edit <service>",
            "level": "intermediate",
            "topic": "Units",
            "description": "Abre editor para crear drop-in.",
            "example": "sudo systemctl edit <service>",
            "expected": "Override guardado en systemd config.",
            "note": ""
        },
        {
            "command": "systemctl show <service> -p MainPID -p ExecMainStatus -p ActiveState",
            "level": "intermediate",
            "topic": "Units",
            "description": "Muestra propiedades puntuales.",
            "example": "systemctl show <service> -p MainPID -p ExecMainStatus -p ActiveState",
            "expected": "clave=valor.",
            "note": ""
        },
        {
            "command": "sudo systemctl set-property <service> MemoryMax=1G",
            "level": "advanced",
            "topic": "Units",
            "description": "Aplica limite cgroup persistente/runtime segun opcion.",
            "example": "sudo systemctl set-property <service> MemoryMax=1G",
            "expected": "Propiedad aplicada.",
            "note": "Valida impacto en el servicio."
        },
        {
            "command": "systemctl list-timers --all",
            "level": "basic",
            "topic": "Timers",
            "description": "Lista timers.",
            "example": "systemctl list-timers --all",
            "expected": "NEXT, LEFT, LAST, PASSED, UNIT, ACTIVATES.",
            "note": ""
        },
        {
            "command": "systemd-analyze calendar 'Mon..Fri 09:00'",
            "level": "intermediate",
            "topic": "Timers",
            "description": "Valida expresion de calendario.",
            "example": "systemd-analyze calendar 'Mon..Fri 09:00'",
            "expected": "Normalized form y next elapse.",
            "note": ""
        },
        {
            "command": "journalctl -u <service> -f",
            "level": "basic",
            "topic": "Logs",
            "description": "Sigue logs del servicio.",
            "example": "journalctl -u <service> -f",
            "expected": "Stream de journal.",
            "note": ""
        },
        {
            "command": "journalctl -u <service> --since '1 hour ago' --no-pager",
            "level": "intermediate",
            "topic": "Logs",
            "description": "Filtra por tiempo.",
            "example": "journalctl -u <service> --since '1 hour ago' --no-pager",
            "expected": "Entradas de la ultima hora.",
            "note": ""
        },
        {
            "command": "journalctl -p err..alert -b",
            "level": "intermediate",
            "topic": "Logs",
            "description": "Muestra errores del boot actual.",
            "example": "journalctl -p err..alert -b",
            "expected": "Eventos de prioridad error a alert.",
            "note": ""
        },
        {
            "command": "systemd-analyze",
            "level": "basic",
            "topic": "Boot y diagnostico",
            "description": "Mide tiempo de arranque.",
            "example": "systemd-analyze",
            "expected": "Kernel + userspace total.",
            "note": ""
        },
        {
            "command": "systemd-analyze blame",
            "level": "intermediate",
            "topic": "Boot y diagnostico",
            "description": "Ordena units por tiempo.",
            "example": "systemd-analyze blame",
            "expected": "Duracion y unit.",
            "note": ""
        },
        {
            "command": "systemd-analyze critical-chain",
            "level": "intermediate",
            "topic": "Boot y diagnostico",
            "description": "Muestra cadena critica de boot.",
            "example": "systemd-analyze critical-chain",
            "expected": "Arbol temporal.",
            "note": ""
        },
        {
            "command": "systemd-analyze security <service>",
            "level": "advanced",
            "topic": "Boot y diagnostico",
            "description": "Evalua exposicion de seguridad de una unit.",
            "example": "systemd-analyze security <service>",
            "expected": "Tabla de checks y exposure level.",
            "note": "Es una ayuda de hardening, no una auditoria completa."
        }
    ]
};

export const EXTRA_COMMAND_CATEGORIES = [
    {
        "id": "deploy-automation",
        "group": "deployment",
        "title": "Automatizaci\u00f3n de deploy",
        "description": "Pipelines repetibles: releases at\u00f3micas, health checks, migraciones, backups, rollback y CI por SSH.",
        "aliases": [
            "deploy",
            "deployment",
            "ci cd",
            "rollback",
            "release"
        ],
        "commands": [
            {
                "command": "git fetch --prune origin",
                "level": "basic",
                "topic": "Preparacion release",
                "description": "Actualiza referencias remotas antes del deploy.",
                "example": "git fetch --prune origin",
                "expected": "Refs actualizadas.",
                "note": ""
            },
            {
                "command": "git checkout main && git pull --ff-only origin main",
                "level": "basic",
                "topic": "Preparacion release",
                "description": "Actualiza main sin merge automatico.",
                "example": "git checkout main && git pull --ff-only origin main",
                "expected": "Working tree actualizado o rechazo si divergio.",
                "note": ""
            },
            {
                "command": "git rev-parse --short HEAD",
                "level": "intermediate",
                "topic": "Preparacion release",
                "description": "Obtiene identificador corto de la release.",
                "example": "git rev-parse --short HEAD",
                "expected": "SHA corto.",
                "note": ""
            },
            {
                "command": "export RELEASE=$(date +%Y%m%d%H%M%S)-$(git rev-parse --short HEAD)",
                "level": "intermediate",
                "topic": "Preparacion release",
                "description": "Genera un nombre de release timestamp+SHA.",
                "example": "export RELEASE=$(date +%Y%m%d%H%M%S)-$(git rev-parse --short HEAD)",
                "expected": "Variable RELEASE definida.",
                "note": ""
            },
            {
                "command": "npm ci",
                "level": "basic",
                "topic": "Build reproducible",
                "description": "Instala exactamente package-lock.",
                "example": "npm ci",
                "expected": "node_modules segun lockfile.",
                "note": ""
            },
            {
                "command": "npm run build",
                "level": "basic",
                "topic": "Build reproducible",
                "description": "Genera artifact de produccion.",
                "example": "npm run build",
                "expected": "dist/build segun proyecto.",
                "note": ""
            },
            {
                "command": "npm ci --omit=dev",
                "level": "intermediate",
                "topic": "Build reproducible",
                "description": "Instala solo dependencias de produccion.",
                "example": "npm ci --omit=dev",
                "expected": "node_modules sin devDependencies.",
                "note": ""
            },
            {
                "command": "docker build --pull -t <image>:<sha> .",
                "level": "intermediate",
                "topic": "Build reproducible",
                "description": "Construye imagen usando base actualizada.",
                "example": "docker build --pull -t <image>:<sha> .",
                "expected": "Imagen tagged con SHA.",
                "note": ""
            },
            {
                "command": "scp -r dist <user>@<host>:<path>",
                "level": "basic",
                "topic": "Artifact transfer",
                "description": "Copia build al servidor.",
                "example": "scp -r dist <user>@<host>:<path>",
                "expected": "Progreso de archivos.",
                "note": ""
            },
            {
                "command": "rsync -az --checksum ./dist/ <user>@<host>:<release>/",
                "level": "intermediate",
                "topic": "Artifact transfer",
                "description": "Sincroniza artifact comparando checksums.",
                "example": "rsync -az --checksum ./dist/ <user>@<host>:<release>/",
                "expected": "Lista/estadisticas de cambios.",
                "note": ""
            },
            {
                "command": "rsync -az --delete --dry-run ./dist/ <user>@<host>:<release>/",
                "level": "intermediate",
                "topic": "Artifact transfer",
                "description": "Simula espejo incluyendo deletes.",
                "example": "rsync -az --delete --dry-run ./dist/ <user>@<host>:<release>/",
                "expected": "Cambios previstos sin aplicar.",
                "note": "Quita --dry-run solo despues de revisar."
            },
            {
                "command": "mkdir -p <app>/releases/<release>",
                "level": "intermediate",
                "topic": "Atomic releases",
                "description": "Crea directorio de release.",
                "example": "mkdir -p <app>/releases/<release>",
                "expected": "Directorio creado.",
                "note": ""
            },
            {
                "command": "ln -sfn <app>/releases/<release> <app>/current",
                "level": "intermediate",
                "topic": "Atomic releases",
                "description": "Apunta current a nueva release atomicamente.",
                "example": "ln -sfn <app>/releases/<release> <app>/current",
                "expected": "Symlink actualizado.",
                "note": ""
            },
            {
                "command": "readlink -f <app>/current",
                "level": "advanced",
                "topic": "Atomic releases",
                "description": "Muestra release activa.",
                "example": "readlink -f <app>/current",
                "expected": "Ruta absoluta de release.",
                "note": ""
            },
            {
                "command": "ln -sfn <app>/releases/<previous> <app>/current",
                "level": "advanced",
                "topic": "Atomic releases",
                "description": "Rollback de symlink a release anterior.",
                "example": "ln -sfn <app>/releases/<previous> <app>/current",
                "expected": "current vuelve a previous.",
                "note": "Asegura compatibilidad con migraciones y datos."
            },
            {
                "command": "sudo systemctl restart <service>",
                "level": "basic",
                "topic": "Servicios",
                "description": "Reinicia servicio tras deploy.",
                "example": "sudo systemctl restart <service>",
                "expected": "Sin salida si funciona.",
                "note": ""
            },
            {
                "command": "sudo systemctl reload <service>",
                "level": "intermediate",
                "topic": "Servicios",
                "description": "Recarga config cuando el servicio lo soporta.",
                "example": "sudo systemctl reload <service>",
                "expected": "Sin salida.",
                "note": ""
            },
            {
                "command": "pm2 reload <app> --update-env",
                "level": "basic",
                "topic": "Servicios",
                "description": "Recarga proceso Node gestionado por PM2.",
                "example": "pm2 reload <app> --update-env",
                "expected": "Proceso online con env actualizado.",
                "note": ""
            },
            {
                "command": "docker compose up -d --remove-orphans",
                "level": "intermediate",
                "topic": "Servicios",
                "description": "Actualiza stack Compose.",
                "example": "docker compose up -d --remove-orphans",
                "expected": "Servicios creados/recreados y orphans removidos.",
                "note": ""
            },
            {
                "command": "curl --fail https://<domain>/health",
                "level": "basic",
                "topic": "Health checks",
                "description": "Falla si HTTP >=400 o error de transporte.",
                "example": "curl --fail https://<domain>/health",
                "expected": "Body y exit code 0 si saludable.",
                "note": ""
            },
            {
                "command": "curl --fail --retry 10 --retry-delay 3 --retry-all-errors https://<domain>/health",
                "level": "intermediate",
                "topic": "Health checks",
                "description": "Espera health con reintentos.",
                "example": "curl --fail --retry 10 --retry-delay 3 --retry-all-errors https://<domain>/health",
                "expected": "Respuesta sana o exit code final de error.",
                "note": ""
            },
            {
                "command": "timeout 60 bash -c 'until curl -sf http://127.0.0.1:3000/health; do sleep 2; done'",
                "level": "intermediate",
                "topic": "Health checks",
                "description": "Espera health local hasta 60s.",
                "example": "timeout 60 bash -c 'until curl -sf http://127.0.0.1:3000/health; do sleep 2; done'",
                "expected": "Exit 0 si queda healthy; 124 por timeout.",
                "note": ""
            },
            {
                "command": "npm run migration:run",
                "level": "basic",
                "topic": "Migraciones",
                "description": "Ejecuta migraciones definidas por el proyecto.",
                "example": "npm run migration:run",
                "expected": "Listado de migraciones aplicadas.",
                "note": "El nombre exacto del script depende de tu package.json."
            },
            {
                "command": "npx prisma migrate deploy",
                "level": "intermediate",
                "topic": "Migraciones",
                "description": "Aplica migraciones Prisma pendientes.",
                "example": "npx prisma migrate deploy",
                "expected": "Migraciones aplicadas o error.",
                "note": ""
            },
            {
                "command": "npx typeorm migration:run -d <datasource>",
                "level": "advanced",
                "topic": "Migraciones",
                "description": "Aplica TypeORM migrations.",
                "example": "npx typeorm migration:run -d <datasource>",
                "expected": "Migraciones ejecutadas.",
                "note": "Valida datasource y backup antes de produccion."
            },
            {
                "command": "pg_dump -Fc -f predeploy.dump <db>",
                "level": "basic",
                "topic": "Backups pre-deploy",
                "description": "Crea backup PostgreSQL antes del cambio.",
                "example": "pg_dump -Fc -f predeploy.dump <db>",
                "expected": "Archivo dump.",
                "note": ""
            },
            {
                "command": "mysqldump --single-transaction <db> > predeploy.sql",
                "level": "intermediate",
                "topic": "Backups pre-deploy",
                "description": "Crea backup MySQL consistente para InnoDB.",
                "example": "mysqldump --single-transaction <db> > predeploy.sql",
                "expected": "Archivo SQL.",
                "note": ""
            },
            {
                "command": "journalctl -u <service> -n 100 --no-pager",
                "level": "basic",
                "topic": "Logs post-deploy",
                "description": "Revisa logs del servicio.",
                "example": "journalctl -u <service> -n 100 --no-pager",
                "expected": "Ultimas entradas.",
                "note": ""
            },
            {
                "command": "pm2 logs <app> --lines 100 --nostream",
                "level": "basic",
                "topic": "Logs post-deploy",
                "description": "Muestra logs PM2 sin quedarse siguiendo.",
                "example": "pm2 logs <app> --lines 100 --nostream",
                "expected": "Ultimas lineas.",
                "note": ""
            },
            {
                "command": "docker compose logs --tail 100",
                "level": "basic",
                "topic": "Logs post-deploy",
                "description": "Muestra logs recientes.",
                "example": "docker compose logs --tail 100",
                "expected": "Logs por servicio.",
                "note": ""
            },
            {
                "command": "ssh <user>@<host> 'cd <app> && ./deploy.sh'",
                "level": "intermediate",
                "topic": "CI por SSH",
                "description": "Dispara un script de deploy remoto.",
                "example": "ssh <user>@<host> 'cd <app> && ./deploy.sh'",
                "expected": "Salida y exit code remotos.",
                "note": "Audita deploy.sh y usa clave dedicada con permisos minimos."
            },
            {
                "command": "ssh -o BatchMode=yes -o StrictHostKeyChecking=yes <user>@<host> '<command>'",
                "level": "advanced",
                "topic": "CI por SSH",
                "description": "Ejecuta SSH no interactivo validando host key.",
                "example": "ssh -o BatchMode=yes -o StrictHostKeyChecking=yes <user>@<host> '<command>'",
                "expected": "Salida o error inmediato si falta auth/host key.",
                "note": "Ideal para CI con known_hosts gestionado."
            },
            {
                "command": "flock -n /tmp/deploy.lock ./deploy.sh",
                "level": "advanced",
                "topic": "Locks",
                "description": "Evita deployments concurrentes.",
                "example": "flock -n /tmp/deploy.lock ./deploy.sh",
                "expected": "Ejecuta script o falla si lock ocupado.",
                "note": "Linux; util para serializar deploys."
            },
            {
                "command": "git revert <bad-commit> --no-edit && git push origin main",
                "level": "advanced",
                "topic": "Rollbacks",
                "description": "Crea commit de rollback sin reescribir historia.",
                "example": "git revert <bad-commit> --no-edit && git push origin main",
                "expected": "Nuevo commit y push.",
                "note": "Preferible a force push en branches compartidas."
            },
            {
                "command": "docker image tag <image>:<previous> <image>:rollback && docker compose up -d",
                "level": "advanced",
                "topic": "Rollbacks",
                "description": "Prepara imagen anterior para rollback.",
                "example": "docker image tag <image>:<previous> <image>:rollback && docker compose up -d",
                "expected": "Stack actualizado segun compose.",
                "note": "Mantene tags inmutables para rollback confiable."
            },
            {
                "command": "kubectl rollout undo deployment/<name> -n <ns>",
                "level": "advanced",
                "topic": "Rollbacks",
                "description": "Revierte deployment Kubernetes.",
                "example": "kubectl rollout undo deployment/<name> -n <ns>",
                "expected": "Rollback aplicado.",
                "note": "Valida migraciones de DB y compatibilidad."
            },
            {
                "command": "kubectl scale deployment/<green> --replicas=3 -n <ns>",
                "level": "advanced",
                "topic": "Canary y blue-green",
                "description": "Escala entorno green antes de cambio de trafico.",
                "example": "kubectl scale deployment/<green> --replicas=3 -n <ns>",
                "expected": "Deployment escalado.",
                "note": ""
            },
            {
                "command": "kubectl patch service <svc> -p '{\"spec\":{\"selector\":{\"version\":\"green\"}}}' -n <ns>",
                "level": "advanced",
                "topic": "Canary y blue-green",
                "description": "Cambia selector del Service a green.",
                "example": "kubectl patch service <svc> -p '{\"spec\":{\"selector\":{\"version\":\"green\"}}}' -n <ns>",
                "expected": "service patched.",
                "note": "Cambio de trafico inmediato; valida health antes."
            },
            {
                "command": "ls -1dt <app>/releases/* | tail -n +6",
                "level": "intermediate",
                "topic": "Limpieza releases",
                "description": "Lista releases antiguas dejando fuera las cinco m\u00e1s recientes.",
                "example": "ls -1dt /var/www/app/releases/* | tail -n +6",
                "expected": "Rutas candidatas a limpieza.",
                "note": "Revis\u00e1 esta salida antes de borrar nada."
            },
            {
                "command": "ls -1dt <app>/releases/* | tail -n +6 | xargs -r rm -rf",
                "level": "advanced",
                "topic": "Limpieza releases",
                "description": "Elimina releases antiguas conservando las cinco m\u00e1s recientes.",
                "example": "ls -1dt /var/www/app/releases/* | tail -n +6 | xargs -r rm -rf",
                "expected": "Directorios antiguos eliminados; normalmente sin salida.",
                "note": "Destructivo. Ejecut\u00e1 primero la variante sin xargs rm -rf y verific\u00e1 las rutas."
            }
        ]
    },
    {
        "id": "hostinger-vps",
        "group": "deployment",
        "title": "Hostinger / VPS Deploy",
        "description": "Administraci\u00f3n y despliegue real sobre VPS Hostinger por SSH: Git, Node/PM2, Docker, Nginx, SSL, backups y automatizaci\u00f3n.",
        "aliases": [
            "hostinger",
            "vps",
            "hpanel",
            "cloudpanel",
            "deploy"
        ],
        "commands": [
            {
                "command": "ssh root@<vps_ip>",
                "level": "basic",
                "topic": "Acceso SSH",
                "description": "Conecta al VPS Hostinger por SSH como root.",
                "example": "ssh root@<vps_ip>",
                "expected": "Prompt remoto tras autenticar.",
                "note": ""
            },
            {
                "command": "ssh <site_user>@<vps_ip>",
                "level": "basic",
                "topic": "Acceso SSH",
                "description": "Conecta con usuario de sitio/CloudPanel.",
                "example": "ssh <site_user>@<vps_ip>",
                "expected": "Prompt remoto con permisos de ese usuario.",
                "note": ""
            },
            {
                "command": "ssh -i ~/.ssh/<key> <user>@<vps_ip>",
                "level": "intermediate",
                "topic": "Acceso SSH",
                "description": "Conecta usando clave privada.",
                "example": "ssh -i ~/.ssh/<key> <user>@<vps_ip>",
                "expected": "Sesion remota.",
                "note": "Preferible a password para automatizacion segura."
            },
            {
                "command": "ssh-copy-id <user>@<vps_ip>",
                "level": "intermediate",
                "topic": "Acceso SSH",
                "description": "Instala tu clave publica en el VPS.",
                "example": "ssh-copy-id <user>@<vps_ip>",
                "expected": "Key agregada y mensaje de prueba.",
                "note": ""
            },
            {
                "command": "sudo apt update && sudo apt upgrade -y",
                "level": "basic",
                "topic": "Preparacion servidor",
                "description": "Actualiza indices y paquetes Ubuntu.",
                "example": "sudo apt update && sudo apt upgrade -y",
                "expected": "Paquetes descargados/actualizados.",
                "note": "Revisa cambios de kernel/servicios en produccion."
            },
            {
                "command": "sudo apt install -y git curl nginx ufw",
                "level": "basic",
                "topic": "Preparacion servidor",
                "description": "Instala herramientas base de deploy.",
                "example": "sudo apt install -y git curl nginx ufw",
                "expected": "Paquetes instalados.",
                "note": ""
            },
            {
                "command": "curl -o- https://raw.githubusercontent.com/nvm-sh/nvm/v0.40.3/install.sh | bash",
                "level": "intermediate",
                "topic": "Preparacion servidor",
                "description": "Instala NVM usando el script oficial del proyecto.",
                "example": "curl -o- https://raw.githubusercontent.com/nvm-sh/nvm/v0.40.3/install.sh | bash",
                "expected": "NVM instalado y l\u00edneas de inicializaci\u00f3n agregadas al profile.",
                "note": "Verific\u00e1 la versi\u00f3n/URL oficial antes de ejecutar un script remoto."
            },
            {
                "command": "nvm install --lts",
                "level": "basic",
                "topic": "Preparacion servidor",
                "description": "Instala Node LTS con NVM.",
                "example": "nvm install --lts",
                "expected": "Version de Node/npm instalada.",
                "note": ""
            },
            {
                "command": "node -v && npm -v",
                "level": "basic",
                "topic": "Preparacion servidor",
                "description": "Verifica runtime.",
                "example": "node -v && npm -v",
                "expected": "Versiones de Node y npm.",
                "note": ""
            },
            {
                "command": "git clone <repo_url> <app_dir>",
                "level": "basic",
                "topic": "Git deploy",
                "description": "Clona la aplicacion en el VPS.",
                "example": "git clone <repo_url> <app_dir>",
                "expected": "Progreso del clone y directorio creado.",
                "note": ""
            },
            {
                "command": "git -C <app_dir> status",
                "level": "basic",
                "topic": "Git deploy",
                "description": "Comprueba estado del checkout.",
                "example": "git -C <app_dir> status",
                "expected": "Branch y working tree.",
                "note": ""
            },
            {
                "command": "git -C <app_dir> fetch --prune origin",
                "level": "intermediate",
                "topic": "Git deploy",
                "description": "Actualiza referencias remotas.",
                "example": "git -C <app_dir> fetch --prune origin",
                "expected": "Objetos/refs actualizados.",
                "note": ""
            },
            {
                "command": "git -C <app_dir> pull --ff-only origin main",
                "level": "intermediate",
                "topic": "Git deploy",
                "description": "Actualiza main solo si es fast-forward.",
                "example": "git -C <app_dir> pull --ff-only origin main",
                "expected": "Archivos actualizados o rechazo si divergio.",
                "note": "Evita merges inesperados en servidor."
            },
            {
                "command": "git -C <app_dir> reset --hard origin/main",
                "level": "advanced",
                "topic": "Git deploy",
                "description": "Iguala checkout exactamente al remoto.",
                "example": "git -C <app_dir> reset --hard origin/main",
                "expected": "HEAD actualizado y cambios locales descartados.",
                "note": "Destruye cambios locales no commiteados."
            },
            {
                "command": "cd <app_dir> && npm ci",
                "level": "basic",
                "topic": "Node y PM2",
                "description": "Instala exactamente el lockfile.",
                "example": "cd <app_dir> && npm ci",
                "expected": "Dependencias instaladas y audit summary.",
                "note": ""
            },
            {
                "command": "cd <app_dir> && npm run build",
                "level": "basic",
                "topic": "Node y PM2",
                "description": "Genera build de produccion.",
                "example": "cd <app_dir> && npm run build",
                "expected": "Directorio de build/dist segun app.",
                "note": ""
            },
            {
                "command": "pm2 start dist/main.js --name <app>",
                "level": "basic",
                "topic": "Node y PM2",
                "description": "Inicia backend Nest compilado.",
                "example": "pm2 start dist/main.js --name <app>",
                "expected": "Proceso online en PM2.",
                "note": ""
            },
            {
                "command": "pm2 reload <app> --update-env",
                "level": "intermediate",
                "topic": "Node y PM2",
                "description": "Recarga app con variables nuevas.",
                "example": "pm2 reload <app> --update-env",
                "expected": "Proceso recargado.",
                "note": ""
            },
            {
                "command": "pm2 save && pm2 startup",
                "level": "basic",
                "topic": "Node y PM2",
                "description": "Persiste procesos y prepara autostart.",
                "example": "pm2 save && pm2 startup",
                "expected": "Dump guardado y comando de startup.",
                "note": ""
            },
            {
                "command": "sudo nginx -t",
                "level": "basic",
                "topic": "Nginx reverse proxy",
                "description": "Valida Nginx antes de recargar.",
                "example": "sudo nginx -t",
                "expected": "syntax is ok / test is successful.",
                "note": ""
            },
            {
                "command": "sudo systemctl reload nginx",
                "level": "basic",
                "topic": "Nginx reverse proxy",
                "description": "Recarga Nginx sin restart completo.",
                "example": "sudo systemctl reload nginx",
                "expected": "Sin salida si funciona.",
                "note": ""
            },
            {
                "command": "curl -H 'Host: <domain>' http://127.0.0.1/",
                "level": "intermediate",
                "topic": "Nginx reverse proxy",
                "description": "Prueba virtual host desde el servidor.",
                "example": "curl -H 'Host: <domain>' http://127.0.0.1/",
                "expected": "Respuesta HTTP de tu site.",
                "note": ""
            },
            {
                "command": "curl http://127.0.0.1:<app_port>/health",
                "level": "intermediate",
                "topic": "Nginx reverse proxy",
                "description": "Prueba la app directamente sin proxy.",
                "example": "curl http://127.0.0.1:<app_port>/health",
                "expected": "Health response del backend.",
                "note": ""
            },
            {
                "command": "sudo certbot --nginx -d <domain>",
                "level": "basic",
                "topic": "SSL y dominio",
                "description": "Solicita SSL para Nginx.",
                "example": "sudo certbot --nginx -d <domain>",
                "expected": "Certificado emitido/config actualizada.",
                "note": ""
            },
            {
                "command": "sudo certbot renew --dry-run",
                "level": "basic",
                "topic": "SSL y dominio",
                "description": "Prueba renovacion automatica.",
                "example": "sudo certbot renew --dry-run",
                "expected": "Simulacion exitosa o diagnostico.",
                "note": ""
            },
            {
                "command": "dig +short <domain> A",
                "level": "intermediate",
                "topic": "SSL y dominio",
                "description": "Verifica DNS A del dominio.",
                "example": "dig +short <domain> A",
                "expected": "IP publicada en DNS.",
                "note": ""
            },
            {
                "command": "sudo ufw allow OpenSSH",
                "level": "basic",
                "topic": "Firewall y seguridad",
                "description": "Permite SSH antes de habilitar firewall.",
                "example": "sudo ufw allow OpenSSH",
                "expected": "Rule added.",
                "note": ""
            },
            {
                "command": "sudo ufw allow 'Nginx Full'",
                "level": "basic",
                "topic": "Firewall y seguridad",
                "description": "Permite HTTP/HTTPS.",
                "example": "sudo ufw allow 'Nginx Full'",
                "expected": "Rule added.",
                "note": ""
            },
            {
                "command": "sudo ufw enable",
                "level": "intermediate",
                "topic": "Firewall y seguridad",
                "description": "Activa UFW.",
                "example": "sudo ufw enable",
                "expected": "Firewall is active.",
                "note": "Confirma acceso SSH antes para no bloquearte."
            },
            {
                "command": "sudo ufw status verbose",
                "level": "basic",
                "topic": "Firewall y seguridad",
                "description": "Muestra reglas y policy.",
                "example": "sudo ufw status verbose",
                "expected": "Status y reglas.",
                "note": ""
            },
            {
                "command": "sudo fail2ban-client status",
                "level": "intermediate",
                "topic": "Firewall y seguridad",
                "description": "Muestra estado Fail2ban si esta instalado.",
                "example": "sudo fail2ban-client status",
                "expected": "Jails activos.",
                "note": ""
            },
            {
                "command": "docker --version && docker compose version",
                "level": "basic",
                "topic": "Docker deploy",
                "description": "Verifica Docker/Compose en el VPS.",
                "example": "docker --version && docker compose version",
                "expected": "Versiones instaladas.",
                "note": ""
            },
            {
                "command": "docker compose up -d --build",
                "level": "basic",
                "topic": "Docker deploy",
                "description": "Construye y levanta stack.",
                "example": "docker compose up -d --build",
                "expected": "Containers creados/iniciados.",
                "note": ""
            },
            {
                "command": "docker compose pull && docker compose up -d",
                "level": "intermediate",
                "topic": "Docker deploy",
                "description": "Actualiza imagenes y recrea servicios segun necesidad.",
                "example": "docker compose pull && docker compose up -d",
                "expected": "Pull + containers updated.",
                "note": ""
            },
            {
                "command": "docker compose logs -f --tail 100",
                "level": "basic",
                "topic": "Docker deploy",
                "description": "Sigue logs del stack.",
                "example": "docker compose logs -f --tail 100",
                "expected": "Stream de logs.",
                "note": ""
            },
            {
                "command": "docker system df",
                "level": "intermediate",
                "topic": "Docker deploy",
                "description": "Mide uso de disco Docker.",
                "example": "docker system df",
                "expected": "Images/containers/volumes/cache.",
                "note": ""
            },
            {
                "command": "tar czf ~/backup-$(date +%F).tgz <app_dir>",
                "level": "basic",
                "topic": "Backups",
                "description": "Empaqueta directorio de app.",
                "example": "tar czf ~/backup-$(date +%F).tgz <app_dir>",
                "expected": "Archivo tgz.",
                "note": "No reemplaza backup de DB consistente."
            },
            {
                "command": "pg_dump -Fc -f ~/db-$(date +%F).dump <db>",
                "level": "intermediate",
                "topic": "Backups",
                "description": "Crea dump PostgreSQL.",
                "example": "pg_dump -Fc -f ~/db-$(date +%F).dump <db>",
                "expected": "Archivo .dump.",
                "note": "Protege el backup y verifica restore periodicamente."
            },
            {
                "command": "rsync -avh ~/backup-*.tgz <backup_user>@<backup_host>:<path>/",
                "level": "intermediate",
                "topic": "Backups",
                "description": "Copia backups fuera del VPS.",
                "example": "rsync -avh ~/backup-*.tgz <backup_user>@<backup_host>:<path>/",
                "expected": "Progreso y estadisticas.",
                "note": "Backups externos reducen riesgo ante fallo total del VPS."
            },
            {
                "command": "pm2 logs <app> --lines 100",
                "level": "basic",
                "topic": "Observabilidad",
                "description": "Revisa logs PM2.",
                "example": "pm2 logs <app> --lines 100",
                "expected": "Ultimas lineas y stream.",
                "note": ""
            },
            {
                "command": "sudo tail -f /var/log/nginx/error.log",
                "level": "basic",
                "topic": "Observabilidad",
                "description": "Sigue errores Nginx.",
                "example": "sudo tail -f /var/log/nginx/error.log",
                "expected": "Stream de errores.",
                "note": ""
            },
            {
                "command": "df -h && free -h && uptime",
                "level": "intermediate",
                "topic": "Observabilidad",
                "description": "Chequeo rapido de disco, memoria y carga.",
                "example": "df -h && free -h && uptime",
                "expected": "Tres bloques de metricas.",
                "note": ""
            },
            {
                "command": "ss -lntp",
                "level": "intermediate",
                "topic": "Observabilidad",
                "description": "Verifica puertos en escucha.",
                "example": "ss -lntp",
                "expected": "Listeners y procesos.",
                "note": ""
            },
            {
                "command": "ssh <user>@<vps_ip> 'cd <app_dir> && git pull --ff-only && npm ci && npm run build && pm2 reload <app>'",
                "level": "intermediate",
                "topic": "Deploy automatizado",
                "description": "Ejecuta pipeline simple por SSH.",
                "example": "ssh <user>@<vps_ip> 'cd <app_dir> && git pull --ff-only && npm ci && npm run build && pm2 reload <app>'",
                "expected": "Salida de cada etapa remota.",
                "note": "Para CI real agrega locks, health check y rollback."
            },
            {
                "command": "rsync -az --delete --exclude .env ./dist/ <user>@<vps_ip>:<release_dir>/",
                "level": "advanced",
                "topic": "Deploy automatizado",
                "description": "Sincroniza artifacts build sin secretos.",
                "example": "rsync -az --delete --exclude .env ./dist/ <user>@<vps_ip>:<release_dir>/",
                "expected": "Lista/estadisticas rsync.",
                "note": "Usa --dry-run primero; --delete elimina archivos destino no presentes."
            },
            {
                "command": "ln -sfn <release_dir> <current_symlink>",
                "level": "advanced",
                "topic": "Deploy automatizado",
                "description": "Cambia symlink current a una release nueva.",
                "example": "ln -sfn <release_dir> <current_symlink>",
                "expected": "Symlink actualizado.",
                "note": "Usalo dentro de estrategia atomic release con health check."
            },
            {
                "command": "curl --fail --retry 5 --retry-delay 2 https://<domain>/health",
                "level": "advanced",
                "topic": "Deploy automatizado",
                "description": "Valida health del deploy.",
                "example": "curl --fail --retry 5 --retry-delay 2 https://<domain>/health",
                "expected": "Body del health o exit code distinto de 0.",
                "note": "Usa el exit code para activar rollback automatico."
            },
            {
                "command": "systemctl status nginx --no-pager",
                "level": "basic",
                "topic": "Troubleshooting",
                "description": "Revisa estado Nginx.",
                "example": "systemctl status nginx --no-pager",
                "expected": "Active state y logs recientes.",
                "note": ""
            },
            {
                "command": "pm2 status",
                "level": "basic",
                "topic": "Troubleshooting",
                "description": "Revisa procesos Node.",
                "example": "pm2 status",
                "expected": "Tabla PM2.",
                "note": ""
            },
            {
                "command": "journalctl -u nginx -n 100 --no-pager",
                "level": "intermediate",
                "topic": "Troubleshooting",
                "description": "Muestra logs systemd de Nginx.",
                "example": "journalctl -u nginx -n 100 --no-pager",
                "expected": "Ultimas entradas.",
                "note": ""
            },
            {
                "command": "curl -vk https://<domain>",
                "level": "intermediate",
                "topic": "Troubleshooting",
                "description": "Depura TLS/HTTP extremo a extremo.",
                "example": "curl -vk https://<domain>",
                "expected": "Handshake, headers y body.",
                "note": "-k ignora validacion solo para diagnostico; no lo uses como solucion permanente."
            }
        ]
    },
    {
        "id": "pm2",
        "group": "deployment",
        "title": "PM2",
        "description": "Process manager de Node.js: procesos, logs, cluster, startup, ecosystem files y deploy remoto.",
        "aliases": [
            "pm2",
            "node process manager",
            "ecosystem"
        ],
        "commands": [
            {
                "command": "npm install -g pm2",
                "level": "basic",
                "topic": "Instalacion y setup",
                "description": "Instala PM2 globalmente.",
                "example": "npm install -g pm2",
                "expected": "Paquete global instalado y binario pm2 disponible.",
                "note": ""
            },
            {
                "command": "pm2 --version",
                "level": "basic",
                "topic": "Instalacion y setup",
                "description": "Muestra la version de PM2.",
                "example": "pm2 --version",
                "expected": "Numero de version.",
                "note": ""
            },
            {
                "command": "pm2 start <file.js> --name <name>",
                "level": "basic",
                "topic": "Procesos",
                "description": "Inicia una aplicacion Node gestionada por PM2.",
                "example": "pm2 start <file.js> --name <name>",
                "expected": "Tabla con proceso online, id y pid.",
                "note": ""
            },
            {
                "command": "pm2 list",
                "level": "basic",
                "topic": "Procesos",
                "description": "Lista procesos gestionados.",
                "example": "pm2 list",
                "expected": "Tabla id, name, mode, pid, uptime, status, cpu y mem.",
                "note": ""
            },
            {
                "command": "pm2 status",
                "level": "basic",
                "topic": "Procesos",
                "description": "Alias de listado/estado.",
                "example": "pm2 status",
                "expected": "Tabla de procesos.",
                "note": ""
            },
            {
                "command": "pm2 show <name>",
                "level": "basic",
                "topic": "Procesos",
                "description": "Muestra detalle de una app.",
                "example": "pm2 show <name>",
                "expected": "Status, script, logs, env, restart count y metrics.",
                "note": ""
            },
            {
                "command": "pm2 restart <name>",
                "level": "basic",
                "topic": "Procesos",
                "description": "Reinicia una app.",
                "example": "pm2 restart <name>",
                "expected": "Tabla actualizada con nuevo restart count.",
                "note": ""
            },
            {
                "command": "pm2 reload <name>",
                "level": "basic",
                "topic": "Procesos",
                "description": "Recarga una app intentando zero-downtime en cluster.",
                "example": "pm2 reload <name>",
                "expected": "Proceso recargado.",
                "note": "El comportamiento depende del modo y de que la app soporte shutdown limpio."
            },
            {
                "command": "pm2 stop <name>",
                "level": "basic",
                "topic": "Procesos",
                "description": "Detiene una app sin borrarla.",
                "example": "pm2 stop <name>",
                "expected": "Status stopped.",
                "note": ""
            },
            {
                "command": "pm2 delete <name>",
                "level": "basic",
                "topic": "Procesos",
                "description": "Elimina la app de la lista PM2.",
                "example": "pm2 delete <name>",
                "expected": "Proceso removido.",
                "note": "No borra codigo ni archivos de la app."
            },
            {
                "command": "pm2 restart all",
                "level": "intermediate",
                "topic": "Procesos",
                "description": "Reinicia todos los procesos.",
                "example": "pm2 restart all",
                "expected": "Tabla con procesos reiniciados.",
                "note": "Impacta todas las apps administradas."
            },
            {
                "command": "pm2 delete all",
                "level": "intermediate",
                "topic": "Procesos",
                "description": "Elimina todos los procesos del daemon.",
                "example": "pm2 delete all",
                "expected": "Lista vacia.",
                "note": "Afecta todas las apps PM2."
            },
            {
                "command": "pm2 logs",
                "level": "basic",
                "topic": "Logs y monitoreo",
                "description": "Sigue logs de todos los procesos.",
                "example": "pm2 logs",
                "expected": "Stream stdout/stderr.",
                "note": ""
            },
            {
                "command": "pm2 logs <name> --lines 200",
                "level": "basic",
                "topic": "Logs y monitoreo",
                "description": "Muestra y sigue ultimas 200 lineas.",
                "example": "pm2 logs <name> --lines 200",
                "expected": "Logs recientes y stream.",
                "note": ""
            },
            {
                "command": "pm2 monit",
                "level": "basic",
                "topic": "Logs y monitoreo",
                "description": "Abre dashboard interactivo.",
                "example": "pm2 monit",
                "expected": "CPU, memoria, logs y metadata.",
                "note": ""
            },
            {
                "command": "pm2 flush",
                "level": "intermediate",
                "topic": "Logs y monitoreo",
                "description": "Vacia archivos de log administrados por PM2.",
                "example": "pm2 flush",
                "expected": "Logs flushed.",
                "note": "Perdes historial local de esos logs."
            },
            {
                "command": "pm2 describe <name>",
                "level": "intermediate",
                "topic": "Logs y monitoreo",
                "description": "Muestra descripcion detallada.",
                "example": "pm2 describe <name>",
                "expected": "Metadata completa del proceso.",
                "note": ""
            },
            {
                "command": "pm2 save",
                "level": "basic",
                "topic": "Startup y persistencia",
                "description": "Guarda la lista actual para resurrect/startup.",
                "example": "pm2 save",
                "expected": "Successfully saved in dump file.",
                "note": ""
            },
            {
                "command": "pm2 startup",
                "level": "basic",
                "topic": "Startup y persistencia",
                "description": "Genera comando para registrar servicio de arranque.",
                "example": "pm2 startup",
                "expected": "Comando sudo/systemd que debes ejecutar.",
                "note": ""
            },
            {
                "command": "pm2 resurrect",
                "level": "intermediate",
                "topic": "Startup y persistencia",
                "description": "Restaura procesos guardados por pm2 save.",
                "example": "pm2 resurrect",
                "expected": "Procesos restaurados.",
                "note": ""
            },
            {
                "command": "pm2 unstartup",
                "level": "advanced",
                "topic": "Startup y persistencia",
                "description": "Deshabilita integracion de startup.",
                "example": "pm2 unstartup",
                "expected": "Servicio de startup removido.",
                "note": "Puede requerir especificar init system."
            },
            {
                "command": "pm2 ecosystem",
                "level": "basic",
                "topic": "Ecosystem file",
                "description": "Genera un ecosystem.config.js de ejemplo.",
                "example": "pm2 ecosystem",
                "expected": "Archivo de configuracion.",
                "note": ""
            },
            {
                "command": "pm2 start ecosystem.config.js",
                "level": "basic",
                "topic": "Ecosystem file",
                "description": "Inicia apps definidas en ecosystem file.",
                "example": "pm2 start ecosystem.config.js",
                "expected": "Tabla con procesos.",
                "note": ""
            },
            {
                "command": "pm2 start ecosystem.config.js --env production",
                "level": "intermediate",
                "topic": "Ecosystem file",
                "description": "Inicia usando env_production.",
                "example": "pm2 start ecosystem.config.js --env production",
                "expected": "Procesos online con variables de production.",
                "note": ""
            },
            {
                "command": "pm2 reload ecosystem.config.js --env production",
                "level": "intermediate",
                "topic": "Ecosystem file",
                "description": "Recarga config y procesos.",
                "example": "pm2 reload ecosystem.config.js --env production",
                "expected": "Apps recargadas.",
                "note": ""
            },
            {
                "command": "pm2 start <file.js> -i max --name <name>",
                "level": "intermediate",
                "topic": "Cluster y escalado",
                "description": "Inicia cluster usando CPUs disponibles.",
                "example": "pm2 start <file.js> -i max --name <name>",
                "expected": "Multiples instances online.",
                "note": ""
            },
            {
                "command": "pm2 scale <name> 4",
                "level": "intermediate",
                "topic": "Cluster y escalado",
                "description": "Escala app cluster a 4 instancias.",
                "example": "pm2 scale <name> 4",
                "expected": "4 instancias o ajuste equivalente.",
                "note": ""
            },
            {
                "command": "pm2 reload <name> --update-env",
                "level": "advanced",
                "topic": "Cluster y escalado",
                "description": "Recarga y actualiza variables de entorno.",
                "example": "pm2 reload <name> --update-env",
                "expected": "Procesos recargados con env actual.",
                "note": ""
            },
            {
                "command": "pm2 deploy ecosystem.config.js production setup",
                "level": "advanced",
                "topic": "Deploy PM2",
                "description": "Prepara directorios/repo remoto segun deploy config.",
                "example": "pm2 deploy ecosystem.config.js production setup",
                "expected": "Setup remoto y clone inicial.",
                "note": "Requiere bloque deploy correctamente configurado y SSH."
            },
            {
                "command": "pm2 deploy ecosystem.config.js production",
                "level": "advanced",
                "topic": "Deploy PM2",
                "description": "Ejecuta deployment remoto PM2.",
                "example": "pm2 deploy ecosystem.config.js production",
                "expected": "Fetch/checkout, post-deploy y restart/reload.",
                "note": "Revisa comandos post-deploy antes de produccion."
            },
            {
                "command": "pm2 deploy ecosystem.config.js production revert 1",
                "level": "advanced",
                "topic": "Deploy PM2",
                "description": "Revierte un deployment.",
                "example": "pm2 deploy ecosystem.config.js production revert 1",
                "expected": "Release anterior restaurada.",
                "note": "Asegura compatibilidad con migraciones de DB."
            },
            {
                "command": "pm2 update",
                "level": "intermediate",
                "topic": "Mantenimiento",
                "description": "Actualiza daemon PM2 en memoria a la version instalada.",
                "example": "pm2 update",
                "expected": "Daemon actualizado y procesos preservados.",
                "note": ""
            },
            {
                "command": "pm2 ping",
                "level": "intermediate",
                "topic": "Mantenimiento",
                "description": "Comprueba que daemon responde.",
                "example": "pm2 ping",
                "expected": "pong.",
                "note": ""
            },
            {
                "command": "pm2 reset <name>",
                "level": "advanced",
                "topic": "Mantenimiento",
                "description": "Resetea restart count y metadata de contadores.",
                "example": "pm2 reset <name>",
                "expected": "Contadores reiniciados.",
                "note": ""
            }
        ]
    },
    {
        "id": "certbot",
        "group": "deployment",
        "title": "Certbot / Let's Encrypt",
        "description": "Certificados TLS: emisi\u00f3n, renovaci\u00f3n, hooks, Nginx/Apache y diagn\u00f3stico.",
        "aliases": [
            "certbot",
            "letsencrypt",
            "ssl",
            "tls"
        ],
        "commands": [
            {
                "command": "certbot --version",
                "level": "basic",
                "topic": "Instalacion y version",
                "description": "Muestra version de Certbot.",
                "example": "certbot --version",
                "expected": "certbot X.Y.Z.",
                "note": ""
            },
            {
                "command": "certbot --help",
                "level": "basic",
                "topic": "Instalacion y version",
                "description": "Muestra ayuda general.",
                "example": "certbot --help",
                "expected": "Comandos/plugins/opciones disponibles.",
                "note": ""
            },
            {
                "command": "sudo certbot --nginx -d <domain>",
                "level": "basic",
                "topic": "Obtener certificado",
                "description": "Solicita certificado usando plugin Nginx.",
                "example": "sudo certbot --nginx -d <domain>",
                "expected": "Certificado emitido y Nginx configurado si challenge funciona.",
                "note": "DNS y puertos deben apuntar al servidor."
            },
            {
                "command": "sudo certbot --apache -d <domain>",
                "level": "basic",
                "topic": "Obtener certificado",
                "description": "Solicita certificado usando Apache.",
                "example": "sudo certbot --apache -d <domain>",
                "expected": "Certificado emitido y config actualizada.",
                "note": ""
            },
            {
                "command": "sudo certbot certonly --webroot -w <webroot> -d <domain>",
                "level": "intermediate",
                "topic": "Obtener certificado",
                "description": "Obtiene certificado sin editar webserver usando webroot.",
                "example": "sudo certbot certonly --webroot -w <webroot> -d <domain>",
                "expected": "Rutas de cert/key bajo /etc/letsencrypt/live.",
                "note": ""
            },
            {
                "command": "sudo certbot certonly --standalone -d <domain>",
                "level": "intermediate",
                "topic": "Obtener certificado",
                "description": "Levanta servidor temporal para challenge HTTP.",
                "example": "sudo certbot certonly --standalone -d <domain>",
                "expected": "Certificado emitido.",
                "note": "Puerto 80 debe estar libre/accesible."
            },
            {
                "command": "sudo certbot certonly --manual --preferred-challenges dns -d '*.example.com' -d example.com",
                "level": "advanced",
                "topic": "Obtener certificado",
                "description": "Obtiene wildcard mediante challenge DNS manual.",
                "example": "sudo certbot certonly --manual --preferred-challenges dns -d '*.example.com' -d example.com",
                "expected": "Instrucciones TXT y certificado tras validacion.",
                "note": "Los certificados manuales no renuevan automaticamente sin hooks de autenticacion."
            },
            {
                "command": "sudo certbot renew",
                "level": "basic",
                "topic": "Renovacion",
                "description": "Renueva certificados cercanos a vencimiento.",
                "example": "sudo certbot renew",
                "expected": "No renewals attempted o certificados renovados.",
                "note": ""
            },
            {
                "command": "sudo certbot renew --dry-run",
                "level": "basic",
                "topic": "Renovacion",
                "description": "Simula el proceso de renovacion.",
                "example": "sudo certbot renew --dry-run",
                "expected": "Resultado de staging renewal.",
                "note": ""
            },
            {
                "command": "sudo certbot renew --deploy-hook 'systemctl reload nginx'",
                "level": "intermediate",
                "topic": "Renovacion",
                "description": "Recarga Nginx solo tras renovacion exitosa.",
                "example": "sudo certbot renew --deploy-hook 'systemctl reload nginx'",
                "expected": "Renewal + hook cuando corresponde.",
                "note": ""
            },
            {
                "command": "sudo certbot renew --quiet",
                "level": "intermediate",
                "topic": "Renovacion",
                "description": "Renueva con salida minima.",
                "example": "sudo certbot renew --quiet",
                "expected": "Solo errores o eventos relevantes.",
                "note": ""
            },
            {
                "command": "sudo certbot renew --force-renewal",
                "level": "advanced",
                "topic": "Renovacion",
                "description": "Fuerza renovacion aunque no este proximo a vencer.",
                "example": "sudo certbot renew --force-renewal",
                "expected": "Certificados renovados si CA acepta.",
                "note": "No usar periodicamente: podes alcanzar rate limits."
            },
            {
                "command": "sudo certbot certificates",
                "level": "basic",
                "topic": "Gestion",
                "description": "Lista certificados administrados.",
                "example": "sudo certbot certificates",
                "expected": "Certificate Name, domains, expiry y paths.",
                "note": ""
            },
            {
                "command": "sudo certbot delete --cert-name <name>",
                "level": "intermediate",
                "topic": "Gestion",
                "description": "Elimina un certificado gestionado.",
                "example": "sudo certbot delete --cert-name <name>",
                "expected": "Confirmacion de deletion.",
                "note": "Actualiza webserver antes si aun referencia esos archivos."
            },
            {
                "command": "sudo certbot reconfigure --cert-name <name>",
                "level": "intermediate",
                "topic": "Gestion",
                "description": "Reconfigura opciones guardadas de un certificado.",
                "example": "sudo certbot reconfigure --cert-name <name>",
                "expected": "Flujo de reconfiguracion.",
                "note": "Disponibilidad depende de la version/plugin."
            },
            {
                "command": "sudo certbot revoke --cert-path /etc/letsencrypt/live/<name>/cert.pem",
                "level": "advanced",
                "topic": "Gestion",
                "description": "Revoca certificado.",
                "example": "sudo certbot revoke --cert-path /etc/letsencrypt/live/<name>/cert.pem",
                "expected": "Confirmacion de revocacion.",
                "note": "La revocacion es irreversible."
            },
            {
                "command": "certbot plugins",
                "level": "basic",
                "topic": "Plugins y diagnostico",
                "description": "Lista plugins instalados.",
                "example": "certbot plugins",
                "expected": "Plugin names y capacidades.",
                "note": ""
            },
            {
                "command": "sudo certbot renew --dry-run -v",
                "level": "intermediate",
                "topic": "Plugins y diagnostico",
                "description": "Simula renovacion con detalle.",
                "example": "sudo certbot renew --dry-run -v",
                "expected": "Logs verbose del challenge/renewal.",
                "note": ""
            },
            {
                "command": "sudo journalctl -u certbot.timer --no-pager",
                "level": "intermediate",
                "topic": "Plugins y diagnostico",
                "description": "Muestra logs del timer systemd si existe.",
                "example": "sudo journalctl -u certbot.timer --no-pager",
                "expected": "Eventos de ejecucion del timer.",
                "note": ""
            },
            {
                "command": "systemctl list-timers | grep certbot",
                "level": "intermediate",
                "topic": "Plugins y diagnostico",
                "description": "Busca el timer autom\u00e1tico de Certbot en systemd.",
                "example": "systemctl list-timers | grep certbot",
                "expected": "Pr\u00f3xima/\u00faltima ejecuci\u00f3n del timer si existe.",
                "note": ""
            },
            {
                "command": "sudo certbot renew --pre-hook '<pre>' --post-hook '<post>'",
                "level": "advanced",
                "topic": "Hooks",
                "description": "Ejecuta hooks alrededor de renovaciones debidas.",
                "example": "sudo certbot renew --pre-hook '<pre>' --post-hook '<post>'",
                "expected": "Hooks solo cuando corresponde y resultado del renewal.",
                "note": "Los hooks corren con privilegios: mantenelos simples y auditados."
            },
            {
                "command": "sudo certbot renew --deploy-hook /usr/local/bin/after-renew.sh",
                "level": "advanced",
                "topic": "Hooks",
                "description": "Ejecuta script solo tras renewal exitoso.",
                "example": "sudo certbot renew --deploy-hook /usr/local/bin/after-renew.sh",
                "expected": "Script ejecutado en renovaciones exitosas.",
                "note": "Asegura permisos/ownership del script."
            },
            {
                "command": "sudo certbot certonly --nginx -d <domain>",
                "level": "intermediate",
                "topic": "Emisi\u00f3n",
                "description": "Obtiene certificado usando el plugin Nginx sin instalar configuraci\u00f3n permanente.",
                "example": "sudo certbot certonly --nginx -d <domain>",
                "expected": "Ruta de certificados en /etc/letsencrypt/live/<name>/.",
                "note": ""
            },
            {
                "command": "sudo certbot certonly --apache -d <domain>",
                "level": "intermediate",
                "topic": "Emisi\u00f3n",
                "description": "Obtiene certificado usando Apache s\u00f3lo para el challenge.",
                "example": "sudo certbot certonly --apache -d <domain>",
                "expected": "Certificado y key almacenados bajo /etc/letsencrypt/live.",
                "note": ""
            },
            {
                "command": "sudo certbot certonly --webroot -w <webroot> -d <domain> --email <email> --agree-tos --no-eff-email",
                "level": "advanced",
                "topic": "Emisi\u00f3n",
                "description": "Emite de forma no interactiva usando webroot.",
                "example": "sudo certbot certonly --webroot -w <webroot> -d <domain> --email <email> --agree-tos --no-eff-email",
                "expected": "Certificado emitido o explicaci\u00f3n del challenge fallido.",
                "note": ""
            },
            {
                "command": "sudo systemctl status certbot.timer",
                "level": "intermediate",
                "topic": "Renovaci\u00f3n",
                "description": "Comprueba el timer de renovaci\u00f3n autom\u00e1tica.",
                "example": "sudo systemctl status certbot.timer",
                "expected": "Estado y pr\u00f3xima ejecuci\u00f3n del timer.",
                "note": ""
            },
            {
                "command": "sudo systemctl enable --now certbot.timer",
                "level": "intermediate",
                "topic": "Renovaci\u00f3n",
                "description": "Habilita y activa el timer de renovaci\u00f3n.",
                "example": "sudo systemctl enable --now certbot.timer",
                "expected": "Timer activo y programado.",
                "note": ""
            },
            {
                "command": "sudo certbot renew --cert-name <name>",
                "level": "advanced",
                "topic": "Renovaci\u00f3n",
                "description": "Renueva s\u00f3lo un certificado por su nombre.",
                "example": "sudo certbot renew --cert-name <name>",
                "expected": "Resultado de renovaci\u00f3n para ese certificado.",
                "note": ""
            },
            {
                "command": "sudo certbot certificates --cert-name <name>",
                "level": "advanced",
                "topic": "Diagn\u00f3stico",
                "description": "Muestra detalles de un certificado espec\u00edfico.",
                "example": "sudo certbot certificates --cert-name <name>",
                "expected": "Dominios, serial, expiraci\u00f3n y rutas.",
                "note": ""
            },
            {
                "command": "sudo grep -R \"renew_hook\\|deploy_hook\" /etc/letsencrypt/renewal /etc/letsencrypt/renewal-hooks 2>/dev/null",
                "level": "advanced",
                "topic": "Diagn\u00f3stico",
                "description": "Busca hooks configurados para renovaciones.",
                "example": "sudo grep -R \"renew_hook\\|deploy_hook\" /etc/letsencrypt/renewal /etc/letsencrypt/renewal-hooks 2>/dev/null",
                "expected": "Archivos/l\u00edneas donde se definieron hooks.",
                "note": ""
            }
        ]
    },
    {
        "id": "vercel",
        "group": "deployment",
        "title": "Vercel CLI",
        "description": "Deploys preview/production, proyectos, variables, logs, dominios, aliases y builds prebuilt.",
        "aliases": [
            "vercel",
            "deployment",
            "frontend hosting"
        ],
        "commands": [
            {
                "command": "vercel login",
                "level": "basic",
                "topic": "Auth y proyecto",
                "description": "Inicia autenticacion Vercel.",
                "example": "vercel login",
                "expected": "Flujo de login y cuenta autenticada.",
                "note": ""
            },
            {
                "command": "vercel whoami",
                "level": "basic",
                "topic": "Auth y proyecto",
                "description": "Muestra usuario actual.",
                "example": "vercel whoami",
                "expected": "Username/account.",
                "note": ""
            },
            {
                "command": "vercel link",
                "level": "basic",
                "topic": "Auth y proyecto",
                "description": "Vincula directorio local con un proyecto.",
                "example": "vercel link",
                "expected": ".vercel/project.json creado.",
                "note": ""
            },
            {
                "command": "vercel project ls",
                "level": "intermediate",
                "topic": "Auth y proyecto",
                "description": "Lista proyectos del scope.",
                "example": "vercel project ls",
                "expected": "Proyectos y metadata.",
                "note": ""
            },
            {
                "command": "vercel project add <name>",
                "level": "intermediate",
                "topic": "Auth y proyecto",
                "description": "Crea proyecto.",
                "example": "vercel project add <name>",
                "expected": "Project created.",
                "note": ""
            },
            {
                "command": "vercel",
                "level": "basic",
                "topic": "Deploy",
                "description": "Crea deployment preview desde directorio actual.",
                "example": "vercel",
                "expected": "URL de preview y links de inspeccion.",
                "note": ""
            },
            {
                "command": "vercel --prod",
                "level": "basic",
                "topic": "Deploy",
                "description": "Despliega a produccion.",
                "example": "vercel --prod",
                "expected": "Production URL y status.",
                "note": ""
            },
            {
                "command": "vercel deploy --prod",
                "level": "basic",
                "topic": "Deploy",
                "description": "Forma explicita de deployment productivo.",
                "example": "vercel deploy --prod",
                "expected": "Deployment ready/production URL.",
                "note": ""
            },
            {
                "command": "vercel build",
                "level": "intermediate",
                "topic": "Deploy",
                "description": "Construye localmente usando config Vercel.",
                "example": "vercel build",
                "expected": ".vercel/output generado.",
                "note": ""
            },
            {
                "command": "vercel deploy --prebuilt --prod",
                "level": "intermediate",
                "topic": "Deploy",
                "description": "Sube un build preconstruido.",
                "example": "vercel deploy --prebuilt --prod",
                "expected": "Deployment productivo desde .vercel/output.",
                "note": ""
            },
            {
                "command": "vercel redeploy <deployment-url>",
                "level": "intermediate",
                "topic": "Deploy",
                "description": "Crea nuevo deployment desde uno existente.",
                "example": "vercel redeploy <deployment-url>",
                "expected": "Nueva URL/deployment.",
                "note": ""
            },
            {
                "command": "vercel rollback <deployment-url>",
                "level": "advanced",
                "topic": "Deploy",
                "description": "Promueve/rollback a deployment previo segun CLI actual.",
                "example": "vercel rollback <deployment-url>",
                "expected": "Produccion apunta al deployment seleccionado.",
                "note": "Revisa dominios y cambios de datos antes."
            },
            {
                "command": "vercel deploy --prod --force",
                "level": "advanced",
                "topic": "Deploy",
                "description": "Fuerza rebuild/deploy sin reutilizar ciertas caches.",
                "example": "vercel deploy --prod --force",
                "expected": "Nuevo deployment.",
                "note": "Usalo para troubleshooting, no como rutina."
            },
            {
                "command": "vercel env ls",
                "level": "basic",
                "topic": "Entornos y variables",
                "description": "Lista environment variables.",
                "example": "vercel env ls",
                "expected": "Nombre, environments y fecha; valores ocultos.",
                "note": ""
            },
            {
                "command": "vercel env add <name> production",
                "level": "intermediate",
                "topic": "Entornos y variables",
                "description": "Agrega variable para production.",
                "example": "vercel env add <name> production",
                "expected": "Prompt del valor y confirmacion.",
                "note": "Usa stdin/secret handling adecuado."
            },
            {
                "command": "vercel env rm <name> production",
                "level": "intermediate",
                "topic": "Entornos y variables",
                "description": "Elimina variable.",
                "example": "vercel env rm <name> production",
                "expected": "Confirmacion.",
                "note": "Puede romper deployments."
            },
            {
                "command": "vercel env pull .env.local",
                "level": "basic",
                "topic": "Entornos y variables",
                "description": "Descarga variables Development a archivo.",
                "example": "vercel env pull .env.local",
                "expected": ".env.local escrito.",
                "note": "El archivo puede contener secretos; no lo commitees."
            },
            {
                "command": "vercel pull --environment=production",
                "level": "intermediate",
                "topic": "Entornos y variables",
                "description": "Descarga settings del proyecto.",
                "example": "vercel pull --environment=production",
                "expected": "Archivos .vercel actualizados.",
                "note": ""
            },
            {
                "command": "vercel ls",
                "level": "basic",
                "topic": "Logs e inspeccion",
                "description": "Lista deployments.",
                "example": "vercel ls",
                "expected": "Age, URL, Status y Environment.",
                "note": ""
            },
            {
                "command": "vercel inspect <deployment-url>",
                "level": "basic",
                "topic": "Logs e inspeccion",
                "description": "Muestra detalles de deployment.",
                "example": "vercel inspect <deployment-url>",
                "expected": "Build, routes, env metadata y status.",
                "note": ""
            },
            {
                "command": "vercel logs <deployment-url>",
                "level": "intermediate",
                "topic": "Logs e inspeccion",
                "description": "Muestra logs disponibles del deployment.",
                "example": "vercel logs <deployment-url>",
                "expected": "Eventos/logs.",
                "note": ""
            },
            {
                "command": "vercel logs <deployment-url> --follow",
                "level": "intermediate",
                "topic": "Logs e inspeccion",
                "description": "Sigue logs en vivo si CLI lo soporta.",
                "example": "vercel logs <deployment-url> --follow",
                "expected": "Stream de logs.",
                "note": ""
            },
            {
                "command": "vercel domains ls",
                "level": "basic",
                "topic": "Dominios y aliases",
                "description": "Lista dominios.",
                "example": "vercel domains ls",
                "expected": "Domain y metadata.",
                "note": ""
            },
            {
                "command": "vercel domains add <domain>",
                "level": "intermediate",
                "topic": "Dominios y aliases",
                "description": "Agrega dominio al scope.",
                "example": "vercel domains add <domain>",
                "expected": "Domain added o instrucciones DNS.",
                "note": ""
            },
            {
                "command": "vercel alias set <deployment-url> <domain>",
                "level": "intermediate",
                "topic": "Dominios y aliases",
                "description": "Asigna alias a deployment.",
                "example": "vercel alias set <deployment-url> <domain>",
                "expected": "Alias created.",
                "note": "Cambias trafico del dominio."
            },
            {
                "command": "vercel alias ls",
                "level": "intermediate",
                "topic": "Dominios y aliases",
                "description": "Lista aliases.",
                "example": "vercel alias ls",
                "expected": "Source deployment y alias.",
                "note": ""
            },
            {
                "command": "vercel dev",
                "level": "basic",
                "topic": "Dev local",
                "description": "Ejecuta entorno local compatible con Vercel.",
                "example": "vercel dev",
                "expected": "Servidor local y logs.",
                "note": ""
            },
            {
                "command": "vercel teams ls",
                "level": "basic",
                "topic": "Equipos",
                "description": "Lista teams/scope disponibles.",
                "example": "vercel teams ls",
                "expected": "Team names/IDs.",
                "note": ""
            },
            {
                "command": "vercel --version",
                "level": "basic",
                "topic": "Mantenimiento",
                "description": "Muestra version CLI.",
                "example": "vercel --version",
                "expected": "Vercel CLI X.Y.Z.",
                "note": ""
            },
            {
                "command": "vercel remove <project-or-deployment>",
                "level": "intermediate",
                "topic": "Mantenimiento",
                "description": "Elimina proyecto/deployment segun objetivo.",
                "example": "vercel remove <project-or-deployment>",
                "expected": "Confirmacion de removal.",
                "note": "Accion destructiva; revisa target."
            }
        ]
    },
    {
        "id": "netlify",
        "group": "deployment",
        "title": "Netlify CLI",
        "description": "Sites, deploys, builds, servidor de desarrollo, variables, Functions, API y addons.",
        "aliases": [
            "netlify",
            "deployment",
            "jamstack"
        ],
        "commands": [
            {
                "command": "netlify login",
                "level": "basic",
                "topic": "Auth y sitio",
                "description": "Autentica Netlify CLI.",
                "example": "netlify login",
                "expected": "Browser flow y login exitoso.",
                "note": ""
            },
            {
                "command": "netlify status",
                "level": "basic",
                "topic": "Auth y sitio",
                "description": "Muestra usuario y site vinculado.",
                "example": "netlify status",
                "expected": "Current Netlify User y Site Info.",
                "note": ""
            },
            {
                "command": "netlify init",
                "level": "basic",
                "topic": "Auth y sitio",
                "description": "Inicializa/vincula un sitio.",
                "example": "netlify init",
                "expected": "Config del site y netlify.toml segun flujo.",
                "note": ""
            },
            {
                "command": "netlify link",
                "level": "basic",
                "topic": "Auth y sitio",
                "description": "Vincula repo/directorio a site existente.",
                "example": "netlify link",
                "expected": "Site linked.",
                "note": ""
            },
            {
                "command": "netlify sites:list",
                "level": "intermediate",
                "topic": "Auth y sitio",
                "description": "Lista sitios.",
                "example": "netlify sites:list",
                "expected": "Site name, URL e ID.",
                "note": ""
            },
            {
                "command": "netlify sites:create --name <name>",
                "level": "intermediate",
                "topic": "Auth y sitio",
                "description": "Crea sitio.",
                "example": "netlify sites:create --name <name>",
                "expected": "Site ID y URL.",
                "note": ""
            },
            {
                "command": "netlify deploy",
                "level": "basic",
                "topic": "Deploy",
                "description": "Crea deploy draft/preview.",
                "example": "netlify deploy",
                "expected": "Draft URL y deploy info.",
                "note": ""
            },
            {
                "command": "netlify deploy --prod",
                "level": "basic",
                "topic": "Deploy",
                "description": "Despliega a produccion.",
                "example": "netlify deploy --prod",
                "expected": "Website URL y deploy URL.",
                "note": ""
            },
            {
                "command": "netlify deploy --dir=dist --prod",
                "level": "intermediate",
                "topic": "Deploy",
                "description": "Publica directorio dist.",
                "example": "netlify deploy --dir=dist --prod",
                "expected": "Archivos subidos y URL.",
                "note": ""
            },
            {
                "command": "netlify dev",
                "level": "basic",
                "topic": "Build y dev",
                "description": "Inicia entorno local Netlify.",
                "example": "netlify dev",
                "expected": "Local server, functions/proxy segun config.",
                "note": ""
            },
            {
                "command": "netlify build",
                "level": "basic",
                "topic": "Build y dev",
                "description": "Ejecuta build como Netlify.",
                "example": "netlify build",
                "expected": "Build logs y output.",
                "note": ""
            },
            {
                "command": "netlify build --context production",
                "level": "intermediate",
                "topic": "Build y dev",
                "description": "Construye con contexto production.",
                "example": "netlify build --context production",
                "expected": "Build usando config/env de production.",
                "note": ""
            },
            {
                "command": "netlify env:list",
                "level": "basic",
                "topic": "Variables",
                "description": "Lista variables.",
                "example": "netlify env:list",
                "expected": "Keys, scopes y contexts; valores segun permisos/output.",
                "note": ""
            },
            {
                "command": "netlify env:set <KEY> <value>",
                "level": "intermediate",
                "topic": "Variables",
                "description": "Define variable.",
                "example": "netlify env:set <KEY> <value>",
                "expected": "Variable set.",
                "note": "Evita secretos en historial; usa manejo seguro cuando sea posible."
            },
            {
                "command": "netlify env:get <KEY>",
                "level": "intermediate",
                "topic": "Variables",
                "description": "Lee variable.",
                "example": "netlify env:get <KEY>",
                "expected": "Valor o metadata.",
                "note": "No compartas salida de secrets."
            },
            {
                "command": "netlify env:unset <KEY>",
                "level": "intermediate",
                "topic": "Variables",
                "description": "Elimina variable.",
                "example": "netlify env:unset <KEY>",
                "expected": "Variable removed.",
                "note": "Puede afectar builds/functions."
            },
            {
                "command": "netlify functions:list",
                "level": "basic",
                "topic": "Functions",
                "description": "Lista funciones.",
                "example": "netlify functions:list",
                "expected": "Function names y rutas.",
                "note": ""
            },
            {
                "command": "netlify functions:invoke <name> --payload '{\"x\":1}'",
                "level": "intermediate",
                "topic": "Functions",
                "description": "Invoca funcion local/remota segun contexto.",
                "example": "netlify functions:invoke <name> --payload '{\"x\":1}'",
                "expected": "Response de la function.",
                "note": ""
            },
            {
                "command": "netlify functions:serve",
                "level": "intermediate",
                "topic": "Functions",
                "description": "Sirve functions localmente.",
                "example": "netlify functions:serve",
                "expected": "Function server activo.",
                "note": ""
            },
            {
                "command": "netlify open",
                "level": "basic",
                "topic": "Open y diagnostico",
                "description": "Abre dashboard del site.",
                "example": "netlify open",
                "expected": "Navegador abierto.",
                "note": ""
            },
            {
                "command": "netlify logs:deploy",
                "level": "intermediate",
                "topic": "Open y diagnostico",
                "description": "Muestra logs de deploy si disponible en CLI.",
                "example": "netlify logs:deploy",
                "expected": "Logs del deploy.",
                "note": "Subcomandos exactos pueden variar por version; consulta netlify help."
            },
            {
                "command": "netlify api listSites",
                "level": "intermediate",
                "topic": "API",
                "description": "Invoca metodo de API desde CLI.",
                "example": "netlify api listSites",
                "expected": "JSON de respuesta.",
                "note": ""
            },
            {
                "command": "netlify api --list",
                "level": "advanced",
                "topic": "API",
                "description": "Lista metodos API disponibles.",
                "example": "netlify api --list",
                "expected": "Nombres de metodos.",
                "note": ""
            },
            {
                "command": "netlify addons:list",
                "level": "basic",
                "topic": "Addons",
                "description": "Lista addons del site.",
                "example": "netlify addons:list",
                "expected": "Addons activos.",
                "note": ""
            },
            {
                "command": "netlify addons:create <addon>",
                "level": "intermediate",
                "topic": "Addons",
                "description": "Provisiona addon.",
                "example": "netlify addons:create <addon>",
                "expected": "Addon creado.",
                "note": "Puede implicar servicio/costo externo."
            },
            {
                "command": "netlify --version",
                "level": "basic",
                "topic": "Mantenimiento",
                "description": "Muestra version.",
                "example": "netlify --version",
                "expected": "netlify-cli/X.Y.Z.",
                "note": ""
            },
            {
                "command": "netlify help",
                "level": "basic",
                "topic": "Mantenimiento",
                "description": "Muestra ayuda.",
                "example": "netlify help",
                "expected": "Comandos y opciones.",
                "note": ""
            },
            {
                "command": "netlify unlink",
                "level": "intermediate",
                "topic": "Sites",
                "description": "Desvincula el directorio local del site actual.",
                "example": "netlify unlink",
                "expected": "Se elimina el enlace local al site.",
                "note": ""
            },
            {
                "command": "netlify deploy --build --prod",
                "level": "intermediate",
                "topic": "Deploy",
                "description": "Ejecuta build y luego despliega a producci\u00f3n.",
                "example": "netlify deploy --build --prod",
                "expected": "Logs del build y URL del deploy de producci\u00f3n.",
                "note": ""
            },
            {
                "command": "netlify env:import .env",
                "level": "intermediate",
                "topic": "Variables",
                "description": "Importa variables desde un archivo .env.",
                "example": "netlify env:import .env",
                "expected": "Variables agregadas/actualizadas en Netlify.",
                "note": "Revis\u00e1 el archivo porque puede contener secretos."
            }
        ]
    },
    {
        "id": "wrangler",
        "group": "deployment",
        "title": "Cloudflare Wrangler",
        "description": "Workers, Pages, KV, D1, R2, Queues, secrets, versiones y logs.",
        "aliases": [
            "wrangler",
            "cloudflare",
            "workers",
            "pages",
            "d1",
            "r2"
        ],
        "commands": [
            {
                "command": "npx wrangler login",
                "level": "basic",
                "topic": "Auth y proyecto",
                "description": "Autentica Wrangler con Cloudflare.",
                "example": "npx wrangler login",
                "expected": "Browser OAuth y login exitoso.",
                "note": ""
            },
            {
                "command": "npx wrangler whoami",
                "level": "basic",
                "topic": "Auth y proyecto",
                "description": "Muestra identidad/cuenta activa.",
                "example": "npx wrangler whoami",
                "expected": "Cuenta, email e IDs accesibles.",
                "note": ""
            },
            {
                "command": "npx wrangler --version",
                "level": "basic",
                "topic": "Auth y proyecto",
                "description": "Muestra version de Wrangler.",
                "example": "npx wrangler --version",
                "expected": "Version X.Y.Z.",
                "note": ""
            },
            {
                "command": "npx wrangler dev",
                "level": "basic",
                "topic": "Desarrollo y deploy",
                "description": "Ejecuta Worker localmente.",
                "example": "npx wrangler dev",
                "expected": "Servidor local y logs.",
                "note": ""
            },
            {
                "command": "npx wrangler deploy",
                "level": "basic",
                "topic": "Desarrollo y deploy",
                "description": "Despliega Worker.",
                "example": "npx wrangler deploy",
                "expected": "Deployment ID/version y URL/routes.",
                "note": ""
            },
            {
                "command": "npx wrangler deploy --env production",
                "level": "intermediate",
                "topic": "Desarrollo y deploy",
                "description": "Despliega usando environment production.",
                "example": "npx wrangler deploy --env production",
                "expected": "Deployment del entorno seleccionado.",
                "note": ""
            },
            {
                "command": "npx wrangler tail",
                "level": "intermediate",
                "topic": "Desarrollo y deploy",
                "description": "Sigue logs del Worker desplegado.",
                "example": "npx wrangler tail",
                "expected": "Stream de requests/logs.",
                "note": ""
            },
            {
                "command": "npx wrangler types",
                "level": "intermediate",
                "topic": "Desarrollo y deploy",
                "description": "Genera tipos a partir de bindings/config.",
                "example": "npx wrangler types",
                "expected": "Archivo de tipos generado.",
                "note": ""
            },
            {
                "command": "npx wrangler secret list",
                "level": "basic",
                "topic": "Secrets",
                "description": "Lista nombres de secrets del Worker.",
                "example": "npx wrangler secret list",
                "expected": "Keys, sin valores.",
                "note": ""
            },
            {
                "command": "npx wrangler secret put <KEY>",
                "level": "intermediate",
                "topic": "Secrets",
                "description": "Carga un secret por prompt/stdin.",
                "example": "npx wrangler secret put <KEY>",
                "expected": "Secret uploaded.",
                "note": "No pongas secretos directamente en historial."
            },
            {
                "command": "npx wrangler secret delete <KEY>",
                "level": "intermediate",
                "topic": "Secrets",
                "description": "Elimina un secret.",
                "example": "npx wrangler secret delete <KEY>",
                "expected": "Secret deleted.",
                "note": "Puede romper el Worker."
            },
            {
                "command": "npx wrangler secret bulk .dev.vars",
                "level": "advanced",
                "topic": "Secrets",
                "description": "Carga varios secrets desde archivo.",
                "example": "npx wrangler secret bulk .dev.vars",
                "expected": "Cantidad de secrets uploaded.",
                "note": "Protege y no commitees el archivo."
            },
            {
                "command": "npx wrangler kv namespace list",
                "level": "basic",
                "topic": "KV",
                "description": "Lista namespaces KV.",
                "example": "npx wrangler kv namespace list",
                "expected": "IDs y titles.",
                "note": ""
            },
            {
                "command": "npx wrangler kv namespace create <name>",
                "level": "intermediate",
                "topic": "KV",
                "description": "Crea namespace.",
                "example": "npx wrangler kv namespace create <name>",
                "expected": "Namespace ID y binding sugerido.",
                "note": ""
            },
            {
                "command": "npx wrangler kv key put <key> <value> --namespace-id <id>",
                "level": "intermediate",
                "topic": "KV",
                "description": "Guarda una key.",
                "example": "npx wrangler kv key put <key> <value> --namespace-id <id>",
                "expected": "Success/metadata.",
                "note": ""
            },
            {
                "command": "npx wrangler kv key get <key> --namespace-id <id>",
                "level": "intermediate",
                "topic": "KV",
                "description": "Lee una key.",
                "example": "npx wrangler kv key get <key> --namespace-id <id>",
                "expected": "Valor.",
                "note": ""
            },
            {
                "command": "npx wrangler kv bulk put <file.json> --namespace-id <id>",
                "level": "advanced",
                "topic": "KV",
                "description": "Carga muchas keys.",
                "example": "npx wrangler kv bulk put <file.json> --namespace-id <id>",
                "expected": "Bulk upload result.",
                "note": "Valida formato y namespace."
            },
            {
                "command": "npx wrangler d1 list",
                "level": "basic",
                "topic": "D1",
                "description": "Lista bases D1.",
                "example": "npx wrangler d1 list",
                "expected": "Name, UUID y metadata.",
                "note": ""
            },
            {
                "command": "npx wrangler d1 create <name>",
                "level": "intermediate",
                "topic": "D1",
                "description": "Crea D1.",
                "example": "npx wrangler d1 create <name>",
                "expected": "Database ID y binding config.",
                "note": ""
            },
            {
                "command": "npx wrangler d1 execute <db> --local --command \"SELECT 1\"",
                "level": "intermediate",
                "topic": "D1",
                "description": "Ejecuta SQL contra D1 local.",
                "example": "npx wrangler d1 execute <db> --local --command \"SELECT 1\"",
                "expected": "Resultados SQL.",
                "note": ""
            },
            {
                "command": "npx wrangler d1 execute <db> --remote --file ./schema.sql",
                "level": "intermediate",
                "topic": "D1",
                "description": "Ejecuta SQL en D1 remoto.",
                "example": "npx wrangler d1 execute <db> --remote --file ./schema.sql",
                "expected": "Statements/resultados.",
                "note": "Puede modificar datos/esquema remoto."
            },
            {
                "command": "npx wrangler d1 export <db> --remote --output backup.sql",
                "level": "advanced",
                "topic": "D1",
                "description": "Exporta D1 remoto.",
                "example": "npx wrangler d1 export <db> --remote --output backup.sql",
                "expected": "Archivo SQL.",
                "note": ""
            },
            {
                "command": "npx wrangler r2 bucket list",
                "level": "basic",
                "topic": "R2",
                "description": "Lista buckets R2.",
                "example": "npx wrangler r2 bucket list",
                "expected": "Buckets y metadata.",
                "note": ""
            },
            {
                "command": "npx wrangler r2 bucket create <name>",
                "level": "intermediate",
                "topic": "R2",
                "description": "Crea bucket.",
                "example": "npx wrangler r2 bucket create <name>",
                "expected": "Bucket created.",
                "note": ""
            },
            {
                "command": "npx wrangler r2 object put <bucket>/<key> --file <file>",
                "level": "intermediate",
                "topic": "R2",
                "description": "Sube objeto.",
                "example": "npx wrangler r2 object put <bucket>/<key> --file <file>",
                "expected": "Upload success.",
                "note": ""
            },
            {
                "command": "npx wrangler r2 object get <bucket>/<key> --file <file>",
                "level": "intermediate",
                "topic": "R2",
                "description": "Descarga objeto.",
                "example": "npx wrangler r2 object get <bucket>/<key> --file <file>",
                "expected": "Archivo escrito.",
                "note": ""
            },
            {
                "command": "npx wrangler queues list",
                "level": "basic",
                "topic": "Queues",
                "description": "Lista queues.",
                "example": "npx wrangler queues list",
                "expected": "Queue IDs/names.",
                "note": ""
            },
            {
                "command": "npx wrangler queues create <name>",
                "level": "intermediate",
                "topic": "Queues",
                "description": "Crea queue.",
                "example": "npx wrangler queues create <name>",
                "expected": "Queue created.",
                "note": ""
            },
            {
                "command": "npx wrangler pages project list",
                "level": "basic",
                "topic": "Pages",
                "description": "Lista proyectos Pages.",
                "example": "npx wrangler pages project list",
                "expected": "Projects y dominios.",
                "note": ""
            },
            {
                "command": "npx wrangler pages deploy ./dist --project-name <name>",
                "level": "intermediate",
                "topic": "Pages",
                "description": "Despliega assets a Pages.",
                "example": "npx wrangler pages deploy ./dist --project-name <name>",
                "expected": "Deployment URL.",
                "note": ""
            },
            {
                "command": "npx wrangler versions list",
                "level": "intermediate",
                "topic": "Versions",
                "description": "Lista versiones de Worker.",
                "example": "npx wrangler versions list",
                "expected": "Version IDs, created, annotations.",
                "note": ""
            },
            {
                "command": "npx wrangler versions upload",
                "level": "advanced",
                "topic": "Versions",
                "description": "Sube nueva version sin cambiar trafico automaticamente.",
                "example": "npx wrangler versions upload",
                "expected": "Version uploaded.",
                "note": "Flujo util para gradual deployments; revisa config."
            }
        ]
    },
    {
        "id": "firebase",
        "group": "deployment",
        "title": "Firebase CLI",
        "description": "Proyectos, emuladores, Hosting, Functions, Firestore, Realtime Database, secrets y extensiones.",
        "aliases": [
            "firebase",
            "hosting",
            "functions",
            "firestore"
        ],
        "commands": [
            {
                "command": "firebase login",
                "level": "basic",
                "topic": "Auth y proyectos",
                "description": "Autentica Firebase CLI.",
                "example": "firebase login",
                "expected": "Browser login y cuenta activa.",
                "note": ""
            },
            {
                "command": "firebase login:list",
                "level": "basic",
                "topic": "Auth y proyectos",
                "description": "Lista cuentas autenticadas.",
                "example": "firebase login:list",
                "expected": "Emails/cuentas.",
                "note": ""
            },
            {
                "command": "firebase projects:list",
                "level": "basic",
                "topic": "Auth y proyectos",
                "description": "Lista proyectos accesibles.",
                "example": "firebase projects:list",
                "expected": "Project ID, Display Name y Number.",
                "note": ""
            },
            {
                "command": "firebase use",
                "level": "basic",
                "topic": "Auth y proyectos",
                "description": "Muestra proyecto activo/aliases.",
                "example": "firebase use",
                "expected": "Active Project y aliases.",
                "note": ""
            },
            {
                "command": "firebase use --add",
                "level": "intermediate",
                "topic": "Auth y proyectos",
                "description": "Asocia un proyecto a un alias local.",
                "example": "firebase use --add",
                "expected": "Alias guardado en .firebaserc.",
                "note": ""
            },
            {
                "command": "firebase init",
                "level": "basic",
                "topic": "Inicializacion",
                "description": "Inicializa productos Firebase.",
                "example": "firebase init",
                "expected": "firebase.json/.firebaserc y archivos segun seleccion.",
                "note": ""
            },
            {
                "command": "firebase emulators:start",
                "level": "basic",
                "topic": "Emuladores",
                "description": "Inicia emuladores configurados.",
                "example": "firebase emulators:start",
                "expected": "Puertos y Emulator UI.",
                "note": ""
            },
            {
                "command": "firebase emulators:start --only firestore,auth,functions",
                "level": "intermediate",
                "topic": "Emuladores",
                "description": "Inicia solo servicios indicados.",
                "example": "firebase emulators:start --only firestore,auth,functions",
                "expected": "Emuladores seleccionados.",
                "note": ""
            },
            {
                "command": "firebase emulators:exec 'npm test'",
                "level": "advanced",
                "topic": "Emuladores",
                "description": "Levanta emuladores, ejecuta comando y los apaga.",
                "example": "firebase emulators:exec 'npm test'",
                "expected": "Salida de tests y shutdown automatico.",
                "note": ""
            },
            {
                "command": "firebase deploy",
                "level": "basic",
                "topic": "Deploy",
                "description": "Despliega productos configurados.",
                "example": "firebase deploy",
                "expected": "Deploy summary y URLs.",
                "note": ""
            },
            {
                "command": "firebase deploy --only hosting",
                "level": "basic",
                "topic": "Deploy",
                "description": "Despliega solo Hosting.",
                "example": "firebase deploy --only hosting",
                "expected": "Hosting URL y release.",
                "note": ""
            },
            {
                "command": "firebase deploy --only functions",
                "level": "intermediate",
                "topic": "Deploy",
                "description": "Despliega functions.",
                "example": "firebase deploy --only functions",
                "expected": "Build/upload y funciones actualizadas.",
                "note": ""
            },
            {
                "command": "firebase deploy --only firestore:rules,firestore:indexes",
                "level": "intermediate",
                "topic": "Deploy",
                "description": "Despliega rules/indexes.",
                "example": "firebase deploy --only firestore:rules,firestore:indexes",
                "expected": "Rules/indexes actualizados.",
                "note": "Cambios de rules afectan seguridad."
            },
            {
                "command": "firebase deploy --only hosting:<target>",
                "level": "intermediate",
                "topic": "Deploy",
                "description": "Despliega target Hosting especifico.",
                "example": "firebase deploy --only hosting:<target>",
                "expected": "Target publicado.",
                "note": ""
            },
            {
                "command": "firebase hosting:sites:list",
                "level": "basic",
                "topic": "Hosting",
                "description": "Lista sites Hosting.",
                "example": "firebase hosting:sites:list",
                "expected": "Site IDs y URLs.",
                "note": ""
            },
            {
                "command": "firebase hosting:channel:deploy <channel>",
                "level": "intermediate",
                "topic": "Hosting",
                "description": "Crea preview channel.",
                "example": "firebase hosting:channel:deploy <channel>",
                "expected": "Preview URL y expiracion.",
                "note": ""
            },
            {
                "command": "firebase hosting:channel:list",
                "level": "intermediate",
                "topic": "Hosting",
                "description": "Lista preview channels.",
                "example": "firebase hosting:channel:list",
                "expected": "Channel ID, URL, expire time.",
                "note": ""
            },
            {
                "command": "firebase hosting:disable",
                "level": "advanced",
                "topic": "Hosting",
                "description": "Deshabilita Hosting del site activo.",
                "example": "firebase hosting:disable",
                "expected": "Site disabled.",
                "note": "Interrumpe acceso publico."
            },
            {
                "command": "firebase functions:list",
                "level": "basic",
                "topic": "Functions",
                "description": "Lista functions desplegadas.",
                "example": "firebase functions:list",
                "expected": "Function, version/runtime/region/status.",
                "note": ""
            },
            {
                "command": "firebase functions:log",
                "level": "basic",
                "topic": "Functions",
                "description": "Muestra logs recientes.",
                "example": "firebase functions:log",
                "expected": "Entradas de functions.",
                "note": ""
            },
            {
                "command": "firebase functions:log --only <name>",
                "level": "intermediate",
                "topic": "Functions",
                "description": "Filtra logs por function.",
                "example": "firebase functions:log --only <name>",
                "expected": "Logs de esa function.",
                "note": ""
            },
            {
                "command": "firebase functions:secrets:set <NAME>",
                "level": "basic",
                "topic": "Secrets",
                "description": "Crea version de secret.",
                "example": "firebase functions:secrets:set <NAME>",
                "expected": "Prompt y secret version created.",
                "note": ""
            },
            {
                "command": "firebase functions:secrets:get <NAME>",
                "level": "basic",
                "topic": "Secrets",
                "description": "Muestra metadata de secret.",
                "example": "firebase functions:secrets:get <NAME>",
                "expected": "Versiones/metadata, no necesariamente valor.",
                "note": ""
            },
            {
                "command": "firebase functions:secrets:access <NAME>@latest",
                "level": "intermediate",
                "topic": "Secrets",
                "description": "Accede al valor de una version.",
                "example": "firebase functions:secrets:access <NAME>@latest",
                "expected": "Valor del secret.",
                "note": "No lo expongas en logs/tickets."
            },
            {
                "command": "firebase functions:secrets:prune",
                "level": "advanced",
                "topic": "Secrets",
                "description": "Elimina versiones de secrets no usadas por functions.",
                "example": "firebase functions:secrets:prune",
                "expected": "Resumen de versiones removidas.",
                "note": "Revisa antes porque es destructivo."
            },
            {
                "command": "firebase apps:list",
                "level": "basic",
                "topic": "Apps",
                "description": "Lista apps registradas.",
                "example": "firebase apps:list",
                "expected": "App ID, platform, display name.",
                "note": ""
            },
            {
                "command": "firebase apps:sdkconfig WEB <app-id>",
                "level": "intermediate",
                "topic": "Apps",
                "description": "Muestra config SDK de una app web.",
                "example": "firebase apps:sdkconfig WEB <app-id>",
                "expected": "Objeto/config para initializeApp.",
                "note": ""
            },
            {
                "command": "firebase firestore:indexes",
                "level": "basic",
                "topic": "Firestore",
                "description": "Lista/obtiene configuracion de indexes segun CLI.",
                "example": "firebase firestore:indexes",
                "expected": "Indexes/config.",
                "note": ""
            },
            {
                "command": "firebase database:get /path",
                "level": "intermediate",
                "topic": "Database",
                "description": "Lee Realtime Database.",
                "example": "firebase database:get /path",
                "expected": "JSON del path.",
                "note": ""
            },
            {
                "command": "firebase database:set /path data.json",
                "level": "advanced",
                "topic": "Database",
                "description": "Reemplaza datos en un path.",
                "example": "firebase database:set /path data.json",
                "expected": "Confirmacion.",
                "note": "Puede sobrescribir datos existentes."
            },
            {
                "command": "firebase ext:list",
                "level": "basic",
                "topic": "Extensions",
                "description": "Lista extensions instaladas.",
                "example": "firebase ext:list",
                "expected": "Instances y estados.",
                "note": ""
            },
            {
                "command": "firebase ext:install <publisher/extension>",
                "level": "intermediate",
                "topic": "Extensions",
                "description": "Instala extension.",
                "example": "firebase ext:install <publisher/extension>",
                "expected": "Flujo de configuracion e instance.",
                "note": "Puede crear recursos facturables."
            }
        ]
    },
    {
        "id": "supabase",
        "group": "deployment",
        "title": "Supabase CLI",
        "description": "Stack local, proyectos, DB, migraciones, Edge Functions, tipos, secrets y branches.",
        "aliases": [
            "supabase",
            "postgres",
            "edge functions"
        ],
        "commands": [
            {
                "command": "supabase init",
                "level": "basic",
                "topic": "Proyecto local",
                "description": "Inicializa configuracion Supabase local.",
                "example": "supabase init",
                "expected": "Directorio supabase/ creado.",
                "note": ""
            },
            {
                "command": "supabase start",
                "level": "basic",
                "topic": "Proyecto local",
                "description": "Inicia stack local en Docker.",
                "example": "supabase start",
                "expected": "URLs, keys locales y servicios.",
                "note": ""
            },
            {
                "command": "supabase status",
                "level": "basic",
                "topic": "Proyecto local",
                "description": "Muestra estado/credenciales locales.",
                "example": "supabase status",
                "expected": "URLs, ports y keys locales.",
                "note": ""
            },
            {
                "command": "supabase stop",
                "level": "basic",
                "topic": "Proyecto local",
                "description": "Detiene stack local.",
                "example": "supabase stop",
                "expected": "Containers detenidos.",
                "note": ""
            },
            {
                "command": "supabase stop --no-backup",
                "level": "intermediate",
                "topic": "Proyecto local",
                "description": "Detiene sin guardar estado DB local.",
                "example": "supabase stop --no-backup",
                "expected": "Stack detenido.",
                "note": "Puede perder cambios locales no migrados."
            },
            {
                "command": "supabase login",
                "level": "basic",
                "topic": "Proyecto remoto",
                "description": "Autentica CLI.",
                "example": "supabase login",
                "expected": "Token/account configurado.",
                "note": ""
            },
            {
                "command": "supabase projects list",
                "level": "basic",
                "topic": "Proyecto remoto",
                "description": "Lista proyectos.",
                "example": "supabase projects list",
                "expected": "Reference ID, Name, Region y Status.",
                "note": ""
            },
            {
                "command": "supabase link --project-ref <ref>",
                "level": "intermediate",
                "topic": "Proyecto remoto",
                "description": "Vincula repo local a proyecto.",
                "example": "supabase link --project-ref <ref>",
                "expected": "Project linked.",
                "note": ""
            },
            {
                "command": "supabase db reset",
                "level": "basic",
                "topic": "Base de datos",
                "description": "Recrea DB local aplicando migrations/seed.",
                "example": "supabase db reset",
                "expected": "DB local reinicializada.",
                "note": "Destructivo para datos locales."
            },
            {
                "command": "supabase db diff -f <name>",
                "level": "intermediate",
                "topic": "Base de datos",
                "description": "Genera migration desde diferencias de schema.",
                "example": "supabase db diff -f <name>",
                "expected": "Archivo migration SQL.",
                "note": ""
            },
            {
                "command": "supabase db push",
                "level": "intermediate",
                "topic": "Base de datos",
                "description": "Aplica migrations locales al remoto vinculado.",
                "example": "supabase db push",
                "expected": "Migrations applied.",
                "note": "Revisa SQL y backup antes de produccion."
            },
            {
                "command": "supabase db pull",
                "level": "intermediate",
                "topic": "Base de datos",
                "description": "Genera migration reflejando schema remoto.",
                "example": "supabase db pull",
                "expected": "Migration local creada.",
                "note": ""
            },
            {
                "command": "supabase db dump -f backup.sql",
                "level": "intermediate",
                "topic": "Base de datos",
                "description": "Exporta DB/schema segun flags.",
                "example": "supabase db dump -f backup.sql",
                "expected": "Archivo SQL.",
                "note": ""
            },
            {
                "command": "supabase migration new <name>",
                "level": "basic",
                "topic": "Migraciones",
                "description": "Crea migration vacia timestamped.",
                "example": "supabase migration new <name>",
                "expected": "Archivo SQL nuevo.",
                "note": ""
            },
            {
                "command": "supabase migration list",
                "level": "basic",
                "topic": "Migraciones",
                "description": "Lista estado local/remoto.",
                "example": "supabase migration list",
                "expected": "Tabla de migrations.",
                "note": ""
            },
            {
                "command": "supabase migration up",
                "level": "intermediate",
                "topic": "Migraciones",
                "description": "Aplica migrations pendientes a DB local.",
                "example": "supabase migration up",
                "expected": "Migrations aplicadas.",
                "note": ""
            },
            {
                "command": "supabase migration repair <version> --status applied",
                "level": "advanced",
                "topic": "Migraciones",
                "description": "Repara historial de migrations.",
                "example": "supabase migration repair <version> --status applied",
                "expected": "Estado actualizado.",
                "note": "Usar solo entendiendo divergence entre local/remoto."
            },
            {
                "command": "supabase migration squash",
                "level": "advanced",
                "topic": "Migraciones",
                "description": "Combina historial segun flujo CLI.",
                "example": "supabase migration squash",
                "expected": "Migration consolidada.",
                "note": "Reescribe historia de migration local; coordina equipo."
            },
            {
                "command": "supabase gen types typescript --local > database.types.ts",
                "level": "basic",
                "topic": "Tipos",
                "description": "Genera tipos TS desde DB local.",
                "example": "supabase gen types typescript --local > database.types.ts",
                "expected": "Archivo TypeScript con tipos.",
                "note": ""
            },
            {
                "command": "supabase gen types typescript --project-id <ref> > database.types.ts",
                "level": "intermediate",
                "topic": "Tipos",
                "description": "Genera tipos desde proyecto remoto.",
                "example": "supabase gen types typescript --project-id <ref> > database.types.ts",
                "expected": "Archivo de tipos.",
                "note": "Requiere acceso al proyecto."
            },
            {
                "command": "supabase functions new <name>",
                "level": "basic",
                "topic": "Functions",
                "description": "Crea Edge Function.",
                "example": "supabase functions new <name>",
                "expected": "Directorio/function template.",
                "note": ""
            },
            {
                "command": "supabase functions serve",
                "level": "basic",
                "topic": "Functions",
                "description": "Sirve functions localmente.",
                "example": "supabase functions serve",
                "expected": "Local endpoint y logs.",
                "note": ""
            },
            {
                "command": "supabase functions deploy <name>",
                "level": "intermediate",
                "topic": "Functions",
                "description": "Despliega Edge Function.",
                "example": "supabase functions deploy <name>",
                "expected": "Function deployed.",
                "note": ""
            },
            {
                "command": "supabase functions list",
                "level": "basic",
                "topic": "Functions",
                "description": "Lista functions remotas.",
                "example": "supabase functions list",
                "expected": "Function names/status.",
                "note": ""
            },
            {
                "command": "supabase functions delete <name>",
                "level": "intermediate",
                "topic": "Functions",
                "description": "Elimina function remota.",
                "example": "supabase functions delete <name>",
                "expected": "Function deleted.",
                "note": "Interrumpe endpoints dependientes."
            },
            {
                "command": "supabase secrets list",
                "level": "basic",
                "topic": "Secrets",
                "description": "Lista secretos remotos.",
                "example": "supabase secrets list",
                "expected": "Nombres/digests, no valores.",
                "note": ""
            },
            {
                "command": "supabase secrets set KEY=value",
                "level": "intermediate",
                "topic": "Secrets",
                "description": "Configura secret.",
                "example": "supabase secrets set KEY=value",
                "expected": "Secret updated.",
                "note": "Evita valores reales en historial; usa env-file/stdin cuando corresponda."
            },
            {
                "command": "supabase secrets unset <KEY>",
                "level": "intermediate",
                "topic": "Secrets",
                "description": "Elimina secret.",
                "example": "supabase secrets unset <KEY>",
                "expected": "Secret removed.",
                "note": "Puede romper functions."
            },
            {
                "command": "supabase branches list",
                "level": "basic",
                "topic": "Branches",
                "description": "Lista preview branches si estan disponibles.",
                "example": "supabase branches list",
                "expected": "Branches y status.",
                "note": ""
            },
            {
                "command": "supabase branches create <name>",
                "level": "intermediate",
                "topic": "Branches",
                "description": "Crea branch de preview.",
                "example": "supabase branches create <name>",
                "expected": "Branch info.",
                "note": "Feature puede depender del plan/producto."
            },
            {
                "command": "supabase --version",
                "level": "basic",
                "topic": "Diagnostico",
                "description": "Muestra version CLI.",
                "example": "supabase --version",
                "expected": "Version.",
                "note": ""
            },
            {
                "command": "supabase inspect db table-sizes",
                "level": "intermediate",
                "topic": "Diagnostico",
                "description": "Inspecciona tamanos de tablas si el subcomando esta disponible.",
                "example": "supabase inspect db table-sizes",
                "expected": "Tabla de tamanos.",
                "note": "Consulta help de tu version para inspect options."
            }
        ]
    },
    {
        "id": "railway",
        "group": "deployment",
        "title": "Railway CLI",
        "description": "Proyectos, servicios, entornos, variables, deploys, logs y ejecuci\u00f3n con contexto remoto.",
        "aliases": [
            "railway",
            "deploy",
            "hosting"
        ],
        "commands": [
            {
                "command": "railway login",
                "level": "basic",
                "topic": "Auth y proyecto",
                "description": "Autentica Railway CLI.",
                "example": "railway login",
                "expected": "Browser/device login y cuenta activa.",
                "note": ""
            },
            {
                "command": "railway whoami",
                "level": "basic",
                "topic": "Auth y proyecto",
                "description": "Muestra usuario autenticado.",
                "example": "railway whoami",
                "expected": "Nombre/email/identidad segun CLI.",
                "note": ""
            },
            {
                "command": "railway init",
                "level": "basic",
                "topic": "Auth y proyecto",
                "description": "Crea o vincula un nuevo proyecto desde el directorio.",
                "example": "railway init",
                "expected": "Proyecto creado/vinculado.",
                "note": ""
            },
            {
                "command": "railway link",
                "level": "basic",
                "topic": "Auth y proyecto",
                "description": "Vincula el directorio a proyecto/servicio existente.",
                "example": "railway link",
                "expected": "Project linked.",
                "note": ""
            },
            {
                "command": "railway status",
                "level": "basic",
                "topic": "Auth y proyecto",
                "description": "Muestra contexto actual.",
                "example": "railway status",
                "expected": "Project, environment y service vinculados.",
                "note": ""
            },
            {
                "command": "railway list",
                "level": "basic",
                "topic": "Auth y proyecto",
                "description": "Lista proyectos.",
                "example": "railway list",
                "expected": "Proyectos accesibles.",
                "note": ""
            },
            {
                "command": "railway up",
                "level": "basic",
                "topic": "Deploy",
                "description": "Sube y despliega el proyecto actual.",
                "example": "railway up",
                "expected": "Build/deploy progress y deployment.",
                "note": ""
            },
            {
                "command": "railway up --detach",
                "level": "intermediate",
                "topic": "Deploy",
                "description": "Dispara deploy sin seguir logs.",
                "example": "railway up --detach",
                "expected": "Deployment iniciado.",
                "note": ""
            },
            {
                "command": "railway redeploy",
                "level": "intermediate",
                "topic": "Deploy",
                "description": "Redeploy del ultimo deployment segun CLI/contexto.",
                "example": "railway redeploy",
                "expected": "Nuevo deployment.",
                "note": "Consulta railway help si tu version usa subcomando distinto."
            },
            {
                "command": "railway run <command>",
                "level": "basic",
                "topic": "Ejecucion remota",
                "description": "Ejecuta localmente un comando con variables del servicio.",
                "example": "railway run <command>",
                "expected": "Salida del comando con env inyectado.",
                "note": ""
            },
            {
                "command": "railway shell",
                "level": "intermediate",
                "topic": "Ejecucion remota",
                "description": "Abre shell con variables del proyecto.",
                "example": "railway shell",
                "expected": "Shell interactiva.",
                "note": ""
            },
            {
                "command": "railway logs",
                "level": "basic",
                "topic": "Logs",
                "description": "Muestra logs recientes.",
                "example": "railway logs",
                "expected": "Stream/log entries.",
                "note": ""
            },
            {
                "command": "railway logs --service <service>",
                "level": "intermediate",
                "topic": "Logs",
                "description": "Filtra logs por servicio.",
                "example": "railway logs --service <service>",
                "expected": "Logs del servicio.",
                "note": ""
            },
            {
                "command": "railway variables",
                "level": "basic",
                "topic": "Variables",
                "description": "Lista variables del contexto.",
                "example": "railway variables",
                "expected": "Keys/valores segun permisos/output.",
                "note": ""
            },
            {
                "command": "railway variables --set KEY=value",
                "level": "intermediate",
                "topic": "Variables",
                "description": "Define variable.",
                "example": "railway variables --set KEY=value",
                "expected": "Variable updated.",
                "note": "Evita secretos en historial si CLI ofrece stdin/env-file."
            },
            {
                "command": "railway variables --service <service>",
                "level": "intermediate",
                "topic": "Variables",
                "description": "Muestra variables de un servicio.",
                "example": "railway variables --service <service>",
                "expected": "Variables del servicio.",
                "note": ""
            },
            {
                "command": "railway environment",
                "level": "basic",
                "topic": "Entornos y servicios",
                "description": "Selecciona/muestra environment segun flujo interactivo.",
                "example": "railway environment",
                "expected": "Environment activo.",
                "note": ""
            },
            {
                "command": "railway service",
                "level": "basic",
                "topic": "Entornos y servicios",
                "description": "Selecciona/muestra service.",
                "example": "railway service",
                "expected": "Service activo.",
                "note": ""
            },
            {
                "command": "railway unlink",
                "level": "intermediate",
                "topic": "Entornos y servicios",
                "description": "Desvincula directorio local.",
                "example": "railway unlink",
                "expected": "Link local removido.",
                "note": "No borra proyecto remoto."
            },
            {
                "command": "railway domain",
                "level": "intermediate",
                "topic": "Dominios",
                "description": "Genera/muestra dominio del servicio segun CLI.",
                "example": "railway domain",
                "expected": "Dominio asignado.",
                "note": ""
            },
            {
                "command": "railway open",
                "level": "basic",
                "topic": "Utilidades",
                "description": "Abre proyecto en dashboard.",
                "example": "railway open",
                "expected": "Navegador abierto.",
                "note": ""
            },
            {
                "command": "railway --version",
                "level": "basic",
                "topic": "Utilidades",
                "description": "Muestra version.",
                "example": "railway --version",
                "expected": "Version CLI.",
                "note": ""
            },
            {
                "command": "railway login --browserless",
                "level": "basic",
                "topic": "Auth",
                "description": "Inicia sesi\u00f3n sin abrir navegador, ideal para SSH o servidores sin GUI.",
                "example": "railway login --browserless",
                "expected": "Imprime URL/c\u00f3digo de dispositivo y espera autenticaci\u00f3n.",
                "note": ""
            },
            {
                "command": "railway environment list",
                "level": "intermediate",
                "topic": "Environments",
                "description": "Lista los entornos del proyecto.",
                "example": "railway environment list",
                "expected": "Nombres/IDs de entornos disponibles.",
                "note": ""
            },
            {
                "command": "railway environment new staging",
                "level": "intermediate",
                "topic": "Environments",
                "description": "Crea un entorno llamado staging.",
                "example": "railway environment new staging",
                "expected": "Confirmaci\u00f3n y nuevo entorno disponible.",
                "note": ""
            },
            {
                "command": "railway environment new staging --duplicate production",
                "level": "advanced",
                "topic": "Environments",
                "description": "Crea staging duplicando configuraci\u00f3n de production.",
                "example": "railway environment new staging --duplicate production",
                "expected": "Nuevo entorno basado en production.",
                "note": ""
            },
            {
                "command": "railway up --ci",
                "level": "intermediate",
                "topic": "Deploy",
                "description": "Despliega en modo CI y sale con el estado del build.",
                "example": "railway up --ci",
                "expected": "Logs de build y c\u00f3digo 0 en \u00e9xito / 1 en fallo.",
                "note": ""
            },
            {
                "command": "railway up --service <service>",
                "level": "intermediate",
                "topic": "Deploy",
                "description": "Despliega apuntando a un servicio espec\u00edfico.",
                "example": "railway up --service <service>",
                "expected": "Build/deploy del servicio seleccionado.",
                "note": ""
            },
            {
                "command": "railway ssh",
                "level": "intermediate",
                "topic": "Debug",
                "description": "Abre una shell interactiva dentro de un contenedor desplegado.",
                "example": "railway ssh",
                "expected": "Sesi\u00f3n SSH interactiva en el servicio.",
                "note": ""
            },
            {
                "command": "railway ssh -- ls -la",
                "level": "intermediate",
                "topic": "Debug",
                "description": "Ejecuta un comando puntual dentro del servicio remoto.",
                "example": "railway ssh -- ls -la",
                "expected": "Salida de ls dentro del contenedor.",
                "note": ""
            },
            {
                "command": "railway connect",
                "level": "intermediate",
                "topic": "Debug",
                "description": "Abre el cliente de base de datos correspondiente al servicio enlazado.",
                "example": "railway connect",
                "expected": "Shell interactiva de la base compatible.",
                "note": ""
            },
            {
                "command": "railway metrics",
                "level": "intermediate",
                "topic": "Debug",
                "description": "Muestra m\u00e9tricas de recursos/HTTP del servicio.",
                "example": "railway metrics",
                "expected": "M\u00e9tricas del servicio seg\u00fan el contexto enlazado.",
                "note": ""
            },
            {
                "command": "railway domain list",
                "level": "intermediate",
                "topic": "Dominios",
                "description": "Lista dominios del servicio.",
                "example": "railway domain list",
                "expected": "Dominios Railway/custom con su estado.",
                "note": ""
            },
            {
                "command": "railway variable list --kv",
                "level": "intermediate",
                "topic": "Variables",
                "description": "Lista variables en formato KEY=VALUE.",
                "example": "railway variable list --kv",
                "expected": "Una variable por l\u00ednea.",
                "note": "Puede mostrar secretos; no compartas la salida."
            }
        ]
    },
    {
        "id": "flyctl",
        "group": "deployment",
        "title": "Fly.io / flyctl",
        "description": "Apps, Machines, deploys, scaling, secrets, vol\u00famenes, SSH, IPs y certificados.",
        "aliases": [
            "fly.io",
            "flyctl",
            "machines",
            "deploy"
        ],
        "commands": [
            {
                "command": "fly auth login",
                "level": "basic",
                "topic": "Auth y apps",
                "description": "Autentica flyctl.",
                "example": "fly auth login",
                "expected": "Browser login y auth success.",
                "note": ""
            },
            {
                "command": "fly auth whoami",
                "level": "basic",
                "topic": "Auth y apps",
                "description": "Muestra identidad.",
                "example": "fly auth whoami",
                "expected": "Email/usuario.",
                "note": ""
            },
            {
                "command": "fly apps list",
                "level": "basic",
                "topic": "Auth y apps",
                "description": "Lista apps.",
                "example": "fly apps list",
                "expected": "NAME, OWNER, STATUS, LATEST DEPLOY.",
                "note": ""
            },
            {
                "command": "fly launch",
                "level": "basic",
                "topic": "Auth y apps",
                "description": "Inicializa app/config y opcionalmente deploy.",
                "example": "fly launch",
                "expected": "fly.toml, app creada y prompts.",
                "note": ""
            },
            {
                "command": "fly apps create <name>",
                "level": "intermediate",
                "topic": "Auth y apps",
                "description": "Crea app vacia.",
                "example": "fly apps create <name>",
                "expected": "App created.",
                "note": ""
            },
            {
                "command": "fly deploy",
                "level": "basic",
                "topic": "Deploy",
                "description": "Construye y despliega.",
                "example": "fly deploy",
                "expected": "Build, machines update y URL.",
                "note": ""
            },
            {
                "command": "fly deploy --strategy rolling",
                "level": "intermediate",
                "topic": "Deploy",
                "description": "Usa estrategia rolling.",
                "example": "fly deploy --strategy rolling",
                "expected": "Machines actualizadas gradualmente.",
                "note": ""
            },
            {
                "command": "fly deploy --ha=false",
                "level": "intermediate",
                "topic": "Deploy",
                "description": "Despliega sin HA extra segun app/config.",
                "example": "fly deploy --ha=false",
                "expected": "Deployment result.",
                "note": "Revisa impacto de disponibilidad."
            },
            {
                "command": "fly deploy --image <registry/image:tag>",
                "level": "advanced",
                "topic": "Deploy",
                "description": "Despliega imagen preconstruida.",
                "example": "fly deploy --image <registry/image:tag>",
                "expected": "Machines actualizadas con image.",
                "note": ""
            },
            {
                "command": "fly status",
                "level": "basic",
                "topic": "Estado y logs",
                "description": "Muestra estado de app.",
                "example": "fly status",
                "expected": "Deployment, hostname y machines.",
                "note": ""
            },
            {
                "command": "fly logs",
                "level": "basic",
                "topic": "Estado y logs",
                "description": "Sigue logs.",
                "example": "fly logs",
                "expected": "Stream de logs.",
                "note": ""
            },
            {
                "command": "fly releases",
                "level": "intermediate",
                "topic": "Estado y logs",
                "description": "Lista releases.",
                "example": "fly releases",
                "expected": "Version, status, description y user.",
                "note": ""
            },
            {
                "command": "fly ssh console",
                "level": "basic",
                "topic": "SSH",
                "description": "Abre shell en una machine.",
                "example": "fly ssh console",
                "expected": "Prompt remoto.",
                "note": ""
            },
            {
                "command": "fly ssh console -C '<command>'",
                "level": "intermediate",
                "topic": "SSH",
                "description": "Ejecuta comando remoto.",
                "example": "fly ssh console -C '<command>'",
                "expected": "Salida del comando.",
                "note": ""
            },
            {
                "command": "fly secrets list",
                "level": "basic",
                "topic": "Secrets",
                "description": "Lista nombres/digests de secrets.",
                "example": "fly secrets list",
                "expected": "NAME y DIGEST.",
                "note": ""
            },
            {
                "command": "fly secrets set KEY=value",
                "level": "intermediate",
                "topic": "Secrets",
                "description": "Define secret y reinicia/actualiza machines segun app.",
                "example": "fly secrets set KEY=value",
                "expected": "Secret staged/deployed.",
                "note": "Evita secretos en historial; preferi stdin/env-file cuando sea posible."
            },
            {
                "command": "fly secrets unset KEY",
                "level": "intermediate",
                "topic": "Secrets",
                "description": "Elimina secret.",
                "example": "fly secrets unset KEY",
                "expected": "Secret removed y deployment/update.",
                "note": ""
            },
            {
                "command": "fly scale show",
                "level": "basic",
                "topic": "Scale",
                "description": "Muestra recursos configurados.",
                "example": "fly scale show",
                "expected": "VM size/count y regiones.",
                "note": ""
            },
            {
                "command": "fly scale count 2",
                "level": "intermediate",
                "topic": "Scale",
                "description": "Escala cantidad de machines.",
                "example": "fly scale count 2",
                "expected": "Count actualizado.",
                "note": "Puede aumentar costo."
            },
            {
                "command": "fly scale vm shared-cpu-2x --memory 1024",
                "level": "intermediate",
                "topic": "Scale",
                "description": "Cambia recursos VM.",
                "example": "fly scale vm shared-cpu-2x --memory 1024",
                "expected": "Scale settings updated.",
                "note": "Puede reiniciar/reemplazar machines."
            },
            {
                "command": "fly machine list",
                "level": "basic",
                "topic": "Machines",
                "description": "Lista machines.",
                "example": "fly machine list",
                "expected": "ID, state, region, image, IP.",
                "note": ""
            },
            {
                "command": "fly machine restart <id>",
                "level": "intermediate",
                "topic": "Machines",
                "description": "Reinicia una machine.",
                "example": "fly machine restart <id>",
                "expected": "Machine restarted.",
                "note": ""
            },
            {
                "command": "fly machine clone <id> --region <region>",
                "level": "advanced",
                "topic": "Machines",
                "description": "Clona machine a otra region.",
                "example": "fly machine clone <id> --region <region>",
                "expected": "Nueva machine ID.",
                "note": "Verifica volumes/secrets/networking."
            },
            {
                "command": "fly ips list",
                "level": "basic",
                "topic": "IPs y certificados",
                "description": "Lista IPs asignadas.",
                "example": "fly ips list",
                "expected": "TYPE, ADDRESS, REGION/CREATED.",
                "note": ""
            },
            {
                "command": "fly certs list",
                "level": "basic",
                "topic": "IPs y certificados",
                "description": "Lista certificados/domains.",
                "example": "fly certs list",
                "expected": "Hostname y status.",
                "note": ""
            },
            {
                "command": "fly certs add <domain>",
                "level": "intermediate",
                "topic": "IPs y certificados",
                "description": "Agrega hostname/certificado.",
                "example": "fly certs add <domain>",
                "expected": "DNS instructions y cert status.",
                "note": ""
            },
            {
                "command": "fly volumes list",
                "level": "basic",
                "topic": "Volumes",
                "description": "Lista volumes.",
                "example": "fly volumes list",
                "expected": "ID, state, size, region, attached machine.",
                "note": ""
            },
            {
                "command": "fly volumes create <name> --region <region> --size 10",
                "level": "intermediate",
                "topic": "Volumes",
                "description": "Crea volume 10GB.",
                "example": "fly volumes create <name> --region <region> --size 10",
                "expected": "Volume ID.",
                "note": "Volumes son regionales y generan costo."
            },
            {
                "command": "fly config show",
                "level": "basic",
                "topic": "Config",
                "description": "Muestra fly.toml efectivo.",
                "example": "fly config show",
                "expected": "Config renderizada.",
                "note": ""
            },
            {
                "command": "fly config save",
                "level": "intermediate",
                "topic": "Config",
                "description": "Descarga config remota a fly.toml.",
                "example": "fly config save",
                "expected": "Archivo actualizado.",
                "note": ""
            }
        ]
    },
    {
        "id": "github-actions",
        "group": "deployment",
        "title": "GitHub Actions",
        "description": "Workflows, runs, logs, artifacts, secrets, variables, runners self-hosted y ejecuci\u00f3n local con act.",
        "aliases": [
            "github actions",
            "actions",
            "workflow",
            "ci cd",
            "act"
        ],
        "commands": [
            {
                "command": "gh workflow list",
                "level": "basic",
                "topic": "Workflows",
                "description": "Lista workflows del repo.",
                "example": "gh workflow list",
                "expected": "NAME, STATE e ID.",
                "note": ""
            },
            {
                "command": "gh workflow view <workflow>",
                "level": "basic",
                "topic": "Workflows",
                "description": "Muestra workflow.",
                "example": "gh workflow view <workflow>",
                "expected": "YAML/metadata segun flags.",
                "note": ""
            },
            {
                "command": "gh workflow run <workflow> --ref main",
                "level": "intermediate",
                "topic": "Workflows",
                "description": "Dispara workflow_dispatch.",
                "example": "gh workflow run <workflow> --ref main",
                "expected": "Dispatch creado.",
                "note": ""
            },
            {
                "command": "gh workflow run <workflow> -f environment=staging",
                "level": "intermediate",
                "topic": "Workflows",
                "description": "Dispara workflow con input.",
                "example": "gh workflow run <workflow> -f environment=staging",
                "expected": "Run encolado.",
                "note": ""
            },
            {
                "command": "gh run list --limit 20",
                "level": "basic",
                "topic": "Runs",
                "description": "Lista runs recientes.",
                "example": "gh run list --limit 20",
                "expected": "STATUS, CONCLUSION, WORKFLOW, BRANCH, EVENT, ID.",
                "note": ""
            },
            {
                "command": "gh run view <run-id>",
                "level": "basic",
                "topic": "Runs",
                "description": "Muestra jobs/estado de run.",
                "example": "gh run view <run-id>",
                "expected": "Resumen de jobs y enlaces.",
                "note": ""
            },
            {
                "command": "gh run watch <run-id>",
                "level": "basic",
                "topic": "Runs",
                "description": "Sigue run en vivo.",
                "example": "gh run watch <run-id>",
                "expected": "Estado de jobs/steps hasta terminar.",
                "note": ""
            },
            {
                "command": "gh run view <run-id> --log",
                "level": "intermediate",
                "topic": "Runs",
                "description": "Muestra logs completos.",
                "example": "gh run view <run-id> --log",
                "expected": "Logs de jobs/steps.",
                "note": ""
            },
            {
                "command": "gh run view <run-id> --log-failed",
                "level": "intermediate",
                "topic": "Runs",
                "description": "Muestra logs fallidos.",
                "example": "gh run view <run-id> --log-failed",
                "expected": "Logs solo de steps con fallo.",
                "note": ""
            },
            {
                "command": "gh run rerun <run-id>",
                "level": "intermediate",
                "topic": "Runs",
                "description": "Reejecuta un run.",
                "example": "gh run rerun <run-id>",
                "expected": "Rerun solicitado.",
                "note": ""
            },
            {
                "command": "gh run rerun <run-id> --failed",
                "level": "advanced",
                "topic": "Runs",
                "description": "Reejecuta solo jobs fallidos si soportado.",
                "example": "gh run rerun <run-id> --failed",
                "expected": "Jobs fallidos reencolados.",
                "note": ""
            },
            {
                "command": "gh run cancel <run-id>",
                "level": "intermediate",
                "topic": "Runs",
                "description": "Cancela run.",
                "example": "gh run cancel <run-id>",
                "expected": "Cancellation requested.",
                "note": "Interrumpe pipeline en curso."
            },
            {
                "command": "gh run download <run-id>",
                "level": "basic",
                "topic": "Artifacts",
                "description": "Descarga artifacts del run.",
                "example": "gh run download <run-id>",
                "expected": "Directorios/archivos descargados.",
                "note": ""
            },
            {
                "command": "gh run download <run-id> -n <artifact>",
                "level": "intermediate",
                "topic": "Artifacts",
                "description": "Descarga artifact puntual.",
                "example": "gh run download <run-id> -n <artifact>",
                "expected": "Artifact extraido.",
                "note": ""
            },
            {
                "command": "gh secret list",
                "level": "basic",
                "topic": "Secrets y variables",
                "description": "Lista secrets Actions.",
                "example": "gh secret list",
                "expected": "Nombres y updated; nunca valores.",
                "note": ""
            },
            {
                "command": "gh secret set <NAME> < <file>",
                "level": "intermediate",
                "topic": "Secrets y variables",
                "description": "Carga secret desde stdin.",
                "example": "gh secret set <NAME> < <file>",
                "expected": "Secret set.",
                "note": ""
            },
            {
                "command": "gh secret set <NAME> --env <environment> < <file>",
                "level": "intermediate",
                "topic": "Secrets y variables",
                "description": "Carga secret en environment.",
                "example": "gh secret set <NAME> --env <environment> < <file>",
                "expected": "Secret set para environment.",
                "note": ""
            },
            {
                "command": "gh variable list",
                "level": "basic",
                "topic": "Secrets y variables",
                "description": "Lista Actions variables.",
                "example": "gh variable list",
                "expected": "Names/values segun scope.",
                "note": ""
            },
            {
                "command": "gh variable set <NAME> --body <value>",
                "level": "intermediate",
                "topic": "Secrets y variables",
                "description": "Define variable no secreta.",
                "example": "gh variable set <NAME> --body <value>",
                "expected": "Variable set.",
                "note": "No uses variables para secretos."
            },
            {
                "command": "gh api repos/{owner}/{repo}/environments",
                "level": "intermediate",
                "topic": "Environments",
                "description": "Lista environments via API.",
                "example": "gh api repos/{owner}/{repo}/environments",
                "expected": "JSON de environments.",
                "note": ""
            },
            {
                "command": "gh api --method PUT repos/{owner}/{repo}/environments/production -f wait_timer=0",
                "level": "advanced",
                "topic": "Environments",
                "description": "Crea/actualiza environment via API.",
                "example": "gh api --method PUT repos/{owner}/{repo}/environments/production -f wait_timer=0",
                "expected": "JSON environment.",
                "note": "Revisa protection rules antes de automatizar."
            },
            {
                "command": "gh api repos/{owner}/{repo}/actions/runners",
                "level": "basic",
                "topic": "Runners",
                "description": "Lista self-hosted runners via API.",
                "example": "gh api repos/{owner}/{repo}/actions/runners",
                "expected": "JSON de runners y status.",
                "note": ""
            },
            {
                "command": "./config.sh --url https://github.com/<owner>/<repo> --token <token>",
                "level": "intermediate",
                "topic": "Runners",
                "description": "Configura runner self-hosted Linux.",
                "example": "./config.sh --url https://github.com/<owner>/<repo> --token <token>",
                "expected": "Runner configured.",
                "note": "Token es temporal/sensible; ejecuta en host confiable."
            },
            {
                "command": "./run.sh",
                "level": "intermediate",
                "topic": "Runners",
                "description": "Inicia runner self-hosted foreground.",
                "example": "./run.sh",
                "expected": "Listening for Jobs.",
                "note": ""
            },
            {
                "command": "sudo ./svc.sh install && sudo ./svc.sh start",
                "level": "advanced",
                "topic": "Runners",
                "description": "Instala runner como servicio.",
                "example": "sudo ./svc.sh install && sudo ./svc.sh start",
                "expected": "Service installed/started.",
                "note": "Solo desde directorio oficial del runner configurado."
            },
            {
                "command": "act -l",
                "level": "basic",
                "topic": "Local con act",
                "description": "Lista jobs ejecutables localmente.",
                "example": "act -l",
                "expected": "Stage, Job ID, Job name, Workflow.",
                "note": ""
            },
            {
                "command": "act",
                "level": "basic",
                "topic": "Local con act",
                "description": "Ejecuta evento push por defecto localmente.",
                "example": "act",
                "expected": "Logs de jobs dentro de containers.",
                "note": ""
            },
            {
                "command": "act pull_request",
                "level": "intermediate",
                "topic": "Local con act",
                "description": "Simula evento pull_request.",
                "example": "act pull_request",
                "expected": "Jobs disparados por ese evento.",
                "note": ""
            },
            {
                "command": "act -j <job>",
                "level": "intermediate",
                "topic": "Local con act",
                "description": "Ejecuta un job puntual.",
                "example": "act -j <job>",
                "expected": "Logs del job.",
                "note": ""
            },
            {
                "command": "act --secret-file .secrets",
                "level": "advanced",
                "topic": "Local con act",
                "description": "Carga secrets locales para simulacion.",
                "example": "act --secret-file .secrets",
                "expected": "Jobs con secrets inyectados.",
                "note": "No commitees .secrets."
            },
            {
                "command": "gh cache list",
                "level": "basic",
                "topic": "Cache",
                "description": "Lista caches de Actions.",
                "example": "gh cache list",
                "expected": "Key, size, created/last accessed.",
                "note": ""
            },
            {
                "command": "gh cache delete <key>",
                "level": "intermediate",
                "topic": "Cache",
                "description": "Elimina cache por key.",
                "example": "gh cache delete <key>",
                "expected": "Cache deleted.",
                "note": "Puede hacer mas lentos builds siguientes."
            }
        ]
    },
    {
        "id": "gitlab-cli",
        "group": "deployment",
        "title": "GitLab CLI / glab",
        "description": "Repositorios, merge requests, issues, pipelines, releases, API y variables de GitLab.",
        "aliases": [
            "gitlab",
            "glab",
            "ci cd",
            "pipelines"
        ],
        "commands": [
            {
                "command": "glab auth login",
                "level": "basic",
                "topic": "Auth y config",
                "description": "Autentica GitLab CLI.",
                "example": "glab auth login",
                "expected": "Prompts y auth saved.",
                "note": ""
            },
            {
                "command": "glab auth status",
                "level": "basic",
                "topic": "Auth y config",
                "description": "Muestra host/cuenta autenticada.",
                "example": "glab auth status",
                "expected": "Status y token scopes cuando aplica.",
                "note": ""
            },
            {
                "command": "glab repo clone <group>/<repo>",
                "level": "basic",
                "topic": "Repositorios",
                "description": "Clona repo GitLab.",
                "example": "glab repo clone <group>/<repo>",
                "expected": "Progreso git clone.",
                "note": ""
            },
            {
                "command": "glab repo view --web",
                "level": "intermediate",
                "topic": "Repositorios",
                "description": "Abre proyecto actual.",
                "example": "glab repo view --web",
                "expected": "Navegador en GitLab.",
                "note": ""
            },
            {
                "command": "glab mr list",
                "level": "basic",
                "topic": "Merge requests",
                "description": "Lista merge requests.",
                "example": "glab mr list",
                "expected": "ID/IID, title, state, author.",
                "note": ""
            },
            {
                "command": "glab mr create --fill",
                "level": "basic",
                "topic": "Merge requests",
                "description": "Crea MR con datos inferidos.",
                "example": "glab mr create --fill",
                "expected": "URL del MR.",
                "note": ""
            },
            {
                "command": "glab mr checkout <iid>",
                "level": "intermediate",
                "topic": "Merge requests",
                "description": "Checkout de branch de MR.",
                "example": "glab mr checkout <iid>",
                "expected": "Branch local activa.",
                "note": ""
            },
            {
                "command": "glab mr view <iid>",
                "level": "intermediate",
                "topic": "Merge requests",
                "description": "Muestra detalles.",
                "example": "glab mr view <iid>",
                "expected": "Title, description, approvals, pipeline.",
                "note": ""
            },
            {
                "command": "glab mr approve <iid>",
                "level": "intermediate",
                "topic": "Merge requests",
                "description": "Aprueba MR.",
                "example": "glab mr approve <iid>",
                "expected": "Approval registered.",
                "note": "Respeta proceso de review."
            },
            {
                "command": "glab mr merge <iid>",
                "level": "intermediate",
                "topic": "Merge requests",
                "description": "Mergea MR segun politicas.",
                "example": "glab mr merge <iid>",
                "expected": "Merge confirmation.",
                "note": "Revisa pipeline/approvals."
            },
            {
                "command": "glab issue list",
                "level": "basic",
                "topic": "Issues",
                "description": "Lista issues.",
                "example": "glab issue list",
                "expected": "IIDs, title, labels, state.",
                "note": ""
            },
            {
                "command": "glab issue create --title '<title>' --description '<body>'",
                "level": "intermediate",
                "topic": "Issues",
                "description": "Crea issue.",
                "example": "glab issue create --title '<title>' --description '<body>'",
                "expected": "URL/IID.",
                "note": ""
            },
            {
                "command": "glab ci list",
                "level": "basic",
                "topic": "Pipelines",
                "description": "Lista pipelines.",
                "example": "glab ci list",
                "expected": "Status, ID, ref y source.",
                "note": ""
            },
            {
                "command": "glab ci run",
                "level": "intermediate",
                "topic": "Pipelines",
                "description": "Dispara pipeline si el comando/version lo soporta.",
                "example": "glab ci run",
                "expected": "Pipeline created.",
                "note": "Consulta glab ci --help para version exacta."
            },
            {
                "command": "glab ci status",
                "level": "basic",
                "topic": "Pipelines",
                "description": "Muestra status de pipeline de branch actual.",
                "example": "glab ci status",
                "expected": "Jobs/status.",
                "note": ""
            },
            {
                "command": "glab ci view <pipeline-id>",
                "level": "intermediate",
                "topic": "Pipelines",
                "description": "Muestra pipeline.",
                "example": "glab ci view <pipeline-id>",
                "expected": "Jobs y estado.",
                "note": ""
            },
            {
                "command": "glab ci trace <job-id>",
                "level": "intermediate",
                "topic": "Pipelines",
                "description": "Sigue log de job.",
                "example": "glab ci trace <job-id>",
                "expected": "Stream de job log.",
                "note": ""
            },
            {
                "command": "glab ci retry <job-id>",
                "level": "intermediate",
                "topic": "Pipelines",
                "description": "Reintenta job/pipeline segun subcomando.",
                "example": "glab ci retry <job-id>",
                "expected": "Retry requested.",
                "note": "Verifica la forma exacta en tu version."
            },
            {
                "command": "glab release list",
                "level": "basic",
                "topic": "Releases",
                "description": "Lista releases.",
                "example": "glab release list",
                "expected": "Tags/names/dates.",
                "note": ""
            },
            {
                "command": "glab release create <tag> --notes '<notes>'",
                "level": "intermediate",
                "topic": "Releases",
                "description": "Crea release.",
                "example": "glab release create <tag> --notes '<notes>'",
                "expected": "Release URL/confirmation.",
                "note": ""
            },
            {
                "command": "glab api projects/:id",
                "level": "intermediate",
                "topic": "API",
                "description": "Consulta API autenticada.",
                "example": "glab api projects/:id",
                "expected": "JSON del proyecto.",
                "note": ""
            },
            {
                "command": "glab variable list",
                "level": "intermediate",
                "topic": "Variables",
                "description": "Lista CI/CD variables segun version/scope.",
                "example": "glab variable list",
                "expected": "Variables/metadata.",
                "note": "Valores protegidos pueden ocultarse."
            },
            {
                "command": "glab variable set <KEY> <VALUE>",
                "level": "advanced",
                "topic": "Variables",
                "description": "Crea/actualiza variable.",
                "example": "glab variable set <KEY> <VALUE>",
                "expected": "Variable set.",
                "note": "No expongas secrets en historial; preferi mecanismos seguros."
            },
            {
                "command": "glab repo list",
                "level": "basic",
                "topic": "Repositorios",
                "description": "Lista repositorios accesibles seg\u00fan el contexto de GitLab.",
                "example": "glab repo list",
                "expected": "Tabla/lista de proyectos.",
                "note": ""
            },
            {
                "command": "glab mr diff <iid>",
                "level": "intermediate",
                "topic": "Merge requests",
                "description": "Muestra el diff de una merge request.",
                "example": "glab mr diff <iid>",
                "expected": "Patch/diff de la MR en terminal.",
                "note": ""
            },
            {
                "command": "glab mr note <iid> -m \"<message>\"",
                "level": "intermediate",
                "topic": "Merge requests",
                "description": "Agrega una nota/comentario a una merge request.",
                "example": "glab mr note <iid> -m \"<message>\"",
                "expected": "Confirmaci\u00f3n de la nota creada.",
                "note": ""
            },
            {
                "command": "glab issue view <iid>",
                "level": "intermediate",
                "topic": "Issues",
                "description": "Muestra detalle de un issue.",
                "example": "glab issue view <iid>",
                "expected": "T\u00edtulo, descripci\u00f3n, labels y metadatos.",
                "note": ""
            },
            {
                "command": "glab ci view",
                "level": "intermediate",
                "topic": "Pipelines",
                "description": "Abre/muestra el pipeline asociado al contexto actual.",
                "example": "glab ci view",
                "expected": "Estado y jobs del pipeline.",
                "note": ""
            },
            {
                "command": "glab release view <tag>",
                "level": "intermediate",
                "topic": "Releases",
                "description": "Muestra una release por tag.",
                "example": "glab release view <tag>",
                "expected": "Nombre, notas, assets y metadatos.",
                "note": ""
            },
            {
                "command": "glab api --paginate <endpoint>",
                "level": "advanced",
                "topic": "API",
                "description": "Consulta un endpoint siguiendo paginaci\u00f3n.",
                "example": "glab api --paginate <endpoint>",
                "expected": "JSON concatenado/paginado del endpoint.",
                "note": "La forma exacta depende del endpoint y permisos."
            }
        ]
    },
    {
        "id": "jenkins-cli",
        "group": "deployment",
        "title": "Jenkins CLI",
        "description": "Jobs, builds, nodes, logs de consola, administraci\u00f3n y Groovy desde jenkins-cli.jar.",
        "aliases": [
            "jenkins",
            "ci cd",
            "jenkins cli"
        ],
        "commands": [
            {
                "command": "java -jar jenkins-cli.jar -s <url> help",
                "level": "basic",
                "topic": "Conexion",
                "description": "Muestra comandos disponibles del Jenkins objetivo.",
                "example": "java -jar jenkins-cli.jar -s <url> help",
                "expected": "Lista de comandos CLI.",
                "note": ""
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> -auth <user>:<token> who-am-i",
                "level": "intermediate",
                "topic": "Conexion",
                "description": "Muestra identidad/autorizaciones.",
                "example": "java -jar jenkins-cli.jar -s <url> -auth <user>:<token> who-am-i",
                "expected": "Authenticated as y authorities.",
                "note": "Usa API token y evita dejarlo en historial; considera archivo/variable segura."
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> list-jobs",
                "level": "basic",
                "topic": "Jobs",
                "description": "Lista jobs.",
                "example": "java -jar jenkins-cli.jar -s <url> list-jobs",
                "expected": "Un job por linea.",
                "note": ""
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> get-job <job> > job.xml",
                "level": "intermediate",
                "topic": "Jobs",
                "description": "Exporta config de un job.",
                "example": "java -jar jenkins-cli.jar -s <url> get-job <job> > job.xml",
                "expected": "Archivo job.xml.",
                "note": ""
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> update-job <job> < job.xml",
                "level": "advanced",
                "topic": "Jobs",
                "description": "Actualiza config desde XML.",
                "example": "java -jar jenkins-cli.jar -s <url> update-job <job> < job.xml",
                "expected": "Sin salida si funciona.",
                "note": "Puede cambiar pipeline/config de produccion."
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> build <job>",
                "level": "basic",
                "topic": "Builds",
                "description": "Dispara un build.",
                "example": "java -jar jenkins-cli.jar -s <url> build <job>",
                "expected": "Build queued/number segun flags.",
                "note": ""
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> build <job> -s -v",
                "level": "intermediate",
                "topic": "Builds",
                "description": "Espera build y muestra console output.",
                "example": "java -jar jenkins-cli.jar -s <url> build <job> -s -v",
                "expected": "Logs y exit code acorde al build.",
                "note": ""
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> console <job> <build>",
                "level": "intermediate",
                "topic": "Builds",
                "description": "Muestra console log.",
                "example": "java -jar jenkins-cli.jar -s <url> console <job> <build>",
                "expected": "Texto del build.",
                "note": ""
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> stop-builds <job> <range>",
                "level": "advanced",
                "topic": "Builds",
                "description": "Detiene builds seleccionados si comando/plugin/version lo soporta.",
                "example": "java -jar jenkins-cli.jar -s <url> stop-builds <job> <range>",
                "expected": "Builds detenidos.",
                "note": "Consulta help del Jenkins objetivo."
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> list-computers",
                "level": "basic",
                "topic": "Nodes",
                "description": "Lista nodes/computers.",
                "example": "java -jar jenkins-cli.jar -s <url> list-computers",
                "expected": "Nombres y estado segun Jenkins.",
                "note": ""
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> offline-node <node> -m '<message>'",
                "level": "intermediate",
                "topic": "Nodes",
                "description": "Marca node offline.",
                "example": "java -jar jenkins-cli.jar -s <url> offline-node <node> -m '<message>'",
                "expected": "Node offline.",
                "note": "Reduce capacidad del cluster."
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> online-node <node>",
                "level": "intermediate",
                "topic": "Nodes",
                "description": "Vuelve node online.",
                "example": "java -jar jenkins-cli.jar -s <url> online-node <node>",
                "expected": "Node online.",
                "note": ""
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> version",
                "level": "basic",
                "topic": "Administracion",
                "description": "Muestra version de Jenkins.",
                "example": "java -jar jenkins-cli.jar -s <url> version",
                "expected": "Numero de version.",
                "note": ""
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> safe-restart",
                "level": "intermediate",
                "topic": "Administracion",
                "description": "Solicita restart cuando builds terminen.",
                "example": "java -jar jenkins-cli.jar -s <url> safe-restart",
                "expected": "Restart programado.",
                "note": "Coordina ventana y disponibilidad."
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> reload-configuration",
                "level": "advanced",
                "topic": "Administracion",
                "description": "Recarga config desde disco.",
                "example": "java -jar jenkins-cli.jar -s <url> reload-configuration",
                "expected": "Configuration reloaded.",
                "note": "Puede afectar jobs/nodes si archivos cambiaron."
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> groovy = < script.groovy",
                "level": "advanced",
                "topic": "Groovy",
                "description": "Ejecuta Groovy en Jenkins controller.",
                "example": "java -jar jenkins-cli.jar -s <url> groovy = < script.groovy",
                "expected": "Salida del script.",
                "note": "Equivale a acceso administrativo potente; audita el script."
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> create-job <job> < job.xml",
                "level": "basic",
                "topic": "Jobs",
                "description": "Crea un job desde una configuraci\u00f3n XML.",
                "example": "java -jar jenkins-cli.jar -s <url> create-job <job> < job.xml",
                "expected": "Devuelve \u00e9xito silencioso o un error HTTP/CLI si el XML no es v\u00e1lido.",
                "note": ""
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> copy-job <from> <to>",
                "level": "intermediate",
                "topic": "Jobs",
                "description": "Duplica un job existente con otro nombre.",
                "example": "java -jar jenkins-cli.jar -s <url> copy-job <from> <to>",
                "expected": "Crea el nuevo job y normalmente no imprime contenido.",
                "note": ""
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> delete-job <job>",
                "level": "intermediate",
                "topic": "Jobs",
                "description": "Elimina un job de Jenkins.",
                "example": "java -jar jenkins-cli.jar -s <url> delete-job <job>",
                "expected": "Normalmente no imprime salida si se elimina correctamente.",
                "note": "Es destructivo; confirm\u00e1 el nombre antes de ejecutarlo."
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> enable-job <job>",
                "level": "intermediate",
                "topic": "Jobs",
                "description": "Habilita un job desactivado.",
                "example": "java -jar jenkins-cli.jar -s <url> enable-job <job>",
                "expected": "El job queda habilitado; normalmente sin salida.",
                "note": ""
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> disable-job <job>",
                "level": "intermediate",
                "topic": "Jobs",
                "description": "Deshabilita un job sin borrarlo.",
                "example": "java -jar jenkins-cli.jar -s <url> disable-job <job>",
                "expected": "El job queda deshabilitado; normalmente sin salida.",
                "note": ""
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> build <job> -p KEY=value -s -v",
                "level": "intermediate",
                "topic": "Builds",
                "description": "Lanza un build con par\u00e1metros y espera su finalizaci\u00f3n mostrando consola.",
                "example": "java -jar jenkins-cli.jar -s <url> build <job> -p KEY=value -s -v",
                "expected": "Imprime la salida del build y devuelve c\u00f3digo distinto de 0 si falla.",
                "note": ""
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> console <job> <build> -f",
                "level": "intermediate",
                "topic": "Builds",
                "description": "Sigue en vivo la consola de un build.",
                "example": "java -jar jenkins-cli.jar -s <url> console <job> <build> -f",
                "expected": "Stream continuo de log hasta finalizar o interrumpirlo.",
                "note": ""
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> list-plugins",
                "level": "intermediate",
                "topic": "Plugins",
                "description": "Lista plugins instalados y versiones.",
                "example": "java -jar jenkins-cli.jar -s <url> list-plugins",
                "expected": "Una l\u00ednea por plugin con nombre corto, versi\u00f3n y estado.",
                "note": ""
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> install-plugin <plugin> -restart",
                "level": "advanced",
                "topic": "Plugins",
                "description": "Instala un plugin y solicita reinicio al terminar.",
                "example": "java -jar jenkins-cli.jar -s <url> install-plugin <plugin> -restart",
                "expected": "Mensajes de descarga/instalaci\u00f3n y posterior reinicio de Jenkins.",
                "note": "Usalo en una ventana de mantenimiento; puede reiniciar Jenkins."
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> get-node <node> > node.xml",
                "level": "intermediate",
                "topic": "Nodes",
                "description": "Exporta la configuraci\u00f3n XML de un nodo/agente.",
                "example": "java -jar jenkins-cli.jar -s <url> get-node <node> > node.xml",
                "expected": "Escribe XML en node.xml.",
                "note": ""
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> update-node <node> < node.xml",
                "level": "advanced",
                "topic": "Nodes",
                "description": "Actualiza la configuraci\u00f3n de un nodo desde XML.",
                "example": "java -jar jenkins-cli.jar -s <url> update-node <node> < node.xml",
                "expected": "Normalmente sin salida si la actualizaci\u00f3n es v\u00e1lida.",
                "note": ""
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> delete-node <node>",
                "level": "advanced",
                "topic": "Nodes",
                "description": "Elimina un nodo/agente configurado.",
                "example": "java -jar jenkins-cli.jar -s <url> delete-node <node>",
                "expected": "Normalmente sin salida si se elimina.",
                "note": "Es destructivo para la configuraci\u00f3n del agente."
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> quiet-down",
                "level": "advanced",
                "topic": "Administraci\u00f3n",
                "description": "Pone Jenkins en modo quiet-down para no iniciar nuevos builds.",
                "example": "java -jar jenkins-cli.jar -s <url> quiet-down",
                "expected": "Jenkins deja de programar nuevos builds hasta cancelarlo.",
                "note": ""
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> cancel-quiet-down",
                "level": "advanced",
                "topic": "Administraci\u00f3n",
                "description": "Sale del modo quiet-down.",
                "example": "java -jar jenkins-cli.jar -s <url> cancel-quiet-down",
                "expected": "Jenkins vuelve a aceptar nuevos builds.",
                "note": ""
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> restart",
                "level": "advanced",
                "topic": "Administraci\u00f3n",
                "description": "Reinicia Jenkins inmediatamente.",
                "example": "java -jar jenkins-cli.jar -s <url> restart",
                "expected": "La conexi\u00f3n puede cortarse mientras Jenkins reinicia.",
                "note": "Interrumpe el servicio; prefer\u00ed safe-restart cuando sea posible."
            },
            {
                "command": "java -jar jenkins-cli.jar -s <url> session-id",
                "level": "advanced",
                "topic": "Administraci\u00f3n",
                "description": "Muestra el identificador de sesi\u00f3n/instancia de Jenkins.",
                "example": "java -jar jenkins-cli.jar -s <url> session-id",
                "expected": "Imprime un identificador de la sesi\u00f3n actual.",
                "note": ""
            }
        ]
    },
    {
        "id": "proxmox",
        "group": "virtualization",
        "title": "Proxmox VE",
        "description": "Administraci\u00f3n CLI de Proxmox VE: QEMU/KVM, LXC, storage, backups, cluster, permisos, HA, Ceph y API pvesh.",
        "aliases": [
            "proxmox",
            "pve",
            "qm",
            "pct",
            "pvesh",
            "pvecm",
            "vzdump"
        ],
        "commands": [
            {
                "command": "pveversion",
                "level": "basic",
                "topic": "Sistema y version",
                "description": "Muestra version principal de Proxmox VE.",
                "example": "pveversion",
                "expected": "pve-manager/X.Y-Z/...",
                "note": ""
            },
            {
                "command": "pveversion -v",
                "level": "basic",
                "topic": "Sistema y version",
                "description": "Muestra versiones de paquetes Proxmox.",
                "example": "pveversion -v",
                "expected": "Lista de paquetes y versiones.",
                "note": ""
            },
            {
                "command": "pveperf",
                "level": "basic",
                "topic": "Sistema y version",
                "description": "Ejecuta benchmark rapido del nodo.",
                "example": "pveperf",
                "expected": "CPU bogomips, filesystem, DNS y metricas.",
                "note": ""
            },
            {
                "command": "pvesh get /nodes",
                "level": "intermediate",
                "topic": "Sistema y version",
                "description": "Consulta nodos via API local.",
                "example": "pvesh get /nodes",
                "expected": "Tabla/JSON de nodos del cluster.",
                "note": ""
            },
            {
                "command": "pvesh get /cluster/resources",
                "level": "intermediate",
                "topic": "Sistema y version",
                "description": "Lista recursos del cluster via API.",
                "example": "pvesh get /cluster/resources",
                "expected": "VMs, CTs, nodes, storages y estados.",
                "note": ""
            },
            {
                "command": "qm list",
                "level": "basic",
                "topic": "VM QEMU/KVM",
                "description": "Lista VMs QEMU/KVM.",
                "example": "qm list",
                "expected": "VMID, NAME, STATUS, MEM, BOOTDISK, PID.",
                "note": ""
            },
            {
                "command": "qm status <vmid>",
                "level": "basic",
                "topic": "VM QEMU/KVM",
                "description": "Muestra estado de una VM.",
                "example": "qm status <vmid>",
                "expected": "status: running/stopped.",
                "note": ""
            },
            {
                "command": "qm start <vmid>",
                "level": "basic",
                "topic": "VM QEMU/KVM",
                "description": "Inicia una VM.",
                "example": "qm start <vmid>",
                "expected": "Sin salida o task result; VM running.",
                "note": ""
            },
            {
                "command": "qm shutdown <vmid>",
                "level": "basic",
                "topic": "VM QEMU/KVM",
                "description": "Solicita apagado ACPI.",
                "example": "qm shutdown <vmid>",
                "expected": "Task iniciada; VM se apaga si guest coopera.",
                "note": ""
            },
            {
                "command": "qm shutdown <vmid> --timeout 60",
                "level": "intermediate",
                "topic": "VM QEMU/KVM",
                "description": "Espera hasta 60s por apagado limpio.",
                "example": "qm shutdown <vmid> --timeout 60",
                "expected": "Task/timeout.",
                "note": ""
            },
            {
                "command": "qm stop <vmid>",
                "level": "intermediate",
                "topic": "VM QEMU/KVM",
                "description": "Detiene VM inmediatamente.",
                "example": "qm stop <vmid>",
                "expected": "VM stopped.",
                "note": "Equivale a cortar energia virtual; riesgo de corrupcion."
            },
            {
                "command": "qm reboot <vmid>",
                "level": "intermediate",
                "topic": "VM QEMU/KVM",
                "description": "Solicita reboot de la VM.",
                "example": "qm reboot <vmid>",
                "expected": "VM reiniciada.",
                "note": ""
            },
            {
                "command": "qm reset <vmid>",
                "level": "advanced",
                "topic": "VM QEMU/KVM",
                "description": "Hace reset virtual forzado.",
                "example": "qm reset <vmid>",
                "expected": "VM reset.",
                "note": "Puede causar perdida/corrupcion como reset fisico."
            },
            {
                "command": "qm config <vmid>",
                "level": "basic",
                "topic": "VM QEMU/KVM",
                "description": "Muestra configuracion de VM.",
                "example": "qm config <vmid>",
                "expected": "Claves como memory, cores, disks, net, boot.",
                "note": ""
            },
            {
                "command": "qm set <vmid> --memory 8192 --cores 4",
                "level": "intermediate",
                "topic": "VM QEMU/KVM",
                "description": "Cambia RAM y CPUs configuradas.",
                "example": "qm set <vmid> --memory 8192 --cores 4",
                "expected": "update VM ...",
                "note": ""
            },
            {
                "command": "qm set <vmid> --onboot 1",
                "level": "intermediate",
                "topic": "VM QEMU/KVM",
                "description": "Habilita arranque automatico.",
                "example": "qm set <vmid> --onboot 1",
                "expected": "update VM ...",
                "note": ""
            },
            {
                "command": "qm set <vmid> --agent enabled=1",
                "level": "intermediate",
                "topic": "VM QEMU/KVM",
                "description": "Habilita QEMU Guest Agent en config.",
                "example": "qm set <vmid> --agent enabled=1",
                "expected": "update VM ...",
                "note": "Tambien instala/activa qemu-guest-agent dentro del guest."
            },
            {
                "command": "qm clone <vmid> <newid> --name <name> --full 1",
                "level": "intermediate",
                "topic": "VM QEMU/KVM",
                "description": "Clona una VM completa.",
                "example": "qm clone <vmid> <newid> --name <name> --full 1",
                "expected": "Task de clone y nueva VM.",
                "note": "Requiere storage/espacio suficiente."
            },
            {
                "command": "qm template <vmid>",
                "level": "intermediate",
                "topic": "VM QEMU/KVM",
                "description": "Convierte VM en template.",
                "example": "qm template <vmid>",
                "expected": "VM pasa a template.",
                "note": "No se inicia directamente despues."
            },
            {
                "command": "qm migrate <vmid> <target-node> --online",
                "level": "advanced",
                "topic": "VM QEMU/KVM",
                "description": "Migra VM encendida a otro nodo.",
                "example": "qm migrate <vmid> <target-node> --online",
                "expected": "Task de migration.",
                "note": "Requiere cluster/storage/network compatibles."
            },
            {
                "command": "qm move_disk <vmid> <disk> <storage> --delete 1",
                "level": "advanced",
                "topic": "VM QEMU/KVM",
                "description": "Mueve disco a otro storage.",
                "example": "qm move_disk <vmid> <disk> <storage> --delete 1",
                "expected": "Task de move y config actualizada.",
                "note": "Valida espacio y backups antes."
            },
            {
                "command": "qm resize <vmid> <disk> +20G",
                "level": "intermediate",
                "topic": "VM QEMU/KVM",
                "description": "Aumenta disco virtual 20 GB.",
                "example": "qm resize <vmid> <disk> +20G",
                "expected": "Disk resized.",
                "note": "Luego amplia particion/filesystem dentro del guest."
            },
            {
                "command": "qm snapshot <vmid> <snapname> --description '<text>'",
                "level": "intermediate",
                "topic": "VM QEMU/KVM",
                "description": "Crea snapshot de VM.",
                "example": "qm snapshot <vmid> <snapname> --description '<text>'",
                "expected": "Snapshot creado.",
                "note": "No todos los storages soportan snapshots."
            },
            {
                "command": "qm listsnapshot <vmid>",
                "level": "basic",
                "topic": "VM QEMU/KVM",
                "description": "Lista snapshots.",
                "example": "qm listsnapshot <vmid>",
                "expected": "Arbol de snapshots.",
                "note": ""
            },
            {
                "command": "qm rollback <vmid> <snapname>",
                "level": "advanced",
                "topic": "VM QEMU/KVM",
                "description": "Revierte a snapshot.",
                "example": "qm rollback <vmid> <snapname>",
                "expected": "VM state/config revertidos.",
                "note": "Descarta cambios posteriores; valida impacto de datos."
            },
            {
                "command": "qm delsnapshot <vmid> <snapname>",
                "level": "intermediate",
                "topic": "VM QEMU/KVM",
                "description": "Elimina snapshot.",
                "example": "qm delsnapshot <vmid> <snapname>",
                "expected": "Snapshot removido.",
                "note": "Puede generar consolidacion/IO."
            },
            {
                "command": "qm terminal <vmid>",
                "level": "intermediate",
                "topic": "VM QEMU/KVM",
                "description": "Abre terminal serial si esta configurada.",
                "example": "qm terminal <vmid>",
                "expected": "Sesion serial.",
                "note": ""
            },
            {
                "command": "qm monitor <vmid>",
                "level": "advanced",
                "topic": "VM QEMU/KVM",
                "description": "Abre monitor QEMU.",
                "example": "qm monitor <vmid>",
                "expected": "Prompt QEMU monitor.",
                "note": "Comandos de bajo nivel; usar con cuidado."
            },
            {
                "command": "qm guest cmd <vmid> ping",
                "level": "intermediate",
                "topic": "VM QEMU/KVM",
                "description": "Comprueba QEMU Guest Agent.",
                "example": "qm guest cmd <vmid> ping",
                "expected": "Respuesta/JSON de ping.",
                "note": "Requiere guest agent operativo."
            },
            {
                "command": "qm guest exec <vmid> -- <command>",
                "level": "advanced",
                "topic": "VM QEMU/KVM",
                "description": "Ejecuta comando dentro del guest via agent.",
                "example": "qm guest exec <vmid> -- <command>",
                "expected": "PID/resultado de guest exec.",
                "note": "Implica ejecucion remota privilegiada segun guest agent."
            },
            {
                "command": "qm pending <vmid>",
                "level": "basic",
                "topic": "VM QEMU/KVM",
                "description": "Muestra cambios pendientes.",
                "example": "qm pending <vmid>",
                "expected": "Current/pending values.",
                "note": ""
            },
            {
                "command": "qm unlock <vmid>",
                "level": "advanced",
                "topic": "VM QEMU/KVM",
                "description": "Quita lock de una VM.",
                "example": "qm unlock <vmid>",
                "expected": "Lock removido.",
                "note": "Solo si verificaste que no hay backup/migration activa."
            },
            {
                "command": "pct list",
                "level": "basic",
                "topic": "Contenedores LXC",
                "description": "Lista containers.",
                "example": "pct list",
                "expected": "VMID, STATUS, LOCK, NAME.",
                "note": ""
            },
            {
                "command": "pct status <ctid>",
                "level": "basic",
                "topic": "Contenedores LXC",
                "description": "Muestra estado.",
                "example": "pct status <ctid>",
                "expected": "status: running/stopped.",
                "note": ""
            },
            {
                "command": "pct start <ctid>",
                "level": "basic",
                "topic": "Contenedores LXC",
                "description": "Inicia container.",
                "example": "pct start <ctid>",
                "expected": "CT running.",
                "note": ""
            },
            {
                "command": "pct shutdown <ctid>",
                "level": "basic",
                "topic": "Contenedores LXC",
                "description": "Apagado limpio.",
                "example": "pct shutdown <ctid>",
                "expected": "CT se detiene.",
                "note": ""
            },
            {
                "command": "pct stop <ctid>",
                "level": "intermediate",
                "topic": "Contenedores LXC",
                "description": "Detiene forzadamente.",
                "example": "pct stop <ctid>",
                "expected": "CT stopped.",
                "note": "Puede interrumpir escrituras."
            },
            {
                "command": "pct reboot <ctid>",
                "level": "intermediate",
                "topic": "Contenedores LXC",
                "description": "Reinicia CT.",
                "example": "pct reboot <ctid>",
                "expected": "CT reiniciado.",
                "note": ""
            },
            {
                "command": "pct config <ctid>",
                "level": "basic",
                "topic": "Contenedores LXC",
                "description": "Muestra config.",
                "example": "pct config <ctid>",
                "expected": "cores, memory, rootfs, net, mountpoints.",
                "note": ""
            },
            {
                "command": "pct set <ctid> --memory 4096 --cores 2",
                "level": "intermediate",
                "topic": "Contenedores LXC",
                "description": "Ajusta recursos.",
                "example": "pct set <ctid> --memory 4096 --cores 2",
                "expected": "Config updated.",
                "note": ""
            },
            {
                "command": "pct enter <ctid>",
                "level": "basic",
                "topic": "Contenedores LXC",
                "description": "Abre shell dentro del CT.",
                "example": "pct enter <ctid>",
                "expected": "Prompt del container.",
                "note": ""
            },
            {
                "command": "pct exec <ctid> -- <command>",
                "level": "intermediate",
                "topic": "Contenedores LXC",
                "description": "Ejecuta comando sin shell interactiva.",
                "example": "pct exec <ctid> -- <command>",
                "expected": "Salida del comando.",
                "note": ""
            },
            {
                "command": "pct push <ctid> <local> <remote>",
                "level": "intermediate",
                "topic": "Contenedores LXC",
                "description": "Copia archivo host->CT.",
                "example": "pct push <ctid> <local> <remote>",
                "expected": "Archivo copiado.",
                "note": ""
            },
            {
                "command": "pct pull <ctid> <remote> <local>",
                "level": "intermediate",
                "topic": "Contenedores LXC",
                "description": "Copia archivo CT->host.",
                "example": "pct pull <ctid> <remote> <local>",
                "expected": "Archivo local.",
                "note": ""
            },
            {
                "command": "pct clone <ctid> <newid> --hostname <name> --full 1",
                "level": "intermediate",
                "topic": "Contenedores LXC",
                "description": "Clona un CT.",
                "example": "pct clone <ctid> <newid> --hostname <name> --full 1",
                "expected": "Nuevo CT.",
                "note": ""
            },
            {
                "command": "pct migrate <ctid> <target-node> --online",
                "level": "advanced",
                "topic": "Contenedores LXC",
                "description": "Migra CT a otro nodo.",
                "example": "pct migrate <ctid> <target-node> --online",
                "expected": "Migration task.",
                "note": "Requisitos dependen de storage/config."
            },
            {
                "command": "pct snapshot <ctid> <snapname>",
                "level": "intermediate",
                "topic": "Contenedores LXC",
                "description": "Crea snapshot.",
                "example": "pct snapshot <ctid> <snapname>",
                "expected": "Snapshot creado.",
                "note": "Storage debe soportarlo."
            },
            {
                "command": "pct listsnapshot <ctid>",
                "level": "basic",
                "topic": "Contenedores LXC",
                "description": "Lista snapshots.",
                "example": "pct listsnapshot <ctid>",
                "expected": "Arbol de snapshots.",
                "note": ""
            },
            {
                "command": "pct rollback <ctid> <snapname>",
                "level": "advanced",
                "topic": "Contenedores LXC",
                "description": "Revierte CT.",
                "example": "pct rollback <ctid> <snapname>",
                "expected": "Estado revertido.",
                "note": "Pierdes cambios posteriores."
            },
            {
                "command": "pvesm status",
                "level": "basic",
                "topic": "Storage",
                "description": "Lista storages y estado.",
                "example": "pvesm status",
                "expected": "Name, Type, Status, Total, Used, Available.",
                "note": ""
            },
            {
                "command": "pvesm list <storage>",
                "level": "basic",
                "topic": "Storage",
                "description": "Lista contenidos de storage.",
                "example": "pvesm list <storage>",
                "expected": "Volid, format, type, size, vmid.",
                "note": ""
            },
            {
                "command": "pvesm list <storage> --content iso",
                "level": "intermediate",
                "topic": "Storage",
                "description": "Lista ISOs.",
                "example": "pvesm list <storage> --content iso",
                "expected": "Volid y metadata de ISOs.",
                "note": ""
            },
            {
                "command": "pvesm list <storage> --content vztmpl",
                "level": "intermediate",
                "topic": "Storage",
                "description": "Lista templates LXC.",
                "example": "pvesm list <storage> --content vztmpl",
                "expected": "Templates disponibles.",
                "note": ""
            },
            {
                "command": "pvesm path <volume-id>",
                "level": "intermediate",
                "topic": "Storage",
                "description": "Resuelve path local de volumen.",
                "example": "pvesm path <volume-id>",
                "expected": "Ruta filesystem cuando aplica.",
                "note": ""
            },
            {
                "command": "pvesm scan nfs <server>",
                "level": "intermediate",
                "topic": "Storage",
                "description": "Descubre exports NFS.",
                "example": "pvesm scan nfs <server>",
                "expected": "Exports disponibles.",
                "note": ""
            },
            {
                "command": "pvesm scan cifs <server> --username <user>",
                "level": "intermediate",
                "topic": "Storage",
                "description": "Descubre shares CIFS/SMB.",
                "example": "pvesm scan cifs <server> --username <user>",
                "expected": "Shares disponibles.",
                "note": "Evita password en linea de comandos; usa mecanismo seguro."
            },
            {
                "command": "pvesm add dir <id> --path <path> --content images,iso,backup",
                "level": "advanced",
                "topic": "Storage",
                "description": "Agrega storage directory.",
                "example": "pvesm add dir <id> --path <path> --content images,iso,backup",
                "expected": "Storage creado.",
                "note": "Verifica mount persistente y permisos antes."
            },
            {
                "command": "pvesm remove <id>",
                "level": "advanced",
                "topic": "Storage",
                "description": "Quita definicion de storage.",
                "example": "pvesm remove <id>",
                "expected": "Storage removido de config.",
                "note": "No borra necesariamente datos; confirma dependencias."
            },
            {
                "command": "vzdump <vmid> --storage <backup-storage> --mode snapshot",
                "level": "basic",
                "topic": "Backups y restore",
                "description": "Crea backup de VM/CT.",
                "example": "vzdump <vmid> --storage <backup-storage> --mode snapshot",
                "expected": "Task, archivo vzdump y logs.",
                "note": ""
            },
            {
                "command": "vzdump --all 1 --storage <backup-storage> --mode snapshot",
                "level": "intermediate",
                "topic": "Backups y restore",
                "description": "Respalda todos los guests.",
                "example": "vzdump --all 1 --storage <backup-storage> --mode snapshot",
                "expected": "Un backup por guest.",
                "note": "Puede consumir IO/espacio considerable."
            },
            {
                "command": "vzdump <vmid> --dumpdir <path> --compress zstd",
                "level": "intermediate",
                "topic": "Backups y restore",
                "description": "Backup a directorio con zstd.",
                "example": "vzdump <vmid> --dumpdir <path> --compress zstd",
                "expected": "Archivo .vma.zst/.tar.zst segun guest.",
                "note": ""
            },
            {
                "command": "qmrestore <backup.vma.zst> <new-vmid> --storage <storage>",
                "level": "advanced",
                "topic": "Backups y restore",
                "description": "Restaura backup QEMU.",
                "example": "qmrestore <backup.vma.zst> <new-vmid> --storage <storage>",
                "expected": "Nueva VM restaurada.",
                "note": "Confirma VMID/storage y espacio."
            },
            {
                "command": "pct restore <new-ctid> <backup.tar.zst> --storage <storage>",
                "level": "advanced",
                "topic": "Backups y restore",
                "description": "Restaura backup LXC.",
                "example": "pct restore <new-ctid> <backup.tar.zst> --storage <storage>",
                "expected": "Nuevo CT restaurado.",
                "note": "Revisa config/red antes de iniciar."
            },
            {
                "command": "pvecm status",
                "level": "basic",
                "topic": "Cluster",
                "description": "Muestra estado del cluster/corosync.",
                "example": "pvecm status",
                "expected": "Quorum, nodes, votes y config version.",
                "note": ""
            },
            {
                "command": "pvecm nodes",
                "level": "basic",
                "topic": "Cluster",
                "description": "Lista nodos.",
                "example": "pvecm nodes",
                "expected": "Nodeid, Votes, Name y status.",
                "note": ""
            },
            {
                "command": "pvecm create <cluster-name>",
                "level": "intermediate",
                "topic": "Cluster",
                "description": "Crea cluster en el nodo.",
                "example": "pvecm create <cluster-name>",
                "expected": "Cluster config creada.",
                "note": "Hazlo en nodo limpio; unir clusters existentes requiere planificacion."
            },
            {
                "command": "pvecm add <cluster-node-ip>",
                "level": "intermediate",
                "topic": "Cluster",
                "description": "Une nodo al cluster.",
                "example": "pvecm add <cluster-node-ip>",
                "expected": "Intercambio de certs/config y membership.",
                "note": "Puede sobrescribir config /etc/pve del nodo que se une."
            },
            {
                "command": "pvecm delnode <node>",
                "level": "advanced",
                "topic": "Cluster",
                "description": "Elimina nodo del cluster.",
                "example": "pvecm delnode <node>",
                "expected": "Membership actualizada.",
                "note": "Solo despues de retirar guests/storage y confirmar nodo fuera."
            },
            {
                "command": "pvecm expected 1",
                "level": "advanced",
                "topic": "Cluster",
                "description": "Cambia votes esperados temporalmente.",
                "example": "pvecm expected 1",
                "expected": "Expected votes actualizado.",
                "note": "Medida de emergencia; evita cambios de cluster mientras forzas quorum."
            },
            {
                "command": "pveum user list",
                "level": "basic",
                "topic": "Usuarios y permisos",
                "description": "Lista usuarios.",
                "example": "pveum user list",
                "expected": "userid, enabled, expire, firstname, realm.",
                "note": ""
            },
            {
                "command": "pveum user add <user>@pve",
                "level": "intermediate",
                "topic": "Usuarios y permisos",
                "description": "Crea usuario local PVE.",
                "example": "pveum user add <user>@pve",
                "expected": "Usuario creado.",
                "note": ""
            },
            {
                "command": "pveum passwd <user>@pve",
                "level": "intermediate",
                "topic": "Usuarios y permisos",
                "description": "Cambia password.",
                "example": "pveum passwd <user>@pve",
                "expected": "Prompt de password.",
                "note": "No automatices passwords interactivos en logs."
            },
            {
                "command": "pveum role list",
                "level": "basic",
                "topic": "Usuarios y permisos",
                "description": "Lista roles.",
                "example": "pveum role list",
                "expected": "roleid y privilegios.",
                "note": ""
            },
            {
                "command": "pveum acl list",
                "level": "intermediate",
                "topic": "Usuarios y permisos",
                "description": "Lista ACLs.",
                "example": "pveum acl list",
                "expected": "Path, roles, users/groups y propagate.",
                "note": ""
            },
            {
                "command": "pveum acl modify /vms/<vmid> -user <user>@pve -role PVEVMUser",
                "level": "advanced",
                "topic": "Usuarios y permisos",
                "description": "Asigna rol sobre una VM.",
                "example": "pveum acl modify /vms/<vmid> -user <user>@pve -role PVEVMUser",
                "expected": "ACL actualizada.",
                "note": "Aplica minimo privilegio."
            },
            {
                "command": "ha-manager status",
                "level": "basic",
                "topic": "HA",
                "description": "Muestra estado HA.",
                "example": "ha-manager status",
                "expected": "Master, LRM y resources.",
                "note": ""
            },
            {
                "command": "ha-manager add vm:<vmid>",
                "level": "intermediate",
                "topic": "HA",
                "description": "Agrega VM a HA.",
                "example": "ha-manager add vm:<vmid>",
                "expected": "Resource added.",
                "note": "Requiere cluster HA correctamente configurado."
            },
            {
                "command": "ha-manager set vm:<vmid> --state started",
                "level": "intermediate",
                "topic": "HA",
                "description": "Define estado HA deseado.",
                "example": "ha-manager set vm:<vmid> --state started",
                "expected": "Resource state updated.",
                "note": ""
            },
            {
                "command": "ha-manager migrate vm:<vmid> <node>",
                "level": "advanced",
                "topic": "HA",
                "description": "Migra recurso HA.",
                "example": "ha-manager migrate vm:<vmid> <node>",
                "expected": "Task de migration.",
                "note": "Coordina con HA; no mezcles operaciones manuales sin entender estado."
            },
            {
                "command": "ha-manager relocate vm:<vmid> <node>",
                "level": "advanced",
                "topic": "HA",
                "description": "Relocaliza recurso HA, pudiendo implicar restart.",
                "example": "ha-manager relocate vm:<vmid> <node>",
                "expected": "Resource relocated.",
                "note": "Puede causar downtime."
            },
            {
                "command": "pveceph status",
                "level": "basic",
                "topic": "Ceph y nodos",
                "description": "Muestra estado Ceph integrado.",
                "example": "pveceph status",
                "expected": "Health, monitors, OSDs y uso.",
                "note": ""
            },
            {
                "command": "pveceph osd ls",
                "level": "intermediate",
                "topic": "Ceph y nodos",
                "description": "Lista OSDs.",
                "example": "pveceph osd ls",
                "expected": "IDs y metadata.",
                "note": ""
            },
            {
                "command": "pvenode status",
                "level": "intermediate",
                "topic": "Ceph y nodos",
                "description": "Muestra estado del nodo.",
                "example": "pvenode status",
                "expected": "CPU, memory, uptime, load y filesystem.",
                "note": ""
            },
            {
                "command": "pvesh get /cluster/status",
                "level": "basic",
                "topic": "API local pvesh",
                "description": "Consulta status cluster via API local.",
                "example": "pvesh get /cluster/status",
                "expected": "JSON/tabla.",
                "note": ""
            },
            {
                "command": "pvesh get /nodes/<node>/qemu",
                "level": "intermediate",
                "topic": "API local pvesh",
                "description": "Lista VMs de nodo via API.",
                "example": "pvesh get /nodes/<node>/qemu",
                "expected": "VM records.",
                "note": ""
            },
            {
                "command": "pvesh get /nodes/<node>/lxc",
                "level": "intermediate",
                "topic": "API local pvesh",
                "description": "Lista CTs de nodo via API.",
                "example": "pvesh get /nodes/<node>/lxc",
                "expected": "Container records.",
                "note": ""
            },
            {
                "command": "pvesh get /nodes/<node>/tasks --limit 20",
                "level": "advanced",
                "topic": "API local pvesh",
                "description": "Consulta tasks recientes.",
                "example": "pvesh get /nodes/<node>/tasks --limit 20",
                "expected": "UPID, type, status, start/end.",
                "note": ""
            }
        ]
    }
];
